// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23eef0f2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%230f6fec%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath stroke=%27%23ffffff%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%230e64d4%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236fa9f4%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23a1a1a8%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/mockup/app-placeholder3.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/*!
 * Bootstrap  v5.3.2 (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #007bff;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #e83e8c;
  --bs-red: #d6293e;
  --bs-orange: #fd7e14;
  --bs-yellow: #f7c32e;
  --bs-green: #0cbc87;
  --bs-teal: #20c997;
  --bs-cyan: #4f9ef8;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray-100: #f7f8f9;
  --bs-gray-200: #eff2f6;
  --bs-gray-300: #eef0f2;
  --bs-gray-400: #e1e4e6;
  --bs-gray-500: #a1a1a8;
  --bs-gray-600: #676a79;
  --bs-gray-700: #29292e;
  --bs-gray-800: #14191e;
  --bs-gray-900: #0f0f10;
  --bs-primary: #0f6fec;
  --bs-secondary: #14191e;
  --bs-success: #0cbc87;
  --bs-info: #4f9ef8;
  --bs-warning: #f7c32e;
  --bs-danger: #d6293e;
  --bs-light: #eef0f2;
  --bs-dark: #14191e;
  --bs-primary-rgb: 15, 111, 236;
  --bs-secondary-rgb: 20, 25, 30;
  --bs-success-rgb: 12, 188, 135;
  --bs-info-rgb: 79, 158, 248;
  --bs-warning-rgb: 247, 195, 46;
  --bs-danger-rgb: 214, 41, 62;
  --bs-light-rgb: 238, 240, 242;
  --bs-dark-rgb: 20, 25, 30;
  --bs-primary-text-emphasis: #0b4ea5;
  --bs-secondary-text-emphasis: #0e1215;
  --bs-success-text-emphasis: #08845f;
  --bs-info-text-emphasis: #376fae;
  --bs-warning-text-emphasis: #ad8920;
  --bs-danger-text-emphasis: #961d2b;
  --bs-light-text-emphasis: #29292e;
  --bs-dark-text-emphasis: #0e1215;
  --bs-primary-bg-subtle: #cfe2fb;
  --bs-secondary-bg-subtle: #d0d1d2;
  --bs-success-bg-subtle: #cef2e7;
  --bs-info-bg-subtle: #dcecfe;
  --bs-warning-bg-subtle: #fdf3d5;
  --bs-danger-bg-subtle: #f7d4d8;
  --bs-light-bg-subtle: #fbfcfc;
  --bs-dark-bg-subtle: #d0d1d2;
  --bs-primary-border-subtle: #9fc5f7;
  --bs-secondary-border-subtle: #a1a3a5;
  --bs-success-border-subtle: #9ee4cf;
  --bs-info-border-subtle: #b9d8fc;
  --bs-warning-border-subtle: #fce7ab;
  --bs-danger-border-subtle: #efa9b2;
  --bs-light-border-subtle: #eff2f6;
  --bs-dark-border-subtle: #a1a3a5;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: "Inter", sans-serif;
  --bs-body-font-size: 0.9375rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #676a79;
  --bs-body-color-rgb: 103, 106, 121;
  --bs-body-bg: #eff2f6;
  --bs-body-bg-rgb: 239, 242, 246;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(103, 106, 121, 0.5);
  --bs-secondary-color-rgb: 103, 106, 121;
  --bs-secondary-bg: #eff2f6;
  --bs-secondary-bg-rgb: 239, 242, 246;
  --bs-tertiary-color: rgba(103, 106, 121, 0.5);
  --bs-tertiary-color-rgb: 103, 106, 121;
  --bs-tertiary-bg: #f7f8f9;
  --bs-tertiary-bg-rgb: 247, 248, 249;
  --bs-heading-color: var(--bs-gray-800);
  --bs-link-color: #0f6fec;
  --bs-link-color-rgb: 15, 111, 236;
  --bs-link-decoration: none;
  --bs-link-hover-color: #0c59bd;
  --bs-link-hover-color-rgb: 12, 89, 189;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: rgba(0, 0, 0, 0.1);
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.4rem;
  --bs-border-radius-sm: 0.2rem;
  --bs-border-radius-lg: 0.7rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0px 0px 20px rgba(93, 83, 84, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(83, 88, 93, 0.15);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(83, 88, 93, 0.15);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #eef0f2;
  --bs-body-color-rgb: 238, 240, 242;
  --bs-body-bg: #0f0f10;
  --bs-body-bg-rgb: 15, 15, 16;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(238, 240, 242, 0.5);
  --bs-secondary-color-rgb: 238, 240, 242;
  --bs-secondary-bg: #14191e;
  --bs-secondary-bg-rgb: 20, 25, 30;
  --bs-tertiary-color: rgba(238, 240, 242, 0.5);
  --bs-tertiary-color-rgb: 238, 240, 242;
  --bs-tertiary-bg: #121417;
  --bs-tertiary-bg-rgb: 18, 20, 23;
  --bs-primary-text-emphasis: #6fa9f4;
  --bs-secondary-text-emphasis: #727578;
  --bs-success-text-emphasis: #6dd7b7;
  --bs-info-text-emphasis: #95c5fb;
  --bs-warning-text-emphasis: #fadb82;
  --bs-danger-text-emphasis: #e67f8b;
  --bs-light-text-emphasis: #f7f8f9;
  --bs-dark-text-emphasis: #eef0f2;
  --bs-primary-bg-subtle: #03162f;
  --bs-secondary-bg-subtle: #040506;
  --bs-success-bg-subtle: #02261b;
  --bs-info-bg-subtle: #102032;
  --bs-warning-bg-subtle: #312709;
  --bs-danger-bg-subtle: #2b080c;
  --bs-light-bg-subtle: #14191e;
  --bs-dark-bg-subtle: #0a0d0f;
  --bs-primary-border-subtle: #09438e;
  --bs-secondary-border-subtle: #0c0f12;
  --bs-success-border-subtle: #077151;
  --bs-info-border-subtle: #2f5f95;
  --bs-warning-border-subtle: #94751c;
  --bs-danger-border-subtle: #801925;
  --bs-light-border-subtle: #29292e;
  --bs-dark-border-subtle: #14191e;
  --bs-heading-color: inherit;
  --bs-link-color: #0f6fec;
  --bs-link-hover-color: #0c59bd;
  --bs-link-color-rgb: 15, 111, 236;
  --bs-link-hover-color-rgb: 12, 89, 189;
  --bs-code-color: #e685b5;
  --bs-highlight-color: #eef0f2;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #29292e;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: var(--bs-gray-500);
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6,
.h6,
h5,
.h5,
h4,
.h4,
h3,
.h3,
h2,
.h2,
h1,
.h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  line-height: 1.25;
  color: var(--bs-heading-color);
}

h1,
.h1 {
  font-size: calc(1.359375rem + 1.3125vw);
}

@media (min-width: 1200px) {

  h1,
  .h1 {
    font-size: 2.34375rem;
  }
}

h2,
.h2 {
  font-size: calc(1.3125rem + 0.75vw);
}

@media (min-width: 1200px) {

  h2,
  .h2 {
    font-size: 1.875rem;
  }
}

h3,
.h3 {
  font-size: calc(1.2890625rem + 0.46875vw);
}

@media (min-width: 1200px) {

  h3,
  .h3 {
    font-size: 1.640625rem;
  }
}

h4,
.h4 {
  font-size: calc(1.265625rem + 0.1875vw);
}

@media (min-width: 1200px) {

  h4,
  .h4 {
    font-size: 1.40625rem;
  }
}

h5,
.h5 {
  font-size: 1.171875rem;
}

h6,
.h6 {
  font-size: 0.9375rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small,
.small {
  font-size: 0.875em;
}

mark,
.mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none;
}

a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]),
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}

a>code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.2rem;
}

kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}

@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}

legend+* {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.171875rem;
  font-weight: 400;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 700;
  line-height: 1.25;
}

@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 700;
  line-height: 1.25;
}

@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 700;
  line-height: 1.25;
}

@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 700;
  line-height: 1.25;
}

@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 700;
  line-height: 1.25;
}

@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 700;
  line-height: 1.25;
}

@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote> :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}

.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {

  .container-sm,
  .container {
    max-width: 96%;
  }
}

@media (min-width: 768px) {

  .container-md,
  .container-sm,
  .container {
    max-width: 100%;
  }
}

@media (min-width: 992px) {

  .container-lg,
  .container-md,
  .container-sm,
  .container {
    max-width: 100%;
  }
}

@media (min-width: 1200px) {

  .container-xl,
  .container-lg,
  .container-md,
  .container-sm,
  .container {
    max-width: 1140px;
  }
}

@media (min-width: 1400px) {

  .container-xxl,
  .container-xl,
  .container-lg,
  .container-md,
  .container-sm,
  .container {
    max-width: 1200px;
  }
}

:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}

.row>* {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto>* {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1>* {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2>* {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3>* {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4>* {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5>* {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6>* {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }

  .row-cols-sm-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-sm-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-sm-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-sm-3>* {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-sm-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-sm-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-sm-6>* {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-sm-0 {
    margin-left: 0;
  }

  .offset-sm-1 {
    margin-left: 8.33333333%;
  }

  .offset-sm-2 {
    margin-left: 16.66666667%;
  }

  .offset-sm-3 {
    margin-left: 25%;
  }

  .offset-sm-4 {
    margin-left: 33.33333333%;
  }

  .offset-sm-5 {
    margin-left: 41.66666667%;
  }

  .offset-sm-6 {
    margin-left: 50%;
  }

  .offset-sm-7 {
    margin-left: 58.33333333%;
  }

  .offset-sm-8 {
    margin-left: 66.66666667%;
  }

  .offset-sm-9 {
    margin-left: 75%;
  }

  .offset-sm-10 {
    margin-left: 83.33333333%;
  }

  .offset-sm-11 {
    margin-left: 91.66666667%;
  }

  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }

  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }

  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }

  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }

  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }

  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }

  .row-cols-md-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-md-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-md-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-md-3>* {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-md-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-md-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-md-6>* {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-md-0 {
    margin-left: 0;
  }

  .offset-md-1 {
    margin-left: 8.33333333%;
  }

  .offset-md-2 {
    margin-left: 16.66666667%;
  }

  .offset-md-3 {
    margin-left: 25%;
  }

  .offset-md-4 {
    margin-left: 33.33333333%;
  }

  .offset-md-5 {
    margin-left: 41.66666667%;
  }

  .offset-md-6 {
    margin-left: 50%;
  }

  .offset-md-7 {
    margin-left: 58.33333333%;
  }

  .offset-md-8 {
    margin-left: 66.66666667%;
  }

  .offset-md-9 {
    margin-left: 75%;
  }

  .offset-md-10 {
    margin-left: 83.33333333%;
  }

  .offset-md-11 {
    margin-left: 91.66666667%;
  }

  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }

  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }

  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }

  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }

  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }

  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }

  .row-cols-lg-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-lg-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-lg-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-lg-3>* {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-lg-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-lg-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-lg-6>* {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-lg-0 {
    margin-left: 0;
  }

  .offset-lg-1 {
    margin-left: 8.33333333%;
  }

  .offset-lg-2 {
    margin-left: 16.66666667%;
  }

  .offset-lg-3 {
    margin-left: 25%;
  }

  .offset-lg-4 {
    margin-left: 33.33333333%;
  }

  .offset-lg-5 {
    margin-left: 41.66666667%;
  }

  .offset-lg-6 {
    margin-left: 50%;
  }

  .offset-lg-7 {
    margin-left: 58.33333333%;
  }

  .offset-lg-8 {
    margin-left: 66.66666667%;
  }

  .offset-lg-9 {
    margin-left: 75%;
  }

  .offset-lg-10 {
    margin-left: 83.33333333%;
  }

  .offset-lg-11 {
    margin-left: 91.66666667%;
  }

  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }

  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }

  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }

  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }

  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }

  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }

  .row-cols-xl-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xl-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xl-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xl-3>* {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-xl-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xl-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xl-6>* {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-xl-0 {
    margin-left: 0;
  }

  .offset-xl-1 {
    margin-left: 8.33333333%;
  }

  .offset-xl-2 {
    margin-left: 16.66666667%;
  }

  .offset-xl-3 {
    margin-left: 25%;
  }

  .offset-xl-4 {
    margin-left: 33.33333333%;
  }

  .offset-xl-5 {
    margin-left: 41.66666667%;
  }

  .offset-xl-6 {
    margin-left: 50%;
  }

  .offset-xl-7 {
    margin-left: 58.33333333%;
  }

  .offset-xl-8 {
    margin-left: 66.66666667%;
  }

  .offset-xl-9 {
    margin-left: 75%;
  }

  .offset-xl-10 {
    margin-left: 83.33333333%;
  }

  .offset-xl-11 {
    margin-left: 91.66666667%;
  }

  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }

  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }

  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }

  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }

  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }

  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }

  .row-cols-xxl-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xxl-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xxl-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xxl-3>* {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-xxl-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xxl-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xxl-6>* {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-xxl-0 {
    margin-left: 0;
  }

  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }

  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }

  .offset-xxl-3 {
    margin-left: 25%;
  }

  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }

  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }

  .offset-xxl-6 {
    margin-left: 50%;
  }

  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }

  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }

  .offset-xxl-9 {
    margin-left: 75%;
  }

  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }

  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }

  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }

  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }

  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }

  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }

  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }

  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}

.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}

.table> :not(caption)>*>* {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}

.table>tbody {
  vertical-align: inherit;
}

.table>thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid var(--bs-gray-500);
}

.caption-top {
  caption-side: top;
}

.table-sm> :not(caption)>*>* {
  padding: 0.25rem 0.25rem;
}

.table-bordered> :not(caption)>* {
  border-width: var(--bs-border-width) 0;
}

.table-bordered> :not(caption)>*>* {
  border-width: 0 var(--bs-border-width);
}

.table-borderless> :not(caption)>*>* {
  border-bottom-width: 0;
}

.table-borderless> :not(:first-child) {
  border-top-width: 0;
}

.table-striped>tbody>tr:nth-of-type(odd)>* {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns> :not(caption)>tr> :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover>tbody>tr:hover>* {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #cfe2ff;
  --bs-table-border-color: #a6b5cc;
  --bs-table-striped-bg: #c5d7f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bacbe6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd1ec;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e2e3e5;
  --bs-table-border-color: #b5b6b7;
  --bs-table-striped-bg: #d7d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cbccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d1d2d4;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #a7b9b1;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #cff4fc;
  --bs-table-border-color: #a6c3ca;
  --bs-table-striped-bg: #c5e8ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #badce3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfe2e9;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #ccc2a4;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #c6acae;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #c6c7c8;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #4d5154;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.8rem + 1px);
  padding-bottom: calc(0.8rem + 1px);
  font-size: 1rem;
}

.col-form-label-sm {
  padding-top: calc(0.4rem + 1px);
  padding-bottom: calc(0.4rem + 1px);
  font-size: 0.8125rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-gray-700);
  appearance: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid var(--bs-gray-400);
  border-radius: 0.4rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}

.form-control[type=file] {
  overflow: hidden;
}

.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control:focus {
  color: var(--bs-gray-700);
  background-color: #fff;
  border-color: #0f6fec;
  outline: 0;
  box-shadow: none;
}

.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}

.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}

.form-control::placeholder {
  color: var(--bs-gray-500);
  opacity: 1;
}

.form-control:disabled {
  background-color: var(--bs-gray-200);
  border-color: var(--bs-border-color);
  opacity: 1;
}

.form-control::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: all 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {

  .form-control::file-selector-button {
    transition: none;
  }
}

.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}

.form-control-plaintext:focus {
  outline: 0;
}

.form-control-plaintext.form-control-sm,
.form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.25em + 0.8rem + 2px);
  padding: 0.4rem 0.8rem;
  font-size: 0.8125rem;
  border-radius: 0.2rem;
}

.form-control-sm::file-selector-button {
  padding: 0.4rem 0.8rem;
  margin: -0.4rem -0.8rem;
  margin-inline-end: 0.8rem;
}

.form-control-lg {
  min-height: calc(1.25em + 1.6rem + 2px);
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  border-radius: 0.2rem;
}

.form-control-lg::file-selector-button {
  padding: 0.8rem 1.5rem;
  margin: -0.8rem -1.5rem;
  margin-inline-end: 1.5rem;
}

textarea.form-control {
  min-height: calc(1.5em + 1rem + 2px);
}

textarea.form-control-sm {
  min-height: calc(1.25em + 0.8rem + 2px);
}

textarea.form-control-lg {
  min-height: calc(1.25em + 1.6rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem;
}

.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.4rem;
}

.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0.4rem;
}

.form-control-color.form-control-sm {
  height: calc(1.25em + 0.8rem + 2px);
}

.form-control-color.form-control-lg {
  height: calc(1.25em + 1.6rem + 2px);
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.5rem 2.25rem 0.5rem 1rem;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-gray-700);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.4rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}

.form-select:focus {
  border-color: #0f6fec;
  outline: 0;
  box-shadow: 0 0 0 0 rgba(15, 111, 236, 0.25);
}

.form-select[multiple],
.form-select[size]:not([size="1"]) {
  padding-right: 1rem;
  background-image: none;
}

.form-select:disabled {
  background-color: var(--bs-secondary-bg);
  border-color: var(--bs-border-color);
}

.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-gray-700);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}

.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-gray-200);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}

.form-check-input[type=radio] {
  border-radius: 50%;
}

.form-check-input:active {
  filter: brightness(90%);
}

.form-check-input:focus {
  border-color: #0f6fec;
  outline: 0;
  box-shadow: 0 0 0 0 rgba(15, 111, 236, 0.25);
}

.form-check-input:checked {
  background-color: #0f6fec;
  border-color: #0f6fec;
}

.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.form-check-input[type=checkbox]:indeterminate {
  background-color: #0f6fec;
  border-color: #0f6fec;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}

.form-check-input[disabled]~.form-check-label,
.form-check-input:disabled~.form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}

.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}

.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}

.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.btn-check[disabled]+.btn,
.btn-check:disabled+.btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}

.form-range:focus {
  outline: 0;
}

.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #eff2f6, none;
}

.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #eff2f6, none;
}

.form-range::-moz-focus-outer {
  border: 0;
}

.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0f6fec;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}

.form-range::-webkit-slider-thumb:active {
  background-color: #b7d4f9;
}

.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}

.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0f6fec;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}

.form-range::-moz-range-thumb:active {
  background-color: #b7d4f9;
}

.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}

.form-range:disabled {
  pointer-events: none;
}

.form-range:disabled::-webkit-slider-thumb {
  background-color: #a1a1a8;
}

.form-range:disabled::-moz-range-thumb {
  background-color: #a1a1a8;
}

.form-floating {
  position: relative;
}

.form-floating>.form-control,
.form-floating>.form-control-plaintext,
.form-floating>.form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}

.form-floating>label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-floating>label {
    transition: none;
  }
}

.form-floating>.form-control,
.form-floating>.form-control-plaintext {
  padding: 1rem 0.75rem;
}

.form-floating>.form-control::placeholder,
.form-floating>.form-control-plaintext::placeholder {
  color: transparent;
}

.form-floating>.form-control:focus,
.form-floating>.form-control:not(:placeholder-shown),
.form-floating>.form-control-plaintext:focus,
.form-floating>.form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating>.form-control:-webkit-autofill,
.form-floating>.form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating>.form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating>.form-control:focus~label,
.form-floating>.form-control:not(:placeholder-shown)~label,
.form-floating>.form-control-plaintext~label,
.form-floating>.form-select~label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating>.form-control:focus~label::after,
.form-floating>.form-control:not(:placeholder-shown)~label::after,
.form-floating>.form-control-plaintext~label::after,
.form-floating>.form-select~label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: #fff;
  border-radius: 0.4rem;
}

.form-floating>.form-control:-webkit-autofill~label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating>.form-control-plaintext~label {
  border-width: 1px 0;
}

.form-floating> :disabled~label,
.form-floating>.form-control:disabled~label {
  color: #6c757d;
}

.form-floating> :disabled~label::after,
.form-floating>.form-control:disabled~label::after {
  background-color: var(--bs-gray-200);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group>.form-control,
.input-group>.form-select,
.input-group>.form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.input-group>.form-control:focus,
.input-group>.form-select:focus,
.input-group>.form-floating:focus-within {
  z-index: 5;
}

.input-group .btn {
  position: relative;
  z-index: 2;
}

.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-gray-700);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-gray-200);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.4rem;
}

.input-group-lg>.form-control,
.input-group-lg>.form-select,
.input-group-lg>.input-group-text,
.input-group-lg>.btn {
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  border-radius: 0.2rem;
}

.input-group-sm>.form-control,
.input-group-sm>.form-select,
.input-group-sm>.input-group-text,
.input-group-sm>.btn {
  padding: 0.4rem 0.8rem;
  font-size: 0.8125rem;
  border-radius: 0.2rem;
}

.input-group-lg>.form-select,
.input-group-sm>.form-select {
  padding-right: 3.25rem;
}

.input-group:not(.has-validation)> :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation)>.dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-control,
.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group.has-validation> :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation>.dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-control,
.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(1px * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group>.form-floating:not(:first-child)>.form-control,
.input-group>.form-floating:not(:first-child)>.form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid~.valid-feedback,
.was-validated :valid~.valid-tooltip,
.is-valid~.valid-feedback,
.is-valid~.valid-tooltip {
  display: block;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid,
.form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}

.was-validated .form-select:valid:not([multiple]):not([size]),
.was-validated .form-select:valid:not([multiple])[size="1"],
.form-select.is-valid:not([multiple]):not([size]),
.form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-select:valid:focus,
.form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid,
.form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid,
.form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}

.was-validated .form-check-input:valid:checked,
.form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}

.was-validated .form-check-input:valid:focus,
.form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-check-input:valid~.form-check-label,
.form-check-input.is-valid~.form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input~.valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group>.form-control:not(:focus):valid,
.input-group>.form-control:not(:focus).is-valid,
.was-validated .input-group>.form-select:not(:focus):valid,
.input-group>.form-select:not(:focus).is-valid,
.was-validated .input-group>.form-floating:not(:focus-within):valid,
.input-group>.form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid~.invalid-feedback,
.was-validated :invalid~.invalid-tooltip,
.is-invalid~.invalid-feedback,
.is-invalid~.invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid,
.form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}

.was-validated .form-select:invalid:not([multiple]):not([size]),
.was-validated .form-select:invalid:not([multiple])[size="1"],
.form-select.is-invalid:not([multiple]):not([size]),
.form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-select:invalid:focus,
.form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid,
.form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid,
.form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}

.was-validated .form-check-input:invalid:checked,
.form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}

.was-validated .form-check-input:invalid:focus,
.form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-check-input:invalid~.form-check-label,
.form-check-input.is-invalid~.form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input~.invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group>.form-control:not(:focus):invalid,
.input-group>.form-control:not(:focus).is-invalid,
.was-validated .input-group>.form-select:not(:focus):invalid,
.input-group>.form-select:not(:focus).is-invalid,
.was-validated .input-group>.form-floating:not(:focus-within):invalid,
.input-group>.form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 1rem;
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.9375rem;
  --bs-btn-font-weight: 500;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.4rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: none;
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0 rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: all 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}

.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}

.btn-check+.btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}

.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:focus-visible+.btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:checked+.btn,
:not(.btn-check)+.btn:active,
.btn:first-child:active,
.btn.active,
.btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}

.btn-check:checked+.btn:focus-visible,
:not(.btn-check)+.btn:active:focus-visible,
.btn:first-child:active:focus-visible,
.btn.active:focus-visible,
.btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn:disabled,
.btn.disabled,
fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0f6fec;
  --bs-btn-border-color: #0f6fec;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d5ec9;
  --bs-btn-hover-border-color: #0c59bd;
  --bs-btn-focus-shadow-rgb: 51, 133, 239;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0c59bd;
  --bs-btn-active-border-color: #0b53b1;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0f6fec;
  --bs-btn-disabled-border-color: #0f6fec;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #14191e;
  --bs-btn-border-color: #14191e;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #11151a;
  --bs-btn-hover-border-color: #101418;
  --bs-btn-focus-shadow-rgb: 55, 60, 64;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #101418;
  --bs-btn-active-border-color: #0f1317;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #14191e;
  --bs-btn-disabled-border-color: #14191e;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0cbc87;
  --bs-btn-border-color: #0cbc87;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0aa073;
  --bs-btn-hover-border-color: #0a966c;
  --bs-btn-focus-shadow-rgb: 48, 198, 153;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a966c;
  --bs-btn-active-border-color: #098d65;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0cbc87;
  --bs-btn-disabled-border-color: #0cbc87;
}

.btn-info {
  --bs-btn-color: #fff;
  --bs-btn-bg: #4f9ef8;
  --bs-btn-border-color: #4f9ef8;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #4386d3;
  --bs-btn-hover-border-color: #3f7ec6;
  --bs-btn-focus-shadow-rgb: 105, 173, 249;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #3f7ec6;
  --bs-btn-active-border-color: #3b77ba;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #4f9ef8;
  --bs-btn-disabled-border-color: #4f9ef8;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #f7c32e;
  --bs-btn-border-color: #f7c32e;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8cc4d;
  --bs-btn-hover-border-color: #f8c943;
  --bs-btn-focus-shadow-rgb: 210, 166, 39;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f9cf58;
  --bs-btn-active-border-color: #f8c943;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f7c32e;
  --bs-btn-disabled-border-color: #f7c32e;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #d6293e;
  --bs-btn-border-color: #d6293e;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #b62335;
  --bs-btn-hover-border-color: #ab2132;
  --bs-btn-focus-shadow-rgb: 220, 73, 91;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ab2132;
  --bs-btn-active-border-color: #a11f2f;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #d6293e;
  --bs-btn-disabled-border-color: #d6293e;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #eef0f2;
  --bs-btn-border-color: #eef0f2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #caccce;
  --bs-btn-hover-border-color: #bec0c2;
  --bs-btn-focus-shadow-rgb: 202, 204, 206;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #bec0c2;
  --bs-btn-active-border-color: #b3b4b6;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #eef0f2;
  --bs-btn-disabled-border-color: #eef0f2;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #14191e;
  --bs-btn-border-color: #14191e;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #373c40;
  --bs-btn-hover-border-color: #2c3035;
  --bs-btn-focus-shadow-rgb: 55, 60, 64;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #43474b;
  --bs-btn-active-border-color: #2c3035;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #14191e;
  --bs-btn-disabled-border-color: #14191e;
}

.btn-outline-primary {
  --bs-btn-color: #0f6fec;
  --bs-btn-border-color: #0f6fec;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0f6fec;
  --bs-btn-hover-border-color: #0f6fec;
  --bs-btn-focus-shadow-rgb: 15, 111, 236;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0f6fec;
  --bs-btn-active-border-color: #0f6fec;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #0f6fec;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0f6fec;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #14191e;
  --bs-btn-border-color: #14191e;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #14191e;
  --bs-btn-hover-border-color: #14191e;
  --bs-btn-focus-shadow-rgb: 20, 25, 30;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #14191e;
  --bs-btn-active-border-color: #14191e;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #14191e;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #14191e;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #0cbc87;
  --bs-btn-border-color: #0cbc87;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0cbc87;
  --bs-btn-hover-border-color: #0cbc87;
  --bs-btn-focus-shadow-rgb: 12, 188, 135;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0cbc87;
  --bs-btn-active-border-color: #0cbc87;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #0cbc87;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0cbc87;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #4f9ef8;
  --bs-btn-border-color: #4f9ef8;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #4f9ef8;
  --bs-btn-hover-border-color: #4f9ef8;
  --bs-btn-focus-shadow-rgb: 79, 158, 248;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4f9ef8;
  --bs-btn-active-border-color: #4f9ef8;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #4f9ef8;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #4f9ef8;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #f7c32e;
  --bs-btn-border-color: #f7c32e;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f7c32e;
  --bs-btn-hover-border-color: #f7c32e;
  --bs-btn-focus-shadow-rgb: 247, 195, 46;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f7c32e;
  --bs-btn-active-border-color: #f7c32e;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #f7c32e;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f7c32e;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #d6293e;
  --bs-btn-border-color: #d6293e;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #d6293e;
  --bs-btn-hover-border-color: #d6293e;
  --bs-btn-focus-shadow-rgb: 214, 41, 62;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #d6293e;
  --bs-btn-active-border-color: #d6293e;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #d6293e;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #d6293e;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #eef0f2;
  --bs-btn-border-color: #eef0f2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #eef0f2;
  --bs-btn-hover-border-color: #eef0f2;
  --bs-btn-focus-shadow-rgb: 238, 240, 242;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #eef0f2;
  --bs-btn-active-border-color: #eef0f2;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #eef0f2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #eef0f2;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #14191e;
  --bs-btn-border-color: #14191e;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #14191e;
  --bs-btn-hover-border-color: #14191e;
  --bs-btn-focus-shadow-rgb: 20, 25, 30;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #14191e;
  --bs-btn-active-border-color: #14191e;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #14191e;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #14191e;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 500;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: var(--bs-gray-400);
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: none;
}

.btn-link:focus-visible {
  color: var(--bs-btn-color);
}

.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg,
.btn-group-lg>.btn {
  --bs-btn-padding-y: 0.8rem;
  --bs-btn-padding-x: 1.5rem;
  --bs-btn-font-size: 1rem;
  --bs-btn-border-radius: 0.2rem;
}

.btn-sm,
.btn-group-sm>.btn {
  --bs-btn-padding-y: 0.4rem;
  --bs-btn-padding-x: 0.8rem;
  --bs-btn-font-size: 0.8125rem;
  --bs-btn-border-radius: 0.2rem;
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}

.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 15rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 1rem;
  --bs-dropdown-spacer: 0;
  --bs-dropdown-font-size: 0.9375rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: #fff;
  --bs-dropdown-border-color: rgba(0, 0, 0, 0.06);
  --bs-dropdown-border-radius: 0.4rem;
  --bs-dropdown-border-width: 1px;
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: rgba(0, 0, 0, 0.1);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0px 20px 30px rgba(83, 88, 93, 0.1), 0px 0px 30px rgba(83, 88, 93, 0.2);
  --bs-dropdown-link-color: var(--bs-gray-600);
  --bs-dropdown-link-hover-color: #0f6fec;
  --bs-dropdown-link-hover-bg: transparent;
  --bs-dropdown-link-active-color: #0f6fec;
  --bs-dropdown-link-active-bg: transparent;
  --bs-dropdown-link-disabled-color: var(--bs-gray-600);
  --bs-dropdown-item-padding-x: 1.2rem;
  --bs-dropdown-item-padding-y: 0.4rem;
  --bs-dropdown-header-color: var(--bs-gray-800);
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}

.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}

.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}

.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }

  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-sm-end {
    --bs-position: end;
  }

  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }

  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-md-end {
    --bs-position: end;
  }

  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }

  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-lg-end {
    --bs-position: end;
  }

  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }

  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xl-end {
    --bs-position: end;
  }

  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }

  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xxl-end {
    --bs-position: end;
  }

  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}

.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}

.dropstart .dropdown-toggle::after {
  display: none;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 500;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}

.dropdown-item.active,
.dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}

.dropdown-item.disabled,
.dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.8203125rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: var(--bs-gray-300);
  --bs-dropdown-bg: var(--bs-gray-800);
  --bs-dropdown-border-color: rgba(0, 0, 0, 0.06);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: var(--bs-gray-300);
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: rgba(255, 255, 255, 0.1);
  --bs-dropdown-link-hover-bg: transparent;
  --bs-dropdown-link-active-color: #0f6fec;
  --bs-dropdown-link-active-bg: transparent;
  --bs-dropdown-link-disabled-color: var(--bs-gray-500);
  --bs-dropdown-header-color: var(--bs-gray-500);
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group>.btn,
.btn-group-vertical>.btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group>.btn-check:checked+.btn,
.btn-group>.btn-check:focus+.btn,
.btn-group>.btn:hover,
.btn-group>.btn:focus,
.btn-group>.btn:active,
.btn-group>.btn.active,
.btn-group-vertical>.btn-check:checked+.btn,
.btn-group-vertical>.btn-check:focus+.btn,
.btn-group-vertical>.btn:hover,
.btn-group-vertical>.btn:focus,
.btn-group-vertical>.btn:active,
.btn-group-vertical>.btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.4rem;
}

.btn-group> :not(.btn-check:first-child)+.btn,
.btn-group>.btn-group:not(:first-child) {
  margin-left: calc(1px * -1);
}

.btn-group>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group>.btn.dropdown-toggle-split:first-child,
.btn-group>.btn-group:not(:last-child)>.btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group>.btn:nth-child(n+3),
.btn-group> :not(.btn-check)+.btn,
.btn-group>.btn-group:not(:first-child)>.btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after,
.dropend .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm+.dropdown-toggle-split,
.btn-group-sm>.btn+.dropdown-toggle-split {
  padding-right: 0.6rem;
  padding-left: 0.6rem;
}

.btn-lg+.dropdown-toggle-split,
.btn-group-lg>.btn+.dropdown-toggle-split {
  padding-right: 1.125rem;
  padding-left: 1.125rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical>.btn,
.btn-group-vertical>.btn-group {
  width: 100%;
}

.btn-group-vertical>.btn:not(:first-child),
.btn-group-vertical>.btn-group:not(:first-child) {
  margin-top: calc(1px * -1);
}

.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical>.btn-group:not(:last-child)>.btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical>.btn~.btn,
.btn-group-vertical>.btn-group:not(:first-child)>.btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 0.75rem;
  --bs-nav-link-padding-y: 0.25rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-body-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-gray-500) !important;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}

.nav-link:hover,
.nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}

.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.nav-link.disabled,
.nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: 1px;
  --bs-nav-tabs-border-color: rgba(0, 0, 0, 0.1);
  --bs-nav-tabs-border-radius: 0.4rem;
  --bs-nav-tabs-link-hover-border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1);
  --bs-nav-tabs-link-active-color: #29292e;
  --bs-nav-tabs-link-active-bg: #eff2f6;
  --bs-nav-tabs-link-active-border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) #eff2f6;
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}

.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}

.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 0.4rem;
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}

.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}

.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}

.nav-underline .nav-link:hover,
.nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}

.nav-underline .nav-link.active,
.nav-underline .show>.nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill>.nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified>.nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content>.tab-pane {
  display: none;
}

.tab-content>.active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0;
  --bs-navbar-color: var(--bs-gray-600);
  --bs-navbar-hover-color: #0f6fec;
  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --bs-navbar-active-color: #0f6fec;
  --bs-navbar-brand-padding-y: 10px;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 1rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}

.navbar>.container,
.navbar>.container-fluid,
.navbar>.container-sm,
.navbar>.container-md,
.navbar>.container-lg,
.navbar>.container-xl,
.navbar>.container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap;
}

.navbar-brand:hover,
.navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.25rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link.active,
.navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}

.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  color: var(--bs-navbar-color);
}

.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}

@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}

.navbar-toggler:hover {
  text-decoration: none;
}

.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-sm .navbar-toggler {
    display: none;
  }

  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-md .navbar-toggler {
    display: none;
  }

  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-lg .navbar-toggler {
    display: none;
  }

  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xl .navbar-toggler {
    display: none;
  }

  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }

  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}

.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}

.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}

.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: #fff;
  --bs-navbar-hover-color: #0f6fec !important;
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #0f6fec !important;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1.25rem;
  --bs-card-spacer-x: 1.25rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: var(--bs-heading-color);
  --bs-card-subtitle-color: ;
  --bs-card-border-width: 1px;
  --bs-card-border-color: rgba(0, 0, 0, 0.09);
  --bs-card-border-radius: 0.4rem;
  --bs-card-box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.04);
  --bs-card-inner-border-radius: calc(0.4rem - 1px);
  --bs-card-cap-padding-y: 1.25rem;
  --bs-card-cap-padding-x: 1.25rem;
  --bs-card-cap-bg: #fff;
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: #fff;
  --bs-card-img-overlay-padding: 1.25rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}

.card>hr {
  margin-right: 0;
  margin-left: 0;
}

.card>.list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card>.list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card>.list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card>.card-header+.list-group,
.card>.list-group+.card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link+.card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}

.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group>.card {
  margin-bottom: var(--bs-card-group-margin);
}

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }

  .card-group>.card {
    flex: 1 0;
    margin-bottom: 0;
  }

  .card-group>.card+.card {
    margin-left: 0;
    border-left: 0;
  }

  .card-group>.card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .card-group>.card:not(:last-child) .card-img-top,
  .card-group>.card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }

  .card-group>.card:not(:last-child) .card-img-bottom,
  .card-group>.card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }

  .card-group>.card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .card-group>.card:not(:first-child) .card-img-top,
  .card-group>.card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }

  .card-group>.card:not(:first-child) .card-img-bottom,
  .card-group>.card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: #676a79;
  --bs-accordion-bg: #fff;
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: rgba(103, 106, 121, 0.125);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-border-color: none;
  --bs-accordion-btn-focus-box-shadow: none;
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: #0e64d4;
  --bs-accordion-active-bg: #e7f1fd;
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.9375rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}

.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}

.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}

.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}

.accordion-button:hover {
  z-index: 2;
}

.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}

.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}

.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:not(:first-of-type) {
  border-top: 0;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}

.accordion-flush .accordion-item:first-child {
  border-top: 0;
}

.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}

.accordion-flush .accordion-item .accordion-button,
.accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0.5rem;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: transparent;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-gray-500);
  --bs-breadcrumb-item-padding-x: 0.8rem;
  --bs-breadcrumb-item-active-color: var(--bs-gray-500);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item+.breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}

.breadcrumb-item+.breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/")
    /* rtl: var(--bs-breadcrumb-divider, "/") */
  ;
}

.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.8rem;
  --bs-pagination-padding-y: 0.4rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-gray-600);
  --bs-pagination-bg: #fff;
  --bs-pagination-border-width: 1px;
  --bs-pagination-border-color: var(--bs-gray-300);
  --bs-pagination-border-radius: 0.4rem;
  --bs-pagination-hover-color: #fff;
  --bs-pagination-hover-bg: #0f6fec;
  --bs-pagination-hover-border-color: #0f6fec;
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-gray-200);
  --bs-pagination-focus-box-shadow: 0 0 0 0 rgba(15, 111, 236, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0f6fec;
  --bs-pagination-active-border-color: #0f6fec;
  --bs-pagination-disabled-color: var(--bs-gray-400);
  --bs-pagination-disabled-bg: #fff;
  --bs-pagination-disabled-border-color: var(--bs-gray-300);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}

.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}

.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}

.page-link.active,
.active>.page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}

.page-link.disabled,
.disabled>.page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}

.page-item .page-link {
  border-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.171875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.8203125rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.85em;
  --bs-badge-font-weight: 400;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}

.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}

.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: rgba(0, 0, 0, 0.1);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked>.progress {
  overflow: visible;
}

.progress-stacked>.progress>.progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-gray-600);
  --bs-list-group-bg: transparent;
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: 0.4rem;
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-gray-700);
  --bs-list-group-action-hover-bg: var(--bs-light);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-light);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0f6fec;
  --bs-list-group-active-border-color: #0f6fec;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}

.list-group-numbered>.list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}

.list-group-item-action:hover,
.list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}

.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled,
.list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}

.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}

.list-group-item+.list-group-item {
  border-top-width: 0;
}

.list-group-item+.list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal>.list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}

.list-group-horizontal>.list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}

.list-group-horizontal>.list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal>.list-group-item+.list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}

.list-group-horizontal>.list-group-item+.list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }

  .list-group-horizontal-sm>.list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  .list-group-horizontal-sm>.list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-sm>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-sm>.list-group-item+.list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }

  .list-group-horizontal-sm>.list-group-item+.list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }

  .list-group-horizontal-md>.list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  .list-group-horizontal-md>.list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-md>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-md>.list-group-item+.list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }

  .list-group-horizontal-md>.list-group-item+.list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }

  .list-group-horizontal-lg>.list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  .list-group-horizontal-lg>.list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-lg>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-lg>.list-group-item+.list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }

  .list-group-horizontal-lg>.list-group-item+.list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }

  .list-group-horizontal-xl>.list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  .list-group-horizontal-xl>.list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-xl>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-xl>.list-group-item+.list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }

  .list-group-horizontal-xl>.list-group-item+.list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}

@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }

  .list-group-horizontal-xxl>.list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  .list-group-horizontal-xxl>.list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-xxl>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-xxl>.list-group-item+.list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }

  .list-group-horizontal-xxl>.list-group-item+.list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}

.list-group-flush {
  border-radius: 0;
}

.list-group-flush>.list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}

.list-group-flush>.list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0 rgba(15, 111, 236, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.4rem;
  opacity: var(--bs-btn-close-opacity);
}

.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}

.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}

.btn-close:disabled,
.btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}

.toast.showing {
  opacity: 0;
}

.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}

.toast-container> :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}

.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: #fff;
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: 0;
  --bs-modal-border-radius: 0.4rem;
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: 0.4rem;
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}

.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}

.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}

.modal-footer>* {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }

  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }

  .modal-sm {
    --bs-modal-width: 300px;
  }
}

@media (min-width: 992px) {

  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}

@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}

.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}

.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}

.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}

.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.75rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}

.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}

.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}

.bs-tooltip-top .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-end .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}

.bs-tooltip-bottom .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-start .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-white);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}

.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}

.popover .popover-arrow::before,
.popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top>.popover-arrow,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-top>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before,
.bs-popover-top>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-top>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}

.bs-popover-top>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end>.popover-arrow,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-end>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before,
.bs-popover-end>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-end>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}

.bs-popover-end>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom>.popover-arrow,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-bottom>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before,
.bs-popover-bottom>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-bottom>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}

.bs-popover-bottom>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}

.bs-popover-bottom .popover-header::before,
.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start>.popover-arrow,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-start>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before,
.bs-popover-start>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-start>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}

.bs-popover-start>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {

  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {

  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}

.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}

.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}

.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}

.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon,
[data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}

[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target],
[data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}

[data-bs-theme=dark] .carousel .carousel-caption,
[data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg)
      /* rtl:ignore */
    ;
  }
}

.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }

  50% {
    opacity: 1;
    transform: none;
  }
}

.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {

  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}

.offcanvas,
.offcanvas-xxl,
.offcanvas-xl,
.offcanvas-lg,
.offcanvas-md,
.offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1.5rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: #fff;
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: rgba(0, 0, 0, 0.1);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}

@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}

@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}

@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}

@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}

@media (max-width: 575.98px) {

  .offcanvas-sm.showing,
  .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
}

@media (max-width: 575.98px) {

  .offcanvas-sm.showing,
  .offcanvas-sm.hiding,
  .offcanvas-sm.show {
    visibility: visible;
  }
}

@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-sm .offcanvas-header {
    display: none;
  }

  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}

@media (max-width: 767.98px) {

  .offcanvas-md.showing,
  .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
}

@media (max-width: 767.98px) {

  .offcanvas-md.showing,
  .offcanvas-md.hiding,
  .offcanvas-md.show {
    visibility: visible;
  }
}

@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-md .offcanvas-header {
    display: none;
  }

  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}

@media (max-width: 991.98px) {

  .offcanvas-lg.showing,
  .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
}

@media (max-width: 991.98px) {

  .offcanvas-lg.showing,
  .offcanvas-lg.hiding,
  .offcanvas-lg.show {
    visibility: visible;
  }
}

@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-lg .offcanvas-header {
    display: none;
  }

  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}

@media (max-width: 1199.98px) {

  .offcanvas-xl.showing,
  .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
}

@media (max-width: 1199.98px) {

  .offcanvas-xl.showing,
  .offcanvas-xl.hiding,
  .offcanvas-xl.show {
    visibility: visible;
  }
}

@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-xl .offcanvas-header {
    display: none;
  }

  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}

@media (max-width: 1399.98px) {

  .offcanvas-xxl.showing,
  .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
}

@media (max-width: 1399.98px) {

  .offcanvas-xxl.showing,
  .offcanvas-xxl.hiding,
  .offcanvas-xxl.show {
    visibility: visible;
  }
}

@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-xxl .offcanvas-header {
    display: none;
  }

  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}

@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}

.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}

.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}

.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}

.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}

.offcanvas.showing,
.offcanvas.show:not(.hiding) {
  transform: none;
}

.offcanvas.showing,
.offcanvas.hiding,
.offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.offcanvas-backdrop.fade {
  opacity: 0;
}

.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}

.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}

.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}

.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary:hover,
.link-primary:focus {
  color: RGBA(12, 89, 189, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(12, 89, 189, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary:hover,
.link-secondary:focus {
  color: RGBA(16, 20, 24, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(16, 20, 24, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-success:hover,
.link-success:focus {
  color: RGBA(10, 150, 108, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 150, 108, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-info:hover,
.link-info:focus {
  color: RGBA(63, 126, 198, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(63, 126, 198, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning:hover,
.link-warning:focus {
  color: RGBA(249, 207, 88, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 207, 88, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger:hover,
.link-danger:focus {
  color: RGBA(171, 33, 50, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(171, 33, 50, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-light:hover,
.link-light:focus {
  color: RGBA(241, 243, 245, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(241, 243, 245, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark:hover,
.link-dark:focus {
  color: RGBA(16, 20, 24, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(16, 20, 24, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis:hover,
.link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}

.icon-link>.bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}

@media (prefers-reduced-motion: reduce) {
  .icon-link>.bi {
    transition: none;
  }
}

.icon-link-hover:hover>.bi,
.icon-link-hover:focus-visible>.bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}

.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}

.ratio>* {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.5rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.5rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.5rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.5rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.359375rem + 1.3125vw) !important;
}

.fs-2 {
  font-size: calc(1.3125rem + 0.75vw) !important;
}

.fs-3 {
  font-size: calc(1.2890625rem + 0.46875vw) !important;
}

.fs-4 {
  font-size: calc(1.265625rem + 0.1875vw) !important;
}

.fs-5 {
  font-size: 1.171875rem !important;
}

.fs-6 {
  font-size: 0.9375rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 400 !important;
}

.fw-normal {
  font-weight: 500 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
  user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
  user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }

  .float-sm-end {
    float: right !important;
  }

  .float-sm-none {
    float: none !important;
  }

  .object-fit-sm-contain {
    object-fit: contain !important;
  }

  .object-fit-sm-cover {
    object-fit: cover !important;
  }

  .object-fit-sm-fill {
    object-fit: fill !important;
  }

  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }

  .object-fit-sm-none {
    object-fit: none !important;
  }

  .d-sm-inline {
    display: inline !important;
  }

  .d-sm-inline-block {
    display: inline-block !important;
  }

  .d-sm-block {
    display: block !important;
  }

  .d-sm-grid {
    display: grid !important;
  }

  .d-sm-inline-grid {
    display: inline-grid !important;
  }

  .d-sm-table {
    display: table !important;
  }

  .d-sm-table-row {
    display: table-row !important;
  }

  .d-sm-table-cell {
    display: table-cell !important;
  }

  .d-sm-flex {
    display: flex !important;
  }

  .d-sm-inline-flex {
    display: inline-flex !important;
  }

  .d-sm-none {
    display: none !important;
  }

  .flex-sm-fill {
    flex: 1 1 auto !important;
  }

  .flex-sm-row {
    flex-direction: row !important;
  }

  .flex-sm-column {
    flex-direction: column !important;
  }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-sm-start {
    justify-content: flex-start !important;
  }

  .justify-content-sm-end {
    justify-content: flex-end !important;
  }

  .justify-content-sm-center {
    justify-content: center !important;
  }

  .justify-content-sm-between {
    justify-content: space-between !important;
  }

  .justify-content-sm-around {
    justify-content: space-around !important;
  }

  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-sm-start {
    align-items: flex-start !important;
  }

  .align-items-sm-end {
    align-items: flex-end !important;
  }

  .align-items-sm-center {
    align-items: center !important;
  }

  .align-items-sm-baseline {
    align-items: baseline !important;
  }

  .align-items-sm-stretch {
    align-items: stretch !important;
  }

  .align-content-sm-start {
    align-content: flex-start !important;
  }

  .align-content-sm-end {
    align-content: flex-end !important;
  }

  .align-content-sm-center {
    align-content: center !important;
  }

  .align-content-sm-between {
    align-content: space-between !important;
  }

  .align-content-sm-around {
    align-content: space-around !important;
  }

  .align-content-sm-stretch {
    align-content: stretch !important;
  }

  .align-self-sm-auto {
    align-self: auto !important;
  }

  .align-self-sm-start {
    align-self: flex-start !important;
  }

  .align-self-sm-end {
    align-self: flex-end !important;
  }

  .align-self-sm-center {
    align-self: center !important;
  }

  .align-self-sm-baseline {
    align-self: baseline !important;
  }

  .align-self-sm-stretch {
    align-self: stretch !important;
  }

  .order-sm-first {
    order: -1 !important;
  }

  .order-sm-0 {
    order: 0 !important;
  }

  .order-sm-1 {
    order: 1 !important;
  }

  .order-sm-2 {
    order: 2 !important;
  }

  .order-sm-3 {
    order: 3 !important;
  }

  .order-sm-4 {
    order: 4 !important;
  }

  .order-sm-5 {
    order: 5 !important;
  }

  .order-sm-last {
    order: 6 !important;
  }

  .m-sm-0 {
    margin: 0 !important;
  }

  .m-sm-1 {
    margin: 0.25rem !important;
  }

  .m-sm-2 {
    margin: 0.5rem !important;
  }

  .m-sm-3 {
    margin: 1rem !important;
  }

  .m-sm-4 {
    margin: 1.5rem !important;
  }

  .m-sm-5 {
    margin: 3rem !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-sm-0 {
    margin-top: 0 !important;
  }

  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }

  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }

  .mt-sm-3 {
    margin-top: 1rem !important;
  }

  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }

  .mt-sm-5 {
    margin-top: 3rem !important;
  }

  .mt-sm-auto {
    margin-top: auto !important;
  }

  .me-sm-0 {
    margin-right: 0 !important;
  }

  .me-sm-1 {
    margin-right: 0.25rem !important;
  }

  .me-sm-2 {
    margin-right: 0.5rem !important;
  }

  .me-sm-3 {
    margin-right: 1rem !important;
  }

  .me-sm-4 {
    margin-right: 1.5rem !important;
  }

  .me-sm-5 {
    margin-right: 3rem !important;
  }

  .me-sm-auto {
    margin-right: auto !important;
  }

  .mb-sm-0 {
    margin-bottom: 0 !important;
  }

  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }

  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }

  .mb-sm-auto {
    margin-bottom: auto !important;
  }

  .ms-sm-0 {
    margin-left: 0 !important;
  }

  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }

  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }

  .ms-sm-3 {
    margin-left: 1rem !important;
  }

  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }

  .ms-sm-5 {
    margin-left: 3rem !important;
  }

  .ms-sm-auto {
    margin-left: auto !important;
  }

  .m-sm-n1 {
    margin: -0.25rem !important;
  }

  .m-sm-n2 {
    margin: -0.5rem !important;
  }

  .m-sm-n3 {
    margin: -1rem !important;
  }

  .m-sm-n4 {
    margin: -1.5rem !important;
  }

  .m-sm-n5 {
    margin: -3rem !important;
  }

  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-sm-n3 {
    margin-top: -1rem !important;
  }

  .mt-sm-n4 {
    margin-top: -1.5rem !important;
  }

  .mt-sm-n5 {
    margin-top: -3rem !important;
  }

  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }

  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }

  .me-sm-n3 {
    margin-right: -1rem !important;
  }

  .me-sm-n4 {
    margin-right: -1.5rem !important;
  }

  .me-sm-n5 {
    margin-right: -3rem !important;
  }

  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }

  .mb-sm-n4 {
    margin-bottom: -1.5rem !important;
  }

  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }

  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-sm-n3 {
    margin-left: -1rem !important;
  }

  .ms-sm-n4 {
    margin-left: -1.5rem !important;
  }

  .ms-sm-n5 {
    margin-left: -3rem !important;
  }

  .p-sm-0 {
    padding: 0 !important;
  }

  .p-sm-1 {
    padding: 0.25rem !important;
  }

  .p-sm-2 {
    padding: 0.5rem !important;
  }

  .p-sm-3 {
    padding: 1rem !important;
  }

  .p-sm-4 {
    padding: 1.5rem !important;
  }

  .p-sm-5 {
    padding: 3rem !important;
  }

  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-sm-0 {
    padding-top: 0 !important;
  }

  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }

  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }

  .pt-sm-3 {
    padding-top: 1rem !important;
  }

  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }

  .pt-sm-5 {
    padding-top: 3rem !important;
  }

  .pe-sm-0 {
    padding-right: 0 !important;
  }

  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }

  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }

  .pe-sm-3 {
    padding-right: 1rem !important;
  }

  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }

  .pe-sm-5 {
    padding-right: 3rem !important;
  }

  .pb-sm-0 {
    padding-bottom: 0 !important;
  }

  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }

  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }

  .ps-sm-0 {
    padding-left: 0 !important;
  }

  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }

  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }

  .ps-sm-3 {
    padding-left: 1rem !important;
  }

  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }

  .ps-sm-5 {
    padding-left: 3rem !important;
  }

  .gap-sm-0 {
    gap: 0 !important;
  }

  .gap-sm-1 {
    gap: 0.25rem !important;
  }

  .gap-sm-2 {
    gap: 0.5rem !important;
  }

  .gap-sm-3 {
    gap: 1rem !important;
  }

  .gap-sm-4 {
    gap: 1.5rem !important;
  }

  .gap-sm-5 {
    gap: 3rem !important;
  }

  .row-gap-sm-0 {
    row-gap: 0 !important;
  }

  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }

  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }

  .column-gap-sm-0 {
    column-gap: 0 !important;
  }

  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }

  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }

  .text-sm-start {
    text-align: left !important;
  }

  .text-sm-end {
    text-align: right !important;
  }

  .text-sm-center {
    text-align: center !important;
  }
}

@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }

  .float-md-end {
    float: right !important;
  }

  .float-md-none {
    float: none !important;
  }

  .object-fit-md-contain {
    object-fit: contain !important;
  }

  .object-fit-md-cover {
    object-fit: cover !important;
  }

  .object-fit-md-fill {
    object-fit: fill !important;
  }

  .object-fit-md-scale {
    object-fit: scale-down !important;
  }

  .object-fit-md-none {
    object-fit: none !important;
  }

  .d-md-inline {
    display: inline !important;
  }

  .d-md-inline-block {
    display: inline-block !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-grid {
    display: grid !important;
  }

  .d-md-inline-grid {
    display: inline-grid !important;
  }

  .d-md-table {
    display: table !important;
  }

  .d-md-table-row {
    display: table-row !important;
  }

  .d-md-table-cell {
    display: table-cell !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .d-md-inline-flex {
    display: inline-flex !important;
  }

  .d-md-none {
    display: none !important;
  }

  .flex-md-fill {
    flex: 1 1 auto !important;
  }

  .flex-md-row {
    flex-direction: row !important;
  }

  .flex-md-column {
    flex-direction: column !important;
  }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-md-wrap {
    flex-wrap: wrap !important;
  }

  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-md-start {
    justify-content: flex-start !important;
  }

  .justify-content-md-end {
    justify-content: flex-end !important;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  .justify-content-md-between {
    justify-content: space-between !important;
  }

  .justify-content-md-around {
    justify-content: space-around !important;
  }

  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-md-start {
    align-items: flex-start !important;
  }

  .align-items-md-end {
    align-items: flex-end !important;
  }

  .align-items-md-center {
    align-items: center !important;
  }

  .align-items-md-baseline {
    align-items: baseline !important;
  }

  .align-items-md-stretch {
    align-items: stretch !important;
  }

  .align-content-md-start {
    align-content: flex-start !important;
  }

  .align-content-md-end {
    align-content: flex-end !important;
  }

  .align-content-md-center {
    align-content: center !important;
  }

  .align-content-md-between {
    align-content: space-between !important;
  }

  .align-content-md-around {
    align-content: space-around !important;
  }

  .align-content-md-stretch {
    align-content: stretch !important;
  }

  .align-self-md-auto {
    align-self: auto !important;
  }

  .align-self-md-start {
    align-self: flex-start !important;
  }

  .align-self-md-end {
    align-self: flex-end !important;
  }

  .align-self-md-center {
    align-self: center !important;
  }

  .align-self-md-baseline {
    align-self: baseline !important;
  }

  .align-self-md-stretch {
    align-self: stretch !important;
  }

  .order-md-first {
    order: -1 !important;
  }

  .order-md-0 {
    order: 0 !important;
  }

  .order-md-1 {
    order: 1 !important;
  }

  .order-md-2 {
    order: 2 !important;
  }

  .order-md-3 {
    order: 3 !important;
  }

  .order-md-4 {
    order: 4 !important;
  }

  .order-md-5 {
    order: 5 !important;
  }

  .order-md-last {
    order: 6 !important;
  }

  .m-md-0 {
    margin: 0 !important;
  }

  .m-md-1 {
    margin: 0.25rem !important;
  }

  .m-md-2 {
    margin: 0.5rem !important;
  }

  .m-md-3 {
    margin: 1rem !important;
  }

  .m-md-4 {
    margin: 1.5rem !important;
  }

  .m-md-5 {
    margin: 3rem !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-md-0 {
    margin-top: 0 !important;
  }

  .mt-md-1 {
    margin-top: 0.25rem !important;
  }

  .mt-md-2 {
    margin-top: 0.5rem !important;
  }

  .mt-md-3 {
    margin-top: 1rem !important;
  }

  .mt-md-4 {
    margin-top: 1.5rem !important;
  }

  .mt-md-5 {
    margin-top: 3rem !important;
  }

  .mt-md-auto {
    margin-top: auto !important;
  }

  .me-md-0 {
    margin-right: 0 !important;
  }

  .me-md-1 {
    margin-right: 0.25rem !important;
  }

  .me-md-2 {
    margin-right: 0.5rem !important;
  }

  .me-md-3 {
    margin-right: 1rem !important;
  }

  .me-md-4 {
    margin-right: 1.5rem !important;
  }

  .me-md-5 {
    margin-right: 3rem !important;
  }

  .me-md-auto {
    margin-right: auto !important;
  }

  .mb-md-0 {
    margin-bottom: 0 !important;
  }

  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-md-3 {
    margin-bottom: 1rem !important;
  }

  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-md-5 {
    margin-bottom: 3rem !important;
  }

  .mb-md-auto {
    margin-bottom: auto !important;
  }

  .ms-md-0 {
    margin-left: 0 !important;
  }

  .ms-md-1 {
    margin-left: 0.25rem !important;
  }

  .ms-md-2 {
    margin-left: 0.5rem !important;
  }

  .ms-md-3 {
    margin-left: 1rem !important;
  }

  .ms-md-4 {
    margin-left: 1.5rem !important;
  }

  .ms-md-5 {
    margin-left: 3rem !important;
  }

  .ms-md-auto {
    margin-left: auto !important;
  }

  .m-md-n1 {
    margin: -0.25rem !important;
  }

  .m-md-n2 {
    margin: -0.5rem !important;
  }

  .m-md-n3 {
    margin: -1rem !important;
  }

  .m-md-n4 {
    margin: -1.5rem !important;
  }

  .m-md-n5 {
    margin: -3rem !important;
  }

  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-md-n3 {
    margin-top: -1rem !important;
  }

  .mt-md-n4 {
    margin-top: -1.5rem !important;
  }

  .mt-md-n5 {
    margin-top: -3rem !important;
  }

  .me-md-n1 {
    margin-right: -0.25rem !important;
  }

  .me-md-n2 {
    margin-right: -0.5rem !important;
  }

  .me-md-n3 {
    margin-right: -1rem !important;
  }

  .me-md-n4 {
    margin-right: -1.5rem !important;
  }

  .me-md-n5 {
    margin-right: -3rem !important;
  }

  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }

  .mb-md-n4 {
    margin-bottom: -1.5rem !important;
  }

  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }

  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-md-n3 {
    margin-left: -1rem !important;
  }

  .ms-md-n4 {
    margin-left: -1.5rem !important;
  }

  .ms-md-n5 {
    margin-left: -3rem !important;
  }

  .p-md-0 {
    padding: 0 !important;
  }

  .p-md-1 {
    padding: 0.25rem !important;
  }

  .p-md-2 {
    padding: 0.5rem !important;
  }

  .p-md-3 {
    padding: 1rem !important;
  }

  .p-md-4 {
    padding: 1.5rem !important;
  }

  .p-md-5 {
    padding: 3rem !important;
  }

  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-md-0 {
    padding-top: 0 !important;
  }

  .pt-md-1 {
    padding-top: 0.25rem !important;
  }

  .pt-md-2 {
    padding-top: 0.5rem !important;
  }

  .pt-md-3 {
    padding-top: 1rem !important;
  }

  .pt-md-4 {
    padding-top: 1.5rem !important;
  }

  .pt-md-5 {
    padding-top: 3rem !important;
  }

  .pe-md-0 {
    padding-right: 0 !important;
  }

  .pe-md-1 {
    padding-right: 0.25rem !important;
  }

  .pe-md-2 {
    padding-right: 0.5rem !important;
  }

  .pe-md-3 {
    padding-right: 1rem !important;
  }

  .pe-md-4 {
    padding-right: 1.5rem !important;
  }

  .pe-md-5 {
    padding-right: 3rem !important;
  }

  .pb-md-0 {
    padding-bottom: 0 !important;
  }

  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-md-3 {
    padding-bottom: 1rem !important;
  }

  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-md-5 {
    padding-bottom: 3rem !important;
  }

  .ps-md-0 {
    padding-left: 0 !important;
  }

  .ps-md-1 {
    padding-left: 0.25rem !important;
  }

  .ps-md-2 {
    padding-left: 0.5rem !important;
  }

  .ps-md-3 {
    padding-left: 1rem !important;
  }

  .ps-md-4 {
    padding-left: 1.5rem !important;
  }

  .ps-md-5 {
    padding-left: 3rem !important;
  }

  .gap-md-0 {
    gap: 0 !important;
  }

  .gap-md-1 {
    gap: 0.25rem !important;
  }

  .gap-md-2 {
    gap: 0.5rem !important;
  }

  .gap-md-3 {
    gap: 1rem !important;
  }

  .gap-md-4 {
    gap: 1.5rem !important;
  }

  .gap-md-5 {
    gap: 3rem !important;
  }

  .row-gap-md-0 {
    row-gap: 0 !important;
  }

  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-md-3 {
    row-gap: 1rem !important;
  }

  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-md-5 {
    row-gap: 3rem !important;
  }

  .column-gap-md-0 {
    column-gap: 0 !important;
  }

  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-md-3 {
    column-gap: 1rem !important;
  }

  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-md-5 {
    column-gap: 3rem !important;
  }

  .text-md-start {
    text-align: left !important;
  }

  .text-md-end {
    text-align: right !important;
  }

  .text-md-center {
    text-align: center !important;
  }
}

@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }

  .float-lg-end {
    float: right !important;
  }

  .float-lg-none {
    float: none !important;
  }

  .object-fit-lg-contain {
    object-fit: contain !important;
  }

  .object-fit-lg-cover {
    object-fit: cover !important;
  }

  .object-fit-lg-fill {
    object-fit: fill !important;
  }

  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }

  .object-fit-lg-none {
    object-fit: none !important;
  }

  .d-lg-inline {
    display: inline !important;
  }

  .d-lg-inline-block {
    display: inline-block !important;
  }

  .d-lg-block {
    display: block !important;
  }

  .d-lg-grid {
    display: grid !important;
  }

  .d-lg-inline-grid {
    display: inline-grid !important;
  }

  .d-lg-table {
    display: table !important;
  }

  .d-lg-table-row {
    display: table-row !important;
  }

  .d-lg-table-cell {
    display: table-cell !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-inline-flex {
    display: inline-flex !important;
  }

  .d-lg-none {
    display: none !important;
  }

  .flex-lg-fill {
    flex: 1 1 auto !important;
  }

  .flex-lg-row {
    flex-direction: row !important;
  }

  .flex-lg-column {
    flex-direction: column !important;
  }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-lg-start {
    justify-content: flex-start !important;
  }

  .justify-content-lg-end {
    justify-content: flex-end !important;
  }

  .justify-content-lg-center {
    justify-content: center !important;
  }

  .justify-content-lg-between {
    justify-content: space-between !important;
  }

  .justify-content-lg-around {
    justify-content: space-around !important;
  }

  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-lg-start {
    align-items: flex-start !important;
  }

  .align-items-lg-end {
    align-items: flex-end !important;
  }

  .align-items-lg-center {
    align-items: center !important;
  }

  .align-items-lg-baseline {
    align-items: baseline !important;
  }

  .align-items-lg-stretch {
    align-items: stretch !important;
  }

  .align-content-lg-start {
    align-content: flex-start !important;
  }

  .align-content-lg-end {
    align-content: flex-end !important;
  }

  .align-content-lg-center {
    align-content: center !important;
  }

  .align-content-lg-between {
    align-content: space-between !important;
  }

  .align-content-lg-around {
    align-content: space-around !important;
  }

  .align-content-lg-stretch {
    align-content: stretch !important;
  }

  .align-self-lg-auto {
    align-self: auto !important;
  }

  .align-self-lg-start {
    align-self: flex-start !important;
  }

  .align-self-lg-end {
    align-self: flex-end !important;
  }

  .align-self-lg-center {
    align-self: center !important;
  }

  .align-self-lg-baseline {
    align-self: baseline !important;
  }

  .align-self-lg-stretch {
    align-self: stretch !important;
  }

  .order-lg-first {
    order: -1 !important;
  }

  .order-lg-0 {
    order: 0 !important;
  }

  .order-lg-1 {
    order: 1 !important;
  }

  .order-lg-2 {
    order: 2 !important;
  }

  .order-lg-3 {
    order: 3 !important;
  }

  .order-lg-4 {
    order: 4 !important;
  }

  .order-lg-5 {
    order: 5 !important;
  }

  .order-lg-last {
    order: 6 !important;
  }

  .m-lg-0 {
    margin: 0 !important;
  }

  .m-lg-1 {
    margin: 0.25rem !important;
  }

  .m-lg-2 {
    margin: 0.5rem !important;
  }

  .m-lg-3 {
    margin: 1rem !important;
  }

  .m-lg-4 {
    margin: 1.5rem !important;
  }

  .m-lg-5 {
    margin: 3rem !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-lg-0 {
    margin-top: 0 !important;
  }

  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }

  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }

  .mt-lg-3 {
    margin-top: 1rem !important;
  }

  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }

  .mt-lg-5 {
    margin-top: 3rem !important;
  }

  .mt-lg-auto {
    margin-top: auto !important;
  }

  .me-lg-0 {
    margin-right: 0 !important;
  }

  .me-lg-1 {
    margin-right: 0.25rem !important;
  }

  .me-lg-2 {
    margin-right: 0.5rem !important;
  }

  .me-lg-3 {
    margin-right: 1rem !important;
  }

  .me-lg-4 {
    margin-right: 1.5rem !important;
  }

  .me-lg-5 {
    margin-right: 3rem !important;
  }

  .me-lg-auto {
    margin-right: auto !important;
  }

  .mb-lg-0 {
    margin-bottom: 0 !important;
  }

  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }

  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }

  .mb-lg-auto {
    margin-bottom: auto !important;
  }

  .ms-lg-0 {
    margin-left: 0 !important;
  }

  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }

  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }

  .ms-lg-3 {
    margin-left: 1rem !important;
  }

  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }

  .ms-lg-5 {
    margin-left: 3rem !important;
  }

  .ms-lg-auto {
    margin-left: auto !important;
  }

  .m-lg-n1 {
    margin: -0.25rem !important;
  }

  .m-lg-n2 {
    margin: -0.5rem !important;
  }

  .m-lg-n3 {
    margin: -1rem !important;
  }

  .m-lg-n4 {
    margin: -1.5rem !important;
  }

  .m-lg-n5 {
    margin: -3rem !important;
  }

  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-lg-n3 {
    margin-top: -1rem !important;
  }

  .mt-lg-n4 {
    margin-top: -1.5rem !important;
  }

  .mt-lg-n5 {
    margin-top: -3rem !important;
  }

  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }

  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }

  .me-lg-n3 {
    margin-right: -1rem !important;
  }

  .me-lg-n4 {
    margin-right: -1.5rem !important;
  }

  .me-lg-n5 {
    margin-right: -3rem !important;
  }

  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }

  .mb-lg-n4 {
    margin-bottom: -1.5rem !important;
  }

  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }

  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-lg-n3 {
    margin-left: -1rem !important;
  }

  .ms-lg-n4 {
    margin-left: -1.5rem !important;
  }

  .ms-lg-n5 {
    margin-left: -3rem !important;
  }

  .p-lg-0 {
    padding: 0 !important;
  }

  .p-lg-1 {
    padding: 0.25rem !important;
  }

  .p-lg-2 {
    padding: 0.5rem !important;
  }

  .p-lg-3 {
    padding: 1rem !important;
  }

  .p-lg-4 {
    padding: 1.5rem !important;
  }

  .p-lg-5 {
    padding: 3rem !important;
  }

  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-lg-0 {
    padding-top: 0 !important;
  }

  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }

  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }

  .pt-lg-3 {
    padding-top: 1rem !important;
  }

  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }

  .pt-lg-5 {
    padding-top: 3rem !important;
  }

  .pe-lg-0 {
    padding-right: 0 !important;
  }

  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }

  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }

  .pe-lg-3 {
    padding-right: 1rem !important;
  }

  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }

  .pe-lg-5 {
    padding-right: 3rem !important;
  }

  .pb-lg-0 {
    padding-bottom: 0 !important;
  }

  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }

  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }

  .ps-lg-0 {
    padding-left: 0 !important;
  }

  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }

  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }

  .ps-lg-3 {
    padding-left: 1rem !important;
  }

  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }

  .ps-lg-5 {
    padding-left: 3rem !important;
  }

  .gap-lg-0 {
    gap: 0 !important;
  }

  .gap-lg-1 {
    gap: 0.25rem !important;
  }

  .gap-lg-2 {
    gap: 0.5rem !important;
  }

  .gap-lg-3 {
    gap: 1rem !important;
  }

  .gap-lg-4 {
    gap: 1.5rem !important;
  }

  .gap-lg-5 {
    gap: 3rem !important;
  }

  .row-gap-lg-0 {
    row-gap: 0 !important;
  }

  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }

  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }

  .column-gap-lg-0 {
    column-gap: 0 !important;
  }

  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }

  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }

  .text-lg-start {
    text-align: left !important;
  }

  .text-lg-end {
    text-align: right !important;
  }

  .text-lg-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }

  .float-xl-end {
    float: right !important;
  }

  .float-xl-none {
    float: none !important;
  }

  .object-fit-xl-contain {
    object-fit: contain !important;
  }

  .object-fit-xl-cover {
    object-fit: cover !important;
  }

  .object-fit-xl-fill {
    object-fit: fill !important;
  }

  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }

  .object-fit-xl-none {
    object-fit: none !important;
  }

  .d-xl-inline {
    display: inline !important;
  }

  .d-xl-inline-block {
    display: inline-block !important;
  }

  .d-xl-block {
    display: block !important;
  }

  .d-xl-grid {
    display: grid !important;
  }

  .d-xl-inline-grid {
    display: inline-grid !important;
  }

  .d-xl-table {
    display: table !important;
  }

  .d-xl-table-row {
    display: table-row !important;
  }

  .d-xl-table-cell {
    display: table-cell !important;
  }

  .d-xl-flex {
    display: flex !important;
  }

  .d-xl-inline-flex {
    display: inline-flex !important;
  }

  .d-xl-none {
    display: none !important;
  }

  .flex-xl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xl-row {
    flex-direction: row !important;
  }

  .flex-xl-column {
    flex-direction: column !important;
  }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xl-center {
    justify-content: center !important;
  }

  .justify-content-xl-between {
    justify-content: space-between !important;
  }

  .justify-content-xl-around {
    justify-content: space-around !important;
  }

  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xl-start {
    align-items: flex-start !important;
  }

  .align-items-xl-end {
    align-items: flex-end !important;
  }

  .align-items-xl-center {
    align-items: center !important;
  }

  .align-items-xl-baseline {
    align-items: baseline !important;
  }

  .align-items-xl-stretch {
    align-items: stretch !important;
  }

  .align-content-xl-start {
    align-content: flex-start !important;
  }

  .align-content-xl-end {
    align-content: flex-end !important;
  }

  .align-content-xl-center {
    align-content: center !important;
  }

  .align-content-xl-between {
    align-content: space-between !important;
  }

  .align-content-xl-around {
    align-content: space-around !important;
  }

  .align-content-xl-stretch {
    align-content: stretch !important;
  }

  .align-self-xl-auto {
    align-self: auto !important;
  }

  .align-self-xl-start {
    align-self: flex-start !important;
  }

  .align-self-xl-end {
    align-self: flex-end !important;
  }

  .align-self-xl-center {
    align-self: center !important;
  }

  .align-self-xl-baseline {
    align-self: baseline !important;
  }

  .align-self-xl-stretch {
    align-self: stretch !important;
  }

  .order-xl-first {
    order: -1 !important;
  }

  .order-xl-0 {
    order: 0 !important;
  }

  .order-xl-1 {
    order: 1 !important;
  }

  .order-xl-2 {
    order: 2 !important;
  }

  .order-xl-3 {
    order: 3 !important;
  }

  .order-xl-4 {
    order: 4 !important;
  }

  .order-xl-5 {
    order: 5 !important;
  }

  .order-xl-last {
    order: 6 !important;
  }

  .m-xl-0 {
    margin: 0 !important;
  }

  .m-xl-1 {
    margin: 0.25rem !important;
  }

  .m-xl-2 {
    margin: 0.5rem !important;
  }

  .m-xl-3 {
    margin: 1rem !important;
  }

  .m-xl-4 {
    margin: 1.5rem !important;
  }

  .m-xl-5 {
    margin: 3rem !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xl-0 {
    margin-top: 0 !important;
  }

  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xl-3 {
    margin-top: 1rem !important;
  }

  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }

  .mt-xl-5 {
    margin-top: 3rem !important;
  }

  .mt-xl-auto {
    margin-top: auto !important;
  }

  .me-xl-0 {
    margin-right: 0 !important;
  }

  .me-xl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xl-3 {
    margin-right: 1rem !important;
  }

  .me-xl-4 {
    margin-right: 1.5rem !important;
  }

  .me-xl-5 {
    margin-right: 3rem !important;
  }

  .me-xl-auto {
    margin-right: auto !important;
  }

  .mb-xl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }

  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }

  .mb-xl-auto {
    margin-bottom: auto !important;
  }

  .ms-xl-0 {
    margin-left: 0 !important;
  }

  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xl-3 {
    margin-left: 1rem !important;
  }

  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }

  .ms-xl-5 {
    margin-left: 3rem !important;
  }

  .ms-xl-auto {
    margin-left: auto !important;
  }

  .m-xl-n1 {
    margin: -0.25rem !important;
  }

  .m-xl-n2 {
    margin: -0.5rem !important;
  }

  .m-xl-n3 {
    margin: -1rem !important;
  }

  .m-xl-n4 {
    margin: -1.5rem !important;
  }

  .m-xl-n5 {
    margin: -3rem !important;
  }

  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-xl-n3 {
    margin-top: -1rem !important;
  }

  .mt-xl-n4 {
    margin-top: -1.5rem !important;
  }

  .mt-xl-n5 {
    margin-top: -3rem !important;
  }

  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }

  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }

  .me-xl-n3 {
    margin-right: -1rem !important;
  }

  .me-xl-n4 {
    margin-right: -1.5rem !important;
  }

  .me-xl-n5 {
    margin-right: -3rem !important;
  }

  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }

  .mb-xl-n4 {
    margin-bottom: -1.5rem !important;
  }

  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }

  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-xl-n3 {
    margin-left: -1rem !important;
  }

  .ms-xl-n4 {
    margin-left: -1.5rem !important;
  }

  .ms-xl-n5 {
    margin-left: -3rem !important;
  }

  .p-xl-0 {
    padding: 0 !important;
  }

  .p-xl-1 {
    padding: 0.25rem !important;
  }

  .p-xl-2 {
    padding: 0.5rem !important;
  }

  .p-xl-3 {
    padding: 1rem !important;
  }

  .p-xl-4 {
    padding: 1.5rem !important;
  }

  .p-xl-5 {
    padding: 3rem !important;
  }

  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-xl-0 {
    padding-top: 0 !important;
  }

  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xl-3 {
    padding-top: 1rem !important;
  }

  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }

  .pt-xl-5 {
    padding-top: 3rem !important;
  }

  .pe-xl-0 {
    padding-right: 0 !important;
  }

  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xl-3 {
    padding-right: 1rem !important;
  }

  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }

  .pe-xl-5 {
    padding-right: 3rem !important;
  }

  .pb-xl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }

  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }

  .ps-xl-0 {
    padding-left: 0 !important;
  }

  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xl-3 {
    padding-left: 1rem !important;
  }

  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }

  .ps-xl-5 {
    padding-left: 3rem !important;
  }

  .gap-xl-0 {
    gap: 0 !important;
  }

  .gap-xl-1 {
    gap: 0.25rem !important;
  }

  .gap-xl-2 {
    gap: 0.5rem !important;
  }

  .gap-xl-3 {
    gap: 1rem !important;
  }

  .gap-xl-4 {
    gap: 1.5rem !important;
  }

  .gap-xl-5 {
    gap: 3rem !important;
  }

  .row-gap-xl-0 {
    row-gap: 0 !important;
  }

  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }

  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }

  .column-gap-xl-0 {
    column-gap: 0 !important;
  }

  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }

  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }

  .text-xl-start {
    text-align: left !important;
  }

  .text-xl-end {
    text-align: right !important;
  }

  .text-xl-center {
    text-align: center !important;
  }
}

@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }

  .float-xxl-end {
    float: right !important;
  }

  .float-xxl-none {
    float: none !important;
  }

  .object-fit-xxl-contain {
    object-fit: contain !important;
  }

  .object-fit-xxl-cover {
    object-fit: cover !important;
  }

  .object-fit-xxl-fill {
    object-fit: fill !important;
  }

  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }

  .object-fit-xxl-none {
    object-fit: none !important;
  }

  .d-xxl-inline {
    display: inline !important;
  }

  .d-xxl-inline-block {
    display: inline-block !important;
  }

  .d-xxl-block {
    display: block !important;
  }

  .d-xxl-grid {
    display: grid !important;
  }

  .d-xxl-inline-grid {
    display: inline-grid !important;
  }

  .d-xxl-table {
    display: table !important;
  }

  .d-xxl-table-row {
    display: table-row !important;
  }

  .d-xxl-table-cell {
    display: table-cell !important;
  }

  .d-xxl-flex {
    display: flex !important;
  }

  .d-xxl-inline-flex {
    display: inline-flex !important;
  }

  .d-xxl-none {
    display: none !important;
  }

  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xxl-row {
    flex-direction: row !important;
  }

  .flex-xxl-column {
    flex-direction: column !important;
  }

  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xxl-center {
    justify-content: center !important;
  }

  .justify-content-xxl-between {
    justify-content: space-between !important;
  }

  .justify-content-xxl-around {
    justify-content: space-around !important;
  }

  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xxl-start {
    align-items: flex-start !important;
  }

  .align-items-xxl-end {
    align-items: flex-end !important;
  }

  .align-items-xxl-center {
    align-items: center !important;
  }

  .align-items-xxl-baseline {
    align-items: baseline !important;
  }

  .align-items-xxl-stretch {
    align-items: stretch !important;
  }

  .align-content-xxl-start {
    align-content: flex-start !important;
  }

  .align-content-xxl-end {
    align-content: flex-end !important;
  }

  .align-content-xxl-center {
    align-content: center !important;
  }

  .align-content-xxl-between {
    align-content: space-between !important;
  }

  .align-content-xxl-around {
    align-content: space-around !important;
  }

  .align-content-xxl-stretch {
    align-content: stretch !important;
  }

  .align-self-xxl-auto {
    align-self: auto !important;
  }

  .align-self-xxl-start {
    align-self: flex-start !important;
  }

  .align-self-xxl-end {
    align-self: flex-end !important;
  }

  .align-self-xxl-center {
    align-self: center !important;
  }

  .align-self-xxl-baseline {
    align-self: baseline !important;
  }

  .align-self-xxl-stretch {
    align-self: stretch !important;
  }

  .order-xxl-first {
    order: -1 !important;
  }

  .order-xxl-0 {
    order: 0 !important;
  }

  .order-xxl-1 {
    order: 1 !important;
  }

  .order-xxl-2 {
    order: 2 !important;
  }

  .order-xxl-3 {
    order: 3 !important;
  }

  .order-xxl-4 {
    order: 4 !important;
  }

  .order-xxl-5 {
    order: 5 !important;
  }

  .order-xxl-last {
    order: 6 !important;
  }

  .m-xxl-0 {
    margin: 0 !important;
  }

  .m-xxl-1 {
    margin: 0.25rem !important;
  }

  .m-xxl-2 {
    margin: 0.5rem !important;
  }

  .m-xxl-3 {
    margin: 1rem !important;
  }

  .m-xxl-4 {
    margin: 1.5rem !important;
  }

  .m-xxl-5 {
    margin: 3rem !important;
  }

  .m-xxl-auto {
    margin: auto !important;
  }

  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xxl-0 {
    margin-top: 0 !important;
  }

  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xxl-3 {
    margin-top: 1rem !important;
  }

  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }

  .mt-xxl-5 {
    margin-top: 3rem !important;
  }

  .mt-xxl-auto {
    margin-top: auto !important;
  }

  .me-xxl-0 {
    margin-right: 0 !important;
  }

  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xxl-3 {
    margin-right: 1rem !important;
  }

  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }

  .me-xxl-5 {
    margin-right: 3rem !important;
  }

  .me-xxl-auto {
    margin-right: auto !important;
  }

  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }

  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }

  .mb-xxl-auto {
    margin-bottom: auto !important;
  }

  .ms-xxl-0 {
    margin-left: 0 !important;
  }

  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xxl-3 {
    margin-left: 1rem !important;
  }

  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }

  .ms-xxl-5 {
    margin-left: 3rem !important;
  }

  .ms-xxl-auto {
    margin-left: auto !important;
  }

  .m-xxl-n1 {
    margin: -0.25rem !important;
  }

  .m-xxl-n2 {
    margin: -0.5rem !important;
  }

  .m-xxl-n3 {
    margin: -1rem !important;
  }

  .m-xxl-n4 {
    margin: -1.5rem !important;
  }

  .m-xxl-n5 {
    margin: -3rem !important;
  }

  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }

  .mt-xxl-n4 {
    margin-top: -1.5rem !important;
  }

  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }

  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }

  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }

  .me-xxl-n3 {
    margin-right: -1rem !important;
  }

  .me-xxl-n4 {
    margin-right: -1.5rem !important;
  }

  .me-xxl-n5 {
    margin-right: -3rem !important;
  }

  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }

  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }

  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }

  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }

  .ms-xxl-n4 {
    margin-left: -1.5rem !important;
  }

  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }

  .p-xxl-0 {
    padding: 0 !important;
  }

  .p-xxl-1 {
    padding: 0.25rem !important;
  }

  .p-xxl-2 {
    padding: 0.5rem !important;
  }

  .p-xxl-3 {
    padding: 1rem !important;
  }

  .p-xxl-4 {
    padding: 1.5rem !important;
  }

  .p-xxl-5 {
    padding: 3rem !important;
  }

  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-xxl-0 {
    padding-top: 0 !important;
  }

  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xxl-3 {
    padding-top: 1rem !important;
  }

  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }

  .pt-xxl-5 {
    padding-top: 3rem !important;
  }

  .pe-xxl-0 {
    padding-right: 0 !important;
  }

  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xxl-3 {
    padding-right: 1rem !important;
  }

  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }

  .pe-xxl-5 {
    padding-right: 3rem !important;
  }

  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }

  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }

  .ps-xxl-0 {
    padding-left: 0 !important;
  }

  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xxl-3 {
    padding-left: 1rem !important;
  }

  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }

  .ps-xxl-5 {
    padding-left: 3rem !important;
  }

  .gap-xxl-0 {
    gap: 0 !important;
  }

  .gap-xxl-1 {
    gap: 0.25rem !important;
  }

  .gap-xxl-2 {
    gap: 0.5rem !important;
  }

  .gap-xxl-3 {
    gap: 1rem !important;
  }

  .gap-xxl-4 {
    gap: 1.5rem !important;
  }

  .gap-xxl-5 {
    gap: 3rem !important;
  }

  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }

  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }

  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }

  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }

  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }

  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }

  .text-xxl-start {
    text-align: left !important;
  }

  .text-xxl-end {
    text-align: right !important;
  }

  .text-xxl-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.34375rem !important;
  }

  .fs-2 {
    font-size: 1.875rem !important;
  }

  .fs-3 {
    font-size: 1.640625rem !important;
  }

  .fs-4 {
    font-size: 1.40625rem !important;
  }
}

@media print {
  .d-print-inline {
    display: inline !important;
  }

  .d-print-inline-block {
    display: inline-block !important;
  }

  .d-print-block {
    display: block !important;
  }

  .d-print-grid {
    display: grid !important;
  }

  .d-print-inline-grid {
    display: inline-grid !important;
  }

  .d-print-table {
    display: table !important;
  }

  .d-print-table-row {
    display: table-row !important;
  }

  .d-print-table-cell {
    display: table-cell !important;
  }

  .d-print-flex {
    display: flex !important;
  }

  .d-print-inline-flex {
    display: inline-flex !important;
  }

  .d-print-none {
    display: none !important;
  }
}

.w-20px {
  width: 20px !important;
}

.w-30px {
  width: 30px !important;
}

.w-40px {
  width: 40px !important;
}

.w-50px {
  width: 50px !important;
}

.w-60px {
  width: 60px !important;
}

.w-70px {
  width: 70px !important;
}

.w-80px {
  width: 80px !important;
}

.w-90px {
  width: 90px !important;
}

.w-100px {
  width: 100px !important;
}

.w-150px {
  width: 150px !important;
}

.w-200px {
  width: 200px !important;
}

.w-300px {
  width: 300px !important;
}

.w-400px {
  width: 400px !important;
}

.h-20px {
  height: 20px !important;
}

.h-30px {
  height: 30px !important;
}

.h-40px {
  height: 40px !important;
}

.h-50px {
  height: 50px !important;
}

.h-60px {
  height: 60px !important;
}

.h-70px {
  height: 70px !important;
}

.h-80px {
  height: 80px !important;
}

.h-90px {
  height: 90px !important;
}

.h-100px {
  height: 100px !important;
}

.h-150px {
  height: 150px !important;
}

.h-200px {
  height: 200px !important;
}

.h-300px {
  height: 300px !important;
}

.h-400px {
  height: 400px !important;
}

.fill-primary {
  fill: #0f6fec !important;
}

.fill-secondary {
  fill: #14191e !important;
}

.fill-success {
  fill: #0cbc87 !important;
}

.fill-info {
  fill: #4f9ef8 !important;
}

.fill-warning {
  fill: #f7c32e !important;
}

.fill-danger {
  fill: #d6293e !important;
}

.fill-light {
  fill: #eef0f2 !important;
}

.fill-dark {
  fill: #14191e !important;
}

.fill-white {
  fill: #fff !important;
}

.z-index-0 {
  z-index: 0 !important;
}

.z-index-1 {
  z-index: 1 !important;
}

.z-index-9 {
  z-index: 9 !important;
}

.z-index-99 {
  z-index: 99 !important;
}

.z-index-n9 {
  z-index: -9 !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-1 {
  opacity: 0.1 !important;
}

.opacity-2 {
  opacity: 0.2 !important;
}

.opacity-3 {
  opacity: 0.3 !important;
}

.opacity-4 {
  opacity: 0.4 !important;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-6 {
  opacity: 0.6 !important;
}

.opacity-7 {
  opacity: 0.7 !important;
}

.opacity-8 {
  opacity: 0.8 !important;
}

.opacity-9 {
  opacity: 0.9 !important;
}

.blur-1 {
  filter: blur(0.2rem) !important;
}

.blur-2 {
  filter: blur(0.4rem) !important;
}

.blur-3 {
  filter: blur(0.6rem) !important;
}

.blur-4 {
  filter: blur(0.8rem) !important;
}

.blur-5 {
  filter: blur(1rem) !important;
}

.blur-6 {
  filter: blur(1.2rem) !important;
}

.blur-7 {
  filter: blur(2rem) !important;
}

.blur-8 {
  filter: blur(5rem) !important;
}

.blur-9 {
  filter: blur(9rem) !important;
}

.border-dashed {
  border-style: dashed !important;
}

.rounded-start-top-0 {
  border-top-left-radius: 0 !important;
}

.accordion.accordion-icon .accordion-item {
  box-shadow: none;
  border-radius: var(--bs-border-radius);
  border: 1px solid var(--bs-border-color);
}

.accordion.accordion-icon .accordion-header {
  position: relative;
}

.accordion.accordion-icon .accordion-header .accordion-button {
  background: transparent;
  font-size: inherit;
  transition: none;
  box-shadow: none !important;
}

.accordion.accordion-icon .accordion-header .accordion-button[aria-expanded=true] {
  border-bottom: 1px solid var(--bs-border-color);
}

.accordion.accordion-icon .accordion-header .accordion-button:after {
  content: "";
  background: var(--bs-gray-800) !important;
  width: 10px;
  height: 2px;
  display: block;
  position: absolute;
  top: 47%;
  right: 20px;
  transform: translateY(-50%);
  transition: all 0.3s ease-in-out;
  transform: rotateZ(0deg);
  z-index: 9;
}

.accordion.accordion-icon .accordion-header .accordion-button:before {
  content: "";
  background: var(--bs-gray-800) !important;
  width: 10px;
  height: 2px;
  display: block;
  position: absolute;
  top: 47%;
  right: 20px;
  transform: translateY(-50%);
  transition: all 0.3s ease-in-out;
  transform: rotateZ(0deg);
  z-index: 9;
}

.accordion.accordion-icon .accordion-header .accordion-button[aria-expanded=false]:after {
  transform: rotateZ(90deg);
}

.accordion.accordion-icon .accordion-header .accordion-button[aria-expanded=true]:before {
  transform: rotateZ(0deg);
}

.accordion.accordion-icon .accordion-collapse {
  border: none;
}

.accordion.accordion-icon .accordion-body {
  padding: 1rem;
}

.breadcrumb-item {
  font-size: 0.8125rem;
}

.breadcrumb-item a {
  color: #676a79;
}

.breadcrumb-item a:hover {
  color: var(--bs-primary);
}

.breadcrumb.breadcrumb-dots .breadcrumb-item+.breadcrumb-item::before {
  content: "•";
  font-size: 22px;
  line-height: 0;
  height: 100%;
  display: flex;
  align-items: center;
}

.btn-link {
  padding: 0;
}

.btn {
  outline: 0;
}

.btn-check:checked+.btn,
:not(.btn-check)+.btn:active,
.btn:first-child:active,
.btn.active,
.btn.show {
  border-color: transparent !important;
}

.input-group .btn {
  margin-bottom: 0;
}

.btn-xs {
  padding: 0.4rem 0.6rem;
  font-size: 0.6rem;
  line-height: 1.2;
  border-radius: 0.2rem;
}

.btn-light.active,
.btn-light:active,
.btn-light:focus,
.btn-light:hover {
  background: var(--bs-gray-400);
  color: var(--bs-gray-900);
  border: 1px solid transparent !important;
}

.btn-white {
  background: var(--bs-white);
  color: #14191e;
}

.btn-white.active,
.btn-white:active,
.btn-white:focus,
.btn-white:hover {
  background: var(--bs-white);
  color: #14191e;
}

.btn-outline-light {
  background: transparent;
  border-color: var(--bs-gray-400);
  color: var(--bs-body-color);
}

.btn-outline-light:hover,
.btn-outline-light:focus,
.btn-outline-light:active,
.btn-check:checked+.btn-outline-light {
  background: var(--bs-gray-400);
  border-color: var(--bs-gray-400);
  color: var(--bs-gray-800);
}

.btn-primary-soft {
  color: #0f6fec;
  background-color: rgba(15, 111, 236, 0.1);
}

.btn-primary-soft:active,
.btn-primary-soft:hover,
.btn-primary-soft:focus {
  color: #fff !important;
  background-color: #0f6fec !important;
  border-color: #0f6fec !important;
}

.btn-secondary-soft {
  color: #14191e;
  background-color: rgba(20, 25, 30, 0.1);
}

.btn-secondary-soft:active,
.btn-secondary-soft:hover,
.btn-secondary-soft:focus {
  color: #fff !important;
  background-color: #14191e !important;
  border-color: #14191e !important;
}

.btn-success-soft {
  color: #0cbc87;
  background-color: rgba(12, 188, 135, 0.1);
}

.btn-success-soft:active,
.btn-success-soft:hover,
.btn-success-soft:focus {
  color: #fff !important;
  background-color: #0cbc87 !important;
  border-color: #0cbc87 !important;
}

.btn-info-soft {
  color: #4f9ef8;
  background-color: rgba(79, 158, 248, 0.1);
}

.btn-info-soft:active,
.btn-info-soft:hover,
.btn-info-soft:focus {
  color: #fff !important;
  background-color: #4f9ef8 !important;
  border-color: #4f9ef8 !important;
}

.btn-warning-soft {
  color: #f7c32e;
  background-color: rgba(247, 195, 46, 0.1);
}

.btn-warning-soft:active,
.btn-warning-soft:hover,
.btn-warning-soft:focus {
  color: #000 !important;
  background-color: #f7c32e !important;
  border-color: #f7c32e !important;
}

.btn-danger-soft {
  color: #d6293e;
  background-color: rgba(214, 41, 62, 0.1);
}

.btn-danger-soft:active,
.btn-danger-soft:hover,
.btn-danger-soft:focus {
  color: #fff !important;
  background-color: #d6293e !important;
  border-color: #d6293e !important;
}

.btn-light-soft {
  color: #eef0f2;
  background-color: rgba(238, 240, 242, 0.1);
}

.btn-light-soft:active,
.btn-light-soft:hover,
.btn-light-soft:focus {
  color: #000 !important;
  background-color: #eef0f2 !important;
  border-color: #eef0f2 !important;
}

.btn-dark-soft {
  color: #14191e;
  background-color: rgba(20, 25, 30, 0.1);
}

.btn-dark-soft:active,
.btn-dark-soft:hover,
.btn-dark-soft:focus {
  color: #fff !important;
  background-color: #14191e !important;
  border-color: #14191e !important;
}

.btn-primary-soft-hover:hover:hover {
  color: #0f6fec !important;
  background-color: rgba(15, 111, 236, 0.1);
}

.btn-secondary-soft-hover:hover:hover {
  color: #14191e !important;
  background-color: rgba(20, 25, 30, 0.1);
}

.btn-success-soft-hover:hover:hover {
  color: #0cbc87 !important;
  background-color: rgba(12, 188, 135, 0.1);
}

.btn-info-soft-hover:hover:hover {
  color: #4f9ef8 !important;
  background-color: rgba(79, 158, 248, 0.1);
}

.btn-warning-soft-hover:hover:hover {
  color: #f7c32e !important;
  background-color: rgba(247, 195, 46, 0.1);
}

.btn-danger-soft-hover:hover:hover {
  color: #d6293e !important;
  background-color: rgba(214, 41, 62, 0.1);
}

.btn-light-soft-hover:hover:hover {
  color: #eef0f2 !important;
  background-color: rgba(238, 240, 242, 0.1);
}

.btn-dark-soft-hover:hover:hover {
  color: #14191e !important;
  background-color: rgba(20, 25, 30, 0.1);
}

.btn-dashed {
  background: linear-gradient(90deg, var(--bs-border-color) 50%, transparent 50%), linear-gradient(0deg, var(--bs-border-color) 50%, transparent 50%), linear-gradient(90deg, var(--bs-border-color) 50%, transparent 50%), linear-gradient(0deg, var(--bs-border-color) 50%, transparent 50%);
  background-repeat: repeat-x, repeat-y, repeat-x, repeat-y;
  background-size: 10px 2px, 2px 10px, 10px 2px, 2px 10px;
  background-position: left top, right top, left bottom, left top;
  padding: 0.5rem, 1rem;
}

.btn-dashed:hover {
  animation: border-dance 4s infinite linear;
}

@keyframes border-dance {
  0% {
    background-position: left top, right top, right bottom, left bottom;
  }

  100% {
    background-position: right top, right bottom, left bottom, left top;
  }
}

.btn-loader {
  position: relative;
  text-align: center;
}

.btn-loader .load-icon {
  display: none;
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.btn-loader .load-text {
  opacity: 1;
  visibility: visible;
}

.btn-loader.active .load-text {
  opacity: 0;
  visibility: hidden;
}

.btn-loader.active .load-icon {
  display: block;
}

.spinner-dots {
  align-items: center;
  display: flex;
  justify-content: center;
}

.spinner-dot {
  background-color: var(--bs-gray-500);
  display: inline-block;
  height: 4px;
  margin: 2px;
  border-radius: 50%;
  width: 4px;
}

@keyframes dot {
  0% {
    background-color: var(--bs-gray-500);
    transform: scale(1);
  }

  50% {
    background-color: var(--bs-gray-600);
    transform: scale(1.3);
  }

  100% {
    background-color: var(--bs-gray-500);
    transform: scale(1);
  }
}

.btn-link-loader.active .spinner-dots .spinner-dot {
  animation: dot ease-in-out 1s infinite;
}

.btn-link-loader.active .spinner-dots .spinner-dot:nth-of-type(2) {
  animation-delay: 0.2s;
}

.btn-link-loader.active .spinner-dots .spinner-dot:nth-of-type(3) {
  animation-delay: 0.3s;
}

.card.overflow-hidden {
  will-change: transform;
}

.card .card-image {
  position: relative;
}

.card .card-image .card-element-hover {
  visibility: hidden;
  margin-top: 20px;
  opacity: 0;
  transition: all 0.3s ease-in-out;
  z-index: 9;
}

.card:hover .card-image .card-element-hover {
  visibility: visible;
  margin-top: 0px;
  opacity: 1;
}

.card.card-overlay-bottom {
  overflow: hidden;
}

.card.card-overlay-bottom:before {
  content: "";
  position: absolute;
  height: 50%;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient(180deg, transparent, black);
  z-index: 1;
}

.card .card-img-overlay {
  z-index: 2;
}

.dropdown-menu {
  box-shadow: 0px 20px 30px rgba(83, 88, 93, 0.1), 0px 0px 30px rgba(83, 88, 93, 0.2);
}

.dropdown-item.active {
  color: var(--bs-primary);
}

.dropdown-toggle:after {
  content: "\\f078";
  font-family: "Font Awesome 6 Free";
  font-size: 0.5rem;
  margin-left: 0.35rem;
  font-weight: 900;
  vertical-align: middle;
  border: none;
}

.dropup .dropdown-toggle:after {
  content: "\\f077";
  font-family: "Font Awesome 6 Free";
  font-size: 0.7rem;
  margin-left: 0.35rem;
  font-weight: 900;
  vertical-align: middle;
  border: none;
}

.dropdown-menu .dropdown-toggle:after {
  position: absolute;
  right: 25px;
  top: 10px;
}

.dropdown-menu .dropdown-toggle:before {
  position: absolute;
  right: 25px;
  top: 10px;
}

.dropdown-menu-size-md {
  min-width: 22rem;
}

@media (max-width: 575.98px) {
  .dropdown-menu-size-md {
    min-width: 16rem;
  }
}

.list-group-borderless .list-group-item {
  border: none;
  padding: 0.425rem 0;
}

.list-group-borderless a.list-group-item:hover {
  background-color: transparent;
  color: var(--bs-primary);
}

.nav .nav-item .nav-link {
  background: transparent;
  border: 1px solid transparent;
}

.nav .nav-item .nav-link.active {
  color: var(--bs-primary);
}

.nav-pills .nav-link {
  cursor: pointer;
  margin-bottom: 15px;
  padding: 0.5rem 1rem;
}

.nav-pills.nav-pills-light .nav-link:hover {
  background-color: var(--bs-light);
}

.nav-pills.nav-pills-light .nav-link.active {
  background-color: var(--bs-light);
}

.nav-pills-soft .nav-link:hover {
  border: 1px solid transparent;
}

.nav-pills-soft .nav-link.active,
.nav-pills-soft .show>.nav-link {
  background-color: rgba(var(--bs-primary-rgb), 0.1);
  border: 1px solid transparent;
}

.nav.nav-bottom-line {
  border-bottom: solid 1px var(--bs-border-color);
}

.nav.nav-bottom-line .nav-link {
  border: transparent;
  font-weight: 600;
  padding: 0.75rem 0.975rem;
}

.nav.nav-bottom-line .nav-item:first-child .nav-link {
  padding-left: 0;
}

.nav.nav-bottom-line .nav-link {
  background: transparent;
  border-bottom: 3px solid transparent;
}

.nav.nav-bottom-line .nav-link.active {
  background: transparent;
  color: var(--bs-primary);
  border-bottom: 3px solid var(--bs-primary);
}

.nav.nav-bottom-line .nav-item {
  margin-bottom: -2px;
}

.nav.flex-column:not(.nav-pills) .nav-link {
  padding-left: 0;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}

.tab-content {
  padding: 25px 0;
  margin-bottom: 20px;
}

.nav-tabs .nav-link {
  padding: 0.5rem 1rem;
}

.nav-tabs-white {
  border-radius: 0.4rem;
}

.nav-tabs-white .nav-item .nav-link {
  transition: all 0.3s ease-in-out;
  border: 0;
  border-radius: 0.4rem;
  margin-right: 4px;
  font-weight: 600;
}

.nav-tabs-white .nav-item:last-child .nav-link {
  margin-right: 0;
}

.nav-tabs-white .nav-item .nav-link.active,
.nav-tabs-white .nav-item .nav-link:hover {
  background: #fff;
  color: var(--bs-primary);
}

.nav.nav-divider .nav-item+.nav-item:before {
  content: "•";
  color: inherit;
  padding-left: 0.6rem;
  padding-right: 0.6rem;
  opacity: 0.8;
}

.nav.nav-divider .nav-item {
  display: flex;
  align-items: center;
}

.nav.nav-divider .nav-link {
  padding: 0;
}

.nav-link-secondary .nav-item .nav-link {
  color: var(--bs-gray-800);
}

.nav-link-secondary .nav-item .nav-link:hover,
.nav-link-secondary .nav-item .nav-link.active {
  color: var(--bs-primary);
}

.nav-stack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  gap: 0.7rem;
}

.nav-stack .nav-link {
  padding-left: 0;
  padding-right: 0;
}

.nav .nav-item .nav-link .nav-icon {
  background: var(--bs-light);
  height: 2.1rem;
  width: 2.1rem;
  font-size: 1.1em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease-in-out;
}

.nav .nav-item .nav-link:hover .nav-icon {
  background: var(--bs-primary);
  color: var(--bs-white);
}

@media (min-width: 992px) {
  .nav-sidenav {
    width: 5rem;
    transition: width 0.3s;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9;
    margin-top: 56px;
  }

  .nav-sidenav .nav-link {
    display: flex;
    align-items: center;
    white-space: nowrap;
    padding-left: 0;
  }

  .nav-sidenav .nav-text {
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease-in-out;
  }

  .sidebar-start-enabled .nav-sidenav {
    width: 270px;
  }

  .sidebar-start-enabled .nav-sidenav .nav-text {
    display: flex;
    opacity: 1;
    visibility: visible;
    padding-left: 10px;
  }
}

@media (max-width: 991.98px) {
  .nav-sidenav {
    width: 270px;
    left: 0;
    transition: transform 0.3s ease-in-out;
    position: fixed;
    top: 0;
    z-index: 9;
    margin-top: 56px;
    transform: translateX(-100%);
  }

  .nav-sidenav .nav-text {
    padding-left: 10px;
  }

  .sidebar-start-enabled .nav-sidenav {
    transform: none;
  }
}

@media (min-width: 992px) {
  .sidebar-end {
    width: 5rem;
    transition: width 0.3s;
    position: fixed;
    right: 0;
    top: 0;
    margin-top: 56px;
    z-index: 9;
  }

  .sidebar-end .sidebar-end-alignment {
    align-items: center;
  }

  .sidebar-end .nav-link {
    display: flex;
    align-items: center;
  }

  .sidebar-end .contact-name,
  .sidebar-end .contact-search,
  .sidebar-end .contact-title,
  .sidebar-end .contact-status {
    opacity: 0;
    display: none;
    visibility: hidden;
    transition: all 0.5s ease-in-out;
    white-space: nowrap;
  }

  .sidebar-end-enabled .sidebar-end {
    width: 270px;
  }

  .sidebar-end-enabled .sidebar-end .sidebar-end-alignment {
    align-items: inherit;
  }

  .sidebar-end-enabled .sidebar-end .contact-name,
  .sidebar-end-enabled .sidebar-end .contact-search,
  .sidebar-end-enabled .sidebar-end .contact-title,
  .sidebar-end-enabled .sidebar-end .contact-status {
    display: flex;
    opacity: 1;
    visibility: visible;
    transition: all 0.2s ease-in-out;
  }
}

@media (max-width: 991.98px) {
  .sidebar-end {
    width: 270px;
    right: 0;
    transition: transform 0.3s ease-in-out;
    position: fixed;
    top: 0;
    z-index: 9;
    transform: translateX(100%);
  }

  .sidebar-end-enabled .sidebar-end {
    transform: none;
  }
}

header {
  height: 56px;
}

.navbar-nav .nav-link {
  font-size: 0.9375rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 56px;
  padding-top: 0;
  padding-bottom: 0;
}

.navbar-nav .nav-link .nav-icon {
  margin-right: 0.3rem;
}

.navbar-nav .nav-item:last-child .nav-link {
  padding-right: 0;
}

.offcanvas .navbar-nav .nav-link {
  line-height: inherit;
  padding: 0.25rem 0.75rem;
}

.navbar-toggler {
  margin-bottom: 0;
  border: 0;
  background-color: var(--bs-light);
}

.navbar-transparent {
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.navbar-dark .navbar-top span:not(.dropdown-item-text) {
  color: #fff;
}

.navbar-dark .navbar-top a:not(.dropdown-item) {
  color: #fff;
}

.navbar-dark .navbar-top a:not(.dropdown-item):hover {
  color: var(--bs-primary);
}

.navbar-dark .nav .nav-link {
  color: #fff;
}

.navbar-dark .nav .nav-link:hover {
  color: var(--bs-primary);
}

@media (max-width: 991.98px) {
  .navbar-dark .navbar-nav .nav-link {
    color: var(--bs-gray-600);
  }
}

.navbar-brand {
  padding-top: 10px;
  padding-bottom: 10px;
}

.navbar-brand .navbar-brand-item {
  height: 36px;
  display: block;
  width: auto;
}

@media (max-width: 991.98px) {
  .navbar-brand {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .navbar-brand .navbar-brand-item {
    height: 36px;
  }
}

.navbar .dropdown-menu .dropdown-submenu.dropend .dropdown-toggle:after {
  content: "\\f00d";
  font-family: "Font Awesome 6 Free";
  font-size: 10px;
  top: 10px;
  transform: rotate(45deg);
  transition: all 0.3s ease-in-out;
  border: none !important;
  margin: 0;
}

@media (hover: hover) {
  .navbar .dropdown-menu .dropdown-submenu.dropend:hover>.dropdown-toggle:after {
    transform: rotate(90deg);
  }
}

.navbar .dropdown-menu .dropdown-submenu.dropend .dropdown-opened.dropdown-toggle:after {
  transform: rotate(90deg);
}

.navbar .dropdown-menu .dropdown-submenu.dropstart .dropdown-toggle:before {
  content: "\\f00d";
  font-family: "Font Awesome 6 Free";
  font-size: 10px;
  top: 8px;
  transform: rotate(45deg);
  transition: all 0.3s ease-in-out;
  border: none !important;
  margin: 0;
  font-weight: 900;
}

.navbar .dropdown-menu .dropdown-submenu.dropstart:hover>.dropdown-toggle:before {
  transform: rotate(90deg);
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    top: 120%;
    visibility: hidden;
    opacity: 0;
    display: block;
    transition: all 0.1s ease-in-out;
  }

  .navbar-expand-sm .navbar-nav .dropdown:hover>.dropdown-menu {
    top: 100%;
    visibility: visible;
    opacity: 1;
    transition: all 0.3s ease-in-out;
  }

  .navbar-expand-sm .navbar-nav .dropdown-submenu:hover>.dropdown-menu {
    top: 0;
    visibility: visible;
    opacity: 1;
    transition: all 0.3s ease-in-out;
  }

  .navbar-expand-sm .dropdown-submenu {
    position: relative;
  }
}

@media (max-width: 575.98px) {
  .navbar-expand-sm .navbar-collapse {
    box-shadow: 0px 10px 30px rgba(83, 88, 93, 0.2);
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    background: #fff;
    border-top: 1px solid var(--bs-border-color);
  }

  .navbar-expand-sm .navbar-collapse .navbar-nav .dropdown-toggle::after {
    position: absolute;
    right: 25px;
  }

  .navbar-expand-sm .navbar-collapse .navbar-nav .dropdown-menu {
    box-shadow: none;
  }

  .navbar-expand-sm .navbar-collapse .navbar-nav .dropdown-menu:before {
    content: none;
  }

  .navbar-expand-sm .navbar-collapse .navbar-nav .dropdown-submenu .dropdown-menu {
    padding-left: 20px;
    padding-bottom: 0px;
  }

  .navbar-expand-sm .navbar-collapse .navbar-nav>.nav-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 5px 30px;
    position: relative;
  }

  .navbar-expand-sm .navbar-collapse .navbar-nav>.nav-item .nav-link {
    line-height: 40px;
  }

  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: static;
    float: none;
  }

  .navbar-expand-sm .navbar-nav .nav-item>.dropdown-menu {
    background: rgba(103, 106, 121, 0.04);
    padding: 20px 0px;
    margin: 10px 0;
  }

  .navbar-expand-sm .navbar-nav .nav-item>.dropdown-menu .dropdown-submenu .dropdown-menu {
    background: rgba(103, 106, 121, 0.06);
    padding: 10px 0px !important;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-nav .dropdown-menu {
    top: 120%;
    visibility: hidden;
    opacity: 0;
    display: block;
    transition: all 0.1s ease-in-out;
  }

  .navbar-expand-md .navbar-nav .dropdown:hover>.dropdown-menu {
    top: 100%;
    visibility: visible;
    opacity: 1;
    transition: all 0.3s ease-in-out;
  }

  .navbar-expand-md .navbar-nav .dropdown-submenu:hover>.dropdown-menu {
    top: 0;
    visibility: visible;
    opacity: 1;
    transition: all 0.3s ease-in-out;
  }

  .navbar-expand-md .dropdown-submenu {
    position: relative;
  }
}

@media (max-width: 767.98px) {
  .navbar-expand-md .navbar-collapse {
    box-shadow: 0px 10px 30px rgba(83, 88, 93, 0.2);
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    background: #fff;
    border-top: 1px solid var(--bs-border-color);
  }

  .navbar-expand-md .navbar-collapse .navbar-nav .dropdown-toggle::after {
    position: absolute;
    right: 25px;
  }

  .navbar-expand-md .navbar-collapse .navbar-nav .dropdown-menu {
    box-shadow: none;
  }

  .navbar-expand-md .navbar-collapse .navbar-nav .dropdown-menu:before {
    content: none;
  }

  .navbar-expand-md .navbar-collapse .navbar-nav .dropdown-submenu .dropdown-menu {
    padding-left: 20px;
    padding-bottom: 0px;
  }

  .navbar-expand-md .navbar-collapse .navbar-nav>.nav-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 5px 30px;
    position: relative;
  }

  .navbar-expand-md .navbar-collapse .navbar-nav>.nav-item .nav-link {
    line-height: 40px;
  }

  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: static;
    float: none;
  }

  .navbar-expand-md .navbar-nav .nav-item>.dropdown-menu {
    background: rgba(103, 106, 121, 0.04);
    padding: 20px 0px;
    margin: 10px 0;
  }

  .navbar-expand-md .navbar-nav .nav-item>.dropdown-menu .dropdown-submenu .dropdown-menu {
    background: rgba(103, 106, 121, 0.06);
    padding: 10px 0px !important;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    top: 120%;
    visibility: hidden;
    opacity: 0;
    display: block;
    transition: all 0.1s ease-in-out;
  }

  .navbar-expand-lg .navbar-nav .dropdown:hover>.dropdown-menu {
    top: 100%;
    visibility: visible;
    opacity: 1;
    transition: all 0.3s ease-in-out;
  }

  .navbar-expand-lg .navbar-nav .dropdown-submenu:hover>.dropdown-menu {
    top: 0;
    visibility: visible;
    opacity: 1;
    transition: all 0.3s ease-in-out;
  }

  .navbar-expand-lg .dropdown-submenu {
    position: relative;
  }
}

@media (max-width: 991.98px) {
  .navbar-expand-lg .navbar-collapse {
    box-shadow: 0px 10px 30px rgba(83, 88, 93, 0.2);
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    background: #fff;
    border-top: 1px solid var(--bs-border-color);
  }

  .navbar-expand-lg .navbar-collapse .navbar-nav .dropdown-toggle::after {
    position: absolute;
    right: 25px;
  }

  .navbar-expand-lg .navbar-collapse .navbar-nav .dropdown-menu {
    box-shadow: none;
  }

  .navbar-expand-lg .navbar-collapse .navbar-nav .dropdown-menu:before {
    content: none;
  }

  .navbar-expand-lg .navbar-collapse .navbar-nav .dropdown-submenu .dropdown-menu {
    padding-left: 20px;
    padding-bottom: 0px;
  }

  .navbar-expand-lg .navbar-collapse .navbar-nav>.nav-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 5px 30px;
    position: relative;
  }

  .navbar-expand-lg .navbar-collapse .navbar-nav>.nav-item .nav-link {
    line-height: 40px;
  }

  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: static;
    float: none;
  }

  .navbar-expand-lg .navbar-nav .nav-item>.dropdown-menu {
    background: rgba(103, 106, 121, 0.04);
    padding: 20px 0px;
    margin: 10px 0;
  }

  .navbar-expand-lg .navbar-nav .nav-item>.dropdown-menu .dropdown-submenu .dropdown-menu {
    background: rgba(103, 106, 121, 0.06);
    padding: 10px 0px !important;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    top: 120%;
    visibility: hidden;
    opacity: 0;
    display: block;
    transition: all 0.1s ease-in-out;
  }

  .navbar-expand-xl .navbar-nav .dropdown:hover>.dropdown-menu {
    top: 100%;
    visibility: visible;
    opacity: 1;
    transition: all 0.3s ease-in-out;
  }

  .navbar-expand-xl .navbar-nav .dropdown-submenu:hover>.dropdown-menu {
    top: 0;
    visibility: visible;
    opacity: 1;
    transition: all 0.3s ease-in-out;
  }

  .navbar-expand-xl .dropdown-submenu {
    position: relative;
  }
}

@media (max-width: 1199.98px) {
  .navbar-expand-xl .navbar-collapse {
    box-shadow: 0px 10px 30px rgba(83, 88, 93, 0.2);
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    background: #fff;
    border-top: 1px solid var(--bs-border-color);
  }

  .navbar-expand-xl .navbar-collapse .navbar-nav .dropdown-toggle::after {
    position: absolute;
    right: 25px;
  }

  .navbar-expand-xl .navbar-collapse .navbar-nav .dropdown-menu {
    box-shadow: none;
  }

  .navbar-expand-xl .navbar-collapse .navbar-nav .dropdown-menu:before {
    content: none;
  }

  .navbar-expand-xl .navbar-collapse .navbar-nav .dropdown-submenu .dropdown-menu {
    padding-left: 20px;
    padding-bottom: 0px;
  }

  .navbar-expand-xl .navbar-collapse .navbar-nav>.nav-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 5px 30px;
    position: relative;
  }

  .navbar-expand-xl .navbar-collapse .navbar-nav>.nav-item .nav-link {
    line-height: 40px;
  }

  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: static;
    float: none;
  }

  .navbar-expand-xl .navbar-nav .nav-item>.dropdown-menu {
    background: rgba(103, 106, 121, 0.04);
    padding: 20px 0px;
    margin: 10px 0;
  }

  .navbar-expand-xl .navbar-nav .nav-item>.dropdown-menu .dropdown-submenu .dropdown-menu {
    background: rgba(103, 106, 121, 0.06);
    padding: 10px 0px !important;
  }
}

@media (min-width: 1400px) {
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    top: 120%;
    visibility: hidden;
    opacity: 0;
    display: block;
    transition: all 0.1s ease-in-out;
  }

  .navbar-expand-xxl .navbar-nav .dropdown:hover>.dropdown-menu {
    top: 100%;
    visibility: visible;
    opacity: 1;
    transition: all 0.3s ease-in-out;
  }

  .navbar-expand-xxl .navbar-nav .dropdown-submenu:hover>.dropdown-menu {
    top: 0;
    visibility: visible;
    opacity: 1;
    transition: all 0.3s ease-in-out;
  }

  .navbar-expand-xxl .dropdown-submenu {
    position: relative;
  }
}

@media (max-width: 1399.98px) {
  .navbar-expand-xxl .navbar-collapse {
    box-shadow: 0px 10px 30px rgba(83, 88, 93, 0.2);
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    background: #fff;
    border-top: 1px solid var(--bs-border-color);
  }

  .navbar-expand-xxl .navbar-collapse .navbar-nav .dropdown-toggle::after {
    position: absolute;
    right: 25px;
  }

  .navbar-expand-xxl .navbar-collapse .navbar-nav .dropdown-menu {
    box-shadow: none;
  }

  .navbar-expand-xxl .navbar-collapse .navbar-nav .dropdown-menu:before {
    content: none;
  }

  .navbar-expand-xxl .navbar-collapse .navbar-nav .dropdown-submenu .dropdown-menu {
    padding-left: 20px;
    padding-bottom: 0px;
  }

  .navbar-expand-xxl .navbar-collapse .navbar-nav>.nav-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 5px 30px;
    position: relative;
  }

  .navbar-expand-xxl .navbar-collapse .navbar-nav>.nav-item .nav-link {
    line-height: 40px;
  }

  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: static;
    float: none;
  }

  .navbar-expand-xxl .navbar-nav .nav-item>.dropdown-menu {
    background: rgba(103, 106, 121, 0.04);
    padding: 20px 0px;
    margin: 10px 0;
  }

  .navbar-expand-xxl .navbar-nav .nav-item>.dropdown-menu .dropdown-submenu .dropdown-menu {
    background: rgba(103, 106, 121, 0.06);
    padding: 10px 0px !important;
  }
}

.navbar-expand .navbar-nav .dropdown-menu {
  top: 120%;
  visibility: hidden;
  opacity: 0;
  display: block;
  transition: all 0.1s ease-in-out;
}

.navbar-expand .navbar-nav .dropdown:hover>.dropdown-menu {
  top: 100%;
  visibility: visible;
  opacity: 1;
  transition: all 0.3s ease-in-out;
}

.navbar-expand .navbar-nav .dropdown-submenu:hover>.dropdown-menu {
  top: 0;
  visibility: visible;
  opacity: 1;
  transition: all 0.3s ease-in-out;
}

.navbar-expand .dropdown-submenu {
  position: relative;
}

.navbar-expand .navbar-collapse {
  box-shadow: 0px 10px 30px rgba(83, 88, 93, 0.2);
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  background: #fff;
  border-top: 1px solid var(--bs-border-color);
}

.navbar-expand .navbar-collapse .navbar-nav .dropdown-toggle::after {
  position: absolute;
  right: 25px;
}

.navbar-expand .navbar-collapse .navbar-nav .dropdown-menu {
  box-shadow: none;
}

.navbar-expand .navbar-collapse .navbar-nav .dropdown-menu:before {
  content: none;
}

.navbar-expand .navbar-collapse .navbar-nav .dropdown-submenu .dropdown-menu {
  padding-left: 20px;
  padding-bottom: 0px;
}

.navbar-expand .navbar-collapse .navbar-nav>.nav-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 5px 30px;
  position: relative;
}

.navbar-expand .navbar-collapse .navbar-nav>.nav-item .nav-link {
  line-height: 40px;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-expand .navbar-nav .nav-item>.dropdown-menu {
  background: rgba(103, 106, 121, 0.04);
  padding: 20px 0px;
  margin: 10px 0;
}

.navbar-expand .navbar-nav .nav-item>.dropdown-menu .dropdown-submenu .dropdown-menu {
  background: rgba(103, 106, 121, 0.06);
  padding: 10px 0px !important;
}

.navbar.navbar-icon .navbar-nav .nav-item {
  position: relative;
  padding-top: 0;
  padding-bottom: 0;
}

.navbar.navbar-icon .navbar-nav .nav-item .nav-link {
  font-size: 1.3rem;
  color: var(--bs-gray-700);
  padding: 0 1.2rem;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  position: relative;
}

.navbar.navbar-icon .navbar-nav .nav-item .nav-link:hover {
  color: var(--bs-primary);
  box-shadow: inset 0px 4px 0px var(--bs-primary);
}

.navbar.navbar-icon .navbar-nav .nav-item .nav-link.active {
  color: var(--bs-primary);
  box-shadow: inset 0px 4px 0px var(--bs-primary);
}

.navbar.navbar-icon .navbar-nav .nav-item .nav-link.active:before {
  position: absolute;
  top: 100%;
  width: 0;
  height: 0;
  content: "";
  border-style: solid;
  border-width: 10px 10px 0 10px;
  border-color: var(--bs-white) transparent transparent transparent;
}

.navbar.navbar-icon .navbar-nav .nav-item .nav-link:last-child {
  padding-right: 1.2rem;
}

.navbar.navbar-icon .navbar-nav .nav-item .notif-badge {
  width: 6px;
  height: 6px;
  background: #d6293e;
  border-radius: 50%;
  position: absolute;
  top: inherit;
  bottom: 10px;
  right: 0;
  left: 0;
  margin: 0 auto;
  z-index: 1;
}

@media (min-width: 992px) {
  .navbar.navbar-icon .navbar-nav .nav-item .nav-link .nav-text {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .navbar.navbar-icon .navbar-collapse {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  .navbar.navbar-icon .navbar-collapse .navbar-nav .nav-item {
    padding: 0 10px;
  }

  .navbar.navbar-icon .navbar-collapse .navbar-nav .nav-item .nav-link {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    padding: 0.2rem 1.2rem;
  }

  .navbar.navbar-icon .navbar-collapse .navbar-nav .nav-item .nav-link::before {
    display: none;
  }

  .navbar.navbar-icon .navbar-collapse .navbar-nav .nav-item .nav-link .nav-text {
    margin-left: 0.4rem;
  }

  .navbar.navbar-icon .navbar-collapse .navbar-nav .nav-item .nav-link .badge-notif.badge-notif-bottom {
    position: static;
    margin: inherit;
  }

  .navbar.navbar-icon .navbar-collapse .navbar-nav .nav-item .notif-badge {
    bottom: inherit;
    right: inherit;
    top: 50%;
    transform: translateY(-50%);
  }
}

@media (min-width: 992px) {
  .navbar-vertical {
    bottom: 0;
    display: block;
    max-width: 300px;
    position: fixed;
    z-index: 9;
    height: 100vh;
    top: 56px;
    width: 100%;
    flex-direction: column;
  }

  .navbar-vertical .offcanvas-start {
    top: 1.5rem;
    left: inherit;
    position: relative;
    width: auto;
    border: none !important;
    transform: none;
    height: calc(100% - 6rem);
    visibility: visible !important;
  }

  .navbar-vertical+.page-content {
    margin-left: calc(300px + 1.5rem);
  }

  .page-content {
    position: relative;
    height: 100%;
    display: block;
    padding: 0 0.7rem 0 0;
  }
}

header.fixed-top+main {
  padding-top: calc(1.5rem + 56px);
  margin-bottom: 1.5rem;
}

.navbar-toggler .navbar-toggler-animation {
  transition: all 0.3s ease-in-out;
  background-image: none;
  position: relative;
  height: 18px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-toggler .navbar-toggler-animation span {
  transition: all 0.3s ease-in-out;
  transform: rotateZ(0deg);
  height: 2px;
  background: var(--bs-gray-600);
  display: block;
  position: absolute;
  width: 100%;
  border-radius: 30px;
}

.navbar-toggler .navbar-toggler-animation span:nth-child(1) {
  top: 10%;
}

.navbar-toggler .navbar-toggler-animation span:nth-child(2) {
  top: 50%;
  transform: translateY(-50%);
}

.navbar-toggler .navbar-toggler-animation span:nth-child(3) {
  bottom: 10%;
}

.navbar-toggler[data-bs-toggle=collapse][aria-expanded=true] .navbar-toggler-animation span:nth-child(1) {
  transform: rotateZ(45deg) translateY(-50%);
  top: 47%;
  transform-origin: 47% 0;
  width: 100%;
}

.navbar-toggler[data-bs-toggle=collapse][aria-expanded=true] .navbar-toggler-animation span:nth-child(2) {
  visibility: hidden;
  transition: all 0s ease-in-out;
}

.navbar-toggler[data-bs-toggle=collapse][aria-expanded=true] .navbar-toggler-animation span:nth-child(3) {
  transform: rotateZ(-45deg) translateY(-50%);
  bottom: 42%;
  transform-origin: 50% 0;
  width: 100%;
}

.pagination .page-item {
  margin-bottom: 5px;
  float: left;
}

.pagination-light .page-item {
  margin: 2px;
}

.pagination-light .page-item.active .page-link {
  background-color: var(--bs-primary) !important;
}

.pagination-light .page-item.disabled .page-link {
  background-color: transparent !important;
}

.pagination-light .page-link {
  border-color: var(--bs-light);
  background-color: var(--bs-light);
  border-radius: 0.2rem;
}

.pagination-light .page-link:hover {
  background-color: #0f6fec;
  border-color: #0f6fec;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  overflow-x: hidden;
  z-index: 0;
  position: relative;
}

main {
  background-color: var(--bs-body-bg);
}

header {
  position: relative;
  z-index: 1020;
}

a {
  transition: all 0.3s ease-in-out;
}

*:focus {
  outline: none !important;
}

h1>a,
h2>a,
h3>a,
h4>a,
h5>a,
h6>a,
.h1>a,
.h2>a,
.h3>a,
.h4>a,
.h5>a,
.h6>a {
  color: var(--bs-gray-800);
}

h1>a:hover,
h2>a:hover,
h3>a:hover,
h4>a:hover,
h5>a:hover,
h6>a:hover,
.h1>a:hover,
.h2>a:hover,
.h3>a:hover,
.h4>a:hover,
.h5>a:hover,
.h6>a:hover {
  color: var(--bs-primary);
}

img {
  max-width: 100%;
  height: auto;
}

video {
  background-size: cover;
  display: table-cell;
  vertical-align: middle;
  width: 100%;
}

section {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

@media (max-width: 767.98px) {
  section {
    padding-top: 4rem;
    padding-bottom: 3rem;
  }
}

small,
.small {
  font-weight: 400;
}

.smaller {
  font-size: 60%;
  font-weight: 500;
}

.dropcap {
  font-size: 4em;
  font-weight: bold;
  display: block;
  float: left;
  margin: 0.04em 0.2em 0 0;
  color: var(--bs-gray-800);
  line-height: 1;
}

.bg-overlay {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.blockquote {
  position: relative;
  padding-left: 80px;
}

.blockquote:before {
  content: '"';
  position: absolute;
  top: 0;
  left: 0;
  font-size: 8rem;
  line-height: 0.8em;
  font-weight: 700;
  color: var(--bs-primary);
}

.blockquote-footer {
  margin-top: 12px;
  padding-left: 80px;
}

a.badge:hover {
  color: #fff;
}

.badge-unread {
  background: var(--bs-light);
}

.badge-unread:hover {
  background: var(--bs-light);
}

.badge-unread:before {
  content: "";
  width: 7px;
  height: 7px;
  background: var(--bs-primary);
  border-radius: 50%;
  position: absolute;
  top: 40px;
  left: 4px;
}

.badge-notif {
  width: 8px;
  height: 8px;
  background: #d6293e;
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: -3px;
  z-index: 1;
}

.badge-notif.badge-notif-bottom {
  width: 6px;
  height: 6px;
  top: inherit;
  bottom: 5px;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.offcanvas-sm {
  width: 270px;
}

@media (max-width: 767.98px) {
  .offcanvas-start {
    width: 260px !important;
  }
}

.toast-chat {
  position: fixed;
  right: calc(400px + 1rem);
  bottom: 0;
  z-index: 11;
}

@media (max-width: 575.98px) {
  .toast {
    width: 288px;
  }
}

.bg-mode {
  background: #fff;
}

.grayscale {
  filter: grayscale(100%);
  transition: all 0.6s ease;
}

.grayscale:hover {
  filter: none;
  -webkit-filter: grayscale(0%);
}

.fw-icon {
  text-align: center;
  width: 1.25em;
  display: inline-block;
}

.icon-xs {
  height: 1.5rem;
  width: 1.5rem;
  font-size: 0.6em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-sm {
  height: 2rem;
  width: 2rem;
  font-size: 0.7em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-md {
  height: 2.5rem;
  width: 2.5rem;
  font-size: 0.9em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-lg {
  height: 3rem;
  width: 3rem;
  font-size: 1em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-xl {
  height: 4rem;
  width: 4rem;
  font-size: 1.6em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-xxl {
  height: 5.125rem;
  width: 5.125rem;
  font-size: 2em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.plyr__control--overlaid,
.plyr--video .plyr__control.plyr__tab-focus,
.plyr--video .plyr__control:hover,
.plyr--video .plyr__control[aria-expanded=true] {
  background: var(--bs-primary);
}

.plyr--full-ui input[type=range] {
  color: var(--bs-primary);
}

/* rtl:raw:
.glightbox-clean .gclose, .glightbox-modern .gclose{
  right: auto !important;
  left: 20px;
}
*/
.password-strength-meter {
  background-color: var(--bs-gray-200) !important;
}

.glightbox-clean .gslide-description {
  background: #fff;
}

.plyr__controls-none .plyr__controls {
  display: none;
}

.plyr__controls-none .plyr--video {
  border-radius: 20px;
}

.nav-search .dropdown-menu {
  top: 120%;
  visibility: hidden;
  opacity: 0;
  display: block;
  transition: all 0.3s ease-in-out;
  width: 300px;
  left: auto;
  right: 0;
}

.nav-search .dropdown-menu.show {
  top: 100%;
  visibility: visible;
  opacity: 1;
}

@media (max-width: 575.98px) {
  .nav-search .dropdown-menu {
    width: 100%;
  }
}

/* rtl:raw:
  .rtl-flip {
    transform: scaleX(-1);
  }
  .rtl-flip.bi:before{
    transform: inherit;
  }
*/
.preloader {
  background-color: #fff;
  position: fixed;
  z-index: 1190;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

.preloader .preloader-item {
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
}

.comment-wrap .comment-item {
  position: relative;
}

.comment-wrap .comment-item .avatar {
  position: relative;
  z-index: 1;
}

.comment-wrap .comment-item:last-child .comment-line-inner {
  background: var(--bs-light);
  height: 20px;
}

.comment-wrap .comment-item-nested {
  padding-left: 2.75rem;
}

.comment-wrap>.comment-item .comment-line-inner {
  position: absolute;
  left: 16px;
  top: 0;
  width: 2px;
  background-color: var(--bs-light);
  height: 100%;
}

.comment-item-nested .comment-item {
  position: relative;
}

.comment-item-nested .comment-item .comment-line-inner {
  position: absolute;
  left: -28px;
  top: 0;
  width: 2px;
  background-color: var(--bs-light);
  height: 100%;
}

.comment-item-nested .comment-item .comment-line-inner:before {
  content: "";
  position: absolute;
  left: 0;
  top: 20px;
  height: 2px;
  width: 26px;
  background: var(--bs-light);
}

@media (min-width: 992px) {
  .rounded-end-lg-0 {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .rounded-start-lg-0 {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .border-end-lg-0 {
    border-right: 0;
  }
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-bottom-0 {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.flip-horizontal {
  transform: scaleX(-1);
  display: inline-block;
}

.timeline {
  width: 100%;
}

.timeline .timeline-item {
  display: flex;
  width: 100%;
  margin-bottom: 1.5rem;
  position: relative;
}

.timeline .timeline-item:last-child {
  margin-bottom: 0;
}

.timeline .timeline-item .timeline-icon {
  margin-right: 0.8rem;
  position: relative;
  position: relative;
}

.timeline .timeline-item .timeline-content {
  width: 100%;
}

.timeline .timeline-item:before {
  content: "";
  position: absolute;
  width: 2px;
  height: calc(100% - 1rem);
  background-color: var(--bs-light);
  top: 2.5rem;
  left: 1.5rem;
  transform: translatex(-50%);
}

.timeline .timeline-item:last-child:before {
  height: calc(100% - 2.5rem);
}

@media (min-width: 992px) {
  .card-chat {
    height: calc(100vh - 5.1125rem - 1.5rem);
  }

  .card-chat-list {
    height: calc(100vh - 10.112rem - 1.5rem);
  }

  .chat-conversation-content {
    height: calc(100% - 5.25rem);
  }

  .chat-tab-list {
    height: calc(100% - 0.75rem);
  }
}

.typing .dot {
  animation: TypingAnimation 1.8s infinite ease-in-out;
  background-color: rgba(var(--bs-secondary-rgb), 0.7);
  border-radius: 50%;
  height: 7px;
  margin-right: 4px;
  vertical-align: middle;
  width: 7px;
  display: inline-block;
}

.typing .dot:nth-child(1) {
  animation-delay: 200ms;
}

.typing .dot:nth-child(2) {
  animation-delay: 300ms;
}

.typing .dot:nth-child(3) {
  animation-delay: 400ms;
}

.typing .dot:last-child {
  margin-right: 0;
}

@keyframes TypingAnimation {
  0% {
    transform: translateY(0px);
    background-color: rgba(var(--bs-secondary-rgb), 0.7);
  }

  28% {
    transform: translateY(-7px);
    background-color: rgba(var(--bs-secondary-rgb), 0.4);
  }

  44% {
    transform: translateY(0px);
    background-color: rgba(var(--bs-secondary-rgb), 0.2);
  }
}

.bi::before,
[class^=bi-]::before,
[class*=" bi-"]::before {
  line-height: 1.5;
}

.fakepasswordicon {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.fakepasswordicon.fa-eye:before {
  content: "\\f06e" !important;
}

.ticket-border {
  border-left: 2px dashed var(--bs-gray-900);
  padding-left: 50px;
  position: relative;
}

.ticket-border:before {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #fff;
  content: "";
  top: -50px;
  left: -25px;
  position: absolute;
}

.ticket-border:after {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #fff;
  content: "";
  bottom: -50px;
  left: -25px;
  position: absolute;
}

@media (max-width: 575.98px) {
  .ticket-border {
    padding-left: 0;
    border: 0;
  }

  .ticket-border:after,
  .ticket-border:before {
    display: none;
  }
}

.plyr--audio .plyr__controls {
  background: transparent;
}

.plyr--audio .plyr__control.plyr__tab-focus,
.plyr--audio .plyr__control:hover,
.plyr--audio .plyr__control[aria-expanded=true] {
  background: var(--bs-primary);
}

[data-autoresize] {
  resize: none;
}

.tooltip-text-start .tooltip-inner {
  text-align: left;
}

[class*=status-]:before {
  content: "";
  position: absolute;
  z-index: 1;
  border-radius: 100%;
  border: 2px solid #fff;
  height: 12px;
  width: 12px;
  right: -2px;
  top: -2px;
}

.status-online:before {
  background-color: #0cbc87;
}

.status-away:before {
  background-color: #f7c32e;
}

.status-offline:before {
  background-color: #d6293e;
}

.avatar.avatar-lg[class*=status-]:before {
  right: 2px;
  top: 2px;
}

.avatar.avatar-xl[class*=status-]:before {
  right: 4px;
  top: 4px;
}

.avatar.avatar-xxl[class*=status-]:before {
  right: 12px;
  top: 12px;
}

.avatar.avatar-xxxl[class*=status-]:before {
  right: 18px;
  top: 18px;
}

.avatar {
  height: 3rem;
  width: 3rem;
  position: relative;
  display: inline-block;
  flex-shrink: 0 !important;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-group {
  padding: 0;
  display: flex;
}

.avatar-group>li {
  position: relative;
}

.avatar-group>li:not(:last-child) {
  margin-right: -0.8rem;
}

.avatar-group .avatar-img {
  border: 2px solid #fff;
}

.avatar-group-two {
  display: inline-flex;
  padding: 0;
}

.avatar-group-two>li {
  margin-top: 0.8rem;
  position: relative;
}

.avatar-group-two>li:not(:last-child) {
  margin-right: -1.2rem;
  margin-top: 0;
}

.avatar-group-three {
  display: inline-flex;
  padding: 0;
  padding-right: 1.2rem;
  position: relative;
}

.avatar-group-three>li {
  position: relative;
}

.avatar-group-three>li:not(:last-child) {
  margin-right: -1.2rem;
}

.avatar-group-three>li:last-child {
  position: absolute;
  bottom: -30px;
  left: 50%;
  top: 0;
  transform: translate(-50%, 50%);
}

.avatar-group-four {
  display: inline-grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: auto auto;
  gap: 0px 0px;
}

.avatar-group-four li {
  margin: 0;
}

.avatar-group-four li:not(:last-child) {
  margin: 0;
}

.avatar-xxs {
  height: 1.5rem;
  width: 1.5rem;
}

.avatar-xs {
  height: 2.1875rem;
  width: 2.1875rem;
}

.avatar-sm {
  height: 2.5rem;
  width: 2.5rem;
}

.avatar-lg {
  height: 4rem;
  width: 4rem;
}

.avatar-xl {
  height: 5.125rem;
  width: 5.125rem;
}

.avatar-xxl {
  height: 5.125rem;
  width: 5.125rem;
}

@media (min-width: 768px) {
  .avatar-xxl {
    width: 8rem;
    height: 8rem;
  }
}

.avatar-xxxl {
  height: 8rem;
  width: 8rem;
}

@media (min-width: 768px) {
  .avatar-xxxl {
    width: 11rem;
    height: 11rem;
  }
}

.avatar-story {
  position: relative;
  padding: 4px;
  z-index: 1;
}

.avatar-story:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  border: 2px solid var(--bs-primary);
  z-index: -1;
}

.avatar-uploader {
  position: relative;
}

.avatar-uploader .avatar-edit {
  position: absolute;
  right: 0;
  z-index: 1;
  top: 0;
}

.avatar-uploader .avatar-edit input {
  display: none;
}

.avatar-uploader .avatar-edit input+label {
  display: inline-block;
  width: 34px;
  height: 34px;
  margin-bottom: 0;
  border-radius: 100%;
  background: #eff2f6;
  border: 1px solid transparent;
  box-shadow: 0px 0px 20px rgba(93, 83, 84, 0.15);
  cursor: pointer;
  font-weight: normal;
  transition: all 0.3s ease-in-out;
}

.avatar-uploader .avatar-edit input+label:after {
  content: "\\f303";
  font-family: "Font Awesome 6 Free";
  color: #14191e;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  text-align: center;
  font-weight: 900;
  transform: translate(0, -56%);
  margin: 0 auto;
  transition: all 0.3s ease-in-out;
}

.avatar-uploader .avatar-edit input+label:hover {
  background: var(--bs-primary);
  border-color: var(--bs-primary);
}

.avatar-uploader .avatar-edit input+label:hover:after {
  color: #fff;
}

.avatar-uploader img#avatar-preview {
  object-fit: cover;
}

.tns-outer {
  position: relative;
}

.tns-item {
  touch-action: pan-y;
  -webkit-user-select: none;
  user-select: none;
}

.tiny-slider .item {
  position: relative;
}

.tns-controls [data-controls] {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 0.4rem;
  display: block;
  z-index: 9;
  text-align: center;
  transition: all 0.3s ease-in-out;
  background: rgba(var(--bs-primary-rgb), 0.3);
  color: #fff;
  border: none;
  padding: 0;
  margin: 0 5px;
}

.tns-controls [data-controls]:hover {
  background-color: var(--bs-primary);
  color: #fff;
}

.tns-controls [data-controls] i {
  line-height: inherit;
}

.tns-controls [data-controls=prev] {
  left: 0;
}

.tns-controls [data-controls=next] {
  right: 0;
}

/* rtl:raw:
.tiny-slider .tns-controls [data-controls]{
  transform: scaleX(-1) translateY(-50%);
}
.tns-visually-hidden {
  right: -10000em !important;
  left: 0 !important;
}
*/
.arrow-dark [data-controls] {
  background: #14191e;
  color: #fff;
}

.arrow-white [data-controls] {
  background-color: #eff2f6;
  color: #676a79;
}

.arrow-round [data-controls] {
  border-radius: 50%;
}

.arrow-hover {
  overflow: hidden;
}

.arrow-hover [data-controls=prev] {
  left: -60px;
}

.arrow-hover [data-controls=next] {
  right: -60px;
}

.arrow-hover:hover [data-controls=prev] {
  left: 0px;
}

.arrow-hover:hover [data-controls=next] {
  right: 0px;
}

.tns-nav {
  position: absolute;
  top: 100%;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  width: auto;
  text-align: center;
  white-space: nowrap;
}

.tns-nav [data-nav] {
  position: relative;
  display: inline-block;
  margin: 0 4px;
  padding: 0;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  overflow: hidden;
  background-color: transparent;
  box-shadow: inset 0 0 0 2px var(--bs-gray-500);
  transition: all 0.3s ease-in-out;
  border: 0;
}

.tns-nav .tns-nav-active {
  background-color: #fff;
}

.dots-inside .tns-nav {
  top: auto;
  padding-bottom: 20px;
}

.dots-white .tns-nav [data-nav] {
  box-shadow: inset 0 0 0 2px #fff;
  transition: all 0.3s ease-in-out;
}

.dots-white .tns-nav [data-nav]:after {
  background-color: #fff;
  box-shadow: 0 0 1px #fff;
}

.dots-dark .tns-nav [data-nav] {
  box-shadow: inset 0 0 0 2px var(--bs-gray-800);
  transition: all 0.3s ease-in-out;
}

.dots-dark .tns-nav [data-nav]:after {
  background-color: var(--bs-gray-800);
  box-shadow: 0 0 1px var(--bs-gray-800);
}

.gslide-description.description-left,
.gslide-description.description-right {
  max-width: 360px;
}

.gdesc-inner {
  width: 100%;
}

.glightbox-container .gslide {
  -webkit-user-select: inherit;
  user-select: inherit;
}

.glightbox-clean .gslide-desc {
  font-family: "Inter", sans-serif;
}

.glightbox-mobile .glightbox-container .gslide-desc .bg-light {
  background: #14191e !important;
}

.glightbox-mobile .glightbox-container .gslide-desc .form-control {
  border-color: rgba(0, 0, 0, 0.1);
}

.glightbox-mobile .glightbox-container .gslide-desc .text-secondary {
  color: #fff !important;
}

.glightbox-mobile .glightbox-container .gslide-desc .dropdown-menu {
  background: #14191e !important;
}

.glightbox-mobile .glightbox-container .gslide-desc a {
  font-weight: normal;
}

.glightbox-mobile .glightbox-container .gslide-desc .nav.nav-divider .nav-item {
  color: #fff !important;
}

.choices .choices__inner {
  background-color: #fff;
  color: var(--bs-gray-700);
  border: 1px solid var(--bs-gray-400);
  line-height: 1.5;
  border-radius: 0.4rem;
  min-height: auto;
  padding: 0.5rem 1rem !important;
  font-size: 0.9375rem;
}

.choices .choices__list--multiple .choices__item {
  background-color: var(--bs-light);
  border: 1px solid var(--bs-light);
  border-radius: 0.4rem;
  color: var(--bs-gray-700);
}

.choices .choices__list--dropdown {
  background: #fff;
  border: 1px solid var(--bs-gray-400);
  visibility: visible !important;
}

.choices .choices__list--dropdown .choices__item--selectable.is-highlighted {
  background-color: var(--bs-light);
}

.choices .choices__list--dropdown .choices__item {
  color: var(--bs-gray-600);
}

.choices .choices__input {
  background: transparent;
  padding: 0;
  color: var(--bs-gray-700);
}

.choices .choices__list--dropdown,
.choices .choices__list[aria-expanded] {
  margin-top: 0px;
}

.choices.is-open .choices__list--dropdown,
.choices.is-open .choices__list[aria-expanded] {
  margin-top: -1px;
}

.choices[data-type*=select-one] .choices__input {
  background: var(--bs-white);
  color: var(--bs-body-color);
  border-color: var(--bs-gray-400) !important;
}

.choices__list--single {
  padding: 0;
}

.choices[data-type*=select-multiple] .choices__button,
.choices[data-type*=text] .choices__button {
  border-left: 1px solid #14191e;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.choices[data-type*=select-one]:after {
  content: "";
  height: 10px;
  width: 10px;
  border: none;
  border-width: 5px;
  position: absolute;
  right: 11.5px;
  top: 50%;
  transform: translateY(-50%);
  margin-top: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 16px 12px;
}

.choices[data-type*=select-one].is-open:after {
  margin-top: 0;
}

.choices[data-type*=select-one] .choices__input {
  background: #fff;
  border-color: #fff;
}

.choices.is-focused .choices__inner {
  border-color: var(--bs-primary);
}

.choices[data-type*=select-one] .choices__list>.choices__list>.choices__item--selectable,
.choices[data-type*=select-multiple] .choices__list>.choices__list>.choices__item--selectable {
  padding-right: 0px;
}

.choices[data-type*=select-one] .choices__list>.choices__list>.choices__item--selectable::after,
.choices[data-type*=select-multiple] .choices__list>.choices__list>.choices__item--selectable::after {
  display: none;
}

.dropzone {
  min-height: auto;
  border-radius: 0.4rem;
  position: relative;
  z-index: 0;
  border: 2px dashed #eef0f2;
}

.dropzone .dz-preview.dz-image-preview {
  background: transparent;
}

.dropzone-custom {
  position: relative;
}

.dropzone-custom .dz-cover-preview {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
}

.dropzone-custom .dz-cover-preview .dz-cover-preview-wrap {
  position: absolute;
  height: 100%;
  width: 100%;
  border: 0 !important;
  overflow: hidden;
}

.dropzone-custom .dz-preview {
  min-height: auto;
  margin: 0;
  width: 100%;
}

.dropzone-custom .dz-preview.dz-cover-preview .dz-cover-preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.375rem;
}

.dropzone-custom.dropzone-cover .dz-message {
  padding: 6rem 2rem;
}

.dropzone-custom.dropzone-cover.dz-file-processing .dz-message {
  display: none;
}

.dropzone-custom.dropzone-cover.dz-file-processing.dz-file-complete .dz-message {
  display: block;
}

.dropzone-custom.dropzone-cover.dz-max-files-reached .dz-message {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  opacity: 0;
  transition: all 0.2s ease-in-out;
  border-color: transparent;
}

.dropzone-custom.dropzone-cover .dz-preview.dz-cover-preview .dz-cover-preview-img {
  width: 100%;
  height: 100%;
}

.dropzone-custom .dz-message {
  position: relative;
  padding: 2rem;
  margin: 0;
}

.dropzone-custom.dropzone .dz-preview {
  display: inline-flex;
}

.dropzone-custom.dz-clickable .dz-message,
.dropzone.dz-clickable .dz-message * {
  cursor: pointer;
}

.dropzone-custom.dropzone-cover.dz-max-files-reached:focus .dz-message,
.dropzone.dropzone-cover.dz-max-files-reached:hover .dz-message {
  opacity: 1;
}

.os-theme-dark>.os-scrollbar>.os-scrollbar-track>.os-scrollbar-handle,
.os-theme-dark>.os-scrollbar:hover>.os-scrollbar-track>.os-scrollbar-handle {
  background: rgba(var(--bs-secondary-rgb), 0.15);
}

.iphone-x {
  position: relative;
  margin: 40px auto;
  width: 360px;
  height: 780px;
  background-color: #14191e;
  border-radius: 40px;
  box-shadow: 0px 0px 0px 11px #14191e, 0px 0px 0px 13px #14191e, 0px 0px 0px 20px #101418;
}

.iphone-x:before,
.iphone-x:after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.iphone-x:after {
  bottom: 7px;
  width: 140px;
  height: 4px;
  background-color: #eef0f2;
  border-radius: 10px;
}

.iphone-x:before {
  top: 0px;
  width: 56%;
  height: 30px;
  background-color: #14191e;
  border-radius: 0px 0px 40px 40px;
}

.iphone-x i,
.iphone-x b,
.iphone-x s,
.iphone-x span {
  position: absolute;
  display: block;
  color: transparent;
}

.iphone-x i {
  top: 0px;
  left: 50%;
  transform: translate(-50%, 6px);
  height: 8px;
  width: 15%;
  background-color: #000;
  border-radius: 8px;
  box-shadow: inset 0px -3px 3px 0px rgba(255, 255, 255, 0.2);
}

.iphone-x b {
  left: 10%;
  top: 0px;
  transform: translate(180px, 4px);
  width: 12px;
  height: 12px;
  background-color: #000;
  border-radius: 12px;
  box-shadow: inset 0px -3px 2px 0px rgba(255, 255, 255, 0.2);
}

.iphone-x b:after {
  content: "";
  position: absolute;
  background-color: rgba(15, 111, 236, 0.5);
  width: 6px;
  height: 6px;
  top: 2px;
  left: 2px;
  top: 3px;
  left: 3px;
  display: block;
  border-radius: 4px;
  box-shadow: inset 0px -2px 2px rgba(0, 0, 0, 0.5);
}

.iphone-x s {
  top: 50px;
  text-align: center;
  text-decoration: none;
  width: 100%;
  font-size: 70px;
  font-weight: 100;
  padding-top: 60px;
}

.iphone-x span {
  bottom: 50px;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  left: 30px;
}

.iphone-x span+span {
  left: auto;
  right: 30px;
}

.iphone-x.iphone-x-small {
  margin: 40px auto;
  width: 300px;
  height: 600px;
}

.iphone-x.iphone-x-half {
  height: 300px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

@media (max-width: 575.98px) {

  .iphone-x,
  .iphone-x.iphone-x-small {
    width: 260px;
    height: 540px;
    background-size: 100%;
  }

  .iphone-x.iphone-x-half {
    width: 240px;
    height: 280px;
    background-size: 100%;
  }

  .iphone-x b {
    left: -6%;
  }
}

.mac_container {
  width: 100%;
  margin: 10px auto;
}

.mac_scaler {
  margin: auto;
  width: 100%;
  padding-top: 57.875%;
  height: 0px;
  position: relative;
}

.mac_holder {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
}

.mac_screen {
  margin: auto;
  background: #14191e;
  width: 86%;
  height: 100%;
  border-top-left-radius: 2% 3%;
  border-top-right-radius: 2% 3%;
  border-bottom-left-radius: 5% 3%;
  border-bottom-right-radius: 5% 3%;
  box-sizing: border-box;
  padding: 3%;
  position: relative;
  overflow: hidden;
  border: 1px solid #eef0f2;
}

.mac_screen:before {
  content: "";
  position: absolute;
  right: 0.3%;
  top: 0.5%;
  width: 36.5%;
  height: 35%;
  border: 1px solid #14191e;
  border-bottom: none;
  border-left: none;
  border-top-right-radius: 4.5% 7%;
}

.mac_screen:after {
  content: "";
  position: absolute;
  right: -25%;
  top: -25%;
  width: 40%;
  height: 150%;
  background: rgba(238, 240, 242, 0.2);
  background: linear-gradient(rgba(255, 255, 255, 0.2), rgba(238, 240, 242, 0) 40%);
  transform: rotate(-30deg);
}

.mac_camera {
  background: #333;
  border-radius: 50%;
  width: 1%;
  height: 1.5%;
  position: absolute;
  left: 49.5%;
  top: 2%;
}

.mac_camera:after {
  content: "";
  position: absolute;
  left: 35%;
  top: 40%;
  width: 30%;
  height: 30%;
  border-radius: 50%;
  background: #777;
}

.mac_bottom {
  background: #e9e9e9;
  background: linear-gradient(#ccc 50%, #444);
  width: 100%;
  height: 3%;
  position: relative;
  top: -1.7%;
  border-bottom-left-radius: 6% 50%;
  border-bottom-right-radius: 6% 50%;
}

.mac_bottom_top_half {
  width: 100%;
  height: 50%;
  background: #e9e9e9;
  background: linear-gradient(90deg, #aaa, #f3f3f3 0.5%, #aaa 2.5%, #f3f3f3 5.5%, #f3f3f3 94.5%, #aaa 97.5%, #f3f3f3 99.5%, #aaa);
}

.mac_bottom:after {
  content: "";
  position: absolute;
  right: 1%;
  bottom: 11%;
  width: 98%;
  height: 0%;
  box-shadow: 1px 0px 8px 1px #333;
}

.mac_thumb_space {
  background: #bbb;
  background: radial-gradient(90% 150% at 50% 1%, #eee 49%, #888);
  margin: auto;
  width: 15%;
  height: 60%;
  border-bottom-left-radius: 8% 100%;
  border-bottom-right-radius: 8% 100%;
}

.mac_screen_content {
  width: 100%;
  height: 100%;
  text-align: center;
}

.flatpickr-calendar {
  background: #fff;
  border-color: #fff;
  box-shadow: 0px 0px 20px rgba(93, 83, 84, 0.15);
}

.flatpickr-current-month .flatpickr-monthDropdown-months,
.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
  background: #fff;
  border-color: rgba(0, 0, 0, 0.1);
}

.flatpickr-calendar.arrowBottom:before,
.flatpickr-calendar.arrowBottom:after {
  border-top-color: #fff;
}

.flatpickr-calendar.arrowTop:before,
.flatpickr-calendar.arrowTop:after,
.flatpickr-current-month .numInputWrapper span.arrowUp:after {
  border-bottom-color: #fff;
}

.flatpickr-current-month .numInputWrapper span.arrowDown:after {
  border-top-color: var(--bs-gray-500);
}

.flatpickr-current-month .numInputWrapper span.arrowUp:after {
  border-bottom-color: var(--bs-gray-500);
}

.flatpickr-months {
  position: relative;
}

.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  border-radius: 0.4rem;
  margin: 3px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  padding: 0;
  transition: all 0.3s ease-in-out;
}

.flatpickr-months .flatpickr-prev-month svg,
.flatpickr-months .flatpickr-next-month svg {
  height: 12px;
  width: 12px;
}

.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover {
  background: rgba(var(--bs-primary-rgb), 0.1);
}

.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: var(--bs-primary);
}

.flatpickr-day,
span.flatpickr-weekday,
.flatpickr-months .flatpickr-month {
  color: var(--bs-gray-500);
}

.flatpickr-day.flatpickr-disabled,
.flatpickr-day.flatpickr-disabled:hover,
.flatpickr-day.prevMonthDay,
.flatpickr-day.nextMonthDay,
.flatpickr-day.notAllowed,
.flatpickr-day.notAllowed.prevMonthDay,
.flatpickr-day.notAllowed.nextMonthDay {
  color: var(--bs-gray-400);
}

.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  fill: var(--bs-gray-500);
}

.flatpickr-day.today,
.flatpickr-day.today:hover,
.flatpickr-day.today:focus {
  background: rgba(var(--bs-primary-rgb), 0.1);
  color: var(--bs-primary);
  border-color: rgba(var(--bs-primary-rgb), 0.1);
}

.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.endRange,
.flatpickr-day.selected.inRange,
.flatpickr-day.startRange.inRange,
.flatpickr-day.endRange.inRange,
.flatpickr-day.selected:focus,
.flatpickr-day.startRange:focus,
.flatpickr-day.endRange:focus,
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.startRange.prevMonthDay,
.flatpickr-day.endRange.prevMonthDay,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.startRange.nextMonthDay,
.flatpickr-day.endRange.nextMonthDay {
  background: var(--bs-primary);
  color: #fff;
  border-color: var(--bs-primary);
}

.flatpickr-day.inRange,
.flatpickr-day.prevMonthDay.inRange,
.flatpickr-day.nextMonthDay.inRange,
.flatpickr-day:hover,
.flatpickr-day.prevMonthDay:hover,
.flatpickr-day.nextMonthDay:hover,
.flatpickr-day:focus,
.flatpickr-day.prevMonthDay:focus,
.flatpickr-day.nextMonthDay:focus {
  background: var(--bs-light);
  border-color: var(--bs-light);
  color: var(--bs-gray-500);
}

.flatpickr-day.today.inRange,
.flatpickr-day.prevMonthDay.today.inRange,
.flatpickr-day.nextMonthDay.today.inRange {
  background: rgba(var(--bs-primary-rgb), 0.1);
  color: var(--bs-primary);
  border-color: rgba(var(--bs-primary-rgb), 0.1);
}

.flatpickr-day.inRange {
  box-shadow: -5px 0 0 var(--bs-light), 5px 0 0 var(--bs-light);
}

.flatpickr-day.selected.startRange+.endRange:not(:nth-child(7n+1)),
.flatpickr-day.startRange.startRange+.endRange:not(:nth-child(7n+1)),
.flatpickr-day.endRange.startRange+.endRange:not(:nth-child(7n+1)) {
  box-shadow: -10px 0 0 var(--bs-primary);
}

.flatpickr-input:disabled,
.flatpickr-input[readonly] {
  background-color: #fff;
}

.flatpickr-time input:hover,
.flatpickr-time .flatpickr-am-pm:hover,
.flatpickr-time input:focus,
.flatpickr-time .flatpickr-am-pm:focus {
  background: var(--bs-light);
}

.flatpickr-calendar.hasTime .flatpickr-time {
  border-top-color: rgba(0, 0, 0, 0.1);
}

.flatpickr-current-month {
  font-size: 120%;
  padding: 9.48px 0 0 0;
  border-radius: 0.4rem;
}

.flatpickr-time input {
  color: var(--bs-gray-500);
}

.flatpickr-time .flatpickr-am-pm {
  color: var(--bs-gray-500);
}

@media (max-width: 575.98px) {

  .flatpickr-calendar,
  .flatpickr-days,
  .dayContainer {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
}

.stories .story>.item-link {
  text-decoration: none;
  color: var(--bs-gray-800);
}

.stories .story>.item-link>.item-preview {
  border-radius: 50%;
  padding: 2px;
  background: var(--bs-primary);
  height: 5.125rem !important;
  width: 5.125rem !important;
}

.stories.carousel .story {
  height: auto !important;
  width: 5.125rem !important;
}

.stories .story>.item-link>.item-preview img {
  border-radius: 50%;
  border: 2px solid #fff;
}

.stories .story.seen {
  opacity: 0.5;
}

.stories .story.seen>a>.item-preview {
  background: #a1a1a8;
}

.stories .story.seen>a {
  color: #676a79 !important;
}

.stories.carousel .story>.item-link>.info .name {
  font-weight: 500;
  font-size: 0.8203125rem;
}

#zuck-modal-content .story-viewer .head .right {
  padding: 0px 30px;
}

#zuck-modal-content .story-viewer .head .right .close {
  color: #fff;
}

#zuck-modal.with-effects {
  height: 100vh !important;
}

.stories-square.stories .story>.item-link>.item-preview {
  border-radius: 5px;
  height: 150px !important;
  object-fit: cover;
  width: auto !important;
  max-height: inherit !important;
  padding: 0 !important;
}

.stories-square.stories.carousel .story {
  border-radius: 0;
  height: 150px !important;
  position: relative;
  width: 120px !important;
  max-width: inherit !important;
  margin-bottom: 4px;
}

.stories-square.stories.carousel .story>.item-link>.info {
  position: absolute;
  left: 10px;
  bottom: 6px;
  color: #fff;
  text-align: left;
  z-index: 1;
}

.stories-square.stories.carousel .story>.item-link>.item-preview img {
  border-radius: 5px;
  border: none;
}

.stories-square.stories .story.seen>a>.item-preview {
  background: transparent;
}

.stories-square.stories .item-preview {
  position: relative;
}

.stories-square.stories .item-preview:before {
  content: "";
  position: absolute;
  height: 50%;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient(180deg, transparent, black);
  z-index: 1;
}

@media (max-width: 1024px) {
  #zuck-modal-content .story-viewer.with-back-button .head .left>.back {
    color: #fff;
  }
}

.scroll-enable.stories.carousel::-webkit-scrollbar-track {
  border-radius: 5px;
  background-color: #fff;
}

.scroll-enable.stories.carousel::-webkit-scrollbar {
  width: 5px;
  height: 8px;
  border-radius: 5px;
  background-color: #fff;
}

.scroll-enable.stories.carousel::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);
  background-color: #e1e4e6;
}

[data-bs-theme=dark] {
  --bs-gray-100: #313235;
  --bs-gray-200: #464950;
  --bs-gray-300: #5f5f68;
  --bs-gray-400: #a1a1a8;
  --bs-gray-500: #bfc0c9;
  --bs-gray-600: #c5c6cc;
  --bs-gray-700: #ffffffb3;
  --bs-gray-800: #fffffff9;
  --bs-gray-900: #fff;
  --bs-light: #202227;
  --bs-secondary-rgb: 197, 198, 204;
  --bs-body-bg: #191a1f;
  --bs-body-color: #a1a1a8;
  --bs-body-color-rgb: 161, 161, 168;
  --bs-mode: #0f0f10;
  --bs-mode-rgb: 15, 15, 16;
  --bs-border-color: rgba(255, 255, 255, 0.07);
  --bs-card-bg-dark: #141519;
  --bs-heading-color: var(--bs-gray-900);
}

[data-bs-theme=dark] .navbar {
  --bs-navbar-color: var(--bs-gray-600);
  --bs-navbar-disabled-color: var(--bs-gray-400);
}

[data-bs-theme=dark] .navbar-dark {
  --bs-navbar-color: var(--bs-gray-900);
}

[data-bs-theme=dark] .dropdown-menu {
  --bs-dropdown-bg: var(--bs-mode);
  --bs-dropdown-link-disabled-color: var(--bs-gray-200);
  box-shadow: none;
  --bs-dropdown-divider-bg: var(--bs-border-color);
  border: 1px solid var(--bs-border-color);
}

[data-bs-theme=dark] .alert-light {
  --bs-alert-bg: var(--bs-gray-600);
  --bs-alert-border-color: var(--bs-gray-600);
}

[data-bs-theme=dark] .bg-light {
  background-color: var(--bs-light) !important;
}

[data-bs-theme=dark] .btn-dark {
  --bs-btn-bg: var(--bs-mode);
}

[data-bs-theme=dark] .btn-close {
  filter: invert(1) grayscale(100%) brightness(300%);
}

[data-bs-theme=dark] .btn-secondary-soft {
  background-color: rgba(var(--bs-secondary-rgb), 0.1);
  color: var(--bs-gray-600);
}

[data-bs-theme=dark] .btn-secondary-soft:hover {
  background-color: rgba(var(--bs-secondary-rgb)) !important;
  color: var(--bs-body-bg) !important;
}

[data-bs-theme=dark] .btn-secondary-soft-hover:hover {
  background-color: rgba(var(--bs-secondary-rgb), 0.1);
  color: var(--bs-gray-600) !important;
}

[data-bs-theme=dark] .btn-light {
  --bs-btn-bg: var(--bs-light);
  --bs-btn-color: var(--bs-gray-800);
  --bs-btn-border-color: var(--bs-light);
  --bs-btn-active-bg: var(--bs-gray-200);
  --bs-btn-active-color: var(--bs-gray-800);
}

[data-bs-theme=dark] .modal {
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-footer-border-color: var(--bs-border-color);
}

[data-bs-theme=dark] .card {
  --bs-card-cap-bg: var(--bs-card-bg-dark) !important;
  --bs-card-bg: var(--bs-card-bg-dark) !important;
  --bs-card-border-color: var(--bs-light);
}

[data-bs-theme=dark] .offcanvas,
[data-bs-theme=dark] .offcanvas-xxl,
[data-bs-theme=dark] .offcanvas-xl,
[data-bs-theme=dark] .offcanvas-lg,
[data-bs-theme=dark] .offcanvas-md,
[data-bs-theme=dark] .offcanvas-sm {
  --bs-offcanvas-bg: var(--bs-body-bg);
}

[data-bs-theme=dark] .popover {
  --bs-popover-bg: var(--bs-body-bg);
}

[data-bs-theme=dark] .accordion {
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-active-bg: var(--bs-body-bg);
}

[data-bs-theme=dark] .accordion-item {
  background-color: var(--bs-body-bg);
  color: var(--bs-gray-400);
}

[data-bs-theme=dark] .accordion-item .accordion-button {
  color: var(--bs-gray-400);
}

[data-bs-theme=dark] .bg-mode {
  background: var(--bs-mode);
}

[data-bs-theme=dark] hr {
  color: var(--bs-gray-300);
}

[data-bs-theme=dark] .fill-secondary {
  fill: rgba(var(--bs-secondary-rgb)) !important;
}

[data-bs-theme=dark] .shadow,
[data-bs-theme=dark] .shadow-lg,
[data-bs-theme=dark] .shadow-sm {
  box-shadow: none !important;
}

[data-bs-theme=dark] .navbar-nav .dropdown .dropdown-submenu:hover>.dropdown-menu {
  box-shadow: none;
}

[data-bs-theme=dark] .iphone-x {
  box-shadow: 0px 0px 0px 11px var(--bs-gray-600), 0px 0px 0px 13px var(--bs-gray-600), 0px 0px 0px 20px var(--bs-gray-400);
}

[data-bs-theme=dark] .iphone-x:after {
  background-color: var(--bs-light);
}

[data-bs-theme=dark] .iphone-x:before {
  background-color: var(--bs-gray-600);
}

[data-bs-theme=dark] .mac_screen {
  background: var(--bs-gray-700);
}

[data-bs-theme=dark] .mac_screen:before {
  border: none;
}

[data-bs-theme=dark] .form-control {
  background-color: var(--bs-body-bg);
  border-color: var(--bs-gray-100);
}

[data-bs-theme=dark] .form-control:focus {
  border-color: var(--bs-primary);
}

[data-bs-theme=dark] .choices .choices__inner {
  background-color: var(--bs-body-bg);
  border: 1px solid var(--bs-gray-100);
}

[data-bs-theme=dark] .choices .choices__list--dropdown {
  background-color: var(--bs-body-bg);
  border: 1px solid var(--bs-gray-100);
}

[data-bs-theme=dark] .choices[data-type*=select-one] .choices__input {
  background: var(--bs-body-bg);
}

[data-bs-theme=dark] .flatpickr-calendar {
  background: var(--bs-mode);
  border-color: var(--bs-mode);
}

[data-bs-theme=dark] .flatpickr-current-month .flatpickr-monthDropdown-months,
[data-bs-theme=dark] .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
  background: var(--bs-mode);
}

[data-bs-theme=dark] .flatpickr-calendar.arrowBottom:before,
[data-bs-theme=dark] .flatpickr-calendar.arrowBottom:after {
  border-top-color: var(--bs-mode);
}

[data-bs-theme=dark] .flatpickr-calendar.arrowTop:before,
[data-bs-theme=dark] .flatpickr-calendar.arrowTop:after,
[data-bs-theme=dark] .flatpickr-current-month .numInputWrapper span.arrowUp:after {
  border-bottom-color: var(--bs-mode);
}

[data-bs-theme=dark] .nav-tabs-white .nav-item .nav-link.active,
[data-bs-theme=dark] .nav-tabs-white .nav-item .nav-link:hover {
  background: var(--bs-mode);
}

[data-bs-theme=dark] .navbar.navbar-icon .navbar-nav .nav-item .nav-link.active:before {
  border-color: var(--bs-mode) transparent transparent transparent;
}

@media (max-width: 575.98px) {
  [data-bs-theme=dark] .navbar-expand-sm .navbar-collapse {
    background: var(--bs-mode) !important;
  }
}

@media (max-width: 767.98px) {
  [data-bs-theme=dark] .navbar-expand-md .navbar-collapse {
    background: var(--bs-mode) !important;
  }
}

@media (max-width: 991.98px) {
  [data-bs-theme=dark] .navbar-expand-lg .navbar-collapse {
    background: var(--bs-mode) !important;
  }
}

@media (max-width: 1199.98px) {
  [data-bs-theme=dark] .navbar-expand-xl .navbar-collapse {
    background: var(--bs-mode) !important;
  }
}

@media (max-width: 1399.98px) {
  [data-bs-theme=dark] .navbar-expand-xxl .navbar-collapse {
    background: var(--bs-mode) !important;
  }
}

[data-bs-theme=dark] .navbar-expand .navbar-collapse {
  background: var(--bs-mode) !important;
}

[data-bs-theme=dark] .glightbox-clean .gslide-description {
  background: var(--bs-mode);
}

[data-bs-theme=dark] .preloader {
  background-color: var(--bs-mode);
}

[data-bs-theme=dark] .ticket-border:before {
  background: var(--bs-mode);
}

[data-bs-theme=dark] .ticket-border:after {
  background: var(--bs-mode);
}

[data-bs-theme=dark] .stories .story>.item-link>.item-preview img {
  border: 2px solid var(--bs-mode);
}

[data-bs-theme=dark] .scroll-enable.stories.carousel::-webkit-scrollbar-track {
  background-color: var(--bs-gray-200);
}

[data-bs-theme=dark] .scroll-enable.stories.carousel::-webkit-scrollbar {
  background-color: var(--bs-gray-200);
}

[data-bs-theme=dark] .scroll-enable.stories.carousel::-webkit-scrollbar-thumb {
  background-color: var(--bs-gray-400);
}

.modeswitch-item .btn-modeswitch {
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateX(-14%);
  height: 40px;
  width: 40px;
  background: var(--bs-light);
  border-radius: 0.4rem;
  transition: all 1s;
}

.modeswitch-item .btn-modeswitch svg {
  fill: var(--bs-gray-900);
}

.modeswitch-item .btn-modeswitch.active {
  background: var(--bs-primary);
}

.modeswitch-item .btn-modeswitch.active svg {
  fill: var(--bs-white);
}

.dark-mode-item {
  display: none !important;
}

[data-bs-theme=dark] .dark-mode-item {
  display: inline-block !important;
}

[data-bs-theme=dark] .light-mode-item {
  display: none !important;
}

/*User CSS*/
.btn-x {

  transform: translate(-50%, 125%);
  width: 60%;
  border-radius: 1rem;
  border: none;
  background-color: #008bf8;
  color: #fff;
  font-size: 1rem;
  padding: .5rem 1rem;
  position: absolute;
  left: 50%;
  bottom: 0;
  opacity: 0;
  transition: 0.3s ease-out;

}












.delete-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgb(243 185 185);
  border: none;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.164);
  cursor: pointer;
  transition-duration: 0.3s;
  overflow: hidden;
  position: relative;
}

.delete-svgIcon {
  width: 15px;
  transition-duration: 0.3s;
}

.delete-svgIcon path {
  fill: white;
}

.delete-button:hover {
  width: 90px;
  border-radius: 50px;
  transition-duration: 0.3s;
  background-color: rgb(255, 69, 69);
  align-items: center;
}

.delete-button:hover .delete-svgIcon {
  width: 20px;
  transition-duration: 0.3s;
  transform: translateY(60%);
  transform: rotate(360deg);
}

.delete-button::before {
  display: none;
  content: "Delete";
  color: white;
  transition-duration: 0.3s;
  font-size: 2px;
}

.delete-button:hover::before {
  display: block;
  padding-right: 10px;
  font-size: 13px;
  opacity: 1;
  transform: translateY(0px);
  transition-duration: 0.3s;
}















/**********************btn delete project********************************/

.deleteproject {
  text-decoration: none;
  position: relative;
  border: none;
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
  color: #fff;
  width: 5em;
  height: 3em;
  line-height: 2em;
  text-align: center;
  background: linear-gradient(90deg, #03a9f4, #f441a5, #03a9f4, #03a9f4);
  background-size: 300%;
  border-radius: 30px;
  z-index: 1;
}

.deleteproject:hover {
  animation: ani 8s linear infinite;
  border: none;
}

@keyframes ani {
  0% {
    background-position: 0%;
  }

  100% {
    background-position: 400%;
  }
}

.deleteproject:before {
  content: "";
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  z-index: -1;
  background: linear-gradient(90deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);
  background-size: 400%;
  border-radius: 35px;
  transition: 1s;
}

.deleteproject:hover::before {
  filter: blur(20px);
}

.deleteproject:active {
  background: linear-gradient(32deg, #03a9f4, #f441a5, #ffeb3b, #03a9f4);
}

/****************leave community*******************/
.Btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 45px;
  height: 45px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
  overflow: hidden;
  transition-duration: 0.3s;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.199);
  background-color: RGB(29, 185, 84);
}

/* plus sign */
.sign {
  width: 100%;
  transition-duration: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sign svg {
  width: 18px;
}

.sign svg path {
  fill: black;
}

/* text */
.text {
  position: absolute;
  right: 0%;
  width: 0%;
  opacity: 0;
  color: black;
  font-size: 1em;
  font-weight: 400;
  transition-duration: 0.3s;
}

/* hover effect on button width */
.Btn:hover {
  width: 125px;
  border-radius: 40px;
  transition-duration: 0.3s;
}

.Btn:hover .sign {
  width: 30%;
  transition-duration: 0.3s;
  padding-left: 20px;
}

/* hover effect button's text */
.Btn:hover .text {
  opacity: 1;
  width: 70%;
  transition-duration: 0.3s;
  padding-right: 10px;
}

/* button click effect*/
.Btn:active {
  transform: translate(2px, 2px);
}

/********search form*****************/
.inputSearch-container {
  position: relative;
  z-index: 1;
  display: flex;
  margin-left: 50%;
  align-items: center;
}

.inputSearch {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: none;
  outline: none;
  padding: 18px 16px;
  background-color: transparent;
  cursor: pointer;
  transition: all .5s ease-in-out;
}

.inputSearch::placeholder {
  color: transparent;
}

.inputSearch:focus::placeholder {
  color: rgb(131, 128, 128);
}

.inputSearch:focus,
.inputSearch:not(:placeholder-shown) {
  background-color: #fff;
  border: 1px solid rgb(98, 0, 255);
  width: 290px;
  cursor: none;
  padding: 18px 16px 18px 40px;
}

.iconss {
  position: absolute;
  left: 0;
  top: 0;
  height: 40px;
  width: 40px;
  background-color: #fff;
  border-radius: 10px;
  z-index: -1;
  fill: rgb(98, 0, 255);
  border: 1px solid rgb(98, 0, 255);
}

.inputSearch:hover+.iconss {
  transform: rotate(360deg);
  transition: .2s ease-in-out;
}

.inputSearch:focus+.iconss,
.inputSearch:not(:placeholder-shown)+.iconss {
  z-index: 0;
  background-color: transparent;
  border: none;
}

.scroll-hidden {

  overflow: auto;

}

.scroll-hidden::-webkit-scrollbar {
  display: none;
}

/*************btn edit profil*****************/


.BtnEditProfil {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 70px;
  height: 35px;
  border: none;
  text-align: center;
  /* padding: 0px 5px; */
  background-color: rgb(29, 119, 237);
  color: white;
  font-weight: 500;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 5px 5px 0px rgb(29, 119, 237);
  transition-duration: .3s;
}

.svgEditProfil {
  width: 13px;
  position: absolute;
  right: 0;
  margin-right: 20px;
  fill: white;
  transition-duration: .3s;
}

.BtnEditProfil:hover {
  color: transparent;
}

.BtnEditProfil:hover svg {
  right: 43%;
  margin: 0;
  padding: 0;
  border: none;
  transition-duration: .3s;
}

.BtnEditProfil:active {
  transform: translate(3px, 3px);
  transition-duration: .3s;
  box-shadow: 2px 2px 0px rgb(140, 32, 212);
}



/*************btn sendmsg***************/
.Commutybutton {
  font-family: inherit;
  font-size: 15px;
  background: linear-gradient(to bottom, #4dc7d9 0%, #66a6ff 100%);
  color: white;
  padding: 0.5em 0.9em;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 25px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
}

.Commutybutton:hover {
  transform: translateY(-3px);
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);
}

.Commutybutton:active {
  transform: scale(0.95);
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
}

.Commutybutton span {
  display: block;
  margin-left: 0.4em;
  transition: all 0.3s;
}

.Commutybutton svg {
  width: 18px;
  height: 18px;
  fill: white;
  transition: all 0.3s;
}

.Commutybutton .Commutysvg-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  margin-right: 0.5em;
  transition: all 0.3s;
}

.Commutybutton:hover .Commutysvg-wrapper {
  background-color: rgba(255, 255, 255, 0.5);
}

.Commutybutton:hover svg {
  transform: rotate(45deg);
}

/*************icon invite----*******/
.buttonInvite {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 9px 12px;
  gap: 8px;
  height: 45px;
  width: 120px;
  border: none;

  cursor: pointer;
  position: relative;
}

.lableInvite {
  line-height: 22px;
  font-size: 15px;
  color: #0cbc87;
  margin-left: 20px;
  font-family: sans-serif;
  letter-spacing: 1px;
}

.lableInvite:hover {

  color: white;

}

.buttonInvite .span {
  /* border-radius: 50%; */
  background-color: #0cbc87;
  padding: 10px;
  position: absolute;
  left: 0;
}

.buttonInvite:hover {
  background: #0cbc87
}

.buttonInvite:hover .svg-iconInvite {
  animation: slope 0.8s linear infinite;
}

@keyframes slope {
  0% {}

  50% {
    transform: rotate(15deg);
  }

  100% {}
}




.my-slider {
  display: flex;
  /* Assurez-vous que les éléments sont disposés horizontalement */
  overflow-x: auto;
  /* Permet le défilement horizontal */
  scroll-snap-type: x mandatory;
  /* Facultatif : assure un défilement fluide */
}

.slider-item {
  flex: 0 0 auto;
  /* Assure que chaque élément du slider a une largeur fixe */
  scroll-snap-align: start;
  /* Facultatif : assure un défilement fluide */
  /* width: 100%; */
  /* Assure que chaque élément occupe 100% de la largeur du container */
  padding: 0 10px;
  /* Espacement entre les éléments */
}

.pagination-container {
  text-align: center;
  margin-top: 20px;
  /* Espacement en haut de la pagination */
}

.pagination-button {
  margin: 0 10px;
  /* Espacement horizontal entre les boutons */
}

/* modal terms and condtions */

.custom-modal {
  max-width: 120%;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css","webpack://./src/assets/vendor/bootstrap/scss/_root.scss","webpack://./src/assets/vendor/bootstrap/scss/vendor/_rfs.scss","webpack://./src/assets/vendor/bootstrap/scss/_reboot.scss","webpack://./src/assets/vendor/bootstrap/scss/_variables.scss","webpack://./src/assets/vendor/bootstrap/scss/_type.scss","webpack://./src/assets/css/_variables.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_lists.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_image.scss","webpack://./src/assets/vendor/bootstrap/scss/_images.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_border-radius.scss","webpack://./src/assets/vendor/bootstrap/scss/_containers.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_container.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_breakpoints.scss","webpack://./src/assets/vendor/bootstrap/scss/_grid.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_grid.scss","webpack://./src/assets/vendor/bootstrap/scss/_tables.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_table-variants.scss","webpack://./src/assets/vendor/bootstrap/scss/forms/_labels.scss","webpack://./src/assets/vendor/bootstrap/scss/forms/_form-text.scss","webpack://./src/assets/vendor/bootstrap/scss/forms/_form-control.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_transition.scss","webpack://./src/assets/vendor/bootstrap/scss/forms/_form-select.scss","webpack://./src/assets/vendor/bootstrap/scss/forms/_form-check.scss","webpack://./src/assets/vendor/bootstrap/scss/forms/_form-range.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_gradients.scss","webpack://./src/assets/vendor/bootstrap/scss/forms/_floating-labels.scss","webpack://./src/assets/vendor/bootstrap/scss/forms/_input-group.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_forms.scss","webpack://./src/assets/vendor/bootstrap/scss/_buttons.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_buttons.scss","webpack://./src/assets/vendor/bootstrap/scss/_transitions.scss","webpack://./src/assets/vendor/bootstrap/scss/_dropdown.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_caret.scss","webpack://./src/assets/vendor/bootstrap/scss/_button-group.scss","webpack://./src/assets/vendor/bootstrap/scss/_nav.scss","webpack://./src/assets/vendor/bootstrap/scss/_navbar.scss","webpack://./src/assets/vendor/bootstrap/scss/_card.scss","webpack://./src/assets/vendor/bootstrap/scss/_accordion.scss","webpack://./src/assets/vendor/bootstrap/scss/_breadcrumb.scss","webpack://./src/assets/vendor/bootstrap/scss/_pagination.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_pagination.scss","webpack://./src/assets/vendor/bootstrap/scss/_badge.scss","webpack://./src/assets/vendor/bootstrap/scss/_alert.scss","webpack://./src/assets/vendor/bootstrap/scss/_progress.scss","webpack://./src/assets/vendor/bootstrap/scss/_list-group.scss","webpack://./src/assets/vendor/bootstrap/scss/_close.scss","webpack://./src/assets/vendor/bootstrap/scss/_toasts.scss","webpack://./src/assets/vendor/bootstrap/scss/_modal.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_backdrop.scss","webpack://./src/assets/vendor/bootstrap/scss/_tooltip.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_reset-text.scss","webpack://./src/assets/vendor/bootstrap/scss/_popover.scss","webpack://./src/assets/vendor/bootstrap/scss/_carousel.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_clearfix.scss","webpack://./src/assets/vendor/bootstrap/scss/_spinners.scss","webpack://./src/assets/vendor/bootstrap/scss/_offcanvas.scss","webpack://./src/assets/vendor/bootstrap/scss/_placeholders.scss","webpack://./src/assets/vendor/bootstrap/scss/helpers/_color-bg.scss","webpack://./src/assets/vendor/bootstrap/scss/helpers/_colored-links.scss","webpack://./src/assets/vendor/bootstrap/scss/helpers/_focus-ring.scss","webpack://./src/assets/vendor/bootstrap/scss/helpers/_icon-link.scss","webpack://./src/assets/vendor/bootstrap/scss/helpers/_ratio.scss","webpack://./src/assets/vendor/bootstrap/scss/helpers/_position.scss","webpack://./src/assets/vendor/bootstrap/scss/helpers/_stacks.scss","webpack://./src/assets/vendor/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./src/assets/vendor/bootstrap/scss/helpers/_stretched-link.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_text-truncate.scss","webpack://./src/assets/vendor/bootstrap/scss/helpers/_vr.scss","webpack://./src/assets/vendor/bootstrap/scss/mixins/_utilities.scss","webpack://./src/assets/vendor/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/css/custom/_accordion.scss","webpack://./src/assets/css/custom/_breadcrumb.scss","webpack://./src/assets/css/custom/_buttons.scss","webpack://./src/assets/css/custom/_card.scss","webpack://./src/assets/css/custom/_dropdowns.scss","webpack://./src/assets/css/custom/_list-group.scss","webpack://./src/assets/css/custom/_nav.scss","webpack://./src/assets/css/custom/_navbar.scss","webpack://./src/assets/css/custom/_pagination.scss","webpack://./src/assets/css/custom/_reboot.scss","webpack://./src/assets/css/custom/_type.scss","webpack://./src/assets/css/custom/_badge.scss","webpack://./src/assets/css/custom/_offcanvas.scss","webpack://./src/assets/css/custom/_toasts.scss","webpack://./src/assets/css/components/_general.scss","webpack://./src/assets/css/components/_avatar.scss","webpack://./src/assets/css/components/_tiny-slider.scss","webpack://./src/assets/css/components/_glightbox.scss","webpack://./src/assets/css/components/_choices.scss","webpack://./src/assets/css/components/_dropzone.scss","webpack://./src/assets/css/components/_overlayscrollbars.scss","webpack://./src/assets/css/components/_mockup.scss","webpack://./src/assets/css/components/_flatpickr.scss","webpack://./src/assets/css/components/_zuck.scss","webpack://./src/assets/css/_dark-mode.scss","webpack://./src/assets/css/_user.scss"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;;;;ECFA;ADOA;;ECEI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAIA,gBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,sBAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAIA,kBAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,6BAAA;EAIA,yBAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAIA,gCAAA;EAAA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAIA,4BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAGF,gCAAA;EACA,6BAAA;EAMA,uBAAA;EACA,qNAAA;EACA,yGAAA;EAOA,yFAAA;EC2OI,0CALI;EDpOR,8BAAA;EACA,0BAAA;EAKA,0BAAA;EACA,wBAAA;EACA,kCAAA;EACA,qBAAA;EAEA,+BAAA;EACA,yBAAA;EAEA,gCAAA;EACA,8CAAA;EACA,uCAAA;EACA,0BAAA;EAEA,oCAAA;EACA,6CAAA;EACA,sCAAA;EACA,yBAAA;EAGA,mCAAA;EAEA,sCAAA;EACA,wBAAA;EACA,iCAAA;EAEA,0BAAA;EACA,8BAAA;EAMA,sCAAA;EACA,wBAAA;EACA,6BAAA;EAGA,0BAAA;EACA,sBAAA;EACA,wBAAA;EACA,qCAAA;EAEA,mDAAA;EACA,0BAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EAGA,8BAAA;EACA,oDAAA;EACA,6DAAA;EACA,sDAAA;EAIA,2DAAA;EACA,8BAAA;EACA,6BAAA;EAIA,+CAAA;EACA,8BAAA;EACA,qCAAA;EACA,gCAAA;EDJF,uCAAA;AACA;;AAEA;ECUI,kBAAA;EACA,wBAAA;EACA,kCAAA;EACA,qBAAA;EAEA,4BAAA;EACA,yBAAA;EAEA,sCAAA;EACA,8CAAA;EACA,uCAAA;EACA,0BAAA;EAEA,iCAAA;EACA,6CAAA;EACA,sCAAA;EACA,yBAAA;EAGE,gCAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAIA,gCAAA;EAAA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAIA,4BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAGF,gCAAA;EAEA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,iCAAA;EAEA,sCAAA;EACA,wBAAA;EACA,6BAAA;EAEA,0BAAA;EACA,0BAAA;EAEA,wDAAA;EACA,8BAAA;EACA,qCAAA;EACA,gCAAA;EDJJ,uCAAA;AACA;;AAEA;;;EAGA,sBAAA;AAEA;;AAEA;EACE;IAAA,uBAAA;EACF;AAEA;;AAEA;EGjJE,SAAA;ED6OI,uCALI;ECtOR,mCAAA;EACA,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EHkJF,6CAAA;AAEA;;AAEA;EG3IE,cAAA;EACA,yBAAA;EACA,SAAA;EACA,wCCynB4B;EJ7e9B,aAAA;AAEA;;AAEA;;;;;;;;;;;;EG5HA,aAAA;EHyIE,qBEqEM;EFrEN,gCAAA;EACF,gBAAA;EAEE,iBAAiB;EGvInB,8BAAA;AHyIA;;AEnGI;;EFuGF,uCE4DM;AF3DR;;AAEA;;EEkDQ;;IA5JJ,qBAAA;ECjCJ;AHiJA;;AACA;;EG7IA,mCAAA;AHiJA;;AErHI;;EFyHF;;IACF,mBAAA;EAEE;AGnJF;;AHqJA;;EGhJA,yCAAA;AHoJA;;AAEA;;EG1IE;;IH6IF,sBAAA;EAEE;AGpIF;;AHuIA;;EGpIE,uCAAA;AHuIF;;AAEA;;EGlIE;;IAEA,qBAAA;EHkIF;AAIA;;AAEA;;EADA,sBAAA;AAIA;;AAEA;;EG/HE,oBAAA;AHkIF;;AAEA;EGhIA,aAAA;EHkIE,mBAAmB;AACrB;;AAEA;EAFA,yCAAA;EAIE,iCAAiC;EGhInC,YAAA;EHgIA,8BAAA;AAIA;;AAEA;EG9HE,mBAAA;EH6HF,kBAAA;EAIE,oBAAoB;AG3HtB;;AH2HA;;EGlHA,kBAAA;AHwHA;;AADA;;;EEhCM,aAAA;EFoCN,mBAAA;AAIA;;AAEA;;;;EAIE,gBAAgB;AGxGlB;;AH2GA;EEjDM,gBAAA;AFmDN;;AADA;EAIE,qBAAqB;EGxGvB,cAAA;AH0GA;;AAEA;EG3GA,gBAAA;AH6GA;;AAEA;;EGzGE,mBAAA;AH4GF;;AGzGE;;EH0GF,kBAAA;AAIA;;AAEA;;EADA,iBAAA;EAIE,gCAAgC;EG7FlC,wCAAA;AH+FA;;AAEA;;EE/EM,kBALI;EFoFV,iBAAA;EAIE,cAAc;EGzFhB,wBAAA;AH2FA;;AAEA;EGzFE,eAAA;AH2FF;;AGtFE;EDHI,WAAA;AF6FN;;AADA;EAIE,gEAAgE;EGtFlE,qBAAA;AHwFA;;AAEA;EAFA,mDAAA;AGlFE;;AHqFF;;EGhFA,cAAA;EACE,qBAAA;AHsFF;;AAEA;;;;EGjFI,qCAAA;ED7BE,cALI;AFsHV;;AGzEA;EACE,cAAA;EH4EF,aAAA;EAIE,mBAAmB;EG1ErB,cAAA;EH4EE,kBAAkB;AACpB;;AAEA;EGrEA,kBAAA;EACE,cAAA;EACA,kBAAA;AHoEF;;AGjEA;EACE,kBAAA;EACA,2BC2X4B;ED1X5B,qBAAA;AHuEF;;AAEA;EGjEA,cAAA;AHmEA;;AADA;EAIE,2BAA2B;EGhE7B,kBAAA;EHkEE,wBAAwB;EACxB,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EGhEE,UAAA;EACA,cAAA;AH+DF;;AGvDA;EACE,gBAAA;AH0DF;;AGpDA;;EHwDA,sBAAA;AAIA;;AAEA;EAFA,oBAAA;EAIE,yBAAyB;AGhD3B;;AHmDA;EACE,mBAAmB;EACnB,sBAAsB;EGhDtB,gCAAA;EACA,gBAAA;AHkDF;;AADA;EAIE,mBAAmB;EG/CrB,gCAAA;AHiDA;;AADA;;;;;;EGrCA,qBAAA;EAGE,mBAAA;EH0CF,eAAA;AGvCE;;AH0CF;EAIE,qBAAqB;AGtCvB;;AHsCA;EAIE,gBAAgB;AGjClB;;AHoCA;EACE,UAAU;AACZ;;AG/BI;;;;;EHmCJ,SAAA;EAIE,oBAAoB;EG/BtB,kBAAA;EACE,oBAAA;AHiCF;;AAEA;;EG5BE,oBAAA;AH4BF;;AGlBA;EACE,eAAA;AHwBF;;AAEA;EAFA,iBAAA;AAIA;;AAEA;EGjBE,UAAA;AHmBF;;AAEA;EGhBE,wBAAA;AHeF;;AAKA;;;;EGlBE,0BAAA;AHuBF;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EGjBE,UAAA;EHgBF,kBAAA;AAIA;;AAEA;EAFA,gBAAA;AAIA;;AAEA;EGXE,YAAA;EHUF,UAAA;EAIE,SAAS;EGNX,SAAA;AHQA;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EGbZ,qBAAA;EAWA,iCAAA;EACE,oBAAA;AHEF;;AGGA;EACE;IHAF,iBAAA;EAIE;AGGF;;AHAA;EAFA,WAAA;AAIA;;AAEA;;;;;;;EAOE,UAAU;AGEZ;;AHPA;EASE,YAAY;AGMd;;AHHA;EAPA,6BAAA;EASE,oBAAoB;AGWtB;;AHhBA;;;;;;;CAeC;AACD;EAPA,wBAAA;AASA;;AAEA;EKpjBI,UAAA;ALsjBJ;;AAOA;EKjkBE,aAAA;EHgQM,0BAAA;AFoUR;;AANA;EE1dI,qBAAA;AFoeJ;;AAEA;EAPA,SAAA;AASA;;AAEA;EK1kBI,kBC+N0B;ED9N1B,eAAA;ALokBJ;;AAUA;EACE,wBE7UM;AF8UR;;AAEA;EKvlBE,wBAAA;ALylBF;;AAEA;EAPA,sBAAA;EEhfI,gBAAA;AF0fJ;;AAEA;EAPA,iCAAA;EASE,gBAAgB;EKlmBhB,iBAAA;ALomBF;;AAEA;EAPA;IE3fI,eAAA;EGpGF;AL0mBF;;AANA;EASE,iCAAiC;EK7mBjC,gBAAA;EHgQM,iBAAA;AFgXR;;AANA;EEtgBI;IGpGF,iBAAA;ELqnBA;AACF;;AAEA;EKhmBA,iCAAA;EEvDE,gBAAA;EACA,iBAAA;APkpBF;;AKvlBA;EE5DE;IACA,eAAA;EPupBF;AASA;;AAEA;EAPA,iCAAA;EK1lBE,gBAAA;EACE,iBAAA;AL4lBJ;;AKllBA;EH8MM;IG5MJ,iBAAA;ELqlBF;AASA;;AAEA;EEpZM,iCALI;EFmZV,gBAAA;EKllBE,iBAAA;AL4lBF;;AAEA;EKzlBA;IACE,eAAA;EACA;AL2lBF;;AANA;EKjlBE,iCAAA;EACE,gBAAA;ELmlBJ,iBAAA;AASA;;AAEA;EQvrBE;IRirBF,iBAAA;EASE;AS3rBF;;AT8rBA;ES3rBE,eAAA;ECGE,gBAAA;AV2rBJ;;AANA;EASE,eAAe;ESrrBjB,gBAAA;ATurBA;;AAEA;ESprBA,qBAAA;ATsrBA;;AANA;EASE,oBAAoB;ASprBtB;;ATurBA;EAPA,kBAAA;EASE,yBAAyB;AWztBzB;;AX4tBF;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EYnuBE,gBAAA;AZquBF;;AAEA;EYnuBE,iBAAA;EACA,mBAAA;EZ6tBF,kBAAA;EASE,cAAc;AahrBZ;;AbmrBJ;EAPE,aAAA;AACF;;AAUA;EACE,eWnuBM;EX4tBN,YAAA;AACF;;AAUA;EACE,gBWxuBM;EXiuBN,mCAAA;EACF,2DAAA;EavrBI,sCAAA;EF5CE,eAAA;EX8uBJ,YW7uBM;AX8uBR;;AansBI;EF5CE,qBAAA;AXmvBN;;AANA;Ec5vBA,qBAAA;EAEI,cAAA;AdqwBJ;;AAEA;EcvwBI,kBAAA;EAAA,gCAAA;AdkwBJ;;Ac7vBE;;;;;;;Ed8wBA,qBejxBA;EAEA,gBAAA;EACA,WAAA;EACA,6CAAA;EfswBF,4CAAA;EcpwBI,kBAAA;ECOF,iBAAA;Af2wBF;;AAEA;;EezwBE;;IfiwBF,cAAA;EAaE;Ae9tBI;;AfiuBN;;EAZA;;;IervBE,eAAA;EfuwBA;AACF;;AAdA;;Ee3uBE;;;;IAEE,eAAA;Ef8uBJ;AAmBA;;AAEA;;EAEE;;;;;IetwBE,iBAAA;Ef4wBF;AACF;;AApBA;;Ee1vBE;;;;;;IfwxBE,iBAAiB;EexxBnB;Af0xBF;;AAEA;Ee1xBI,qBAAA;EfkwBJ,yBAAA;EA2BE,yBAAyB;Ee/xBzB,yBAAA;EACE,0BAAA;EfiyBF,2BejyBE;AfkyBJ;;AA1BA;EA6BE,qBAAqB;EerwBjB,gBAAA;EfywBJ,aezzBA;Ef6xBF,eAAA;EA+BE,yCAAyC;EetwBjC,6CAAA;EAhEN,4CAAA;Afy0BJ;;AAEA;EAEE,cAAc;Ee7wBN,WAAA;EAhEN,eAAA;Efg1BF,6Ceh1BE;Efi1BF,4Cej1BE;EACA,8BAAA;AfgzBJ;;AejvBU;EfwxBR,Sex1BE;Afy1BJ;;AAEA;EAGE,ce91BE;Ef+1BF,We/1BE;Afg2BJ;;AAEA;EAGE,cer2BE;Efs2BF,Wet2BE;Afu2BJ;;AAEA;EAGE,ce52BE;Ef62BF,Ue72BE;Af82BJ;;AAEA;EAGE,cen3BE;Efo3BF,mBep3BE;Afq3BJ;;AAEA;EAGE,ce13BE;Ef23BF,Ue33BE;Af43BJ;;AAEA;EAGE,cej4BE;Efk4BF,Uel4BE;Afm4BJ;;AAEA;EAGE,cex4BE;Efy4BF,mBez4BE;Af04BJ;;AAEA;EAGE,ce/4BE;Efg5BF,Weh5BE;Afi5BJ;;AAEA;EAGE,cet5BE;Efu5BF,kBev5BE;Afw5BJ;;AAEA;EAnDA,cAAA;EAuDE,mBAAmB;Aet1BT;;AfmyBZ;Ee31BE,cAAA;Ef+1BF,UAAA;AAuDA;;AAEA;Eeh2BY,cAAA;EAxDV,mBAAA;Afu2BF;;Ae/yBY;Ef02BV,cAAc;Ee12BJ,mBAAA;Af42BZ;;AAEA;EAnDA,cAAA;EAuDE,UAAU;Ael3BA;;Af+zBZ;Eev3BE,cAAA;Ef23BF,mBAAA;AAuDA;;AAEA;Eej3BQ,cAAA;Efq3BN,mBAAmB;AACrB;;AAEA;Eej3BU,cAAA;Ef+zBV,UAAA;AAuDA;;AAEA;EAGE,cAAc;Ee73BR,mBAAA;Af+3BR;;AApDA;EAyDE,cAAc;Eev4BN,mBAAA;Afm1BV;;Aeh1BQ;Efq1BR,cAAA;EAuDE,WAAW;Aej5BL;;Afo5BR;EArDA,wBAAA;AAuDA;;AAEA;Eej5BU,yBAAA;Af61BV;;Aep2BQ;Ef65BN,gBAAgB;AAClB;;AAEA;Ee35BQ,yBAAA;Af65BR;;AApDA;EAuDE,yBAAyB;Aer6BnB;;Afw6BR;EArDA,gBAAA;AAuDA;;AAEA;Eer6BU,yBAAA;Afi3BV;;Aa36BI;EEUE,yBAAA;Af29BN;;AAEA;EAvDE,gBAAA;AAyDF;;AAEA;EACE,yBelgCA;AfmgCF;;AAEA;EACE,yBet/BE;Afu/BJ;;AAEA;;Ee1/BE,gBAAA;Af6/BF;;AAEA;;EA5DE,gBAAA;AA+DF;;AAEA;;EAEE,sBepgCE;AfqgCJ;;AAEA;;EAEE,sBe1gCE;Af2gCJ;;AAEA;;EAEE,qBe/gCE;AfghCJ;;AAEA;;EAEE,qBephCE;AfqhCJ;;AAEA;;Eev/BM,mBAAA;Af0/BN;;AAEA;;EAtEE,mBAAA;AAyEF;;AAEA;;EAEE,qBe5jCE;Af6jCJ;;AAEA;;EAEE,qBelkCE;AfmkCJ;;AAEA;;EAEE,mBevkCE;AfwkCJ;;AAEA;;EAEE,mBe5kCE;Af6kCJ;;AAEA;EA/EE;IAmFE,SenlCA;EfolCF;;EAhFA;IAqFE,cezlCA;If0lCA,We1lCA;Ef2lCF;;Ee3hCQ;IfgiCN,cehmCA;IACA,WAAA;Ef2gCF;;EAwFA;IenmCE,cAAA;If+gCF,UAAA;Eeh9BQ;;Ef2iCR;IAvFA,cAAA;Iep9BQ,mBAAA;EfgjCR;;EAEA;IeljCQ,cAAA;IAhEN,UAAA;EfunCF;;EAEA;IeznCE,cAAA;If6nCA,Ue7nCA;Ef8nCF;;EA9FA;IAGA,cAAA;Ie39BU,mBAAA;Ef6jCV;;Ee7jCU;IAAA,cAAA;IAxDV,WAAA;Ef4hCA;;EAkGA;Ie9nCA,cAAA;IfkiCA,kBAAA;Ee1+BU;;Ef6+BV;IAGA,cAAA;Ieh/BU,mBAAA;EfklCV;;EellCU;IAAA,cAAA;IAxDV,UAAA;EfijCA;;EAkGA;IAGE,cAAc;IejlCR,mBAAA;Efm/BR;;EAkGA;IevlCM,cAAA;If2lCJ,mBAAmB;EACrB;;EevlCM;If4/BN,cAAA;IejgCM,UAAA;EfmmCN;;EA9FA;Ie9/BQ,cAAA;IfkgCR,mBAAA;EezgCM;;Ef4mCN;IAGE,cAAc;IexmCR,mBAAA;Ef0gCR;;EAkGA;Ie9mCM,cAAA;IfknCJ,UAAU;EACZ;;EexnCM;If6hCN,cAAA;IexhCM,mBAAA;Ef0nCN;;EA9FA;Ie1kCI,cAAA;IACE,mBAAA;Ef8qCN;;EAhGA;IAqGE,ceptCF;IfqtCE,WertCF;EfstCA;;EevsCA;IACE,cAAA;Ef0sCF;;EAEA;IArGA,wBAAA;EexmCA;;EfitCA;IACE,yBejtCA;EfktCF;;EentCA;IACE,gBAAA;EfstCF;;EAEA;IAzGA,yBAAA;EehnCA;;Ef6tCA;IACE,yBe7tCA;Ef8tCF;;Ee/tCA;IACE,gBAAA;EfkuCF;;EAEA;IA7GA,yBAAA;EexnCA;;EfyuCA;IACE,yBezuCA;Ef0uCF;;Ee1sCI;IAhDJ,gBAAA;Ef8vCA;;EAEA;IAjHA,yBAAA;EezlCQ;;Ef8sCR;IACE,yBe/wCA;EfgxCF;;EehtCQ;;IfotCN,gBepxCA;EfqxCF;;EApHA;;IejqCE,gBAAA;Ef0xCF;;EAEA;;Ie5tCQ,sBAAA;Ef+tCR;;EAEA;;IAxHA,sBAAA;EezmCQ;;EfsuCR;;IeryCE,qBAAA;Ef4qCF;;EA8HA;;IAEE,qBe7yCA;Ef8yCF;;Ee9uCQ;;IfkvCN,mBelzCA;EfmzCF;;EA9HA;;IerrCE,mBAAA;EfwzCF;;EAEA;;Ie1vCQ,qBAAA;Ef6vCR;;EAEA;;IAlIA,qBAAA;Ee7nCQ;;EfowCR;;Ien0CE,mBAAA;EfgsCF;;EAwIA;;IAEE,mBe30CA;Ef40CF;AACF;;AAEA;EACE;IAvIA,SAAA;EejoCU;;EfooCV;IAGA,cAAA;IevoCU,WAAA;EfmxCV;;EenxCU;IAAA,cAAA;IAxDV,WAAA;EfwsCA;;EA4IA;Iep1CA,cAAA;If8sCA,UAAA;EetpCU;;EfypCV;IAGA,cAAA;Ie5pCU,mBAAA;EfwyCV;;EexyCU;IAAA,cAAA;IAxDV,UAAA;Ef6tCA;;EA4IA;IejyCM,cAAA;IfqyCJ,UAAU;EACZ;;Ee3yCM;IfsqCN,cAAA;IejqCM,mBAAA;Ef6yCN;;EAxIA;IexqCQ,cAAA;If4qCR,WAAA;EezqCM;;EfszCN;IAGE,cAAc;Ie5zCR,kBAAA;EforCR;;EA4IA;Iel0CM,cAAA;Ifs0CJ,mBAAmB;EACrB;;Eel0CM;If6rCN,cAAA;IelsCM,UAAA;Ef80CN;;EAxIA;Ie/rCQ,cAAA;IfmsCR,mBAAA;EACF;;EepvCM;Ifm4CF,cel4CI;IfuvCN,mBAAA;EepvCI;;Efm4CJ;IA3IA,cAAA;Ie7wCA,UAAA;Ef65CA;;EAEA;Ie/5CA,cAAA;IACE,mBAAA;Efm6CF;;EAEA;Ier6CE,cAAA;Ify6CA,mBez6CA;Ef06CF;;EAlJA;IAuJE,ce/6CA;Ifg7CA,Ueh7CA;Efi7CF;;Eel7CA;Ifu7CE,cet7CA;IACA,mBAAA;Ef+xCF;;EA0JA;Iez7CE,cAAA;IfmyCF,mBAAA;EepwCI;;Efi6CJ;IAzJA,cAAA;IelwCQ,WAAA;Efg6CR;;EAEA;Iej+CE,cAAA;Efq0CF;;EAgKA;IACE,wBev+CA;Efw+CF;;EA9JA;Ie1wCQ,yBAAA;Ef46CR;;EAEA;Ie7+CE,gBAAA;Ef60CF;;EAoKA;IACE,yBen/CA;Efo/CF;;EAlKA;IelxCQ,yBAAA;Efw7CR;;EAEA;Iez/CE,gBAAA;Efq1CF;;EAwKA;IACE,yBe//CA;EfggDF;;EAtKA;Ie1xCQ,yBAAA;Efo8CR;;EAEA;IergDE,gBAAA;Ef61CF;;EA4KA;IACE,yBe3gDA;Ef4gDF;;EA1KA;IelyCQ,yBAAA;Efg9CR;;EAEA;;IA5KA,gBAAA;EetyCQ;;Efu9CR;;IethDE,gBAAA;Efy2CF;;EAkLA;;IAEE,sBe9hDA;Ef+hDF;;Ee/9CQ;;Ifm+CN,sBeniDA;EfoiDF;;EAlLA;;Iel2CA,qBAAA;Efq2CA;;EAsLA;;Ien+CU,qBAAA;Efs+CV;;Eet+CU;;IfszCV,mBAAA;EetzCU;;EfyzCV;;Iej3CA,mBAAA;Efo3CA;;EAsLA;;Iel/CU,qBAAA;Efq/CV;;Eer/CU;;Ifq0CV,qBAAA;Eer0CU;;Efw0CV;;Ieh4CA,mBAAA;Efm4CA;;EAsLA;;Iet/CM,mBAAA;Efy/CN;AACF;;AAEA;EACE;Ie7/CM,SAAA;EfigDN;;EAlLA;Iex0CQ,cAAA;If40CR,WAAA;Een1CM;;Ef0gDN;IAGE,cAAc;IetgDR,WAAA;Efo1CR;;EAsLA;Ie5gDM,cAAA;IfghDJ,UAAU;EACZ;;EethDM;Ifu2CN,cAAA;Iel2CM,mBAAA;EfwhDN;;EAlLA;Iez2CQ,cAAA;If62CR,UAAA;Ee12CM;;EfiiDN;IazlDE,cAAA;IEUE,UAAA;EfolDJ;;EAEA;IetnDA,cAAA;If0nDE,mBe1nDF;Ef2nDA;;EAtLA;IA2LE,cehnDA;IfinDA,WejnDA;EfknDF;;EennDA;IfwnDE,cevnDA;IACA,kBAAA;Ef47CF;;EA8LA;Ie1nDE,cAAA;Ifg8CF,mBAAA;Eel8CA;;EfmoDA;IA7LA,cAAA;Iet8CA,UAAA;EfwoDA;;EAEA;Ie1oDA,cAAA;IACE,mBAAA;Ef8oDF;;EAEA;IehqDA,cAAA;IfoqDE,mBepqDF;EfqqDA;;EApMA;IAyME,ceprDA;IfqrDA,UerrDA;EfsrDF;;EetnDQ;If2nDN,ce3rDA;IACA,mBAAA;Efk/CF;;EA4MA;Ie9rDE,cAAA;Ifs/CF,mBAAA;Eev7CQ;;EfsoDR;IA3MA,cAAA;Ie37CQ,UAAA;Ef2oDR;;EAEA;Ie7oDQ,cAAA;IAhEN,mBAAA;EfktDF;;EAEA;IeptDE,cAAA;IfwtDA,mBextDA;EfytDF;;EAlNA;IAuNE,ce9tDA;If+tDA,We/tDA;EfguDF;;EehqDQ;IAhEN,cAAA;EfouDF;;EAEA;IAvNA,wBAAA;Ee/8CQ;;Ef0qDR;IACE,yBe3uDA;Ef4uDF;;Ee5qDQ;IAhEN,gBAAA;EfgvDF;;EAEA;IA3NA,yBAAA;Eev9CQ;;EfsrDR;IACE,yBevvDA;EfwvDF;;EehrDU;IAxDV,gBAAA;Ef8gDA;;EAgOA;IA7NA,yBAAA;Eez9CU;;Ef49CV;Ie59CU,yBAAA;Ef4rDV;;Ee5rDU;IAxDV,gBAAA;Ef0hDA;;EAgOA;IA7NA,yBAAA;Eer+CU;;Efw+CV;Iex+CU,yBAAA;EfwsDV;;EexsDU;;If8+CV,gBAAA;Ee9+CU;;Efi/CV;;IeziDA,gBAAA;Ef4iDA;;EAgOA;;IezsDM,sBAAA;Ef4sDN;;EA5NA;;IAgOE,sBAAsB;EACxB;;EejtDM;;IAEE,qBAAA;Efs/CR;;EAgOA;;IA5NA,qBAAA;Ee5/CM;;Ef6tDN;;IextDM,mBAAA;Ef2tDN;;EA5NA;;IAgOE,mBAAmB;EACrB;;EehuDM;;IAEE,qBAAA;EfqgDR;;EAgOA;;IA5NA,qBAAA;Ee3gDM;;Ef4uDN;;IejvDM,mBAAA;EfovDN;;EA5NA;;IAgOE,mBAAmB;EACrB;AACF;;Aa7yDI;EEUE;IfyyDF,SexyDI;EfykDN;;EAkOA;Ie30DA,cAAA;If6mDA,WAAA;Ee/lDA;;Efo0DA;IAjOA,cAAA;IenmDA,WAAA;Efy0DA;;EAEA;Ie30DA,cAAA;IACE,UAAA;Ef+0DF;;EAEA;Iej1DE,cAAA;Ifq1DA,mBer1DA;Efs1DF;;EAxOA;IA6OE,ce31DA;If41DA,Ue51DA;Ef61DF;;Ee91DA;Ifm2DE,cel2DA;IACA,UAAA;EfqnDF;;EAgPA;Ier3DA,cAAA;IfyoDA,mBAAA;EeplDQ;;Efu0DR;IA/OA,cAAA;IexlDQ,WAAA;Ef40DR;;EAEA;Ie90DQ,cAAA;IAhEN,kBAAA;Efm5DF;;EAEA;Ier5DE,cAAA;Ify5DA,mBez5DA;Ef05DF;;EAtPA;IA2PE,ce/5DA;Ifg6DA,Ueh6DA;Efi6DF;;Eej2DQ;Ifs2DN,cet6DA;IACA,mBAAA;Ef2qDF;;EA8PA;Iez6DE,cAAA;If+qDF,mBAAA;EehnDQ;;Efi3DR;IA7PA,cAAA;IepnDQ,UAAA;Efs3DR;;EAEA;Iex3DQ,cAAA;IAhEN,mBAAA;Ef67DF;;EAEA;Ie/7DE,cAAA;Ifm8DA,mBen8DA;Efo8DF;;EApQA;IAyQE,cez8DA;If08DA,Ue18DA;Ef28DF;;Een4DU;IAAA,cAAA;IAxDV,mBAAA;Ef0rDA;;EA0QA;Iep8DA,cAAA;IfgsDA,mBAAA;EexoDU;;Ef2oDV;IAGA,cAAA;Ie9oDU,WAAA;Efw5DV;;Eex5DU;IAxDV,cAAA;Ef4sDA;;EA0QA;IAvQA,wBAAA;EevpDU;;Ef0pDV;Ie1pDU,yBAAA;Efo6DV;;Eep6DU;IAxDV,gBAAA;EfwtDA;;EA0QA;Ie75DQ,yBAAA;EfupDR;;EA0QA;Ie55DQ,yBAAA;EfspDR;;EA0QA;Ier6DQ,gBAAA;Ef+pDR;;EA0QA;Iep6DQ,yBAAA;Ef8pDR;;EA0QA;Ie76DQ,yBAAA;EfuqDR;;EA0QA;Ie56DQ,gBAAA;EfsqDR;;EA0QA;Ier7DQ,yBAAA;Ef+qDR;;EA0QA;Iep7DQ,yBAAA;Ef8qDR;;EA0QA;;IAtQA,gBAAA;EeprDM;;Ef+7DN;;Iep8DM,gBAAA;Efu8DN;;EAtQA;;IA0QE,sBAAsB;EACxB;;EAtQF;;IgBlzDE,sBAAA;EACA;;EAEA;;IAGA,qBAAA;EACA;;EAEA;;IAEA,qBAAA;EACA;;EAEA;;IAGA,mBVkIO;EUjIP;;EhBozDF;;IgB3yDI,mBAAA;EAEA;;EAEA;;IhBsjEA,qBgBrjEA;EhB6yDJ;;EgBzyDI;;IAGF,qBAAA;EACE;;EhBqjEF;;IgBhjEA,mBAAA;EhB0yDF;;EgBnyDA;;IhBuyDA,mBAAA;EA0QE;AgBtiEA;;AhBgyDF;EA0QE;IAtQF,SAAA;EgBhxDI;;EhBmxDJ;IgB1wDI,cAAA;IhB8wDJ,WAAA;EgB3wDE;;EhB8wDF;IgBlwDI,cAAA;IACA,WAAA;EhBswDJ;;EgBhwDE;IhBqwDF,cAAA;IA0QI,UAAU;EgBrgEd;;EAEE;IAQA,cAAA;IACE,mBAAA;EACA;;EhBmgEF;IiBvoEE,cAAA;IACA,UAAA;EACA;;EAEA;IAGA,cAAA;IAEA,UAAA;EACA;;EjB2oEF;IiBrpEE,cAAA;IACA,mBAAA;EACA;;EAEA;IAGA,cAAA;IAEA,WAAA;EACA;;EjBypEF;IiBnqEE,cAAA;IACA,kBAAA;EACA;;EAEA;IAGA,cAAA;IAEA,mBAAA;EACA;;EjBuqEF;IiBjrEE,cAAA;IACA,UAAA;EACA;;EAEA;IAGA,cAAA;IAEA,mBAAA;EACA;;EjBqrEF;IiB/rEE,cAAA;IACA,mBAAA;EACA;;EAEA;IAGA,cAAA;IAEA,UAAA;EACA;;EjBmsEF;IiB7sEE,cAAA;IACA,mBAAA;EACA;;EAEA;IAGA,cAAA;IAEA,mBAAA;EACA;;EjBitEF;IiB3tEE,cAAA;IACA,UAAA;EACA;;EAEA;IAGA,cAAA;IAEA,mBAAA;EACA;;EjB+tEF;IiBzuEE,cAAA;IACA,mBAAA;EACA;;EAEA;IAGA,cAAA;IAEA,WAAA;EACA;;EjB6uEF;IgB5lEE,cAAA;EACE;;EhBs1DN;IA0QI,wBAAwB;Ea1rExB;;Eb6rEF;IgBlmEI,yBAAA;EhB21DJ;;Eat7DE;IGyFA,gBAAA;EhB0mEF;;EAvQA;IACF,yBAAA;Ea77DI;;EbysEF;IgB9mEI,yBAAA;EhBu2DJ;;Eal8DE;IGyFA,gBAAA;EhBsnEF;;EAvQA;IACF,yBAAA;Eaz8DI;;EbqtEF;IgB1nEI,yBAAA;EhBm3DJ;;EkBthEF;IACE,gBAAA;ElByhEF;;EkBhhEA;IACE,yBAAA;EACA;;EhB+QI;IgB1QJ,yBZsP4B;EN2xD9B;;EkB7gEA;;IAEE,gBAAA;EhBoQI;;EFuhEJ;;IkBtxEA,gBAAA;EACA;;ElBihEF;;ImB9iEA,sBAAA;EACE;;EAIA;;InByzEE,sBAAsB;EoB9zE1B;;EAEE;;IlByRI,qBALI;EkBhRR;;EAEA;;IpBg0EE,qBoB/zEF;EpBg0EA;;EoB9zEA;;IVIE,mBAAA;EWHE;;EAAA;;IrBwjEN,mBAAA;EqBpjEM;;ErBq0EJ;;IA7QA,qBAAA;EACF;;EoBpjEI;;IAEA,qBAAA;EACE;;EAKJ;;IAEE,mBAAA;EACA;;EAME;;IpBgjEN,mBAAA;EoB5iEE;ApB8zEF;;AAEA;EA/QA,8BAAA;EoB3hEE,2BAAA;EACE,+BAAA;EACA,4BAAA;EpB6hEJ,0CAAA;EoBzhEE,gCAAA;EACE,+Cd2VoC;EczVpC,iCAAA;EpB0hEJ,kDAAA;EoB7hEE,+DAAA;EACE,iDd2VoC;EczVpC,6DAAA;EpB0hEJ,gDAAA;EoB7hEE,8DAAA;EACE,WAAA;EAEA,mBAAA;EpB0hEJ,mBAAA;EoB7hEE,0CAAA;ApBuzEF;;AA1RA;EoB7hEE,sBAAA;EACE,qFd2VoC;EczVpC,oCAAA;EpB0hEJ,2CAAA;EoBhhEI,2Gd6ToC;ANs/DxC;;AA9RA;EoB9gEE,uBAAA;ApBgzEF;;AAEA;EACE,sBoBhzEE;ApBizEJ;;AAEA;EoB/yEI,qEAAA;ApBizEJ;;AAEA;EoB/yEI,iBAAA;ApBizEJ;;AAhSA;EoB5hEE,wBAAA;ApBg0EF;;AAEA;EACE,sCM5lE4B;AN6lE9B;;AAEA;EoB/zEI,sCAAA;ApBi0EJ;;AAEA;EoB/zEI,sBAAA;ApBi0EJ;;AAhTA;EqBtmEM,mBAAA;ArB05EN;;AAEA;EAlTE,oDAAA;EoBhiEA,8CAAA;ApBq1EF;;AAEA;EAtTA,oDAAA;EoBlhEE,8CAAA;ApB20EF;;AoB30EE;EACE,oDhB47B8B;EJwlClC,8CAAA;AA2TA;;AAEA;EoBt0EE,mDAAA;EACA,6CAAA;ApBw0EF;;AAEA;EoBt0EE,sBAAA;EACA,sBAAA;EACA,gCAAA;EpB8gEF,8BAAA;EoB5gEE,8BAAA;EACE,6BAAA;EpB8gEJ,6BAAA;EoB3gEE,4BAAA;EAEE,4BAAA;EACA,4BAAA;EpB4gEJ,0CAAA;AA2TA;;AAEA;EoB5zEE,sBAAA;ElByII,sBALI;EQvQN,gCAAA;EVyoEJ,8BAAA;EoBlgEE,8BAAA;EACE,6BAAA;EACA,6BAAA;EACA,4BdiL0B;EN6oE5B,4BoB9zEE;EpBogEJ,4BAAA;EoBvgEE,0CAAA;ApBo0EF;;AAEA;EACE,sBoBp0EE;EpBogEJ,sBAAA;EAkUE,gCAAgC;EoBl0ElC,8BAAA;EACE,8BAAA;EACA,6BAAA;ElB4HI,6BALI;EQvQN,4BAAA;EVqpEJ,4BAAA;EoBjgEE,4BAAA;EACE,0CAAA;ApBo0EJ;;AAEA;EAjUA,sBAAA;EoBtgEE,sBAAA;EACE,gCAAA;EACA,8BAAA;EACA,8BdyK0B;ENiqE5B,6BoB10EE;EpBmgEJ,6BAAA;EAyUE,4BAA4B;EoBp0E5B,4BAAA;EACE,4BAAA;EpB8/DJ,0CAAA;AoB3/DE;;ApB8/DF;EoB1/DE,sBAAA;EACE,sBAAA;EpB4/DJ,gCAAA;EAyUE,8BAA8B;EoBh0EhC,8BAAA;EACE,6BhBquBsC;EgBpuBtC,6BAAA;EACA,4BdiI4B;ENy3D9B,4BAAA;EoBx/DE,4BAAA;EACE,0CAAA;ApB0/DJ;;AA0UA;EUv/EI,sBAAA;EVirEJ,sBAAA;EoBt/DE,gCAAA;EACE,8BAAA;EV5LA,8BAAA;EVqrEJ,6BAAA;EoBr/DE,6BAAA;EAAoB,4BAAA;EpBw/DtB,4BAAA;EoBv/DE,4BAAA;EAAoB,0CduNkB;ANmyDxC;;AsBzsEA;EACE,sBAAA;EAEA,sBAAA;EACA,gCAAA;EACA,8BAAA;EpBqRI,8BALI;EoB7QR,6BlB+lB4B;EkB9lB5B,6BhB6P4B;EgB5P5B,4BhBwYsC;EgBvYtC,4BAAA;EtBkhFA,4BsBlhFA;EtBmhFA,0CsBnhFA;AtBohFF;;AAEA;EsBlhFE,sBAAA;EACA,sBAAA;EACA,gCAAA;EZHE,8BAAA;EWHE,8BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,4BAAA;ErBktEN,4BAAA;EqB9sEM,4BAAA;ECfN,0CAAA;AtB6iFA;;AAEA;EA7UA,gBAAA;EsB5sEE,iCAAA;AtB4hFF;;AAEA;EACE;IA9UF,gBAAA;IsBtsEE,iCAAA;EAEE;AtBshFJ;;AsBlhFE;EAEE;IACA,gBAAA;ItBqsEJ,iCAAA;EsBjsEE;AtBkhFF;;AA7UA;EAgVE;IsB/gFF,gBAAA;IACE,iClBsuB4B;EkBruB5B;AtBihFF;;AAEA;EA9UA;IAgVI,gBAAgB;IsB/gFpB,iCAAA;EACE;AtBihFF;;AAEA;EUlkFI;IVqvEJ,gBAAA;IAgVI,iCAAiC;EsB7gFjC;AtB+gFJ;;AAEA;EuBxlFA,qBAAA;AvB0lFA;;AAEA;EuBxlFE,+BnBq6BwC;EJs2C1C,kCAAA;EuBzwEE,gBAAA;EACE,kBAAA;EACA,gBAAA;AvB2wEJ;;AuBvwEA;EACE,+BnB25BwC;EmB15BxC,kCAAA;EACA,eAAA;AvB0wEF;;AAiVA;EuBvlFI,+BAAA;EACA,kCAAA;EvB0wEJ,oBAAA;AAgVA;;AAEA;EuBrlFE,mBAAA;EvBulFA,kBuBvlFA;EACA,gCnB04BwC;AJ8sD1C;;AAEA;EuBtlFE,cAAA;EvBwlFA,WuBxlFA;EvBylFA,oBuBzlFA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EAGA,gBAAA;EvB0lFA,sBuB1lFA;EvBwwEF,4BAAA;EuBrwEE,oCAAA;Eb3BE,qBAAA;EaiCA,wEjB4XsC;AiBzXxC;;AvBwlFF;EAnVA;IuBhwEI,gBAAA;EACA;AvBulFJ;;AAnVA;EuBhwEE,gBAAA;AvBulFF;;AAnVA;EuBhwEI,eAAA;AvBulFJ;;AuB/kFI;EAII,yBAAA;EvB0vER,sBAAA;EuBrvEE,qBAAA;EACE,UAAA;EAME,gBAAA;AvBmvEN;;AAuVA;EuBpkFI,eAAA;EvBskFF,auBtkFE;EACA,SAAA;AvBivEJ;;AAwVA;EuBhkFM,cnBy1BqC;EJm5C3C,UAAA;AAuVA;;AAlUA;EuBluEI,yBAAA;EACE,UAAA;AvB4jFN;;AuBljFE;EACE,oCnBwzB8B;EmBvzB9B,oCAAA;EvB6tEJ,UAAA;AuB3tEI;;AvBukFJ;EAxVA,oBAAA;EA0VE,qBAAqB;EuB3iFjB,uBAAA;EvBqtEN,2BAAA;EA0VE,uCAAuC;EwBluFzC,oBAAA;EACE,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;ExBouFA,gBwBpuFA;EACA,gCAAA;AxB24EF;;AA6VA;;EwBhuFI;IxB44EJ,gBAAA;EwBz4EE;AxBuuFF;;AAMA;EACE,wCwBtuFE;AxBuuFJ;;AAEA;EqBvvFM,cAAA;EAAA,WAAA;EAAA,iBAAA;EAAA,gBAAA;ErB45EN,gBAAA;EqBx5EM,2BAAA;EGMJ,6BAAA;ExBqvFA,yBqB1vFM;ErB2vFN,mBqB3vFM;ArB4vFR;;AwB5uFI;ECjCF,UAAA;AzBg7EF;;AAmWA;;EwB1uFI,gBAAA;EACA,epBu+B8B;AJswDlC;;AAEA;EAhWA,uCAAA;EwBx4EE,sBAAA;EACE,oBpBo+BuC;EoBn+BvC,qBpBm+BuC;AJwwD3C;;AASA;EACE,sBqBvxFM;ErBwxFN,uBqBxxFM;ErBs7ER,yBAAA;AwB54EI;;AxB+4EJ;EwB14EE,uCAAA;EACE,sBpB88B8B;EoB78B9B,epB88B8B;EoB78B9B,qBAAA;AxBgvFJ;;AASA;EAnWA,sBAAA;EwBv4EI,uBAAA;ExB04EJ,yBAAA;AAqWA;;AAEA;EAnWA,oCAAA;A0Bj+EE;;A1Bw0FF;E0Br0FI,uCAAA;A1Bu0FJ;;AAlWA;E0Bh+EE,uCAAA;A1Bs0FF;;AAEA;E0Bp0FI,WAAA;EACA,gCAAA;EACA,eAAA;A1Bs0FJ;;AAEA;E0Bp0FI,eAAA;A1Bs0FJ;;AAEA;EACE,oB0Bt0FE;ELRE,qBAAA;ArBg1FN;;AAEA;EAvWA,oBAAA;EqBv+EM,qBAAA;ArBi1FN;;AAEA;EAxWE,mCAAA;AACF;;AA2WA;E0B70FI,mCAAA;A1Bs+EJ;;AA2WA;EAvWA,gEAAA;E0Bx+EI,cAAA;EACE,WAAA;E1Bu+EN,mCAAA;E0Bx+EI,oBAAA;EACE,gBAAA;E1Bu+EN,gBAAA;E0Bx+EI,yBAAA;EAAA,gBAAA;E1B21FF,mCAAmC;E0B11F/B,mFAAA;E1Bu+EN,4BAAA;E0Bp+EI,yCAAA;EAEE,0BtB4gCkC;EsB3gClC,2DtB4gCkC;EJ29CxC,qBAAA;E0Bv+EM,wEtB4gCkC;AsB/gCpC;;A1Bo2FJ;E0Bl2FM;I1Bw+EN,gBAAA;E0Bp+EI;A1Bm2FJ;;AAEA;EA5XA,qBAAA;E0Bn+EE,UAAA;EAEE,4CtBigCoC;AJo+CxC;;AA+XA;;EAxXA,mBAAA;E0Br+EI,sBAAA;A1Bi2FJ;;AA5XA;E0Br+EI,wCAAA;E1Bq2FF,oCAAoC;AACtC;;AAEA;E0Bt2FM,kBAAA;E1Bw2FJ,qC0Bx2FI;A1Bm+EN;;AAwYA;E0Bv2FQ,oBAAA;EACA,uBAAA;EACA,oBtBm/BgC;EsBl/BhC,mBAAA;EACA,yCpB9DM;ANu6Fd;;A0B/2FM;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBtBm/BgC;EsBl/BhC,yCAAA;A1Bk3FR;;AA1YA;E0B7+EM,gEAAA;A1B23FN;;AAEA;E0B53FQ,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBtBm/BgC;AJ24DxC;;AAEA;EAvZA,WAAA;E0Bh+EI,mBAAA;A1B03FJ;;AAEA;EAxZA,oBAAA;E0B79EI,eAAA;EACE,iBAAA;A1B+9EN;;AA2ZA;E0Bp3FI,YAAA;E1B69EJ,oBAAA;E0B39EI,cAAA;A1Bs3FJ;;AAvZA;EA0ZE,sCAAsC;E2B98FtC,cAAA;EACA,UAAA;EAAA,WAAA;EAAA,kBAAA;EACA,mBAAA;E3Bq9FA,gB2Bp9FA;E3Bq9FA,yC2Br9FA;EACA,+CAAA;E3BwjFF,4BAAA;E2BtjFE,2BAAA;E3Bs9FA,wBAAwB;EACxB,qCAAqC;E2Bp9FnC,iCAAA;EACA,yBAAA;A3Bs9FJ;;AAEA;E2Bt9FI,qBAAA;A3BwjFJ;;AAkaA;EACE,kBAAkB;AACpB;;A2B/8FE;EAEE,uBAAA;A3BkjFJ;;AAkaA;EA/ZA,qBAAA;EAiaE,UAAU;E2Bv8FV,4CAAA;A3B08FF;;AAEA;EACE,yB2B58FA;E3B68FA,qB2B78FA;A3B88FF;;AAEA;E2B58FE,iErBuN4B;ANuvF9B;;AAEA;E2B58FE,iErByYsC;ANqkFxC;;AAlaA;EAqaE,yBAAyB;E2Bt8F3B,qBAAA;E3Bw8FE,iEAAiP;AACnP;;AAEA;EE/uFM,oBALI;EFm1EV,YAAA;EAqaE,YAAY;A2Bt8Fd;;A3By8FA;;E2Br8FE,eAAA;EzB+MI,YAAA;AF0vFN;;AAEA;E2Bt8FA,mBAAA;A3Bw8FA;;AAlaA;EAqaE,4DAA2K;E2B57FzK,UAAA;E3B87FF,mBAAmB;EACnB,0CAA0C;EAC1C,gCAAgC;EUjgG9B,kBAAA;EVgmFJ,iDAAA;A2BthFI;;A3B67FJ;EACE;IUvgGE,gBAAA;EVsmFJ;A2BhhFE;;A3Bu7FF;EU//FI,4DAAA;AV6lFJ;;AAsaA;EUpgGI,iCAAA;EACA,4DAAA;AVkmFJ;;A4B1nFE;EACE,oBAAA;EACA,eAAA;A5BiiGJ;;AAEA;EAnaA,oBAAA;EAqaE,cAAc;A4B9hGd;;A5BiiGF;E4B9hGI,qBAAA;EACA,kBAAA;A5BgiGJ;;AAEA;EE1yFM,kBAAA;E0BlPF,sBxBqiCqB;EwBpiCrB,oBAAA;A5B+hGJ;;AAEA;;EAEE,oBAAoB;EAEpB,YAAY;E4B9hGR,aAAA;A5B4nFN;;A4B3qFI;EAqDE,4DxBuhCmB;AJugEzB;;AAEA;E4B1hGQ,WAAA;EACA,cAAA;E5BwnFR,UAAA;E4BnnFQ,gBAAA;E5B2hGN,6B4B3hGM;A5BunFR;;A4BxrFI;EA0EI,UAAA;A5BuhGR;;AAEA;E4BjhGM,mCAAA;A5B+mFN;;AAuaA;E4BhhGU,mCxB05B8B;AJwnExC;;AAnaA;E4BzmFM,SAAA;A5BghGN;;AAEA;EAraA,WAAA;EAuaE,YAAY;E4BlnGV,oBAAA;E5B+sFJ,gBAAA;EAuaE,yBAAyB;E4BtnGvB,SAAA;EA+GE,mBAAA;EAGE,oHxB09BiB;EwB19BjB,4GxB09BiB;AwBv9BnB;;A5B0gGN;EAtaA;I4B/lFQ,wBAAA;IAAA,gBAAA;E5BkmFR;AAwaA;;AAEA;EAtaA,yBAAA;AAwaA;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;E4BngGV,eAAA;E5B8lFV,wCAAA;EAwaE,yBAAyB;E4B5nGzB,mBAAA;A5B8nGF;;AAEA;EE33FM,WAAA;E0B/PF,YAAA;E5B8nGF,gBAAgB;E4B3nGhB,yBAAA;EACE,SAAA;EACA,mBAAA;EAEA,iHAAA;EAAA,4GAAA;A5B6nGJ;;AAEA;EEv4FM;I0BjPF,qBAAA;IAAA,gBAAA;ElB3BA;AVivFJ;;A4BjtFI;E5B2nGF,yBAAyB;AAC3B;;AAEA;EAtaA,WAAA;EAwaE,cAAc;E4B7qGZ,kBAAA;EAqDE,eAAA;EAGE,wCxB81BgC;EwB71BhC,yBAAA;EACA,mBAAA;A5BynGR;;AAraA;E4B/sFM,oBAAA;A5BwnGN;;AAEA;EAvaA,yBAAA;AAyaA;;AAEA;E4BlnGQ,yBAAA;A5B4sFR;;A4BvxFI;EAkFE,kBAAA;A5BysFN;;AA0aA;;;E4B3mGU,uDAAA;E5BusFV,2DAAA;E4BnsFM,iBAAA;A5B6mGN;;AAEA;EAxaA,kBAAA;EA0aE,MAAM;E4B/sGJ,OAAA;EAwGI,UAAA;E5BisFR,YAAA;EA0aE,qBAAqB;E4BntGnB,gBAAA;EA+GE,iBAAA;E5B8rFN,uBAAA;E4B5rFM,mBAAA;EACE,oBAAA;E5B8rFR,6BAAA;E4B1rFQ,qBAAA;EAGF,gEAAA;A5B6rFN;;A4BvrFI;EACE;I5BqmGF,gBAAgB;E4BruGhB;A5BuuGJ;;AAEA;;E4B7lGU,qBAAA;A5BsrFV;;AAgcA;;E6B3uGE,kBAAA;A7B8uGF;;AAcA;;;;EA3aA,qBAAA;E6Bp0FE,wBAAA;A7BqvGF;;AAEA;;E6BhvGE,qBAAA;EAEE,wBAAA;A7BkvGJ;;AA7aA;E6Bh0FE,qBAAA;EACE,wBAAA;A7BivGJ;;A6B1tGE;;;;E7ByzFF,2CAAA;E6BxyFQ,8DAAA;A7B4tGR;;AAsBA;;;;EAIE,kBAAkB;E6B7tGlB,oBAAA;ECtGA,WAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;A9Bs0GF;;AAEA;E8Bp0GE,2CAAA;EAEA,8DAAA;A9Bs0GF;;AAEA;EAjbA,mBAAA;AAmbA;;AAEA;;E8Bp1GE,cAAA;A9Bu1GF;;AAEA;;E8Bp1GE,oCAAA;A9Bu1GF;;AAEA;E8Br1GE,kBAAA;E9Bu6FF,aAAA;E6B50FE,eAAA;ECpGA,oBAAA;EACA,WAAA;A9Bw2GF;;AAEA;;;E8Bp2GE,kBAAA;EAGA,cAAA;EACA,SAAA;E9Bs7FF,YAAA;AAmbA;;AAEA;;;E8Br3GE,UAAA;A9By3GF;;AAEA;E8Bv3GE,kBAAA;EACA,UAAA;A9By3GF;;AAEA;E8Bv3GE,UAAA;A9By3GF;;AAEA;E8Bt4GE,aAAA;EAGA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,oCAAA;E9Bw9FF,qBAAA;AAmbA;;AAEA;;;;E8Bt5GE,sBAAA;EACA,eAAA;EACA,qBAAA;A9B25GF;;AAEA;;;;E8Bt5GE,sBAAA;E9By+FF,oBAAA;EAmbE,qBAAqB;A6Bn0GrB;;A7Bs0GF;;E8Bz6GE,sBAAA;A9B46GF;;AAEA;;;;E8Bv6GE,0BAAA;EACA,6BAAA;A9B46GF;;AAhbA;;;;E8B7+FE,0BAAA;EACA,6BAAA;A9Bo6GF;;AAEA;E8Bl6GE,2BAAA;EACA,yBAAA;EACA,4BAAA;A9Bo6GF;;AAEA;;E8Bj6GE,yBAAA;E9Bk/FF,4BAAA;AAmbA;;AAEA;E8Bn7GE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;A9Bq7GF;;AAEA;E8Bn7GE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;E9BmgGF,uBAAA;EAmbE,kBAAkB;E6B51GlB,mBAAA;ECvGA,WAAA;EACA,mCAAA;EACA,sCAAA;A9Bs8GF;;AAEA;;;;E8Bj8GE,cAAA;A9Bs8GF;;AAEA;;EAhbA,+CAAA;EAmbE,oCAAoC;E6B72GpC,yDAAA;ECvGA,4BAAA;EACA,2DAAA;EACA,gEAAA;A9Bu9GF;;AAEA;;E8Bp9GE,+CAAA;EAEA,2DAAA;A9Bu9GF;;AAEA;;EAhbA,oCAAA;EAmbE,kFAAkF;A6B93GlF;;A7Bi4GF;;E8Br+GE,+CAAA;A9Bw+GF;;AAEA;;;;E8Bn+GE,iEAAA;EACA,uBAAA;EACA,+DAAA;EACA,2EAAA;A9BsjGF;;A6B59FE;;ECtGA,+CAAA;EAEA,2DAAA;A9By/GF;;AAEA;;E8Bt/GE,yCAAA;A9By/GF;;AAEA;;E8Bt/GE,+CAAA;A9BukGF;;A6B7+FE;;ECtGA,4CAAA;A9B0gHF;;AAEA;;E8BtgHE,2DAAA;A9B0gHF;;AAEA;;E8BvgHE,iCAAA;A9B0gHF;;AAEA;E6Bj7GE,kBAAA;A7Bm7GF;;AAEA;;;;;;E8BphHE,UAAA;A9B2hHF;;AAEA;E8BzhHE,aAAA;EACA,WAAA;E9BymGF,mBAAA;EAmbE,kBAAkB;E6Bt7GpB,mCAAA;A7Bw7GA;;AAEA;E6Bt7GE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EAEA,kCvBY0B;ENy/F5B,sCAAA;A6B3/FE;;A7B8/FF;;;;EAsbE,cAAc;A6Bp6GhB;;A7Bu6GA;;E8B5iHE,iDAAA;E9B6nGF,oCAAA;EAmbE,0DAA4U;E6Bv6G9U,4BAAA;EC5IE,2DAAA;EACA,gEAAA;A9BsjHF;;AAhbA;;E+BvsGA,iDAAA;EVgBM,0DUfJ;A/B0sGF;;AAqbA;;EAEE,oCqB7mHM;ErB0rGN,kFAAA;AACF;;AAsbA;;EAEE,iDAAiD;A+B9nHjD;;A/B6sGF;;;;E+BtsGE,kEAAA;EVDI,uBAAA;EAAA,+DUEJ;E/B2sGF,2EAAA;AqBzsGM;;ArBioHN;;EApbE,iDAAA;E+B7sGA,0DAAA;A/BsoHF;;AAEA;;EArbA,yCAAA;AqBntGM;;ArB6oHN;;EAtbE,iDAAA;AACF;;AgC3uGA;;EhCuqHE,8CAA8C;AAChD;;AAEA;;EAGE,0DAA0D;AgCpqH5D;;AhC+uGA;;EiCrtGM,mCAAA;AjCgpHN;;AAEA;EiCprHE,kBAAA;AjCsrHF;;AAEA;;;;;;EgCxqHA,UAAA;AhC+qHA;;AAEA;EgC5qHE,wBAAA;EACA,0BAAA;E9BuQI,sBAAA;E8BrQJ,6BAAA;EACA,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,8BAAA;EACA,wCAAA;EACA,yBAAA;EACA,+BAAA;EACA,2EAAA;EACA,qBAAA;EACA,wDAAA;EACA,sCAAA;EACA,kCAAA;EACA,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;E9B0OI,mEALI;E8BnOR,0CAAA;EACA,kCAAA;EAEA,gCAAA;AhC4qHF;;AAEA;EAvbA;IgChvGI,gBAAA;EACA;AhC2qHJ;;AAEA;EgCppHI,gCAAA;EACE,wCAAA;EhC8tGN,8CAAA;AgC5tGM;;AhCupHN;EAvbA,0BAAA;EAybE,kCAAkC;EgCnpHhC,wCAAA;AhCqpHJ;;AgClpHM;EACE,gCAAA;EACA,wCAAA;EhC6tGR,8CAAA;EAybE,UAAU;EgCpqHR,0CAAA;AhCuqHJ;;AAEA;EACE,8CgCtqHM;EhCuqHN,UgCtqHM;EAIJ,0CAAA;AhCqqHJ;;AAEA;;;;;Ea5sHI,iCAAA;EmB4BA,yCAAA;EhCurHF,+CgCtrHI;AhCurHN;;AAEA;;;;;EgC9qHM,0CAAA;AhCqrHN;;AAEA;;;EgCnsHI,mCAAA;EhCusHF,oBgCtsHI;EhC+wGJ,2CAAA;EgC7wGI,iDAAA;EhCusHJ,uCgCtsHM;AhCusHR;;AAEA;EACE,oBgCpsHI;EhC6wGJ,oBAAA;EgC3wGI,8BAAA;EhCqsHJ,0BgCpsHM;EhCqsHN,0BgCpsHM;EhC6wGN,oCAAA;EACF,uCAAA;EaxzGI,2BAAA;EmB4BA,2BAAA;EhCutHF,qCgCttHI;EhC+xGJ,4BAAA;EgC7xGI,6BAAA;EhCutHJ,6BgCttHM;EhCutHN,uCgCttHM;AhCutHR;;AAEA;EAvbE,oBAAA;EgC3xGI,oBAAA;EhCqtHJ,8BgCptHM;EhCqtHN,0BgCptHM;EhC6xGN,0BAAA;EACF,oCAAA;Eax0GI,qCAAA;EmB4BA,2BAAA;EhCuuHF,2BgCtuHI;EhC+yGJ,qCAAA;EgC7yGI,4BAAA;EhCuuHJ,6BgCtuHM;EhCuuHN,6BgCtuHM;EhC+yGN,uCAAA;AAybF;;AAEA;EgCnuHM,oBAAA;EhCquHJ,oBgCpuHM;EhCquHN,8BgCpuHM;EhC6yGN,0BAAA;EACF,0BAAA;EgCpyGE,oCAAA;EACE,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EhCsyGJ,4BAAA;EiC13GI,6BAAA;EACE,6BAAA;EACA,uC7B6hBwB;AJuxG9B;;AAEA;EiCj1HE,oBAAA;EACA,oBAAA;EACA,8BAAA;EjC25GF,0BAAA;EiCx2GI,0BAAA;EACE,oCAAA;EjC02GN,wCAAA;EAybE,2BAA2B;EgCnuH3B,2BAAA;EACE,qCAAA;EACA,4BAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC6yGJ;;AA0bA;EiCv0HM,oB7B6hBwB;E6B5hBxB,oBAAA;EACA,8BAAA;EAvBJ,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EjCy6GF,2BAAA;EiC73GI,2BAAA;EACE,qCAAA;EjC+3GN,4BAAA;EgCrzGI,6BAAA;EACE,6BAAA;EhCuzGN,uCAAA;AAybA;;AAEA;EgC1uHI,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EhCozGJ,0BAAA;EiCv6GI,oCAAA;EACE,sCAAA;EACA,2B7B6hBwB;E6B5hBxB,2B7B2hBwB;E6B1hBxB,qCAAA;EjCy6GN,4BAAA;EiC95GM,6BAAA;EACE,6BAAA;EjCg6GR,uCAAA;AiC75GM;;AjCw1HN;EiCr1HQ,oBAAA;EACA,oBAAA;EAnCN,8BAAA;EACA,0BAAA;EACA,0BAAA;EjCm8GF,oCAAA;EiC75GI,wCAAA;EACE,2BAAA;EjC+5GN,2BAAA;EgCp0GI,qCAAA;EACE,4BAAA;EhCs0GN,6BAAA;EAybE,6BAA6B;EgCxvH/B,uCAAA;AhC0vHA;;AAEA;EgCxvHE,oBAAA;EACA,oBAAA;EhCk0GF,8BAAA;EAybE,0BAA0B;EgCrvH5B,0BAAA;EACE,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qC1BkF4B;E0BjF5B,4BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,uCAAA;AhCsvHF;;AAtbA;EgC5zGE,uBAAA;EAEE,8BAAA;EP1LF,0BAAA;EzBw/GF,0BAAA;EgCzzGE,oCAAA;EAEE,uCAAA;EACA,2BAAA;EPlMF,2BAAA;EzB6/GF,qCAAA;EgCvzGE,4BAAA;EAEE,gCAAA;EACA,iCAAA;EACA,uCAAA;EhCwzGJ,mBAAA;AAybA;;AAEA;EAvbA,uBAAA;EAybE,8BAA8B;EgC1uHhC,0BAAA;EACE,0BAAA;EACA,oCAAA;EACA,qCAAA;E9BmEI,2BALI;E8B5DR,2BAAA;EACA,qCAAA;EhCozGF,4BAAA;EAybE,gCAAgC;EgCzuHlC,iCAAA;EACE,uCAAA;EACA,mBAAA;AhC2uHF;;AAEA;EgCxuHA,uBAAA;EAEE,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EhCizGF,mBAAA;AAybA;;AAEA;EkCh+HE,uBAAA;EACA,8BAAA;EAAA,0BAAA;EAAA,0BAAA;EACA,oCAAA;ElC0iHF,uCAAA;EkCxiHE,2BAAA;ElCo+HA,2BAA2B;EkCn+HzB,qCAAA;EACA,4BAAA;ElCq+HF,gCkCr+HE;ElCs+HF,iCkCt+HE;ElC2iHJ,uCAAA;EkCtiHE,mBAAA;AlCo+HF;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;EkCx+HzB,qCAAA;ElC8iHJ,4BAAA;EA6bE,gCAAgC;EkCt+HlC,iCAAA;EACE,uCAAA;EAAA,mBAAA;AlCy+HF;;AAEA;EkCz+HE,uBAAA;ElC2+HA,8BkC3+HA;ElC4+HA,0BkC5+HA;ElC4iHF,0BAAA;EkC1iHE,oCAAA;EACE,sCAAA;ElC4iHJ,2BAAA;EAkcE,2BAA2B;EkC1+H7B,qCAAA;ExBhBI,4BAAA;EV4jHJ,gCAAA;EkCxiHE,iCAAA;ElC2+HA,uCAAuC;EkCz+HrC,mBAAA;AlC0iHJ;;AAmcA;EACE,uBAAuB;EUp/HrB,8BAAA;EACA,0BAAA;EVqjHJ,0BAAA;EkCliHE,oCAAA;ElCq+HA,wCAAwC;EACxC,2BAA2B;EU5+HzB,2BAAA;EACA,qCAAA;EV6iHJ,4BAAA;EAkcE,gCAAgC;EkCv9HlC,iCAAA;EACE,uCAAA;EACA,mBAAA;AlCwhHF;;AAmcA;EAhcA,uBAAA;EkCnhHE,8BAAA;EACE,0BAAA;ElCqhHJ,0BAAA;EAkcE,oCAAoC;EkCn9HtC,qCAAA;EACE,2BAAA;EACA,2BAAA;ElCohHF,qCAAA;EAkcE,4BAA4B;EkCn9H9B,gCAAA;EACE,iCAAA;EACA,uCAAA;ElCohHF,mBAAA;AAkcA;;AAEA;EkCn8HE,yBAAA;ElCq8HA,oCkCr8HA;ElCs8HA,wBkCt8HA;EACA,kCAAA;ElCu8HA,gDkCv8HA;ElCw8HA,wCkCx8HA;EACA,iDAAA;ElCy8HA,yCkCz8HA;ElC08HA,2CkC18HA;ElCmgHF,2CAAA;EkCjgHE,+BAAA;ElC28HA,uCAAuC;EkCz8HrC,qBAAA;AlCmgHJ;;AA0cA;EkCx8HI,0BAAA;AlCkgHJ;;AA0cA;EUliII,gCAAA;AVoiIJ;;AkCr8HE;;ExB7GE,0BAAA;EACA,0BAAA;EV+mHJ,wBAAA;EAycE,8BAA8B;AmChlIhC;;AnCmlIA;;EmC7kIE,0BAAA;EACA,0BAAA;EACA,6BAAA;EAGA,8BAAA;AnC8kIF;;AAEA;EmC9kIE,gCAAA;AnCilIF;;AAzcA;EA4cE;ImC9kIA,gBAAA;EACA;AnCilIF;;AAEA;EmC9kIE,UAAA;AnCglIF;;AAEA;EA3cA,aAAA;AqBjpHM;;ArBgmIN;EACE,SqBhmIM;ErBopHN,gBAAA;EmCvoHA,6BAAA;AnCulIF;;AmCjlIE;EACE;InCqlIA,gBmCplIA;EnCuoHJ;AmCnoHE;;AnColIF;EmChlII,QAAA;EnCooHJ,YAAA;EmC5nHA,4BAAA;AnC6kIA;;AAEA;EmC1kIE;IAEA,gBAAA;EACA;AnC4kIF;;AmCvkIE;;;;;;EAKE,kBAAA;AnC2kIJ;;AA5cA;EmCvnHE,mBAAA;AnCukIF;;AAEA;EmCrkII,qBAAA;EnCynHJ,oBAAA;EmCtnHE,uBAAA;EAEE,WAAA;EzBjEA,uBAAA;EACA,qCAAA;EVyrHJ,gBAAA;EA+cE,oCAAoC;AmC7jItC;;AnCgkIA;EmC5jIE,cAAA;AnCgnHF;;AAgdA;EA7cA,0BAAA;EmC5mHE,8BAAA;EnC4jIA,0BAA0B;EmC1jIxB,6BAAA;EVjHF,uBAAA;EzBguHF,kCAAA;EA+cE,yCAAyC;EmCpjI3C,sBAAA;EAEE,+CAAA;EACA,mCAAA;EACA,+BAAA;EAGA,yFAAA;EnCqmHF,4CAAA;EmCnmHE,sCAAA;EACE,iGAAA;EACA,4CAAA;EACA,uCAAA;EnCqmHJ,wCAAA;EmCnmHI,wCAAA;EAEE,yCAAA;EnComHN,qDAAA;EmChmHE,oCAAA;EnCgjIA,oCAAoC;EmC9iIlC,8C7BiH0B;E6BhH1B,oCAAA;EACA,sCAAA;EnCkmHJ,kBAAA;EA+cE,kCAAkC;EmCviIlC,aAAA;EnCyiIA,uCAAuC;EmCviIrC,kEAAA;EnCyiIF,SmCziIE;EnC0iIF,uCmC1iIE;EACA,+BAAA;EnC2lHJ,gBAAA;EAidE,gBAAgB;EmCviIhB,uCAAA;EnCyiIA,4BAA4B;EmCviI1B,6EAAA;EnCyiIF,+CmCziIE;AnC0iIJ;;AAEA;EmC1iII,SAAA;EnCylHJ,OAAA;EAodE,qCAAqC;AmCviIrC;;AnC0iIF;EAldA,oBAAA;AAodA;;AAEA;EAldA,WAAA;EmC9kHE,OAAA;AnCmiIF;;AAEA;EoCjuIA,kBAAA;ApCmuIA;;AAEA;EoChuIE,QAAA;EACA,UAAA;ApCkuIF;;AAEA;EoChuIE;IACA,oBAAA;EACA;;EAEA;IACA,WAAA;IACA,OAAA;EACA;;EAEA;IACA,kBAAA;EACA;;EAIA;IAAA,QAAA;IAAA,UAAA;EACA;ApCkuIF;;AAEA;EACE;IoCnuIA,oBAAA;EpCquIA;;EoCpuIA;IpC6wHF,WAAA;IoCvwHE,OAAA;EpCmuIA;;EAEA;IACE,kBAAkB;EACpB;;EoCtuIE;IAAA,QAAA;IAAA,UAAA;EACA;ApC2uIJ;;AAEA;EACE;IoC5uIE,oBAAA;EpC8uIF;;EA/dF;IoC3vHA,WAAA;IACE,OAAA;EACA;;ElC6NI;IkC1NJ,kBAAA;EAEA;;EAEA;IAEE,QAAA;IpC2vHJ,UAAA;EAkeE;AoCntIF;;ApCstIA;EoCjtIE;IACA,oBAAA;EACA;;EAIA;IAAA,WAAA;IAAA,OAAA;EACA;;EpCotIA;IACE,kBoCrtIF;EACA;;EAEA;IpCgvHF,QAAA;IoC7uHI,UAAA;EAEE;ApC8uHN;;AAweA;EAreA;IAueI,oBAAoB;EoC1sIxB;;EAEE;IACA,WAAA;IpCsuHF,OAAA;EoCpuHE;;EpC6sIA;IoC1sIE,kBAAA;EpCsuHJ;;EoCztHA;IACE,QAAA;IpCksIE,UoClsIF;EACA;ApCmsIF;;AAEA;EACE,SoCnsIA;EpCosIA,YoCpsIA;EpC0tHF,aAAA;EA4eE,wCAAwC;AoClsI1C;;ApCqsIA;EoClsIE,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;E1BxIE,aAAA;EWHE,qCAAA;EAAA,0BAAA;ErBs2HN,oCAAA;AqBl2HM;;ArBi1IN;EACE,cqBj1IM;ArBk1IR;;AoCxsIE;EACE,MAAA;EpC8tHJ,WAAA;EoC3tHE,UAAA;EACE,aAAA;EACA,sCAAA;ApC0sIJ;;AA5eA;EA+eE,qBAAqB;EoCtsIvB,oBAAA;EACE,uBAAA;EACA,WAAA;EACA,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;ApCwsIF;;AA5eA;EA+eE,cAAc;AoCtsIhB;;ApCysIA;EA7eA,iBAAA;AA+eA;;AAEA;EACE,MoC9rIM;EpC+rIN,WoC/rIM;EpCgsIN,UoC/rIM;EpCgsIN,aoChsIM;EpCisIN,uCoCjsIM;ApCksIR;;AAEA;EACE,qBoClsIQ;EpCmsIR,oBoCnsIQ;EpCosIR,uBoCpsIQ;EpCitHR,WAAA;AAqfF;;AAEA;EoClsIU,aAAA;ApCosIV;;AAEA;EoChsIQ,qBAAA;EpCksIN,qBoCjsIQ;EpC8sHR,uBAAA;EoC3sHM,WAAA;EpCisIN,mCoChsIQ;EpCisIR,yBoCjsIQ;EpCksIR,sCoClsIQ;ApCmsIV;;AAEA;EoCjsIQ,cAAA;ApCmsIR;;AAEA;EACE,iBoChsIQ;ApCisIV;;AAEA;EACE,SAAS;EACT,6CoClsIQ;EpCmsIR,gBoClsIQ;EpCmsIR,mDoClsIQ;EpCmsIR,UoClsIQ;ApCmsIV;;AAEA;EACE,cqBl6II;ErBm6IJ,WqBn6II;ErBy6HJ,4EAAA;EoCtsHQ,WAAA;EpCmsIR,gBoClsIU;EpCwsHV,oCAAA;EoCrsHQ,mBAAA;EpCksIR,mBoCjsIU;EpCksIV,6BoClsIU;EpCmsIV,SoCnsIU;EpCosIV,uDoCnsIU;ApCosIZ;;AAEA;;EA7fE,0CAAA;EACF,kDAAA;Aap4HI;;Abs4IJ;;EAEE,2CoC/vIM;EpCgwIN,qBoChwIM;EpCiwIN,mDoCjwIM;ApCkwIR;;AAEA;;EAEE,6CoCnwIQ;EpCowIR,oBoCpwIQ;EpCgwHR,6BAAA;AAsgBF;;AAEA;EoClwIU,cAAA;ApCowIV;;AAEA;EoChwIQ,cAAA;EpCkwIN,gFoCjwIQ;EpC6vHR,gBAAA;EoC1vHM,uBAAA;EpCiwIN,sCoChwIQ;EpCiwIR,mBoCjwIQ;ApCkwIV;;AAEA;EAvgBE,cAAA;EoCzvHM,4EAAA;EpCmwIN,oCoClwIQ;ApCmwIV;;AAEA;EACE,uCoChwIQ;EpCiwIR,oCoChwIQ;EpCiwIR,+CoCjwIQ;EpCkwIR,0BoClwIQ;EpCmwIR,4CoClwIQ;EpCmwIR,oCoClwIQ;EpCmwIR,kDoClwIQ;EpCmwIR,wCoClwIQ;EpCmwIR,wCoClwIQ;EpCmwIR,yCoClwIQ;EpCmwIR,qDoCnwIQ;EpCowIR,8CoClwIQ;ApCmwIV;;AAEA;;EA1gBE,kBAAA;EA+gBA,oBoClwIU;EpCmwIV,sBoCnwIU;ApCowIZ;;AAEA;;EAEE,kBoCrwIU;EvB5LR,cAAA;Abq8IJ;;AAEA;;;;;;;;;;;;EAYE,UoCp0IU;ApCq0IZ;;AAEA;EoC9zIQ,aAAA;EpC6yHN,eAAA;EAyhBA,2BoCj0IQ;ApCk0IV;;AAEA;EAxhBE,WAAA;AA0hBF;;AAEA;EoCh0IQ,qBAAA;ApCk0IR;;AAEA;;EAEE,2BoCl0IQ;ApCm0IV;;AAEA;;;EAGE,0BoCl0IQ;EpCm0IR,6BoCn0IQ;ApCo0IV;;AAEA;;;EA1hBE,yBAAA;EoCnyHQ,4BAAA;ApCk0IV;;AAEA;EACE,sBoCn0IU;EpCo0IV,qBoCp0IU;ApCq0IZ;;AAEA;;;EajgJI,cAAA;AbqgJJ;;AAEA;EACE,eoC/3IM;ApCg4IR;;AAEA;;EAEE,qBoCj4IQ;EpCk4IR,oBoCl4IQ;ApCm4IV;;AAEA;;EAEE,uBoCp4IU;EpC81HV,sBAAA;AAwiBF;;AAEA;EAniBE,sBAAA;EA0iBA,uBoCj4IQ;EpCo4IR,uBoCn4IQ;ApCo4IV;;AAEA;;EoC/3IQ,WAAA;ApCk4IR;;AAEA;;EAEE,0BoCl4IQ;ApCm4IV;;AAEA;;EAEE,6BoCl4IQ;EpCm4IR,4BoCl4IQ;ApCm4IV;;AAEA;;EoCh4IU,yBAAA;EpCm4IR,0BoCl4IU;ApCm4IZ;;AAEA;EACE,gCoCl4IU;EpCm4IV,gCoCn4IU;EpCo4IV,2BoCn4IU;EpCo4IV,yCoCp4IU;EpCq4IV,qDoCr4IU;EpCs4IV,2DoCr4IU;EpCs1HZ,aAAA;EoC34HI,eAAA;EpCg8IF,eoC97IM;EpC+7IN,gBoC/7IM;EpCg8IN,gBoC/7IM;ApCg8IR;;AAEA;EoCh8IQ,cAAA;EpCk8IN,kEoCj8IQ;EpCk8IR,uCoCl8IQ;EpCm8IR,2CoCn8IQ;EpCo8IR,+BoCp8IQ;EpC64HR,gBAAA;EoC34HQ,SAAA;EpC84HR,uGAAA;AAyjBF;;AAEA;EAvjBE;IoCv4HQ,gBAAA;EpC04HR;AAyjBF;;AAEA;;EAEE,qCoCl8IQ;ApCm8IV;;AAEA;EACE,UoCl8IQ;EAGF,kDAAA;ApCk8IR;;AAEA;;EAEE,wCoCl8IQ;EpCm8IR,oBoCl8IQ;EpCm8IR,eoCl8IQ;ApCm8IV;;AAEA;EACE,+BoCl8IQ;EpCm8IR,8CoCn8IQ;EpCo8IR,mCoCl8IQ;EpCm8IR,+FoCn8IQ;EpCq4HR,wCAAA;EoCl4HQ,qCAAA;EpCm8IR,qFoCl8IU;EpCo4HV,oFAAA;AAgkBF;;AAEA;EACE,yDoCn8IU;EpCo8IV,yDoCn8IU;EpCo8IV,wDoCp8IU;EpCq8IV,yDoCr8IU;ApCs8IZ;;AAEA;;EoC5/II,kBAAA;EAEI,wDAAA;ApC8/IR;;AAEA;;EApkBA,2CAAA;EoCz7HQ,mDAAA;EACE,yDAAA;ApCigJV;;AAEA;EAxkBA,sDAAA;EoCz7HU,yBAAA;EACE,0BAAA;ApC27HZ;;AA2kBA;EoCjgJY,oCAAA;EpC07HZ,sCAAA;EoCt7HQ,sCAAA;ApCigJR;;AoC7/IQ;EACE,gDAAA;ApCggJV;;AAEA;;EA1kBA,4CAAA;EoCp7HQ,oDAAA;ApCkgJR;;AoC9/IQ;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EpCggJR,gCoChgJQ;ApCigJV;;AAEA;EoChgJU,gBAAA;EACA,eAAA;EACA,qEAAA;ApCkgJV;;AAEA;;EA9kBA,iCAAA;AoCh7HU;;ApCm7HV;;EoC96HY,gBAAA;EAAA,gDAAA;EAAA,iCAAA;ApCmgJZ;;AAEA;;EAIE,cAAc;EoCr/IhB,kBAAA;ApCu/IA;;AAEA;;EoCl/IE,aAAA;EAGA,YAAA;EpCk6HF,kBAAA;AAqlBA;;AAEA;;EAEE,WAAW;AqC7wJb;;ArCgxJA;EqC5wJE,aAAA;ArC8wJF;;AAEA;EqC5wJE,cAAA;ArC8wJF;;AAEA;EqC5wJE,wBAAA;EACA,wBAAA;EACA,qCAAA;EACA,gCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,kCAAA;EACA,oCAAA;EAGA,8DAAA;EACA,oEAAA;EAAA,oCAAA;EAAA,sCAAA;EACA,gCAAA;EAAA,sCAAA;ErC+wJA,qEqC/wJA;ErCgxJA,oDqChxJA;EACA,0DAAA;EACA,kCAAA;EACA,4DAAA;EACA,kBAAA;EAGA,aAAA;ErCyrIF,eAAA;EqCnrII,mBAAA;EAIA,8BAAA;EACA,8DAAA;ArCsrIJ;;AA2lBA;;;;;;;EqClwJE,aAAA;EAEE,kBAAA;EAIJ,mBAAA;ErC6wJE,8BqC1wJA;ArC2wJF;;AAzlBA;EA4lBE,6CAA6C;EqCzwJ/C,gDAAA;EACE,+CAAA;EACA,2CAAA;ErCgrIF,mCAAA;EA4lBE,mBAAmB;AqCzwJrB;;ArC4wJA;;EAzlBA,yCAAA;AA4lBA;;AAEA;EA1lBA,0BAAA;EA4lBE,gCAAgC;EqCpwJhC,2BAAA;EACE,2CAAA;ErC2qIJ,uDAAA;EA4lBE,6DAA6D;EqC7vJ7D,aAAA;ErCyqIF,sBAAA;EqCpqIE,eAAA;E3B7FE,gBAAA;EVowIJ,gBAAA;AA4lBA;;AAEA;;EqC7vJE,oCAAA;ArCgwJF;;AqC7vJE;E3BxGE,gBAAA;AV8wIJ;;AqC5pIA;EACE,oBAAA;EACA,uBAAA;EACA,6BAAA;ArC0vJF;;AqCvvJE;;;ErCiqIF,oCAAA;AA4lBA;;AAEA;EAzlBA,gBAAA;EqCzpIE,YAAA;EAGA,mBAAA;ArCwvJF;;AAEA;EA1lBA,8EAAA;EA4lBE,6CAA6C;EqCtvJ/C,cAAA;ErCwvJE,6BAA6B;EAC7B,6BAA6B;EqCtvJ7B,0EAAA;ErC6pIF,qDAAA;EqC1pIA,+CAAA;ArCwvJA;;AAEA;EA1lBA;IqC3pIA,gBAAA;ErCyvJE;AACF;;AAzlBA;EA4lBE,qBAAqB;AqChvJrB;;ArCwpIF;EalxII,qBAAA;EwBuHJ,UAAA;ErC0vJE,sDqClvJE;ArCmvJJ;;AAEA;EACE,qBqCrvJE;ErCsvJF,YqCtvJE;ErCupIF,aAAA;EqCppIE,sBAAA;ErCsvJF,kDqCpvJI;ErCqvJJ,4BqCrvJI;ErCsvJJ,2BqCtvJI;ErCuvJJ,qBqCtvJI;ArCuvJN;;AAEA;EACE,yCqCtvJM;ErCqpIN,gBAAA;AAmmBF;;AAEA;EAjmBE;IAomBE,iBAAiB;IqChvJX,2BAAA;ErCovJR;;EAhmBA;IAIA,mBAAA;EqC9oIQ;;ErCmvJR;IAjmBA,kBAAA;EqC7oIQ;;ErCkvJR;IAjmBA,kDAAA;IACF,iDAAA;EAmmBE;;EsCp9JA;IACA,iBAAA;EACA;;EAEA;IAGA,wBAAA;IAEA,gBAAA;EACA;;EAEA;IACA,aAAA;EACA;;EAEA;IACA,gBAAA;IACA,aAAA;IAGA,YAAA;ItCq3IF,sBAAA;IAmmBI,uBAAuB;IsCp9J3B,8BAAA;IACE,wCAAA;IACA,oBAAA;IAAA,0BAAA;ItCy9JE,gBsCx9JF;EtCy9JA;;EsCv9JA;IpC2PI,aAAA;EoCzPJ;;EAEA;IAGA,aAAA;ItCq3IF,YAAA;IqB54IM,UAAA;IiBWN,mBAAA;EtC2+JE;AACF;;AAtmBA;EsCv3IE;IAEE,iBAAA;ItC03IJ,2BAAA;EsCv3II;;EAEE;IAMF,mBAAA;EtCg+JF;;EsC99JE;IACA,kBAAA;EACA;;EAEA;IACA,kDAAA;IjBlDE,iDAAA;EAAA;;EAIA;IiBsCJ,iBAAA;EtC8+JA;;EA3mBA;IsCt3IE,wBAAA;IAGF,gBAAA;EACE;;EAEA;IACA,aAAA;EtCs+JF;;EAEA;IsCp+JF,gBAAA;IACE,aAAA;IAGF,YAAA;IACE,sBAAA;IACA,uBAAA;IACA,8BAAA;ItCw3IF,wCAAA;IsCt3IE,oBAAA;I5B9DE,0BAAA;I4BiEA,gBAAA;E5BlEA;;EV67IJ;IsCt3IE,aAAA;EACE;;EAIF;ItCw3IF,aAAA;IUr7II,YAAA;IVy7IJ,UAAA;IsCn3II,mBAAA;E5BvEA;AV2iKJ;;AAEA;EsCh+JA;ItCq3IA,iBAAA;IsC12II,2BAAA;EtC82IJ;;EsC12II;IAIA,mBAAA;EAAgB;;EAChB;IAAe,kBAAA;EtCg3InB;;EUx+II;IV2+IJ,kDAAA;IA+mBI,iDAAiD;EsCr9JjD;;EAEE;ItCy2IN,iBAAA;EA+mBE;;EuChnKA;IAIA,wBAAA;IAEA,gBAAA;EACA;;EAIA;IAAA,aAAA;EAAA;;EvCmnKA;IuCjnKA,gBAAA;IACA,aAAA;IAGA,YAAA;I7BAE,sBAAA;IVmgJJ,uBAAA;IAknBI,8BAA8B;IuC/mKhC,wCAAA;IACE,oBAAA;IAEA,0BAAA;IAEE,gBAAA;EACA;;EvCigJN;IuC5/IE,aAAA;EACE;;EvCgnKF;IwClpKA,aAAA;IAGA,YAAA;IACA,UAAA;IACA,mBAAA;EACA;AxCspKF;;AAEA;EwCppKE;IAEA,iBAAA;IAGA,2BAAA;EACA;;EAEA;IjCjBA,mBAAA;EACA;;EP4qKA;IwCrpKF,kBAAA;EACE;;EAEA;ItCgQI,kDALI;IsCzPR,iDAAA;EAEA;;EnBnBI;IAAA,iBAAA;EAAA;;ErBwjJN;IqBnjJQ,wBAAA;IrBujJN,gBAAA;EACF;;EwCriJI;IACA,aAAA;EAEA;;ExCwiJJ;IwCpiJE,gBAAA;IACE,aAAA;IAGA,YlC6iBgC;IkC5iBhC,sBAAA;IxC6pKA,uBwC7pKA;IxCsiJJ,8BAAA;IwCniJE,wCAAA;IAEE,oBAAA;IfrDF,0BAAA;IzB4lJF,gBAAA;EwCjiJE;;EAGE;IACA,aAAA;EACA;;ExC2pKF;IArnBF,aAAA;IAGA,YAAA;IAynBI,UAAU;IwChoKd,mBAAA;EClGE;AzCquKF;;AAEA;EAvnBA;IwC1gJA,iBAAA;ItCqLM,2BAAA;EuCxRJ;;EzC6uKA;IEr9JI,mBAAA;EwCrRJ;;EAEA;IAGA,kBAAA;EACA;;EAEA;IACA,kDAAA;IACA,iDAAA;EACA;;EAEA;IhCJE,iBAAA;EV2nJJ;;E0CjnJI;IAKJ,wBAAA;IAEE,gBAAA;E1CknJF;;E2ClpJA;IAEE,aAAA;EACA;;EAEA;IACA,gBAAA;IACA,aAAA;IAGA,YAAA;IAGA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IjCFE,0BAAA;IV+wKA,gBAAgB;E2CvwKpB;;E3CkpJA;IAynBI,aAAa;E2CrwKjB;;EAEE;IAQF,aAAA;IAIE,YAAA;IACE,UAAA;IACA,mBAAA;EACA;A3CiwKJ;;AAtnBA;E2CjoJE,iBAAA;EAGE,2BAAA;A3C4vKJ;;AAEA;E2C9vKI,mBAAA;A3CmwKJ;;AAEA;E2CxwKE,kBAAA;A3C0wKF;;AAEA;E2CxwKI,kDAAA;E3CkpJJ,iDAAA;AAynBA;;AAEA;E2C/wKI,iBAAA;A3CixKJ;;AAtnBA;E2C5pJI,wBAAA;EAEA,gBAAA;A3CwxKJ;;AAEA;E2C7xKE,aAAA;A3C+xKF;;AAEA;E2C7xKI,gBAAA;E3CuqJJ,aAAA;E2C1qJI,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;E3C8qJJ,wCAAA;EAynBE,oBAAoB;E2C1yKlB,0BAAA;EAEA,gBAAA;A3C6yKJ;;AAEA;E4C12KE,aAAA;A5C42KF;;AAEA;E4C92KE,aAAA;E5CsvJA,YAAA;EACF,UAAA;E4CjvJA,mBAAA;A5Ci3KA;;AAEA;;E4C72KE,uBAAA;EACA,2CAAA;EACA,qDAAA;EACA,4CAAA;EACA,6BAAA;EAGA,mCAAA;EAAA,0DAAA;EAAA,qEAAA;A5Cg3KF;;AAEA;E4C92KE,qEAAA;A5Cg3KF;;AAEA;E4C72KA,2BAAA;EACE,2BAAA;EAAA,gCAAA;EAAA,8CAAA;EACA,0BAAA;EAAA,2BAAA;E5Ck3KA,2C4Cl3KA;E5Cm3KA,+B4Cn3KA;EACA,sDAAA;E5Co3KA,iD4Cp3KA;E5Cq3KA,gC4Cr3KA;EACA,gCAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EvBxBI,kBAAA;EAAA,sCAAA;ErBwwJN,+BAAA;EqBpwJM,kBAAA;ErBg5KJ,aqB/4KM;EuBuBR,sBAAA;EnBAE,YAAA;EmBEA,6BAAA;E5CovJF,2BAAA;EA0oBE,qBAAqB;E4C33KvB,mCAAA;EACE,2BAAA;E5CovJF,qEAAA;EA0oBE,2CAA2C;A4C33K7C;;A5CqvJA;EA0oBE,eAAe;E4C13Kf,cAAA;A5C43KF;;AAxoBA;E4ChvJM,mBAAA;EAJJ,sBAAA;A5Ci4KF;;AAEA;EA1oBA,mBAAA;EA4oBE,0DAA0D;E6C37K5D,2DAAA;A7C67KA;;AAEA;E6C17KE,sBAAA;EACA,8DAAA;EACA,6DAAA;A7C47KF;;AAEA;;E6Cz7KE,aAAA;A7C47KF;;AAEA;E6Cx7KE,cAAA;EAGA,wDAAA;EAAA,2BAAA;A7C27KF;;AAEA;EACE,4C6C77KA;E7C87KA,iC6C97KA;A7C+7KF;;AAEA;EA/oBA,sDAAA;EAipBE,gBAAgB;E6C37KlB,oCAAA;A7C67KA;;AA9oBA;E6C3yJE,gBAAA;A7C67KF;;AA9oBA;EAipBE,oCAAoC;A6Cp7KtC;;A7Cu7KA;E6Cp7KE,kEAAA;E7CsyJF,gBAAA;E6CnyJE,+BAAA;EAEE,uCAAA;EACA,4EAAA;A7Co7KJ;;AA9oBA;E6CjyJE,wFAAA;A7Cm7KF;;AA9oBA;EAipBE,kEAAkE;E6C56KpE,+BAAA;EACE,uCAAA;EACA,yEAAA;A7C86KF;;AAEA;E6C36KE,wFAAA;A7C6xJF;;AAkpBA;EUn+KI,uDAAA;EVq1JJ,sDAAA;E6C3xJE,sDAAA;EnC7CE,gBAAA;AV29KJ;;A6C16KE;EAEE,mCAAA;EACA,sCAAA;A7C46KJ;;A6Cv6KE;EACE,uDAAA;EACA,sDAAA;A7C06KJ;;AA9oBA;E6CtxJE,kBAAA;EACE,MAAA;E7CwxJJ,QAAA;E6CtxJI,SAAA;EACE,OAAA;EACA,2CAAA;E7CwxJN,iDAAA;AAipBA;;AAEA;;;EAGE,W6Ch6KI;A7C8wJN;;AAqpBA;;EAjpBA,0DAAA;E6C1wJQ,2DAAA;A7C+5KR;;AAjpBA;;E6CxwJU,8DAAA;E7C2wJV,6DAAA;A6CxwJQ;;A7C85KR;EAlpBA,0CAAA;A6CxwJU;;A7C85KV;EAlpBA;I6ClyJI,aAAA;I7C47KA,mB6C37KE;E7CsyJJ;;EAwpBA;I6Ct7KM,SAAA;InCxEJ,gBAAA;EVmgLF;;E6Ct7KM;IACE,cAAA;I7CmyJR,cAAA;E6ChyJM;;E7Cy7KN;IArpBA,0BAAA;I6ChyJQ,6BAAA;E7Cw7KR;;EAppBA;;Iax3JE,0BAAA;EgC8DA;;E7Cq9KF;;IAEE,6B6Ct9KE;E7C8zJJ;;EA2pBA;IUzhLE,yBAAA;IVk4JF,4BAAA;E6C1zJM;;E7Cs9KN;;I6Cj9KM,yBAAA;E7Co9KN;;E6Ch9KM;;IAEE,4BAAA;E7C0zJR;AA0pBF;;AAEA;EAxpBE,6BAAA;EACF,uBAAA;Eaj5JI,8KAAA;EgC8DA,uDAAA;E7C++KF,mD6C9+KI;E7C++KJ,qD6C/+KI;E7Cg/KJ,4F6Ch/KI;E7Ci/KJ,qC6Cj/KI;E7Cs1JJ,kCAAA;E6Cn1JM,8CAAA;E7Ci/KN,6CUxiLE;EVyiLF,iEUrjLE;EV05JF,sCAAA;E6Cl1JM,kDAAA;E7Cg/KN,8DUxjLE;EVyjLF,wEU7iLE;EVk5JF,2CAAA;E6Cj1JM,yCAAA;E7C++KN,sC6C9+KQ;E7Cm1JR,mCAAA;E6Ch1JM,oCAAA;E7C8+KN,iC6C7+KQ;A7C8+KV;;AAEA;EACE,kB6C7+KU;E7Co1JZ,aAAA;EA+pBE,mB6CzgLI;E7C0gLJ,W6C1gLI;E7C2gLJ,4E6C3gLI;E7C4gLJ,oB6C5gLI;E7C82JJ,oCAAA;E6C32JM,gBAAA;E7C4gLN,4CUnkLE;EVokLF,SUhlLE;EVk7JF,gBAAA;E6C12JM,qBAAA;E7C4gLN,0CUxkLE;AVykLJ;;AAEA;EA9pBE;I6Cv2JQ,gBAAA;E7CygLR;AACF;;AAEA;EACE,uC6CxgLU;E7C02JV,+CAAA;Eah8JE,kGAAA;AbkmLJ;;AAEA;EACE,qD6CtiLI;E7Cs4JJ,iDAAA;AAmqBF;;AAEA;E6CniLQ,cAAA;E7CsiLN,yCU9mLE;EV+mLF,0CUnmLE;EVk8JF,iBAAA;E6Cj4JM,WAAA;E7CqiLN,8C6CpiLQ;E7Cm4JR,4BAAA;E6Ch4JM,mDAAA;E7CqiLN,mD6CniLQ;A7CoiLV;;AAEA;EACE;IAhqBF,gBAAA;E6Cr3JA;A7CyhLA;;A6CthLE;EACE,UAAA;A7Cu3JJ;;AAoqBA;EAjqBA,UAAA;EAmqBE,wDAAwD;E6C7gLxD,UAAA;EAEE,oDAAA;A7C+gLJ;;AAEA;E6C7gLI,gBAAA;A7C+gLJ;;AAEA;E6C7gLI,gCAAA;E7C62JJ,wCAAA;EAmqBE,+EAA+E;A6C1hL/E;;A7C6hLF;E6C1hLI,yDAAA;EACA,0DAAA;A7C4hLJ;;AAEA;E6C1hLI,+DAAA;EACA,gEAAA;A7C4hLJ;;AAEA;E6CviLE,aAAA;A7CyiLF;;AAEA;E6CviLI,6DAAA;EACA,4DAAA;A7CyiLJ;;AAEA;E6CviLI,mEAAA;EACA,kEAAA;A7Cu4JJ;;A6Cj5JE;EACE,6DAAA;EACA,4DAAA;A7CsjLJ;;AAEA;E6CpjLI,8EAAA;A7CsjLJ;;AAEA;E6CpjLI,eAAA;A7Co5JJ;;A6C95JE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;A7CmkLJ;;AAEA;E6CjkLI,aAAA;A7CmkLJ;;AAEA;EAjqBA,gBAAA;AAmqBA;;AAEA;;E6C7kLI,gBAAA;A7CglLJ;;AAEA;E6C9kLI,iEAAA;EACA,wEAAA;A7CglLJ;;AAhqBA;EAmqBE,4BAA4B;E6C3lL5B,iCAAA;EACE,mCAAA;EACA,+BAAA;EACA,+BAAA;EACA,iDAAA;EACA,sCAAA;EACA,qDAAA;EAGA,aAAA;E7C47JJ,eAAA;EAmqBE,sEAAsE;E6CxmLtE,iDAAA;EACE,yCAAA;EACA,gBAAA;EACA,yCAAA;EACA,iDAAA;A7C0mLJ;;AAEA;E6CxmLI,iDAAA;A7C0mLJ;;AAhqBA;EAmqBE,WAAW;E8CvyLb,kDAAA;EAEE,yCAAA;EACA;;EAEA;A9CwyLF;;AAEA;E8CtyLE,6CAAA;A9CwyLF;;AAEA;E8CryLE,iC1CkpD2B;E0CjpD3B,iCAAA;EACA,+BAAA;EACA,yCAAA;EACA,wBAAA;EpCJE,iCAAA;EoCMF,gDAAA;E9CooKF,qCAAA;E8CjoKE,iCAAA;EACE,iCAAA;EACA,2CAAA;EACA,uDAAA;E9CmoKJ,4CAAA;E8ChoKE,kEAAA;EACE,kCAAA;EACA,kCAAA;E9CqyLF,4C8CryLE;EACA,kDAAA;E9CkoKJ,iCAAA;E8C/nKE,yDAAA;E9CuyLA,a8CpyLE;E9CqyLF,e8CryLE;E9CsyLF,gB8CtyLE;A9CuyLJ;;AAEA;E8ChyLA,kBAAA;EAHE,cAAA;E9CsyLA,sE8CtyLA;E9C+nKF,yCAAA;EAyqBE,iCAAiC;E8C/xL/B,yCAAA;EATF,iFAAA;E9C6yLA,qIAAqI;AAEvI;;AAEA;E+C71LE;I7C0RI,gBAAA;E6CvRJ;A/C+1LF;;AAEA;E+C71LE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,qDAAA;A/C+1LF;;AAEA;EEjlLM,UAAA;E6CzQJ,uCAAA;EACA,+CAAA;EACA,UAAA;EAEA,iDAAA;A/C61LF;;AAEA;;E+C31LE,UAAA;EACE,wCAAA;E/CorKJ,gDAAA;E+CjrKE,sDAAA;A/C61LF;;AAEA;;E+Cz1LE,0CAAA;EAEA,oBAAA;EACA,kDAAA;EACA,wDAAA;A/C21LF;;AAEA;E+C31LE,8CAAA;A/CirKF;;AA8qBA;EA3qBA,iDAAA;AA6qBA;;AAEA;E+C31LE,iCAAA;EAAA,kCAAA;EACA,sCAAA;E/C81LA,yD+C91LA;A/C+1LF;;AAEA;E+C91LE,iCAAA;EACA,kCAAA;EACA,uCAAA;ErChCE,yDAAA;AVi4LJ;;A+C91LE;EACE,4BAAA;EACA,4BAAA;E/CirKJ,4BAAA;EAirBE,2BAA2B;E+C91L7B,sBAAA;EACE,iDAAA;EACA,qBAAA;E/CgrKF,4DAAA;EAirBE,oCAAoC;EgD/5LtC,wCAAA;EAEE,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,4CAAA;AhDg6LF;;AAEA;EgD95LE,aAAA;AhDg6LF;;AAEA;EgD95LE,kBAAA;EACA,SAAA;AhDg6LF;;AAEA;EgD95LE,0BAAA;EACA,0BAAA;EACA,0BAAA;EAGA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EACA,kBAAA;EACA,4DAAA;EACA,4CAAA;EAGA,4BAAA;EhD4uKF,oCAAA;EAirBE,8BAA8B;EgDt5LhC,4CAAA;AhDw5LA;;AAEA;EgDr5LE,cAAA;AhDuuKF;;AAkrBA;EqBl8LM,gBAAA;EAAA,iCAAA;ArBq8LN;;AAEA;EAnrBA,mBAAA;AqBhxKM;;ArBu8LN;EACE,kBqBv8LM;ErBmxKN,MAAA;EACF,QAAA;EgDzuKE,UAAA;EACE,qBAAA;AhDg6LJ;;AgD55LE;EACE,iD5C27CgC;EJo+IlC,0CIp+IkC;EJ8yHpC,wDAAA;EAwrBE,sDAAsD;AgD75LxD;;AhDyuKA;EgDtuKE,mDAAA;EACE,4CAAA;EACA,0DAAA;EhDwuKJ,wDAAA;AgDruKE;;AhDwuKF;EAwrBE,iDAAiD;EgD35LnD,0CAAA;EACE,wDAAA;EAAA,sDAAA;AhD85LF;;AAEA;EACE,8CgDh6LA;EACA,uCAAA;EhDsuKF,qDAAA;EA4rBE,mDAAmD;AgD95LrD;;AhDi6LA;EgD/5LE,iDAAA;EAAA,0CAAA;EACA,wDAAA;EAAA,sDAAA;AhDm6LF;;AAEA;EgDl6LE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;AhDo6LF;;AAEA;EA/rBA,+CAAA;EAisBE,wCAAwC;EgD/5L1C,sDAAA;EAEE,oDAAA;AhDg6LF;;AAEA;EiDjhME,8CAAA;EACA,uCAAA;EACA,qDDkH0B;ECjH1B,mDAAA;AjDmhMF;;AAxrBA;EAisBE;IgDt6LF,2BAAA;EACE;AhDw6LF;;AAEA;;EgDx6LE,0BAAA;EhD26LA,gCgD36LA;EhD46LA,oCgD56LA;EACA,oDAAA;EhD66LA,oDgD76LA;EhD86LA,6BgD96LA;EACA,6BAAA;EACA,6CAAA;EhD0uKF,aAAA;EgDvuKE,iCAAA;EACE,gBAAA;EACA,uCAAA;EhDyuKJ,uCAAA;EAwsBE,+CAA+C;AgD56LjD;;AhD+6LA;EgDx6LA,aAAA;EhD+6LE,sBgD36LA;EhD86LA,uBAAuB;EgDz6LzB,gBAAA;EACE,mCAAA;EAAA,kBAAA;EAAA,mBAAA;EACA,2CAAA;EACA,6CAAA;AhD86LF;;AAEA;EACE;IAEE,gBgDj7LF;EhDk7LA;AACF;;AAEA;EU5iMI,qMAAA;EACA,oEAAA;AV61KJ;;AAmtBA;EAhtBA,iBAAA;AAktBA;;AAEA;EACE,WgD96LE;AhD+6LJ;;AAEA;EAEE,kDgD56LE;AhD66LJ;;AAEA;EACE;IA/sBF,eAAA;Ea31KI;Ab8iMJ;;AAEA;EAhtBE,yCAAA;EACF,+BAAA;Eaj2KI,oDAAA;EmC2IF,oDAAA;EhD06LA,qCgDz6LE;EhDytKF,oCAAA;EACF,sCAAA;EgDhtKI,uDAAA;EACE,sDAAA;EACA,gDAAA;EACA,yDAAA;EACA,iDAAA;EhDktKN,yDAAA;EgDhtKM,8CAAA;EACE,kCAAA;EACA,kCAAA;EtC1MJ,4CAAA;EVgnMF,aAAa;EgD55LP,sBAAA;EhDgtKR,eAAA;EAktBE,gBAAgB;Ea7jMd,iDAAA;Ab+jMJ;;AAEA;EACE,qBgDt7LI;EhDu7LJ,sBgDt7LI;AhDu7LN;;AAEA;EACE,oCgDt7LM;EhDu7LN,0BUjoME;AVkoMJ;;AAEA;EACE,WUroME;EVq7KF,wCAAA;EgDluKI,mBAAA;AhDq7LN;;AA/sBA;;EgDvvKI,UAAA;EhD28LF,8CgD18LI;EhD28LJ,qBgD18LI;EhD28LJ,sDgD18LI;AhD28LN;;AAEA;EACE,+CgD18LM;EhD28LN,uDgD18LM;AhD28LR;;AAEA;EACE,kBAAkB;EAClB,cUzpME;EVy8KF,gFAAA;EgDtvKI,iCAAA;EhDy8LJ,yCgDx8LM;EhDwvKN,iFAAA;AACF;;AAmtBA;EACE,+BgD99LI;EhD+9LJ,gCgD99LI;AhD+9LN;;AAEA;EgD79LM,mCAAA;EhD+9LJ,kCgD99LM;AhD+9LR;;AAEA;;EAEE,0CAA0C;EAC1C,oBU7qME;EV69KF,kDAAA;AAktBF;;AAEA;EAhtBA,UAAA;Eax6KI,wCAAA;EmCyIA,gDAAA;EhDm/LF,sDgDl/LI;AhDm/LN;;AAEA;EAhtBE,mBAAA;AAktBF;;AAEA;EACE,wDU7rME;EV6+KF,mDAAA;AAktBF;;AAEA;EA7sBE,mBAAA;AACF;;AAmtBA;EACE,6DgDtgMI;EhDugMJ,0BgDtgMI;AhDugMN;;AAEA;EgDrgMM,2DAAA;EhDugMJ,4BgDtgMM;AhDugMR;;AAEA;EgDpgMM,aAAA;AhDsgMN;;AAEA;EgDngMM,mDAAA;EhDqgMJ,oBgDpgMM;AhDqgMR;;AkD3uMA;EAEE,yDAAA;EACA,oDAAA;AlD6uMF;;AAEA;EEp9LM;IgDnRJ,mBAAA;EACA;;EAIA;IACA,6DAAA;IACA,0BAAA;EClBA;;EAGA;IACA,2D7CsQ4B;I6CrQ5B,4BAAA;EACA;;EAEA;IACA,aAAA;EACA;;EAEA;IACA,mDAAA;IACA,oBAAA;EjDgRI;;EgDpQJ;IlDmiLF,yDAAA;IkDjiLE,oDAAA;EAAS;AlDoiLX;;AAmtBA;EkDnvMI;IAIE,mBAAA;EACA;;EAEA;IlDoiLN,6DAAA;IAktBI,0BAA0B;EkDjvM9B;;ElDmiLA;IkDhiLE,2DAAA;IACE,4BAAA;EACA;;ElDmiLJ;IAktBI,aAAa;EkDhvMjB;;EAEE;IACA,mDAAA;IACA,oBAAA;ElDiiLF;;EkD9hLI;IACA,yDAAA;IACA,oDAAA;ElDiiLJ;AAktBA;;AkD7uMA;EACE;IAIE,mBAAA;EACA;;ElDivMF;IkD7uMF,6DAAA;IACA,0BAAA;EACE;;EAEA;IlD8hLF,2DAAA;IkD5hLE,4BAAA;EACE;;EAEA;IlD8hLJ,aAAA;EAktBE;;EkD1tMF;IACE,mDAAA;IACA,oBAAA;EACA;;EAEA;IxCjGE,yDAAA;IV8mLJ,oDAAA;EAktBE;AoDn1MF;;ApDs1MA;EEvjMM;IkDvRJ,mBAAA;EACA;;EAEA;IACA,6DAAA;IlDmRI,0BAAA;EkDjRJ;;EAEA;IACA,2DAAA;IACA,4BAAA;EACA;;EAEA;IAGA,aAAA;EACA;;EDxBA;IAEA,mDAAA;IACA,oB7CiQ4B;E6ChQ5B;;EAEA;IACA,yDAAA;IACA,oDAAA;EACA;AnD22MF;;AAEA;EmDz2ME;ICmBA,mBAAA;EACA;;E1CfE;IV4pLJ,6DAAA;IoDxoLE,0BAAA;EACE;;EAEA;IpD0oLJ,2DAAA;IoDxoLI,4BAAA;EAEE;;EAEA;IACA,aAAA;EACA;;EpD0oLN;IAktBI,mDAAmD;IoDr1MrD,oBAAA;EACE;;EAEA;IAEE,yDAAA;IpDqoLN,oDAAA;EoDloLI;ApDq1MJ;;AA/sBA;EoDjoLI,gBAAA;ApDo1MJ;;AA/sBA;EAktBE,mDAAmD;AoDh1MrD;;ApDm1MA;EoD/0MI,sBAAA;ApDi1MJ;;AoD90MI;EAEE,sDAAA;EpD+nLN,+CAAA;EoD5nLI,6DAAA;EACE,4DAAA;EACA,gEAAA;EpD8nLN,6DAAA;EoD3nLI,iEAAA;EACE,yDAAA;EACA,0DAAA;EpD6nLN,oEAAA;AAktBA;;AoDv0ME;EACE,wDAAA;EpDynLJ,iDAAA;EoDvnLI,+DAAA;EAEE,4DAAA;EpDwnLN,kEAAA;EoDrnLI,6DAAA;EACE,mEAAA;EACA,2DAAA;EpDunLN,4DAAA;EoDpnLI,sEAAA;ApDu0MJ;;AA/sBA;EoDjnLE,sDAAA;EACE,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EpDmnLJ,oEAAA;AAktBA;;AoD/zME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EpDinLJ,4DAAA;EoD/mLI,6DAAA;EAEE,6DAAA;EpDgnLN,8DAAA;EoD7mLI,sDAAA;EACE,uDAAA;EACA,iEAAA;ApD+mLN;;AAmtBA;EoD7zMM,sDAAA;EpD8mLN,+CAAA;EAktBE,6DAA6D;EoD3zM/D,4DAAA;EAkBA,gEAAA;EACE,6DAAA;EACA,iEAAA;ElD2GI,yDALI;EkDpGR,0DAAA;EACA,oEAAA;ApD4yMF;;AAEA;EAhtBA,qDAAA;EoD1lLE,8CAAA;EACE,4DAAA;EpD4lLJ,4DAAA;EAktBE,+DAA+D;EoD1yMjE,6DAAA;EACE,gEAAA;EACA,wDAAA;EpD2lLF,yDAAA;EAktBE,mEAAmE;AqDl+MrE;;ArDoxLA;EAktBE,oDAAoD;EqDl+MtD,6CAAA;EACE,2DAAA;ErDo+MA,4DqDp+MA;ErDmxLF,8DAAA;EAmtBE,6DAA6D;EqDn+M/D,+DAAA;EACE,uDAAA;EACA,wDAAA;EACA,kEAAA;ArDmxLF;;AAotBA;EsD3/MI,mDAAA;EACA,4CAAA;EtD2yLJ,0DAAA;EAmtBE,4DAA4D;EqDv+M9D,6DAAA;EACE,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;ArDy+MF;;AAEA;EqB5/MM,0BAAA;EAAA,2DgCmBJ;EhCnBI,2BAAA;ErB0yLN,kCAAA;EqBtyLM,6DAAA;EgCQN,+BAAA;ErDu/ME,qCqB9/MM;ErB+/MN,uEqB//MM;ErB0yLR,uBAAA;EAwtBE,UAAU;EqDj/MZ,WAAA;ErDm/ME,sBAAsB;EACtB,gCAAgC;EqDj/MhC,wEAAA;ErD4xLF,SAAA;EAwtBE,qBAAqB;EqDj/MvB,oCAAA;ArDm/MA;;AAEA;EAvtBA,gCAAA;EAytBE,qBAAqB;EqDl/MvB,0CAAA;ArDo/MA;;AAEA;EAxtBA,UAAA;EqDnxLE,4CAAA;EACE,0CAAA;ArD++MJ;;AAEA;;EAztBA,oBAAA;EqDnxLE,yBAAA;EAGE,iBAAA;EACA,6CAAA;ArDqxLJ;;AA6tBA;EqD5+MI,wCAAA;ArD++MJ;;AA1tBA;EqDxxLE,wCAAA;ArDu/MF;;AAEA;EA5tBE,uBAAA;EACF,6BAAA;EA8tBE,4BAA4B;EqD/+M9B,0BAAA;ErDi/ME,2BAA2B;EqD/+M3B,8BAAA;EACA,kBAAA;EACA,gDAAA;EACA,+CAAA;EAEA,2DAAA;EAAA,iDAAA;EAAA,2CAAA;EACA,kDAAA;ErDk/MA,uDqDl/MA;ErDm/MA,kEqDn/MA;EACA,gCAAA;ErDo/MA,eqDp/MA;ErDq/MA,oCqDr/MA;EACA,4BjDghDmC;EiD/gDnC,oBAAA;EACA,oCjD1FS;EiD2FT,4BAAA;EACA,uEAAA;EAEA,sCjD2gDmC;EiBjmD/B,4CgCuFJ;ArDs/MF;;AqBzkNM;EgCkEN,UAAA;ArD2gNA;;AAEA;EApuBE,aAAA;AACF;;AAuuBA;EACE,uBAAuB;EqD5/MrB,kBjDpGO;EiDqGP,+BAAA;ErD2xLJ,kBAAA;EAsuBE,eAAe;EqD5/MjB,oBAAA;ArD8/MA;;AAEA;EqD5/MA,sCAAA;ArD8/MA;;AAEA;EqDx/ME,aAAA;EAGA,mBAAA;EACA,4DAAA;EACA,mCAAA;ErDuxLF,2CAAA;EAsuBE,4BAA4B;EqD1/M9B,qFAAA;ErD4/ME,0FAA0F;EAC1F,2FAA2F;AAC7F;;AAEA;EACE,oDAAoD;EACpD,sCqDlgNF;AAQA;;ArDwxLA;EAsuBE,kCAAkC;EqD3/MpC,qBAAA;ArD6/MA;;AAEA;EqDt/MA,uBAAA;EACE,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2DAAA;EAAA,0BAAA;EAAA,gCAAA;EACA,8CAAA;ErD0/MA,sCqD1/MA;ErD2/MA,iCqD3/MA;EACA,iCAAA;EAEA,oCjD48CmC;EiD38CnC,sDAAA;EACA,sDjD08CmC;EJw0IrC,iCAAA;EqDhxLE,6BAAA;EACE,sBAAA;ErD2/MF,sDqD3/ME;EACA,sDAAA;ErD4/MF,eqD5/ME;ErD6/MF,MAAM;EqD5/MJ,OAAA;EACA,+BjD08CiC;EiDz8CjC,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;ArD8/MJ;;AAEA;EqD3/MI,kBAAA;EACA,WAAA;EhCxKE,8BAAA;EAAA,oBAAA;ArB07LN;;AA+uBA;EA3uBE,mCAAA;EqDjxLE,8BjD87CiC;AJu1IrC;;AqD5wLA;EACE;IAEA,gBjDw7CmC;EiDv7CnC;ArD6/MF;;AAEA;EA5uBA,eAAA;AA+uBA;;AAEA;EAEE,sBqD1/ME;ArD4wLJ;;AAivBA;EA9uBA,+CAAA;AqDxwLE;;ArD2wLF;EAgvBE,gBAAgB;EqDpgNhB,gBAAA;ArDsgNF;;AAEA;EACE,gBqDvgNE;ArDwxLJ;;AAkvBA;EqDlgNI,ajD5MO;EmDdX,mBAAA;EvDmuNE,mDAAmD;AACrD;;AAEA;EuDjuNE,kBAAA;EvDquNA,auDluNA;EAKA,sBAAA;EvDkuNA,WuDluNK;EvDmuNL,4BuDnuNK;EvDk/LL,oBAAA;EACF,oCAAA;EAmvBE,4BAA4B;EuDvuN9B,uEAAA;EACE,4CAAA;EvDyuNA,UuDzuNK;AvD0uNP;;AAvvBA;EuD/+LA,0BAAA;EAEE,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCAAA;EAGA,YAAA;EACA,aAAA;EvD8+LF,uCAAA;AA0vBA;;AAEA;EuDpuNE,UAAA;AvDsuNF;;AAEA;EuD9tNA,mCAAA;AvDguNA;;AAEA;EAGE,auDhuNE;EvDkuNF,cuDjuNE;EvDouNF,mBAAmB;EAGnB,8BuD3uNE;EvD4uNF,uCuD5uNE;EvDu+LF,4FAAA;EuDr+LA,2DAAA;EvD6uNA,4DuD5uNE;AvD6uNJ;;AAEA;EAtwBA,kGAAA;EuDn+LA,sJAAA;AvD4uNA;;AAEA;EuDzuNE,gBAAA;EACA,8CAAA;AvD2uNF;;AArwBA;EAwwBE,kBAAkB;EuDruNlB,cAAA;EvDk+LF,gCAAA;AAwwBA;;AAEA;EApwBE,aAAA;EwDhjMF,cAAA;EAGE,eAAA;EAGA,mBAAA;EAGA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;EACA,+DAAA;ExDkjMF,8DAAA;AAwwBA;;AAEA;EACE,8CwD1yNI;AxD2yNN;;AAEA;EACE;IwD3yNI,0BAAA;IACA,2CAAA;ExD6yNJ;;EAEA;IwD9yNI,gCAAA;IACA,kBAAA;IACA,iBAAA;ExDgzNJ;;EAEA;IqB30NI,uBAAA;ErB60NJ;AACF;;AqB10NM;;ErB80NJ;;IA5wBA,uBAAA;EACF;Aa3gMI;;Ab4xNJ;EACE;IwDtzNM,wBAAA;ExDwzNN;AACF;;AAEA;EA9wBA,YAAA;EaphMI,eAAA;E2CpBE,YAAA;ExD0zNJ,SwDzzNM;AxD0zNR;;AAEA;EACE,YwDzzNM;ExD0zNN,SAAS;EA/wBT,gBAAA;AACF;;AAkxBA;;EAEE,gBwD3zNM;AxD4zNR;;AAEA;EACE,gBwD3zNM;AxD4zNR;;AAEA;EAhxBA;IaxiMI,YAAA;I2CFE,eAAA;IACE,YAAA;IACA,SAAA;ExD8zNN;;EAEA;IwD5zNM,YAAA;IxD8zNJ,SwD9zNI;IxD6iMN,gBAAA;EACF;;EwD3iMM;;IxDi0NF,gBwD/zNI;ExD6iMN;;EatjME;I2CYE,gBAAA;ExDi0NJ;AACF;;Aa31NI;E2C/BF;IAiEM,YAAA;IACA,eAAA;IACA,YAAA;IxD2iMN,SAAA;EwDziMM;;ExD4iMN;IwDxiMM,YAAA;IACE,SAAA;IAAA,gBAAA;ExD8zNR;;EAEA;;IwD9zNQ,gBAAA;ExDi0NR;;EArxBA;IACF,gBAAA;EAwxBE;Aar2NE;;Abw2NJ;EACE;IwDj5NI,YAAA;IACA,eAAA;IAAA,YAAA;IAAA,SAAA;ExDq5NJ;;EAEA;IACE,YwDv5NE;IACA,SAAA;IACA,gBAAA;ExDw5NJ;;EAEA;;IqBl7NI,gBAAA;ErBq7NJ;;EA3xBF;IqBtpMM,gBAAA;EmCYJ;AxD06NF;;AAEA;EA7xBA;IanmMI,YAAA;I2C5BE,eAAA;IACE,YAAA;IACA,SAAA;ExDg6NN;;EAEA;IACE,YwDh6NI;IxDkoMN,SAAA;IACF,gBAAA;Ea5mMI;;Eb84NF;;IwD/5NM,gBAAA;ExDk6NN;;EAEA;IA/xBA,gBAAA;EACF;AarnMI;;Abw5NJ;EACE;IwDl6NM,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ExDo6NN;;EA/xBA;IACF,YAAA;IahoMI,SAAA;I2CFE,gBAAA;ExDs6NJ;;EAEA;;IwDn6NM,gBAAA;ExDs6NN;;EAhyBA;IACF,gBAAA;Ea1oMI;Ab86NJ;;AAEA;EAlyBE,yBAAA;EACF,6BAAA;Ea/oMI,8BAAA;E2CYE,+BAAA;ExDy6NJ,qBwDt6NM;ExDooMN,+BAAA;EACF,qCAAA;EajqMI,yCAAA;E2C/BF,mDAAA;ExDs+NA,yBwDr6NM;ExDs6NN,gCwDr6NM;ExDs6NN,iCwDr6NM;ExDmoMN,iCAAA;EwDjoMM,cAAA;ExDs6NN,gCwDr6NQ;ExDmoMR,gCAAA;EwDhoMM,kBAAA;ExDq6NN,gBwDp6NQ;ExDq6NR,gBwDr6NQ;ExDs6NR,gBwDt6NQ;ExDu6NR,iBwDt6NQ;ExDu6NR,qBwDv6NQ;ExDw6NR,iBwDx6NQ;ExDy6NR,oBwDx6NQ;ExDy6NR,sBwDx6NQ;ExDy6NR,kBwDv6NQ;ExDioMR,mBAAA;EACF,oBAAA;EAwyBE,gBAAgB;Ea78Nd,sCAAA;E2C5CF,qBAAA;ExD4/NA,UwD1/NI;AxD2/NN;;AAEA;EACE,kCwD3/NI;AxD4/NN;;AAEA;EACE,cwD9/NI;ExD+/NJ,oCwD//NI;ExDggOJ,sCwD//NI;AxDggON;;AAEA;EACE,kBwD//NI;ExDggOJ,WwD//NI;ExDggOJ,yBqB5hOI;ErB6hOJ,mBqB7hOI;ArB8hON;;AqB1hOM;;ErB8hOJ,iDqB7hOM;ArB8hOR;;AA5yBA;;EwDvtMM,SAAA;ExDwgOJ,wFwDvgOM;ExDwgON,sCwDvgOM;AxDwgOR;;AAEA,qBwDvgOQ;AxDwgOR;;EA7yBA,+CAAA;EapsMI,qCAAA;E2CpBE,qCAAA;AxD0gON;;AAEA;;EAEE,WwDzgOM;ExD0gON,kIwD1gOM;ExD2tMN,wCAAA;AACF;;AAkzBA,mBwD3gOM;AxD4gON;;EAEE,8CwD3gOM;AxD4gOR;;AAEA;;EAEE,YwD5gOM;ExD4tMN,wFAAA;EACF,yCAAA;AaxtMI;;Ab4gOJ,qBwD7gOQ;AxD8gOR;;EAEE,gDwD7gOM;ExD8gON,qCwD7gOM;ExD8gON,qCwD7gOM;AxD8gOR;;AAhzBA;;EwD3tMM,UAAA;ExDghOJ,kIwD9gOM;ExD+gON,uCwD/gOM;AxDghOR;;AazhOI,mBAAA;Ab4hOJ;EACE,sCwD9gOM;ExD4tMN,gEAAA;EACF,8BAAA;EazvMI,kBAAA;E2C/BF,sCAAA;ExD8kOA,8CwD7gOM;AxD8gOR;;AAEA;EwD5gOQ,yBAAA;ExD8gON,6BwD7gOQ;ExD2tMR,gCAAA;EwDxtMM,gCAAA;ExD6gON,iDwD5gOQ;ExD6gOR,6DwD7gOQ;ExD8gOR,sDwD9gOQ;ExD+gOR,2FwD9gOQ;ExD+gOR,6CwD/gOQ;ExDghOR,mCwDhhOQ;ExDihOR,qCwDhhOQ;ExDihOR,mCwDhhOQ;ExDihOR,kCwD/gOQ;ExDytMR,8CAAA;EACF,iCAAA;EAwzBE,iCAAiC;EarjO/B,6CAAA;E2C5CF,8BAAA;ExDomOA,iCwDlmOI;ExDmmOJ,yDwDlmOI;ExDmmOJ,iCwDlmOI;ExDmmOJ,cwDlmOI;ExDmmOJ,sCwDnmOI;ExDomOJ,gCwDpmOI;ExDqmOJ,kBwDpmOI;ExDqmOJ,gBwDrmOI;ExDsmOJ,gBwDtmOI;ExDumOJ,gBwDvmOI;ExDwmOJ,iBwDvmOI;ExDwmOJ,qBwDvmOI;ExDwmOJ,iBwDvmOI;ExDwmOJ,oBwDvmOI;ExDwmOJ,sBwDvmOI;ExDwmOJ,kBwDvmOI;ExDwmOJ,mBqBpoOI;ErBqoOJ,oBqBroOI;ErBy0MJ,gBAAA;EACF,sCAAA;EqBt0MM,qBAAA;EmCYJ,sCAAA;ExD0nOA,4BqBroOM;ErBsoON,2EqBtoOM;ErBy0MN,8CAAA;AACF;;AAg0BA;EACE,cwD/mOM;ExDgnON,oCwD/mOM;ExDgnON,sCwD/mOM;AxDgnOR;;AAEA;;EA7zBA,kBAAA;Ea5xMI,cAAA;E2CpBE,WAAA;ExDknOJ,yBwDjnOM;ExDknON,mBwDjnOM;ExDknON,ewDjnOM;AxDknOR;;AAEA;;EA9zBA,oFAAA;AaryMI;;AbwmOJ;;;;EAIE,wFwDnnOM;AxDonOR;;AAEA;;EA/zBA,SAAA;EahzMI,gDAAA;AbmnOJ;;AAEA;;EAEE,sCwDrnOM;ExDsnON,sCwDrnOM;AxDsnOR;;AAEA,qBAl0BE;AACF;;EwDnzMM,kFAAA;ExDwnOJ,qCwDtnOM;ExDunON,qCwDvnOM;AxDwnOR;;AajoOI;;;;Ebo0MJ,kIAAA;Aaj1MI;;AbupOJ;;EAEE,OwDrnOM;ExDmzMN,kDAAA;AAo0BF;;AAEA;;EAEE,oCwDpnOQ;ExDqnOR,wCwDrnOQ;AxDsnOV;;AAEA,mBwDvnOU;AxDwnOV;;EAEE,iFwDxnOQ;AxDynOV;;AAr0BA;;;;EA20BE,wFwD1sOI;AxD2sON;;AAEA;;EAEE,MwD5sOI;ExD6sOJ,mDwD5sOI;AxD6sON;;AAEA;;EAEE,mCwD/sOI;ExDgtOJ,yCwD/sOI;AxDgtON;;AAEA;;EAEE,kBqB7uOI;ErBi6MJ,MAAA;EACF,SAAA;EqB95MM,cAAA;EmCYJ,oCAAA;ExDkuOA,uDqB7uOM;ErB8uON,WqB9uOM;ErBi6MN,+EAAA;AACF;;AAg1BA,qBwDvtOM;AxDwtON;;EAEE,mFwDvtOM;ExDwtON,qCwDvtOM;ExDwtON,qCwDvtOM;AxDwtOR;;AA70BA;;;;EAm1BE,kIwDztOM;AxD0tOR;;AAEA;;EA90BE,QAAA;EACF,iDAAA;Aa73MI;;AbgtOJ;;EAEE,qCwD3tOM;ExD4tON,uCwD3tOM;AxD4tOR;;AAEA,mBwD3tOQ;AxD4tOR;EAh1BE,8EAAA;EACF,gBAAA;Eax4MI,6CAAA;E2CFE,qCAAA;ExD8tOJ,6CwD7tOM;ExD8tON,kFwD7tOM;ExD8tON,6DwD7tOM;ExD8tON,8DwD7tOM;AxD8tOR;;AAEA;EAj1BE,aAAA;AACF;;AAo1BA;EACE,0EwD9tOM;ExD+tON,mCwD/tOM;AxDguOR;;AazuOI;E2CYE,kBAAA;AxDiuON;;AAj1BA;EwDx8ME,mBAAA;AxD8xOF;;AAEA;EAl1BE,kBAAA;EwDz4MM,WAAA;ExD8tON,gBwD7tOQ;AxD8tOV;;AAEA;EACE,cwD7tOQ;ExD8tOR,WwD9tOQ;ExD+tOR,WwD9tOQ;AxD+tOV;;AAEA;EACE,kBwDhuOQ;ExDiuOR,awD/tOQ;ExDy4MR,WAAA;EACF,WAAA;EAw1BE,mBAAmB;EwD/yOf,2BAAA;EAGA,sCAAA;AxDmzON;;AAEA;EACE;IwDpzOI,gBAAA;EACA;AxDuzON;;AAEA;;;EqBj1OM,cAAA;ArBw/MN;;AA+1BA;;EA31BE,2BAAA;AACF;;AAg2BA;;EwDzzOQ,4BAAA;AxD6zOR;;AA71BA;EwD59MM,UAAA;EAEE,4BAAA;EAEA,eAAA;AxD6zOR;;AA91BA;;;EwDz9MQ,UAAA;EACA,UAAA;AxD6zOR;;AAEA;;EAEE,UwD7zOM;ExD69MR,UAAA;EwDz9MQ,2BAAA;AxD6zOR;;AAEA;;EwD1zOQ;;IAGF,gBAAA;EAEE;AxD4zOR;;AwDzzOM;;ExD09MN,kBAAA;EAo2BE,MAAM;EwDhyOR,SAAA;EPpHE,UAAA;EAGA,a7C0mCkC;E6CvmClC,mBAAA;EAGS,uBAAA;EjDojNX,UAAA;EiDnjNE,UAAA;EAAS,WAAA;EjDsjNX,kBAAA;EAo2BE,gBAAgB;EwD5yOlB,SAAA;EACE,YAAA;EAAA,8BAAA;AxDgzOF;;AAEA;;EAEE;;IAt2BF,gBAAA;EwDz8ME;AxDozOF;;AAEA;;;;EwD9yOA,WAAA;EACE,qBAAA;EACA,UAAA;ExD08MF,YAAA;AA02BA;;AAEA;EACE,OwDnzOA;AxDozOF;;AAEA;EA12BA,QAAA;AA42BA;;AAEA;;EyDr8OE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,4BrDgzCkC;EJ6yKpC,wBAAA;EyD3lNE,0BAAA;AzDw8OF;;AAz2BA;;;;;;;GyDnlNE;AzD2lNF;EA42BE,0DAAyQ;AyDp8O3Q;;AzD4lNA;EA42BE,0DAA0Q;AyDl8O1Q;;AzDq8OF;EA32BA,kBAAA;EA62BE,QAAQ;EyDl8OV,SAAA;EACE,OAAA;EzDo8OA,UyDn8OE;EzDs8OF,aAAa;EAGb,uBItrMkC;EJq0KlC,UAAA;EACF,iBAAA;EyDrlNA,mBAAA;EACE,gBAAA;AzDy8OF;;AAEA;EAEE,uByD38OA;EAGF,cAAA;EACE,WAAA;EzD48OA,WyD38OE;EzD48OF,UyD58OE;EzDulNF,iBAAA;EACF,gBAAA;EAu3BE,mBAAmB;EyDj9OrB,eAAA;EACE,sBAAA;EzDm9OA,4ByDl9OE;EzDm9OF,SAAS;EA53BT,kCAAA;EACF,qCAAA;EsDtoNE,YAAA;EAEE,6BAAA;AtDqgPJ;;AAEA;E0DzgPE;IAEE,gBAAA;E1D8oNJ;AA83BA;;AAEA;E0D9gPI,UAAA;A1DmpNJ;;A0DrpNE;EACE,kBAAA;EACA,UAAA;E1DwpNJ,eAAA;EA83BE,SAAS;E0DxhPT,oBAAA;EACE,uBAAA;EACA,WAAA;E1D6pNJ,kBAAA;AA83BA;;AAEA;;EAGE,gCAAgC;A0DliPhC;;A1DqiPF;EA53BA,sBAAA;AA83BA;;AAEA;E0DviPI,WAAA;A1D4qNJ;;A0D9qNE;;;;ECAA,gCAAA;A3DmjPF;;AA33BA;;E2DhrNQ,sBAAA;A3DgjPR;;AAEA;;E2DzjPI,WAAA;A3D4jPJ;;A2DxjPM;;EAIE,qBAAA;E3D4rNR,8BAAA;EA83BE,gCAAgC;E2DnkPhC,gDAAA;EACE,kBAAA;E3DysNJ,6FAAA;A2DrsNM;;A3DglPN;E2DrlPE;IAKI;;IAIE;E3DutNR;AA83BA;;AAEA;E2D9lPI,wBAAA;E3DmuNJ,yBAAA;E2DhuNM,qCAAA;EAGE,iCAAA;EACA,mCAAA;E3DguNR,2CAAA;EA83BE,yDAAyD;E2DvmPzD,+BAAA;A3DymPF;;AA33BA;E2DzuNM,wBAAA;EAGE,yBAAA;EACA,gCAAA;A3DyuNR;;A2D7tNI;EAEE;I3D6uNN,mBAAA;EA83BE;;E4DnoPA;IAEA,UAAA;I5DwwNF,eAAA;EA+3BE;A6D1oPF;;A7D6oPA;E6D5oPE,wBAAA;EACA,yBzD6c4B;EyD5c5B,qCAAA;E7D8oPA,mC6D9oPA;E7D+oPA,yC6D/oPA;EACA,8BAAA;EACA,UAAA;A7DgpPF;;AAj4BA;E6D5wNE,wBAAA;EACE,yBAAA;A7DipPJ;;AAEA;;EqB5oPM;;IrB2wNN,kCAAA;EqBvwNM;ArB8oPN;;AAEA;;;;;;EAME,2B6DrpPI;E7D+wNN,2BAAA;EAw4BE,2BAA2B;E8D1qP7B,gCAAA;EACE,8BAAA;EACA,0CAAA;E9DqyNF,uBAAA;E8DnyNE,mDAAA;EACE,+CAAA;EACA,kDAAA;EACA,qDAAA;E9DqyNJ,qCAAA;A8DlyNE;;A9D4qPF;E8DzqPI;IACA,eAAA;IACA,SAAA;I9DoyNJ,mCAAA;I8D9xNI,aAAA;IAAA,sBAAA;I9DsyNJ,eAAA;IAw4BI,gCAAgC;I8D/qPlC,kBAAA;IACE,wCAAA;I9D0yNJ,4BAAA;IAw4BI,UAAU;I8DlrPV,0CAAA;E9D8yNJ;AAw4BA;;AAEA;E+D3sPE;IAEA,gBAAA;EACA;A/Ds0NF;;A+Dn0NA;EACE;IACA,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qF3D+lCkC;IJ+mNhC,4BAA4B;E+DtsP5B;A/DwsPJ;;AAEA;EAt4BA;IAw4BI,MAAM;I+DtsPN,QAAA;IACE,gCAAA;IACA,oFAAA;I/Dk0NN,2BAAA;EAw4BE;Aa1qPE;;Ab6qPJ;EACE;I+DntPI,MAAA;I/D80NJ,QAAA;I+D30NE,OAAA;IACE,kCAAA;IACA,gBAAA;IACA,sF3D6kC8B;IJiwLpC,4BAAA;Ea/yNI;AbwrPJ;;AAEA;EACE;IAt4BA,QAAA;I+Dv1NE,OAAA;IACE,kCAAA;IACA,gBAAA;IACA,mF3D6kC8B;IJ6wLpC,2BAAA;Ea3zNI;AbosPJ;;AAEA;;EAr4BE;;I+Dj2NI,eAAA;E/D4uPJ;AACF;;Aa7sPI;;EbitPF;;;IAp4BA,mBAAA;E+D/2NE;A/DwvPJ;;AAEA;EAt4BE;IACF,2BAAA;Ian1NI,8BAAA;IkDxCA,wCAAA;E/DqwPF;;EAEA;IAt4BA,aAAA;E+D33NE;;E/DqwPF;IAp4BF,aAAA;IgE55NE,YAAA;IAAA,UAAA;IACA,mBAAA;IAAA,wCAAA;EhEyyPA;AACF;;AAEA;EACE;IgE3yPA,eAAA;IhE6yPE,SgE7yPF;IhE+5NF,mCAAA;IgE35NE,aAAA;IhEizPE,sBgEhzPF;IhEizPE,egEjzPF;IACA,gCAAA;IAAA,kBAAA;IhEmzPE,wCgEnzPF;IhEozPE,4BgEpzPF;IACA,UAAA;IhE+5NF,0CAAA;EAw5BE;AiE/zPF;;AjEk0PA;EkE7zPE;IAEA,gBAAA;EACA;AlE+zPF;;AAEA;EAt5BA;IkEr6NE,MAAA;IlE8zPE,OAAO;IkE7zPP,gCAAA;IlEw6NJ,qFAAA;ImEt7NE,4BAAA;EACE;AnEg1PJ;;AAEA;EmE90PI;IACA,MAAA;IACA,QAAA;InEy7NJ,gCAAA;IAw5BI,oFAAoF;IoEz1PtF,2BAAA;EACA;ApE41PF;;AAEA;EqEn2PA;IACE,MAAA;IACA,QAAA;IrEq2PE,OqEr2PF;IACA,kCjEisB4B;IiEhsB5B,gBAAA;IACA,sFAAA;IrE+8NF,4BAAA;EAy5BE;AsE3yPM;;AtEs5NR;EAy5BE;IsE/yPM,QAAA;IAOI,OAAA;ItEm5NZ,kCAAA;IAy5BI,gBAAgB;IsEnzPZ,mFAAA;ItE85NR,2BAAA;EAy5BE;AsEvzPM;;AtEk6NR;;EsEl6NQ;;ItE+zPJ,eAAe;EsE/zPX;AtEi0PR;;AAEA;;EsE5zPY;;;IAPJ,mBAAA;EAOI;AtE26NZ;;AsEl7NQ;EAOI;ItE+6NZ,2BAAA;IAy5BI,8BAA8B;IsE/0P1B,wCAAA;EAOI;;EtEm7NZ;IA05BI,aAAa;EsEp1PT;;EtEu1PN;IsEv1PM,aAAA;ItEk8NR,YAAA;IA45BI,UAAU;IsE91PN,mBAAA;IAOI,wCAAA;EtE01PV;AA35BF;;AsEt8NQ;EAOI;ItE+1PR,esE/1PQ;ItEm8NZ,SAAA;IA85BI,mCAAmC;IA15BvC,aAAA;IAIA,sBAAA;IA85BI,eAAe;IsEh3PX,gCAAA;IAOI,kBAAA;ItE+8NZ,wCAAA;IA85BI,4BAA4B;IsEp3PxB,UAAA;ItE09NR,0CAAA;EA85BE;AsEx3PM;;AtE89NR;EA85BE;IsEr3PU,gBAAA;EtE29NZ;AA85BA;;AAEA;EA55BA;IA85BI,MAAM;IsEp4PF,OAAA;IAOI,gCAAA;ItEm+NZ,qFAAA;IsE1+NQ,4BAAA;EAOI;AtEu+NZ;;AsE9+NQ;EAOI;ItE2+NZ,MAAA;IA85BI,QAAQ;IsEh5PJ,gCAAA;IAOI,oFAAA;ItE64PR,2BAA2B;EsEp5PvB;AtEs5PR;;AAEA;EsEx5PQ;IAOI,MAAA;ItEu/NZ,QAAA;IA85BI,OAAO;IsE55PH,kCAAA;IAOI,gBAAA;ItE2/NZ,sFAAA;IsElgOQ,4BAAA;EAOI;AtE+/NZ;;AsEtgOQ;EAOI;ItEmgOZ,QAAA;IA85BI,OAAO;IsEx6PH,kCAAA;IAOI,gBAAA;ItEugOZ,mFAAA;IsE9gOQ,2BAAA;EAOI;AtE2gOZ;;AsElhOQ;;EtEshOR;;IsE/gOY,eAAA;EtEmhOZ;AA85BA;;AAEA;;EAEE;;;IA15BF,mBAAA;EA85BE;AsEh8PM;;AtEsiOR;EA85BE;IsEp8PM,2BAAA;IAOI,8BAAA;ItEmiOZ,wCAAA;EA85BE;;EsEj8PU;ItEuiOZ,aAAA;EA85BE;;EsEr8PU;ItE2iOZ,aAAA;IsE3iOY,YAAA;IAAA,UAAA;IAAA,mBAAA;ItE+iOZ,wCAAA;EAk6BE;AsEx9PM;;AtE0jOR;EAk6BE;IsE59PM,eAAA;IAOI,SAAA;ItEw9PR,mCsEx9PQ;IAPJ,aAAA;ItEs+PJ,sBAAsB;IsEt+PlB,eAAA;IAOI,gCAAA;ItEk+PR,kBsEl+PQ;ItE+jOZ,wCAAA;IAq6BI,4BAA4B;IsE3+PxB,UAAA;ItE8+PJ,0CsEv+PQ;EtEmkOZ;AAs6BA;;AAEA;EAp6BA;IsExlOQ,gBAAA;EACE;AtE2lOV;;AsE5lOQ;EACE;ItE+lOV,MAAA;IAs6BI,OAAO;IsEtgQH,gCAAA;IACE,qFAAA;ItEygQN,4BAA4B;EsE1gQxB;AtE4gQR;;AAEA;EsE9gQQ;IACE,MAAA;ItE2mOV,QAAA;IAs6BI,gCAAgC;IsElhQ5B,oFAAA;ItEgnOR,2BAAA;EAs6BE;AsEthQM;;AtEonOR;EAs6BE;IsEhhQM,MAAA;IAOI,QAAA;ItEumOZ,OAAA;IAs6BI,kCAAkC;IsEphQ9B,gBAAA;IAOI,sFAAA;ItEihQR,4BAA4B;EsExhQxB;AtE0hQR;;AAEA;EsE5hQQ;IAOI,QAAA;ItEmnOZ,OAAA;IAs6BI,kCAAkC;IsEhiQ9B,gBAAA;IAOI,mFAAA;ItE6hQR,2BAA2B;EsEpiQvB;AtEsiQR;;AAEA;;EsEjiQY;;IAPJ,eAAA;EAOI;AtEmoOZ;;AsE1oOQ;;EtE8oOR;;;IsEvoOY,mBAAA;EtE2oOZ;AAs6BA;;AAEA;EAp6BA;IAs6BI,2BAA2B;IsE5jQvB,8BAAA;IAOI,wCAAA;EtEmpOZ;;EsE1pOQ;IAOI,aAAA;EtEupOZ;;EsE9pOQ;ItEwkQJ,aAAa;IAl6BjB,YAAA;IAs6BI,UAAU;IsE5kQN,mBAAA;IAOI,wCAAA;EtEmqOZ;AAs6BA;;AAEA;EAp6BA;IAs6BI,eAAe;IsEplQX,SAAA;IAOI,mCAAA;ItEklQR,aAAa;IAn6BjB,sBAAA;IAw6BI,eAAe;IsE9lQX,gCAAA;IAOI,kBAAA;ItE0lQR,wCsE1lQQ;ItEmrOZ,4BAAA;IAy6BI,UAAU;IsE5lQF,0CAAA;EtEurOZ;AAy6BA;;AAEA;EAv6BA;IsElsOQ,gBAAA;EAOI;AtE+rOZ;;AsEtsOQ;EAOI;ItEmsOZ,MAAA;IAy6BI,OAAO;IsEnnQH,gCAAA;IAOI,qFAAA;ItEgnQR,4BAA4B;EsEvnQxB;AtEynQR;;AAEA;EsE3nQQ;IAOI,MAAA;ItE+sOZ,QAAA;IAy6BI,gCAAgC;IsE/nQ5B,oFAAA;ItE0tOR,2BAAA;EAy6BE;AsEnoQM;;AtE8tOR;EAy6BE;IsEvoQM,MAAA;IAOI,QAAA;ItE2tOZ,OAAA;IAy6BI,kCAAkC;IsE3oQ9B,gBAAA;IAIQ,sFAAA;ItEmuOhB,4BAAA;EAy6BE;AsEhpQM;;AtEmpQR;EAv6BA;IAy6BI,QAAQ;IsErpQJ,OAAA;IAIQ,kCAAA;IAGJ,gBAAA;ItE0uOZ,mFAAA;IsEjvOQ,2BAAA;EAIQ;AtEypQhB;;AAEA;;EsE3pQgB;;ItEgqQZ,eAAe;EsEpqQX;AtEsqQR;;AAt6BA;;EsEhwOQ;;;ItEqwOR,mBAAA;EAy6BE;AsE9qQM;;AtEirQR;EAv6BA;IAy6BI,2BAA2B;IsEnrQvB,8BAAA;IAIQ,wCAAA;EAGJ;;EtEirQV;IsExrQM,aAAA;EAIQ;;EtEgxOhB;IsE7wOY,aAAA;IAPJ,YAAA;IAOI,UAAA;ItEqxOZ,mBAAA;IAy6BI,wCAAwC;EsErsQpC;AtEusQR;;AAEA;EsEzsQQ,eAAA;EAOI,SAAA;EtE6xOZ,mCAAA;EsE7xOY,aAAA;EAAA,sBAAA;EtEqyOZ,eAAA;EAy6BE,gCAAgC;EsErtQ1B,kBAAA;EAOI,wCAAA;EtEyyOZ,4BAAA;EAy6BE,UAAU;EsEltQA,0CAAA;AtE6yOZ;;AsEpzOQ;EAOI;ItE0tQR,gBAAgB;EsEjuQZ;AtEmuQR;;AAEA;EsEruQQ,MAAA;EAOI,OAAA;EtEyzOZ,gCAAA;EAy6BE,qFAAqF;EsEluQ3E,4BAAA;AtE6zOZ;;AsEp0OQ;EAOI,MAAA;EtEi0OZ,QAAA;EAy6BE,gCAAgC;EsE3vQ1B,oFAAA;EtEs1OR,2BAAA;AAy6BA;;AAEA;EAv6BA,MAAA;EAy6BE,QAAQ;EsEnwQF,OAAA;EACE,kCAAA;EtE61OV,gBAAA;EAy6BE,sFAAsF;EsEtwQ9E,4BAAA;AtEi2OV;;AsEl2OQ;EACE,QAAA;EtEq2OV,OAAA;EAy6BE,kCAAkC;EsErwQ5B,gBAAA;EAOI,mFAAA;EtEkwQV,2BAA2B;AsEzwQrB;;AtEo2OR;;EsE71OY,eAAA;AtEi2OZ;;AsEx2OQ;;;EtEqxQN,mBAAmB;AsErxQb;;AtEg3OR;EAy6BE,eAAe;EsEzxQT,MAAA;EAOI,OAAA;EtE62OZ,aAAA;EAy6BE,YAAY;EsE7xQN,aAAA;EAOI,sBAAA;AtEi3OZ;;AsEx3OQ;EAOI,UAAA;AtEq3OZ;;AsE53OQ;EAOI,YAAA;AtEy3OZ;;AsEh4OQ;EtE6yQN,aAAa;EAr6Bf,mBAAA;EsEj4OY,8BAAA;EtEq4OZ,oEAAA;AAy6BA;;AAEA;EAv6BA,4FAAA;EAy6BE,sDAAsD;EsEzzQhD,wDAAA;EAOI,yDAAA;AtE64OZ;;AsEp5OQ;EAOI,gBAAA;EtEi5OZ,kDAAA;AAy6BA;;AAEA;EsEn0QQ,YAAA;EAOI,oEAAA;EtEi0QV,gBsEj0QU;AtEk0QZ;;AAEA;EsE30QQ,qBAAA;EAOI,eAAA;EAAA,sBAAA;EtEw0QV,YsEx0QU;EtEy0QV,8BsEz0QU;EtE65OZ,YAAA;AA86BA;;AAEA;EsE70QY,qBAAA;EtE+0QV,WsE/0QU;AtEg1QZ;;AAEA;EsEz1QQ,iBAAA;AtE21QR;;AAEA;EACE,iBsEv1QU;AtEq6OZ;;AsE56OQ;EAOI,iBAAA;AtE41QZ;;AAEA;EAEE,mDAAmD;AsEv2Q7C;;AtEg3QR;EACE;IAz7BF,YAAA;EA27BE;AsEn3QM;;AtEs3QR;EAEE,+EAA+E;EsEj3QrE,oBAAA;EtEy7OZ,8CAAA;AA67BA;;AAr7BA;EA+7BE;IsEh4QU,uBAAA;EtEm4QV;AA97BF;;AsE58OQ;EAOI,cAAA;EtEw4QV,WsEx4QU;EtEy4QV,WsEz4QU;AtEy8OZ;;AsEh9OQ;EAOI,sBAAA;EtE84QV,iFsE94QU;AtE+4QZ;;AAEA;EsEx5QQ,sBAAA;EAOI,mFAAA;AtEo5QZ;;AAn8BA;EAs8BE,sBAAsB;EsE95QhB,iFAAA;AtEg6QR;;AAEA;EAt8BA,sBAAA;EAw8BE,8EAA8E;AsEp6QxE;;AtEu6QR;EAv8BA,sBAAA;EAy8BE,iFAAiF;AsEz6Q3E;;AtE46QR;EACE,sBsEt6QU;EtE69OZ,gFAAA;AA28BA;;AAEA;EACE,sBsE36QU;EtE46QV,+EsE56QU;AtEi+OZ;;AsEx+OQ;EAOI,sBAAA;EtEi7QV,8EsEj7QU;AtEk7QZ;;AAEA;EsE37QQ,wEAAA;EAOI,kGAAA;AtEu7QZ;;AA98BA;;EsEh/OQ,8DAAA;EAOI,wFAAA;AtE67QZ;;AAh9BA;EAm9BE,0EAA0E;EsEv8QpE,oGAAA;AtEy8QR;;AAEA;;EAEE,6DAA6D;EsE78QvD,uFAAA;AtE+8QR;;AAn9BA;EAs9BE,wEAAwE;EsEl9QlE,kGAAA;AtEo9QR;;AAp9BA;;EsEhgPQ,+DAAA;EAOI,yFAAA;AtEm9QZ;;AAEA;EsE59QQ,qEAAA;EAOI,+FAAA;AtEw9QZ;;AAEA;;EsE19QY,+DAAA;EtE69QV,yFsE79QU;AtEqgPZ;;AsE5gPQ;EAOI,wEAAA;EtEk+QV,kGsEl+QU;AtEygPZ;;AsEhhPQ;;EtE8+QN,+DsEv+QU;EtE6gPZ,yFAAA;AA49BA;;AAEA;EACE,uEsE5+QU;EtEihPZ,iGAAA;AA69BA;;AAEA;;EA39BA,8DAAA;EA89BE,wFAAwF;AsE1/QlF;;AtE6/QR;EA79BA,sEAAA;EA+9BE,gGAAgG;AsE//Q1F;;AtEkgRR;;EAEE,gEAAgE;EsEpgR1D,0FAAA;AtEsgRR;;AA99BA;EAi+BE,qEAAqE;EsEzgR/D,+FAAA;AtE2gRR;;AAEA;;EAEE,6DAA6D;EsE/gRvD,uFAAA;AtEihRR;;AAEA;EAn+BA,+EAAA;EAq+BE,yGAAyG;AsErhRnG;;AtEwhRR;;EAp+BA,kFAAA;EAu+BE,4GAA4G;AsE3hRtG;;AtE8hRR;EACE,UsExhRU;EtE0hRV,kJAAkJ;AsEjiR5I;;AtEoiRR;EAGE,oBAAoB;EsEviRd,aAAA;EtE2iRN,mBsEpiRU;EtEyjPZ,kFAAA;EA6+BE,6BAA6B;EsEtiRnB,2BAAA;AtEyiRZ;;AA5+BA;EsEpkPQ,cAAA;EAOI,UAAA;EtE+iRV,WsE/iRU;EtEgjRV,kBsEhjRU;EtEkjRV,sCAAsC;AsEzjRhC;;AtE4kPR;EAi/BE;IsEtjRU,gBAAA;EtEykPZ;AAi/BA;;AAEA;;EsEnkRQ,mEAAA;AtEukRR;;AAEA;EsEzkRQ,kBAAA;EAOI,WAAA;AtEqlPZ;;AsE5lPQ;EAOI,cAAA;EtEylPZ,mCAAA;EAi/BE,WAAW;AsEjlRL;;AtEomPR;EAi/BE,kBAAkB;EsErlRZ,MAAA;EAOI,OAAA;EAAA,WAAA;EtEkmPZ,YAAA;AAi/BA;;AAEA;EsErlRY,uBAAA;AtEumPZ;;AsE9mPQ;EAOI,sBAAA;AtE2lRZ;;AAEA;EsEpmRQ,yBAAA;AtEsmRR;;AA9+BA;EAi/BE,iCAAiC;AsEzmR3B;;AtE4mRR;EA/+BA,eAAA;EAi/BE,MAAM;EsE9mRA,QAAA;EAOI,OAAA;EAAA,aAAA;AtE2nPZ;;AsEloPQ;EAOI,eAAA;EAAA,QAAA;EtEgoPZ,SAAA;EAi/BE,OAAO;EsExnRD,aAAA;AtE0nRR;;AA9+BA;EAi/BE,gBAAgB;EsE7nRV,MAAA;EAOI,aAAA;AtEynRZ;;AAEA;EsEloRQ,gBAAA;EAOI,SAAA;EAAA,aAAA;AtE+oPZ;;AsEtpPQ;EAOI;IAAA,gBAAA;ItEopPZ,MAAA;IAi/BI,aAAa;EsE5oRT;;EAOI;ItEypPZ,gBAAA;IAi/BI,SAAS;IsEjpRL,aAAA;EAOI;AtE6oRZ;;AAEA;EsEtpRQ;IAOI,gBAAA;IAAA,MAAA;ItEmqPZ,aAAA;EAi/BE;;EsEppRU;ItEuqPZ,gBAAA;IAi/BI,SAAS;IsE/pRL,aAAA;EAOI;AtE2qPZ;;AsElrPQ;EAOI;ItE+qPZ,gBAAA;IAi/BI,MAAM;IsEvqRF,aAAA;EAOI;;EtEoqRV;IsE3qRM,gBAAA;IAOI,SAAA;ItEurPZ,aAAA;EAi/BE;AsE/qRM;;AtEksPR;EAi/BE;IsEnrRM,gBAAA;IAOI,MAAA;ItE+rPZ,aAAA;EAi/BE;;EsEhrRU;ItEmsPZ,gBAAA;IAi/BI,SAAS;IsE3rRL,aAAA;EAOI;AtEusPZ;;AsE9sPQ;EAOI;ItE2sPZ,gBAAA;IAi/BI,MAAM;IsEnsRF,aAAA;EAOI;;EtEgsRV;IsEvsRM,gBAAA;IAOI,SAAA;ItEmtPZ,aAAA;EAi/BE;AsE3sRM;;AtE8tPR;EsEvtPY,aAAA;EAAA,mBAAA;EAPJ,mBAAA;EtE0uPR,mBAAA;AAi/BA;;AAEA;EsE7tRQ,aAAA;EtEmuRN,cAAc;EAId,sBAAsB;EsEhuRZ,mBAAA;AtEmvPZ;;AsE1vPQ;;EtE8vPR,qBAAA;EAi/BE,sBAAsB;EsE/uRhB,qBAAA;EAOI,uBAAA;EtE2vPZ,2BAAA;EAi/BE,iCAAiC;EsEnvR3B,8BAAA;EAOI,oBAAA;AtE+vPZ;;AsEtwPQ;;EtE0wPR,6BAAA;AAi/BA;;AAEA;EA/+BA,kBAAA;EAi/BE,MAAM;EsE/vRA,QAAA;EAOI,SAAA;EtE2wPZ,OAAA;EAi/BE,UAAU;EsEnwRJ,WAAA;AtEqwRR;;AAEA;EsEvwRQ,gBAAA;EAOI,uBAAA;EtEmxPZ,mBAAA;AAi/BA;;AAEA;EA/+BA,qBAAA;EsE9xPQ,mBAAA;EAOI,6BAAA;EtE2xPZ,eAAA;EAi/BE,8BAA8B;EsEnxRxB,aAAA;AtEqxRR;;AAEA;EsEvxRQ,mCAAA;AtEyxRR;;AAEA;EsE3xRQ,8BAAA;AtE6xRR;;AAEA;EsE/xRQ,iCAAA;AtEiyRR;;AA9+BA;EAi/BE,iCAAiC;AsEpyR3B;;AtEuyRR;EA/+BA,sCAAA;AAi/BA;;AAEA;EsEpyRY,mCAAA;AtEszPZ;;AsE7zPQ;EAOI,sBAAA;AtE0yRZ;;AAEA;EsEnzRQ,uBAAA;AtEqzRR;;AA9+BA;EAi/BE,sBAAsB;AsExzRhB;;AtE2zRR;EAEE,8BAA8B;AsE7zRxB;;AtEg0RR;EAEE,4BAA4B;AsEl0RtB;;AtEq0RR;EAEE,2BAA2B;AsEv0RrB;;AtE00RR;EAEE,iCAAiC;AsE50R3B;;AtE+0RR;EAEE,2BAA2B;AsEj1RrB;;AtEo2PR;EAi/BE,qBAAqB;AsEr1Rf;;AtEw2PR;EAi/BE,wBAAwB;AsEz1RlB;;AtE42PR;EAi/BE,uBAAuB;AsE71RjB;;AtEg3PR;EAi/BE,wBAAwB;AsEj2RlB;;AtEo3PR;EAi/BE,qBAAqB;AsEr2Rf;;AtEw3PR;EAi/BE,yBAAyB;AsEz2RnB;;AtE43PR;EAi/BE,2BAA2B;AsE72RrB;;AtEg4PR;EAi/BE,4BAA4B;AsEj3RtB;;AtEo4PR;EAi/BE,2BAA2B;AsEr3RrB;;AtEw4PR;EAi/BE,2BAA2B;AsEz3RrB;;AtE44PR;EAi/BE,6BAA6B;AsE73RvB;;AtEg5PR;EAi/BE,8BAA8B;AsEj4RxB;;AtEo5PR;EAi/BE,6BAA6B;AsEr4RvB;;AtEw5PR;EAi/BE,2BAA2B;AsEz4RrB;;AtE45PR;EAi/BE,6BAA6B;AsE74RvB;;AtEg6PR;EAi/BE,8BAA8B;AsEj5RxB;;AtEo6PR;EAi/BE,6BAA6B;AsEr5RvB;;AtEw6PR;EAi/BE,0BAA0B;AsEz5RpB;;AtE46PR;EAi/BE,gCAAgC;AsE75R1B;;AtEg7PR;EAi/BE,yBAAyB;AsEj6RnB;;AtEo7PR;EAi/BE,wBAAwB;AsEr6RlB;;AtEw7PR;EAi/BE,+BAA+B;AsEz6RzB;;AtE47PR;EAi/BE,yBAAyB;AsE76RnB;;AtEg8PR;EAi/BE,6BAA6B;AsEj7RvB;;AtEo8PR;EAi/BE,8BAA8B;AsEr7RxB;;AtEw8PR;EsEj8PY,wBAAA;AtEq7RZ;;AAEA;EsEv7RY,+BAAA;AtE28PZ;;AsEl9PQ;EAOI,wBAAA;AtE+7RZ;;AAEA;EsEj8RY,2CAAA;AtEo8RZ;;AAEA;EsEt8RY,8CAAA;AtEy8RZ;;AAEA;EsE38RY,8CAAA;AtE88RZ;;AAEA;EsEh9RY,2BAAA;AtEm9RZ;;AAEA;EsE59RQ,gFAAA;AtE89RR;;AA9+BA;EAi/BE,kFAAkF;AsEj+R5E;;AtEo+RR;EA/+BA,gFAAA;AAi/BA;;AAEA;EsEj+RY,6EAAA;AtEm/PZ;;AsE1/PQ;EAOI,gFAAA;AtEu+RZ;;AAEA;EsEh/RQ,+EAAA;AtEk/RR;;AA9+BA;EAi/BE,8EAA8E;AsEr/RxE;;AtEwgQR;EAi/BE,6EAA6E;AsEz/RvE;;AtE4gQR;EAi/BE,2BAA2B;AsE7/RrB;;AtEghQR;EAi/BE,6BAA6B;AsEjgSvB;;AtEohQR;EAi/BE,6BAA6B;AsErgSvB;;AtEwhQR;EAi/BE,0BAA0B;AsEzgSpB;;AtE4hQR;EAi/BE,2BAA2B;AsE7gSrB;;AtEgiQR;EAi/BE,iBAAiB;AsEjhSX;;AtEoiQR;EAi/BE,mBAAmB;AsErhSb;;AtEwiQR;EAi/BE,oBAAoB;AsEzhSd;;AtE4iQR;EAi/BE,oBAAoB;AsE7hSd;;AtEgjQR;EAi/BE,sBAAsB;AsEjiShB;;AtEojQR;EAi/BE,uBAAuB;AsEriSjB;;AtEwjQR;EAi/BE,kBAAkB;AsEziSZ;;AtE4jQR;EAi/BE,oBAAoB;AsE7iSd;;AtEgkQR;EAi/BE,qBAAqB;AsEjjSf;;AtEokQR;EAi/BE,mBAAmB;AsErjSb;;AtEwkQR;EAi/BE,qBAAqB;AsEzjSf;;AtE4kQR;EAi/BE,sBAAsB;AsE7jShB;;AtEglQR;EsEhlQQ,2CAAA;AtEmkSR;;AAEA;EsE9jSY,sCAAA;AtEilQZ;;AsExlQQ;EtE4lQR,sCAAA;AAi/BA;;AAEA;EA/+BA,uFAAA;AAi/BA;;AAEA;EA/+BA,oBAAA;AAi/BA;;AAEA;EA/+BA,2FAAA;AAi/BA;;AAEA;EA/+BA,wBAAA;AAi/BA;;AAEA;EA/+BA,6FAAA;AAi/BA;;AAEA;EA/+BA,0BAAA;AAi/BA;;AAEA;EA/+BA,8FAAA;AAi/BA;;AAEA;EA/+BA,2BAAA;AAi/BA;;AAEA;EA/+BA,4FAAA;AAi/BA;;AAEA;EA/+BA,yBAAA;AAi/BA;;AAEA;EA/+BA,sBAAA;EAi/BE,8EAA8E;AsEznSxE;;AtE4oQR;EAi/BE,sBAAsB;EsE7nShB,gFAAA;AtE+nSR;;AAEA;EsEjoSQ,sBAAA;EAOI,8EAAA;AtE6oQZ;;AsEppQQ;EAOI,sBAAA;EtEioSV,2EsEjoSU;AtEkoSZ;;AAEA;EsE3oSQ,sBAAA;EAOI,8EAAA;AtEuoSZ;;AAl/BA;EAq/BE,sBAAsB;EsEjpShB,6EAAA;AtEmpSR;;AAEA;EAr/BA,sBAAA;EAu/BE,4EAA4E;AsEvpStE;;AtE0pSR;EACE,sBsEppSU;EtE6pQZ,2EAAA;AAy/BA;;AAEA;EACE,sBsEzpSU;EtE0pSV,4EsE1pSU;AtEiqQZ;;AsExqQQ;EAOI,sBAAA;EtE+pSV,4EsE/pSU;AtEgqSZ;;AAEA;EsEzqSQ,wDAAA;AtE2qSR;;AAEA;EsE7qSQ,0DAAA;AtE+qSR;;AAEA;EsEjrSQ,wDAAA;AtEmrSR;;AAEA;EsErrSQ,qDAAA;AtEurSR;;AAEA;EsEzrSQ,wDAAA;AtE2rSR;;AAEA;EsE7rSQ,uDAAA;AtE+rSR;;AAEA;EsEjsSQ,sDAAA;AtEmsSR;;AAEA;EsErsSQ,qDAAA;AtEusSR;;AAEA;EsEzsSQ,4BAAA;AtE2sSR;;AAEA;EsE7sSQ,4BAAA;AtE+sSR;;AAEA;EsEjtSQ,4BAAA;AtEmtSR;;AAEA;EsErtSQ,4BAAA;AtEutSR;;AAEA;EsEztSQ,4BAAA;AtE2tSR;;AAEA;EsE7tSQ,wBAAA;AtE+tSR;;AAEA;EsEjuSQ,yBAAA;AtEmuSR;;AAEA;EsEruSQ,wBAAA;AtEuuSR;;AAEA;EsEzuSQ,yBAAA;AtE2uSR;;AAEA;EsE7uSQ,sBAAA;AtE+uSR;;AAEA;EsEjvSQ,qBAAA;AtEmvSR;;AAEA;EsErvSQ,qBAAA;AtEuvSR;;AAEA;EsEzvSQ,qBAAA;AtE2vSR;;AAEA;EsE7vSQ,sBAAA;AtE+vSR;;AAEA;EsEjwSQ,sBAAA;AtEmwSR;;AAEA;EsErwSQ,0BAAA;AtEuwSR;;AAEA;EsEzwSQ,uBAAA;AtE2wSR;;AAEA;EsE7wSQ,2BAAA;AtE+wSR;;AAEA;EsEjxSQ,sBAAA;AtEmxSR;;AAEA;EsErxSQ,sBAAA;AtEuxSR;;AAEA;EsEzxSQ,sBAAA;AtE2xSR;;AAEA;EsE7xSQ,uBAAA;AtE+xSR;;AAEA;EsEjySQ,uBAAA;AtEmySR;;AAEA;EsEnzSQ,2BAAA;AAcA;;AtEyySR;EA3/BA,wBAAA;AA6/BA;;AsE3ySQ;EAIQ,4BAAA;AtE2yShB;;AAEA;EsE1ySY,yBAAA;AtEkzQZ;;AsEzzQQ;EtE2zSN,8BAA8B;AsE3zSxB;;AtE8zSR;EsE1zSgB,iCAAA;AtE+zShB;;AAEA;EAx/BA,sCAAA;AA6/BA;;AAEA;EsE50SQ,yCAAA;AtEi1SR;;AA1/BA;EsEn1QgB,uBAAA;AtEm1ShB;;AAEA;EsEl1SY,uBAAA;AtE01QZ;;AsEj2QQ;EAOI,yBAAA;AtE+1QZ;;AsEt2QQ;EAOI,yBAAA;AtEo2QZ;;AsE32QQ;EAOI,0BAAA;AtEy2QZ;;AsEh3QQ;EAOI,4BAAA;AtE82QZ;;AsEr3QQ;EAOI,kCAAA;AtEm3QZ;;AsE13QQ;EtE+3QR,sCAAA;AA6/BA;;AAEA;EAGE,oCAAoC;AsEj4S9B;;AtEo4SR;EsE94SQ,kCAAA;AtEk5SR;;AAEA;EAz/BA,yCAAA;AA6/BA;;AAEA;EAEE,wCAAwC;AsE55SlC;;AtEm6QR;EsEl5QY,wCAAA;AtEs5QZ;;AsE75QQ;EtE85SN,kCAAkC;AsE95S5B;;AtEq6QR;EsE95QY,gCAAA;AtEk6QZ;;AsEz6QQ;EtE06SN,8BAA8B;AsE16SxB;;AtEi7QR;EsE16QY,gCAAA;AtE86QZ;;AsEr7QQ;EtEs7SN,+BAA+B;AsEh8SzB;;AtEu8QR;EsEl8QU,oCAAA;AtEi8SV;;AAEA;EsEv8SU,kCAAA;AtE88QV;;AsE18QU;EtE88QV,gCAAA;AA6/BA;;AAEA;EAEE,uCAAuC;AsE/8S/B;;AtEs9QV;EsE39QQ,sCAAA;AtE09SR;;AAEA;EsEt9SY,iCAAA;AtE69QZ;;AsEn+QQ;EtEu+QR,2BAAA;AA6/BA;;AAEA;EAEE,iCAAiC;AsE99S3B;;AtEq+QR;EsEz9QU,+BAAA;AtEw9SV;;AAEA;EsE/9SY,6BAAA;AtEs+QZ;;AsEj+QU;EtEq+QV,+BAAA;AA6/BA;;AAEA;EAEE,8BAA8B;AsEt+StB;;AtE6+QV;EsEr/QgB,oBAAA;AtEq/ShB;;AAEA;EsEp/SY,mBAAA;AtE4/QZ;;AsEngRQ;EtEwgRR,mBAAA;AA6/BA;;AAEA;EAGE,mBAAmB;AsE1gTb;;AtE6gTR;EsE7gTQ,mBAAA;AtEihTR;;AA1/BA;EsEnhRgB,mBAAA;AtEmhThB;;AAEA;EsElhTY,mBAAA;AtE0hRZ;;AsEjiRQ;EtEsiRR,mBAAA;AA6/BA;;AAEA;EA3/BA,oBAAA;AA6/BA;;AAEA;EA3/BA,0BAAA;AA6/BA;;AAEA;EA3/BA,yBAAA;AA6/BA;;AAEA;EA3/BA,uBAAA;AA6/BA;;AAEA;EA3/BA,yBAAA;AA6/BA;;AAEA;EA3/BA,uBAAA;AA6/BA;;AAEA;EA3/BA,uBAAA;AA6/BA;;AAEA;EA3/BA,0BAAA;EA6/BE,yBAAyB;AsE7kTnB;;AtEolRR;EA6/BE,gCAAgC;EsE5kTxB,+BAAA;AtE8kTV;;AAEA;EsErlTQ,+BAAA;EACE,8BAAA;AtE2lRV;;AsEvlRU;EACE,6BAAA;EtE0lRZ,4BAAA;AA6/BA;;AAEA;EsE9kTY,+BAAA;EtEolRZ,8BAAA;AA6/BA;;AAEA;EsEnlTY,6BAAA;EtEylRZ,4BAAA;AA6/BA;;AAEA;EsExlTY,6BAAA;EtE8lRZ,4BAAA;AA6/BA;;AAEA;EsE7lTY,wBAAA;EtEmmRZ,2BAAA;AA6/BA;;AAEA;EsElmTY,8BAAA;EtEwmRZ,iCAAA;AA6/BA;;AAEA;EsEvmTY,6BAAA;EtE6mRZ,gCAAA;AA6/BA;;AAEA;EsE5mTY,2BAAA;EtEknRZ,8BAAA;AA6/BA;;AAEA;EsEjnTY,6BAAA;EtEunRZ,gCAAA;AA6/BA;;AAEA;EsEtnTY,2BAAA;EtE4nRZ,8BAAA;AA6/BA;;AAEA;EsE3nTY,2BAAA;EtEioRZ,8BAAA;AA6/BA;;AAEA;EsEhoTY,wBAAA;AtEsoRZ;;AsE7oRQ;EAIQ,8BAAA;AtEyoThB;;AAEA;EsE/oTQ,6BAAA;AtEipTR;;AA1/BA;EA6/BE,2BAA2B;AsEppTrB;;AtEupTR;EA3/BA,6BAAA;AA6/BA;;AAEA;EA3/BA,2BAAA;AA6/BA;;AAEA;EA3/BA,2BAAA;AA6/BA;;AAEA;EA3/BA,0BAAA;AA6/BA;;AAEA;EA3/BA,gCAAA;AA6/BA;;AAEA;EA3/BA,+BAAA;AA6/BA;;AAEA;EA3/BA,6BAAA;AA6/BA;;AAEA;EA3/BA,+BAAA;AA6/BA;;AAEA;EA3/BA,6BAAA;AA6/BA;;AAEA;EA3/BA,6BAAA;AA6/BA;;AAEA;EA3/BA,2BAAA;AA6/BA;;AAEA;EA3/BA,iCAAA;AA6/BA;;AAEA;EA3/BA,gCAAA;AA6/BA;;AAEA;EA3/BA,8BAAA;AA6/BA;;AAEA;EA3/BA,gCAAA;AA6/BA;;AAEA;EACE,8BsE7sTU;AtE8sTZ;;AAEA;EsEvtTQ,8BAAA;AtEytTR;;AAEA;EACE,yBsErtTU;AtEqtRZ;;AsE5tRQ;EAOI,+BAAA;AtE0tTZ;;AAEA;EAngCA,8BAAA;AAqgCA;;AAEA;EAngCA,4BAAA;AAqgCA;;AAEA;EAngCA,8BAAA;AAqgCA;;AAEA;EAngCA,4BAAA;AAqgCA;;AAEA;EAngCA,4BAAA;AAqgCA;;AAEA;EAngCA,2BAAA;AAqgCA;;AAEA;EAngCA,0BAAA;AAqgCA;;AAEA;EAngCA,wBAAA;AAqgCA;;AAEA;EAngCA,0BAAA;AAqgCA;;AAEA;EAngCA,wBAAA;AAqgCA;;AAEA;EAngCA,iCAAA;EAqgCE,gCAAgC;AsE7wT1B;;AtE4wRR;EAqgCE,gCAAgC;EsEjxT1B,+BAAA;AtEmxTR;;AAlgCA;EAqgCE,8BAA8B;EsEtxTxB,6BAAA;AtEwxTR;;AAlgCA;EAqgCE,gCAAgC;EsE3xT1B,+BAAA;AtE6xTR;;AAlgCA;EAqgCE,8BAA8B;EsEhyTxB,6BAAA;AtEkyTR;;AAlgCA;EAqgCE,+BAA+B;EsEryTzB,kCAAA;AtEuyTR;;AAlgCA;EAqgCE,8BAA8B;EsE1yTxB,iCAAA;AtE4yTR;;AAlgCA;EAqgCE,4BAA4B;EsE/yTtB,+BAAA;AtEizTR;;AAlgCA;EAqgCE,8BAA8B;EsEpzTxB,iCAAA;AtEszTR;;AAlgCA;EAqgCE,4BAA4B;EsEzzTtB,+BAAA;AtE2zTR;;AAlgCA;EAqgCE,+BAA+B;AsE9zTzB;;AtEi0TR;EAngCA,8BAAA;AAqgCA;;AAEA;EsE9zTY,4BAAA;AtE4zRZ;;AsEn0RQ;EAOI,8BAAA;AtEo0TZ;;AAEA;EsE70TQ,4BAAA;AtE+0TR;;AAlgCA;EAqgCE,iCAAiC;AsEl1T3B;;AtEq1TR;EAngCA,gCAAA;AAqgCA;;AAEA;EsEl1TY,8BAAA;AtEg1RZ;;AsEv1RQ;EAOI,gCAAA;AtEw1TZ;;AAEA;EsEj2TQ,8BAAA;AtEm2TR;;AAlgCA;EAqgCE,kCAAkC;AsEt2T5B;;AtEy2TR;EAngCA,iCAAA;AAqgCA;;AAEA;EsEt2TY,+BAAA;AtEo2RZ;;AsE32RQ;EAOI,iCAAA;AtE42TZ;;AAEA;EsEr3TQ,+BAAA;AtEu3TR;;AAlgCA;EAqgCE,gCAAgC;AsE13T1B;;AtE63TR;EAngCA,+BAAA;AAqgCA;;AAEA;EsE13TY,6BAAA;AtEw3RZ;;AsE/3RQ;EAOI,+BAAA;AtEg4TZ;;AAEA;EsEz4TQ,6BAAA;AtE24TR;;AAlgCA;EAqgCE,qBAAqB;AsE94Tf;;AtEi5TR;EAngCA,2BAAA;AAqgCA;;AAEA;EsE94TY,0BAAA;AtE44RZ;;AsEn5RQ;EAOI,wBAAA;AtEo5TZ;;AAEA;EsE75TQ,0BAAA;AtE+5TR;;AAlgCA;EAqgCE,wBAAwB;AsEl6TlB;;AtEq6TR;EAngCA,2BAAA;EAqgCE,0BAA0B;AsEv6TpB;;AtE06TR;EAngCA,iCAAA;EAqgCE,gCAAgC;AsE56T1B;;AtE+6TR;EAngCA,gCAAA;EAqgCE,+BAA+B;AsEj7TzB;;AtEo7TR;EAngCA,8BAAA;EAqgCE,6BAA6B;AsEt7TvB;;AtEy7TR;EAngCA,gCAAA;EAqgCE,+BAA+B;AsE37TzB;;AtE87TR;EAngCA,8BAAA;EAqgCE,6BAA6B;AsEh8TvB;;AtEm8TR;EAngCA,yBAAA;EAqgCE,4BAA4B;AsEr8TtB;;AtEo8RR;EAqgCE,+BAA+B;EsEz8TzB,kCAAA;AtE28TR;;AAEA;EsE78TQ,8BAAA;EAOI,iCAAA;AtEq8RZ;;AsE58RQ;EAOI,4BAAA;EtEy8RZ,+BAAA;AAqgCA;;AAEA;EAngCA,8BAAA;EAqgCE,iCAAiC;AsEz9T3B;;AtEw9RR;EAqgCE,4BAA4B;EsE79TtB,+BAAA;AtE+9TR;;AAEA;Eap+TI,yBAAA;Abs+TJ;;AAEA;EsEr+TQ,+BAAA;AtEu+TR;;AAEA;EACE,8BsEn+TU;AtEo+TZ;;AAEA;EACE,4BsEv+TU;AtEw+TZ;;AAEA;EACE,8BsE3+TU;AtE4+TZ;;AAEA;EACE,4BsE/+TU;AtEg/TZ;;AAEA;EACE,2BsEn/TU;AtEo/TZ;;AAEA;EACE,iCsEv/TU;AtEw/TZ;;AAEA;EAxgCE,gCAAA;AA0gCF;;AAEA;EsErgUQ,8BAAA;AtEugUR;;AAEA;EACE,gCsEngUU;AtEogUZ;;AAEA;EAxgCE,8BAAA;AA0gCF;;AAEA;EsEjhUQ,4BAAA;AtEmhUR;;AAEA;EACE,kCsE/gUU;AtEghUZ;;AAEA;EACE,iCsEnhUU;AtEohUZ;;AAEA;EACE,+BsEvhUU;AtEwhUZ;;AAEA;EsEjiUQ,iCAAA;AtEmiUR;;AAEA;EACE,+BsE/hUU;AtEgiUZ;;AAEA;EsEziUQ,0BAAA;AtE2iUR;;AAEA;EACE,gCsEviUU;AtEwiUZ;;AAEA;EACE,+BsE3iUU;AtE4iUZ;;AAEA;EsErjUQ,6BAAA;AtEujUR;;AAEA;EACE,+BsEnjUU;AtEojUZ;;AAEA;EACE,6BsEvjUU;AtEwjUZ;;AAEA;EsEjkUQ,iBAAA;AtEmkUR;;AAEA;EA5hCE,uBAAA;AA8hCF;;AAEA;EACE,sBsEnkUU;AtEokUZ;;AAEA;EACE,oBsEvkUU;AtEwkUZ;;AAEA;EACE,sBsE3kUU;AtE4kUZ;;AAEA;EACE,oBsE/kUU;AtEglUZ;;AAEA;EACE,qBsEnlUU;AtEolUZ;;AAEA;EACE,2BsEvlUU;AtEwlUZ;;AAEA;EACE,0BsE3lUU;AtE4lUZ;;AAEA;EACE,wBsE/lUU;AtEgmUZ;;AAEA;EsEzmUQ,0BAAA;AtE2mUR;;AAEA;EAziCE,wBAAA;AA2iCF;;AAEA;EsEjnUQ,wBAAA;AtEqnUR;;AAEA;EAGE,8BsEnnUU;AtEonUZ;;AAEA;EAGE,6BsEznUU;AtE0nUZ;;AAEA;EAhjCE,2BAAA;AAojCF;;AAEA;EsEzoUQ,6BAAA;AtE6oUR;;AAEA;EAGE,2BsE3oUU;AtE4oUZ;;AAEA;EsErpUQ,gDAAA;AtEupUR;;AAEA;EsEzpUQ,kDAAA;AtE2pUR;;AAEA;EsE7pUQ,8CAAA;AtE+pUR;;AAEA;EsEjqUQ,oDAAA;AtEmqUR;;AAEA;EsErqUQ,kDAAA;AtEuqUR;;AAEA;EsEzqUQ,iCAAA;AtE2qUR;;AAEA;EsE7qUQ,+BAAA;AtE+qUR;;AAEA;EsEjrUQ,6BAAA;AtEmrUR;;AAEA;EsErrUQ,6BAAA;AtEurUR;;AAEA;EsEzrUQ,+BAAA;AtE2rUR;;AAEA;EsE7rUQ,2BAAA;AtE+rUR;;AAEA;EsEjsUQ,2BAAA;AtEmsUR;;AAEA;EsErsUQ,2BAAA;AtEusUR;;AAEA;EAtkCE,2BAAA;AAwkCF;;AAEA;EACE,2BsEvsUU;AtEwsUZ;;AAEA;EACE,8BsE3sUU;AtE4sUZ;;AAEA;EACE,yBsE/sUU;AtEgtUZ;;AAEA;EsEztUQ,4BAAA;AtE2tUR;;AAEA;EA9kCE,2BAAA;AAglCF;;AAEA;EACE,yBsE3tUU;AtE4tUZ;;AAEA;EACE,2BsE/tUU;AtEguUZ;;AAEA;EACE,4BsEnuUU;AtEouUZ;;AAEA;EsE7uUQ,6BAAA;AtE+uUR;;AAEA;EACE,gCsE3uUU;AtE4uUZ;;AAEA;EAplCE,qCAAA;AAslCF;;AAEA;EsEzvUQ,wCAAA;AtE2vUR;;AAEA;EACE,oCsEvvUU;AtEwvUZ;;AAEA;EAplCE,oCAAA;AAslCF;;AAEA;EAplCE,qCAAA;AAslCF;;AAEA;EAplCE,8BAAA;AAslCF;;AAEA;EAplCE,8BAAA;AAslCF;;AAEA,qBsE1wUY;AtE2wUZ;EsElxUQ,gCAAA;EtEoxUN,iCsE7wUU;AtE8wUZ;;AAEA,mBsEvxUQ;AtEwxUR;EACE,oBsElxUU;EtE8rSV,qEAAA;AAslCF;;AAEA;EAplCE,oBAAA;EsEzsSM,uEAAA;AtEgyUR;;AAEA;EsElyUQ,oBAAA;EtEoyUN,qEsE7xUU;AtE8xUZ;;AAEA;EACE,oBsEjyUU;EtEkyUV,kEsElyUU;AtEmyUZ;;AAEA;EACE,oBsEtyUU;EtEktSV,qEAAA;AAslCF;;AAEA;EAplCE,oBAAA;EsE7tSM,oEAAA;AtEozUR;;AAEA;EsEtzUQ,oBAAA;EtEwzUN,mEsEjzUU;AtEkzUZ;;AAEA;EACE,oBsErzUU;EtEiuSV,kEAAA;AAslCF;;AAEA;EsEh0UQ,oBAAA;EtEk0UN,mEsE3zUU;AtE4zUZ;;AAEA;EAplCE,oBAAA;EsEjvSM,mEAAA;AtEw0UR;;AAEA;EACE,oBsEp0UU;EtEgvSV,wEAAA;AAslCF;;AAEA;EsE/0UQ,oBAAA;EtEi1UN,2CsE10UU;AtE20UZ;;AAEA;EAplCE,oBAAA;EsEhwSM,oCAAA;AtEu1UR;;AAEA;EACE,oBsEn1UU;EtE+vSV,0CAAA;AAslCF;;AAEA;EsE91UQ,oBAAA;EtEg2UN,2CsEz1UU;AtE01UZ;;AAEA;EAplCE,oBAAA;EsE/wSM,0CAAA;AtEs2UR;;AAEA;EACE,oBsEl2UU;EtE8wSV,0CAAA;AAslCF;;AAEA;EsE72UQ,oBAAA;EtE+2UN,yBsEx2UU;AtEy2UZ;;AAEA;EAplCE,uBAAA;AAslCF;;AAEA;EsEt3UQ,sBAAA;AtEw3UR;;AAEA;EACE,uBsEp3UU;AtEq3UZ;;AAEA;EAplCE,oBAAA;AAslCF;;AAEA;EsEl4UQ,iDAAA;AtEo4UR;;AAEA;EACE,mDsEh4UU;AtEi4UZ;;AAEA;EAplCE,iDAAA;AAslCF;;AAEA;EsE94UQ,8CAAA;AtEg5UR;;AAEA;EACE,iDsE54UU;AtE64UZ;;AAEA;EAplCE,gDAAA;AAslCF;;AAEA;EsE15UQ,+CAAA;AtE45UR;;AAEA;EACE,8CsEx5UU;AtEy5UZ;;AAEA;EACE,sBsE55UU;AtE65UZ;;AAEA;EACE,sBsEh6UU;AtEi6UZ;;AAEA;EACE,uBsEp6UU;AtEq6UZ;;AAEA;EACE,uBsEx6UU;AtEy6UZ;;AAEA;EACE,sBsE56UU;AtE66UZ;;AAEA;EACE,sBsEh7UU;AtEi7UZ;;AAEA;EACE,uBsEp7UU;AtEq7UZ;;AAEA;EACE,uBsEx7UU;AtEy7UZ;;AAEA;EACE,oBsE57UU;AtE67UZ;;AAEA;EACE,oBsEh8UU;AtEi8UZ;;AAEA;EAplCE,yCAAA;AAslCF;;AAEA;EsE98UQ,yCAAA;AtEg9UR;;AAEA;EACE,wCsE58UU;AtE68UZ;;AAEA;EAplCE,wCAAA;AAslCF;;AAEA;EsE19UQ,yCAAA;AtE49UR;;AAEA;EACE,yCsEx9UU;AtEy9UZ;;AAEA;EAplCE,8BAAA;EsE94SM,+FAAA;AtEq+UR;;AAEA;EACE,8BsEj+UU;EtE64SV,iGAAA;AAslCF;;AAEA;EsE5+UQ,8BAAA;EtE8+UN,+FsEv+UU;AtEw+UZ;;AAEA;EAplCE,8BAAA;EsE75SM,4FAAA;AtEo/UR;;AAEA;EACE,8BsEh/UU;EtE45SV,+FAAA;AAslCF;;AAEA;EsE3/UQ,8BAAA;EtE6/UN,8FsEt/UU;AtEu/UZ;;AAEA;EAplCE,8BAAA;EsE56SM,6FAAA;AtEmgVR;;AAEA;EACE,8BsE//UU;EtE26SV,4FAAA;AAslCF;;AAEA;EsE1gVQ,8BAAA;EtE4gVN,qGsErgVU;AtEsgVZ;;AAEA;EAplCE,8BAAA;AAslCF;;AAEA;EsEnhVQ,8BAAA;AtEqhVR;;AAEA;EsEvhVQ,gCAAA;AtEyhVR;;AAEA;EsE3hVQ,gCAAA;AtE6hVR;;AAEA;EsE/hVQ,iCAAA;AtEiiVR;;AAEA;EsEniVQ,iCAAA;AtEqiVR;;AAEA;EsEviVQ,gCAAA;AtEyiVR;;AAEA;EsE3iVQ,gCAAA;AtE6iVR;;AAEA;EsE/iVQ,iCAAA;AtEijVR;;AAEA;EsEnjVQ,iCAAA;AtEqjVR;;AAEA;EsEvjVQ,8BAAA;AtEyjVR;;AAEA;EsE3jVQ,8BAAA;AtE6jVR;;AAEA;EsE/jVQ,kBAAA;EtEikVN,8EsE1jVU;AtE2jVZ;;AAEA;EACE,kBsE9jVU;EtE0+SV,gFAAA;AAslCF;;AAEA;EsEzkVQ,kBAAA;EtE2kVN,8EsEpkVU;AtEqkVZ;;AAEA;EAplCE,kBAAA;EsE1/SM,2EAAA;AtEilVR;;AAEA;EACE,kBsE7kVU;EtEy/SV,8EAAA;AAslCF;;AAEA;EsExlVQ,kBAAA;EtE0lVN,6EsEnlVU;AtEolVZ;;AAEA;EAplCE,kBAAA;EsEzgTM,4EAAA;AtEgmVR;;AAEA;EACE,kBsE5lVU;EtEwgTV,2EAAA;AAslCF;;AAEA;EsEvmVQ,kBAAA;EtEymVN,4EsElmVU;AtEmmVZ;;AAEA;EAplCE,kBAAA;EsExhTM,4EAAA;AtE+mVR;;AAEA;EACE,kBsE3mVU;EtEuhTV,8EAAA;AAslCF;;AAEA;EsEtnVQ,kBAAA;EtEwnVN,wCsEjnVU;AtEknVZ;;AAEA;EAplCE,kBAAA;EsEviTM,mFAAA;AtE8nVR;;AAEA;EACE,kBsE1nVU;EtEsiTV,kFAAA;AAslCF;;AAEA;EsEroVQ,oBAAA;AtEuoVR;;AAEA;EACE,qBsEnoVU;AtEooVZ;;AAEA;EAplCE,oBAAA;AAslCF;;AAEA;EsEjpVQ,qBAAA;AtEmpVR;;AAEA;EACE,kBsE/oVU;AtEgpVZ;;AAEA;EAplCE,wDAAA;AAslCF;;AAEA;EsE7pVQ,0DAAA;AtE+pVR;;AAEA;EACE,wDsE3pVU;AtE4pVZ;;AAEA;EAplCE,qDAAA;AAslCF;;AAEA;EsEzqVQ,wDAAA;AtE2qVR;;AAEA;EACE,uDsEvqVU;AtEwqVZ;;AAEA;EACE,sDsE3qVU;AtE4qVZ;;AAEA;EACE,qDsE/qVU;AtEgrVZ;;AAEA;EsEzrVQ,+CAAA;AtE2rVR;;AAEA;EA1lCE,mCAAA;EA6lCA,2BsEzrVU;AtE0rVZ;;AAEA;EsEnsVQ,oCAAA;EtEusVN,4BsEhsVU;AtEisVZ;;AAEA;EACE,oCsEpsVU;EAPJ,4BAAA;AtE+sVR;;AAEA;EACE,+BsE3sVU;AtE4sVZ;;AAEA;EAhmCE,+BAAA;AACF;;AAmmCA;EACE,iDsEntVU;AtEotVZ;;AAEA;EAhmCE,2BAAA;AAkmCF;;AAEA;EsEjuVQ,oDAAA;AtEmuVR;;AAEA;EsEruVQ,iDAAA;AtEuuVR;;AAEA;EsEzuVQ,oDAAA;AtE2uVR;;AAEA;EsE7uVQ,oDAAA;AtE+uVR;;AAEA;EsEjvVQ,qDAAA;AtEmvVR;;AAEA;EsErvVQ,6BAAA;AtEuvVR;;AAEA;EACE,sDsEnvVU;AtEovVZ;;AAEA;EArmCE,0DAAA;EsExpTM,2DAAA;AtEgwVR;;AAEA;EACE,oCsE5vVU;EtEupTV,qCAAA;AAumCF;;AAEA;EsEvwVQ,6DAAA;EtEywVN,8DsElwVU;AtEmwVZ;;AAEA;EArmCE,0DAAA;EsEvqTM,2DAAA;AtE+wVR;;AAEA;EAvmCE,6DAAA;EsE1qTM,8DAAA;AtEoxVR;;AAEA;EAzmCE,6DAAA;EsE7qTM,8DAAA;AtEyxVR;;AAEA;EACE,8DsErxVU;EtEsxVV,+DsEtxVU;AtEuxVZ;;AAEA;EACE,sCsE1xVU;EtE2xVV,uCsE3xVU;AtE4xVZ;;AAEA;EsEryVQ,+DAAA;EtEuyVN,gEsEhyVU;AtEiyVZ;;AAEA;EAjnCE,2DAAA;EsEzrTM,8DAAA;AtE6yVR;;AAEA;EACE,qCsEzyVU;EtEqrTV,wCAAA;AAsnCF;;AAEA;EACE,8DsE9yVU;EtE+yVV,iEsE/yVU;AtEgzVZ;;AAEA;EACE,2DsEnzVU;EtEozVV,8DsEpzVU;AtEqzVZ;;AAEA;EACE,8DsExzVU;EtEyzVV,iEsEzzVU;AtE0zVZ;;AAEA;EACE,8DsE7zVU;EtEisTV,iEAAA;AA8nCF;;AAEA;EA7nCE,+DAAA;EsE3sTM,kEAAA;AtE20VR;;AAEA;EsE70VQ,uCAAA;EtE+0VN,0CsEx0VU;AtEy0VZ;;AAEA;EACE,gEsE50VU;EtE60VV,mEsE70VU;AtE80VZ;;AAEA;EACE,8DsEj1VU;EtEk1VV,6DsEl1VU;AtEm1VZ;;AAEA;EACE,wCsEt1VU;EtEu1VV,uCsEv1VU;AtEw1VZ;;AAEA;EACE,iEsE31VU;EtE41VV,gEsE51VU;AtE61VZ;;AAEA;EACE,8DsEh2VU;EtEi2VV,6DsEj2VU;AtEk2VZ;;AAEA;EACE,iEsEr2VU;EtE4tTV,gEAAA;AA2oCF;;AAEA;EACE,iEsE12VU;EtE+tTV,gEAAA;AA6oCF;;AAEA;EACE,kEsE/2VU;EtEkuTV,iEAAA;AA+oCF;;AAEA;EACE,0CsEp3VU;EtEquTV,yCAAA;AAipCF;;AAEA;EACE,mEsEz3VU;EtEwuTV,kEAAA;AAmpCF;;AAEA;EACE,6DsE93VU;EtE2uTV,0DAAA;AAqpCF;;AAEA;EACE,uCsEn4VU;EtE8uTV,oCAAA;AAupCF;;AAEA;EAtpCE,gEAAA;EsExvTM,6DAAA;AtEi5VR;;AAEA;EsEn5VQ,6DAAA;EtEq5VN,0DsE94VU;AtE+4VZ;;AAEA;EACE,gEsEl5VU;EtEm5VV,6DsEn5VU;AtEo5VZ;;AAEA;EACE,gEsEv5VU;EtE6vTV,6DAAA;AA4pCF;;AAEA;EA3pCE,iEAAA;EsEvwTM,8DAAA;AtEq6VR;;AAEA;EsEv6VQ,yCAAA;EtEy6VN,sCsEl6VU;AtEm6VZ;;AAEA;EACE,kEsEt6VU;EtEu6VV,+DsEv6VU;AtEw6VZ;;AAEA;EACE,8BsE36VU;AtE46VZ;;AAEA;EACE,6BsE/6VU;AtEg7VZ;;AAEA;EACE,sBsEn7VU;AtEo7VZ;;AAEA;EACE,qBsEv7VU;AtEw7VZ;;AAEA;EACE,qBsE37VU;AtE47VZ;;AAEA;EsEr8VQ,qBAAA;AtEu8VR;;AAEA;EAvqCE,qBAAA;AAyqCF;;AAEA;EACE;IAzqCA,sBAAA;EsEryTM;;EtEk9VN;IACE,uBsE58VQ;EtEiyTV;;EA8qCA;IACE,sBsEh9VQ;EtEi9VV;;EsEx9VM;ItE49VJ,8BsEr9VQ;EtEs9VV;;EsE79VM;ItEi+VJ,4BsE19VQ;EtE29VV;;EsEl+VM;ItEozTN,2BAAA;EsEpzTM;;EtEuzTN;IsEhzTU,iCAAA;EtEmzTV;;EAorCA;IsE9+VM,2BAAA;EtEi/VN;;EsEj/VM;IAOI,0BAAA;EtE4zTV;;EAorCA;IAjrCA,gCAAA;EsEt0TM;;EtE2/VN;IAjrCA,yBAAA;EsE10TM;;EtE+/VN;IAjrCA,wBAAA;EsE90TM;;EtEmgWN;IAjrCA,+BAAA;EsEl1TM;;EtEugWN;IAjrCA,yBAAA;EsEt1TM;;EtE2gWN;IAjrCA,6BAAA;EsE11TM;;EtE+gWN;IAjrCA,8BAAA;EsE91TM;;EtEmhWN;IsE5gWU,wBAAA;EtEghWV;;EsEvhWM;ItE02TN,+BAAA;EsE12TM;;EtE+hWN;IAjrCA,wBAAA;EsE92TM;;EtEmiWN;IsE5hWU,yBAAA;EtEgiWV;;EsEviWM;IAAA,8BAAA;EtE8iWN;;EAhrCA;IsE93TM,iCAAA;EtEqjWN;;EsErjWM;IAOI,sCAAA;EtEm4TV;;EAorCA;IA9qCA,yCAAA;EsEh5TM;;EtEm5TN;IAGA,uBAAA;EsEt5TM;;EtEy5TN;IAGA,uBAAA;EsE55TM;;EtE+5TN;IsEx5TU,yBAAA;EtE25TV;;EAorCA;IsEtlWM,yBAAA;EtEylWN;;EsEzlWM;ItE26TN,0BAAA;EsE36TM;;EtE86TN;IsEv6TU,4BAAA;EtE06TV;;EAorCA;IsErmWM,kCAAA;EtEwmWN;;EsExmWM;IAAA,sCAAA;EtE8mWN;;EsE9mWM;IAAA,oCAAA;EtEonWN;;EsEpnWM;IAAA,kCAAA;EtE0nWN;;EsE1nWM;IAAA,yCAAA;EtEgoWN;;EsEhoWM;ItEk9TN,wCAAA;EsEl9TM;;EtEq9TN;IAGA,wCAAA;EsEx9TM;;EtE29TN;IAGA,kCAAA;EsE99TM;;EtEi+TN;IsE19TU,gCAAA;EtE89TV;;EAorCA;IsEzpWM,8BAAA;EtE6pWN;;EAhrCA;IsEt+TU,gCAAA;EtE0+TV;;EAorCA;IsErqWM,+BAAA;EtEyqWN;;EAhrCA;IsEl/TU,oCAAA;EtEuqWV;;EsE9qWM;IAOI,kCAAA;EtE0/TV;;EAorCA;IAhrCA,gCAAA;EsErgUM;;EtE0rWN;IsE1rWM,uCAAA;EtE6rWN;;EsE7rWM;ItE+gUN,sCAAA;EsE/gUM;;EtEkhUN;IsE3gUU,iCAAA;EtE8gUV;;EAorCA;IsEzsWM,2BAAA;EtE4sWN;;EsE5sWM;ItE8hUN,iCAAA;EsE9hUM;;EtEiiUN;IsE1hUU,+BAAA;EtE6hUV;;EAorCA;IsExtWM,6BAAA;EtE2tWN;;EsE3tWM;ItE6iUN,+BAAA;EsE7iUM;;EtEgjUN;IsEziUU,8BAAA;EtE4iUV;;EAorCA;IsEhuWU,oBAAA;EtEkjUV;;EAorCA;IsEtuWU,mBAAA;EtEwjUV;;EAorCA;IsE5uWU,mBAAA;EtE8jUV;;EAorCA;IsElvWU,mBAAA;EtEokUV;;EAorCA;IsExvWU,mBAAA;EtE0kUV;;EAorCA;IsE9vWU,mBAAA;EtEglUV;;EAorCA;IsE3wWM,mBAAA;EtE+wWN;;EAhrCA;IsExlUU,mBAAA;EtE4lUV;;EAorCA;IsEhxWU,oBAAA;EtEgmUV;;EAorCA;IsEpxWU,0BAAA;EtEomUV;;EAorCA;IsExxWU,yBAAA;EtEwmUV;;EAorCA;IsE5xWU,uBAAA;EtE4mUV;;EAorCA;IsEhyWU,yBAAA;EtEgnUV;;EAorCA;IsEpyWU,uBAAA;EtEonUV;;EAorCA;IsExyWU,uBAAA;EtEwnUV;;EAorCA;IsE5yWU,0BAAA;ItE4nUV,yBAAA;EsEnoUM;;EtEwzWN;IAjrCA,gCAAA;IsEvoUM,+BAAA;EtE2zWN;;EsE3zWM;IAOI,+BAAA;ItEsoUV,8BAAA;EsE7oUM;;EtEgpUN;IsEhpUM,6BAAA;IAOI,4BAAA;EtE4oUV;;EAorCA;IAjrCA,+BAAA;IsEtpUM,8BAAA;EtE00WN;;EsE10WM;IAOI,6BAAA;ItEqpUV,4BAAA;EsE5pUM;;EtE+pUN;IsE/pUM,6BAAA;IAOI,4BAAA;EtE2pUV;;EAorCA;IAjrCA,wBAAA;IsErqUM,2BAAA;EtEy1WN;;EsEz1WM;IAOI,8BAAA;ItEoqUV,iCAAA;EsE3qUM;;EtE8qUN;IsE9qUM,6BAAA;IAOI,gCAAA;EtE0qUV;;EAorCA;IAjrCA,2BAAA;IsEprUM,8BAAA;EtEw2WN;;EsEx2WM;IAOI,6BAAA;ItEmrUV,gCAAA;EsE1rUM;;EtE6rUN;IsE7rUM,2BAAA;IAOI,8BAAA;EtEyrUV;;EAorCA;IAjrCA,2BAAA;IsEnsUM,8BAAA;EtEu3WN;;EsEv3WM;IAOI,wBAAA;EtEksUV;;EAorCA;IAjrCA,8BAAA;EsE5sUM;;EtE+sUN;IsE/sUM,6BAAA;EtEm4WN;;EsEn4WM;IAOI,2BAAA;EtE8sUV;;EAorCA;IAjrCA,6BAAA;EsExtUM;;EtE2tUN;IsE3tUM,2BAAA;EtE+4WN;;EsE/4WM;IAOI,2BAAA;EtE0tUV;;EAorCA;IAjrCA,0BAAA;EsEpuUM;;EtEuuUN;IsEvuUM,gCAAA;EtE25WN;;EsE35WM;IAOI,+BAAA;EtEsuUV;;EAorCA;IAjrCA,6BAAA;EsEhvUM;;EtEmvUN;IsEnvUM,+BAAA;EtEu6WN;;EAEA;IAnrCA,6BAAA;EsEtvUM;;EtE66WN;IACE,6BsEv6WQ;EtEkvUV;;EAwrCA;IACE,2BsE36WQ;EtE46WV;;EsEn7WM;IAOI,iCAAA;EtEg7WV;;EAxrCA;IsE/vUM,gCAAA;EtE27WN;;EAEA;IA3rCA,8BAAA;EsElwUM;;EtEi8WN;IACE,gCsE37WQ;EtE8vUV;;EAgsCA;IA7rCA,8BAAA;EsExwUM;;EtE2wUN;IsE3wUM,8BAAA;EtE28WN;;EA5rCF;IalxUI,yBAAA;EyDGI;;EtEmxUN;IsEnxUM,+BAAA;EtEm9WN;;EsEn9WM;IAOI,8BAAA;EtEkxUV;;EAgsCA;IACE,4BsEn9WQ;EtEqxUV;;EAisCA;IACE,8BsEv9WQ;EtEwxUV;;EAksCA;IACE,4BsE39WQ;EtE2xUV;;EAmsCA;IACE,4BsE/9WQ;EtE8xUV;;EAosCA;IACE,2BsEn+WQ;EtEiyUV;;EAqsCA;IAlsCA,0BAAA;EsE3yUM;;EtE8yUN;IsE9yUM,wBAAA;EtEm/WN;;EsEn/WM;IAOI,0BAAA;EtE6yUV;;EAqsCA;IAlsCA,wBAAA;EsEvzUM;;EtE0zUN;IsE1zUM,iCAAA;IAOI,gCAAA;EtEszUV;;EAqsCA;IAlsCA,gCAAA;IsEh0UM,+BAAA;EtEqgXN;;EAEA;IApsCA,8BAAA;IsEn0UM,6BAAA;EtE0gXN;;EAEA;IAtsCA,gCAAA;IsEt0UM,+BAAA;EtE+gXN;;EsE/gXM;IAOI,8BAAA;ItE4gXR,6BsE5gXQ;EtE6gXV;;EsEphXM;IAOI,+BAAA;IAAA,kCAAA;EtEkhXV;;EA1sCA;IsE/0UM,8BAAA;IAOI,iCAAA;EtEuhXV;;EAEA;IA9sCA,4BAAA;IsEl1UM,+BAAA;EtEmiXN;;EAEA;IACE,8BsE/hXQ;ItE80UV,iCAAA;EsEr1UM;;EtE0iXN;IACE,4BsEpiXQ;ItEqiXR,+BsEriXQ;EtEi1UV;;EAutCA;IACE,+BsEziXQ;EtE0iXV;;EsEjjXM;IAOI,8BAAA;EtE8iXV;;EAvtCA;IsE91UM,4BAAA;EtEyjXN;;EAxtCA;IsEj2UM,8BAAA;EtE6jXN;;EAztCA;IsEp2UM,4BAAA;EtEikXN;;EA1tCA;IsEv2UM,iCAAA;EtEqkXN;;EA3tCA;IsE12UM,gCAAA;EtEykXN;;EA5tCA;IsE72UM,8BAAA;EtE6kXN;;EAEA;IA/tCA,gCAAA;EsEh3UM;;EtEmlXN;IACE,8BsE7kXQ;EtE42UV;;EAouCA;IACE,kCsEjlXQ;EtEklXV;;EsEzlXM;IAOI,iCAAA;EtEslXV;;EApuCA;IsEz3UM,+BAAA;EtEimXN;;EAruCA;IsE53UM,iCAAA;EtEqmXN;;EAEA;IAxuCA,+BAAA;EsE/3UM;;EtE2mXN;IACE,gCsErmXQ;EtE23UV;;EA6uCA;IACE,+BsEzmXQ;EtE0mXV;;EsEjnXM;IAOI,6BAAA;EtE8mXV;;EA7uCA;IsEx4UM,+BAAA;EtEynXN;;EAEA;IAhvCA,6BAAA;EsE34UM;;EtE+nXN;IACE,qBsEznXQ;EtEu4UV;;EAqvCA;IACE,2BsE7nXQ;EtE04UV;;EAsvCA;IACE,0BsEjoXQ;EtE64UV;;EAuvCA;IACE,wBsEroXQ;EtEg5UV;;EAwvCA;IACE,0BsEzoXQ;EtEm5UV;;EAyvCA;IACE,wBsE7oXQ;EtEs5UV;;EA0vCA;IACE,2BsEjpXQ;ItEy5UV,0BAAA;EsEh6UM;;EtE4pXN;IAzvCA,iCAAA;IsEn6UM,gCAAA;EtE+pXN;;EAzvCA;IsEt6UM,gCAAA;IAOI,+BAAA;EtE6pXV;;EsEpqXM;IAOI,8BAAA;ItEiqXR,6BsEjqXQ;EtEq6UV;;EA+vCA;IACE,gCsErqXQ;ItEw6UV,+BAAA;EsE/6UM;;EtEgrXN;IA9vCA,8BAAA;IsEl7UM,6BAAA;EtEmrXN;;EAEA;IAhwCA,yBAAA;IsEr7UM,4BAAA;EtEwrXN;;EAEA;IAlwCA,+BAAA;IsEx7UM,kCAAA;EtE6rXN;;EAEA;IApwCA,8BAAA;IsE37UM,iCAAA;EtEksXN;;EAEA;IAtwCA,4BAAA;IsE97UM,+BAAA;EtEusXN;;EAEA;IAxwCA,8BAAA;IsEj8UM,iCAAA;EtE4sXN;;EAEA;IA1wCA,4BAAA;IsEp8UM,+BAAA;EtEitXN;;EAEA;IA5wCA,yBAAA;EsEv8UM;;EtEutXN;IACE,+BsEjtXQ;EtEm8UV;;EAixCA;IA9wCA,8BAAA;EsE78UM;;EtEg9UN;IsEh9UM,4BAAA;EtEiuXN;;EsEjuXM;IAOI,8BAAA;EtE+8UV;;EAixCA;IA9wCA,4BAAA;EsEz9UM;;EtE49UN;IsE59UM,2BAAA;EtE6uXN;;EsE7uXM;IAOI,iCAAA;EtE0uXV;;EsEjvXM;IAOI,gCAAA;EtE8uXV;;EsErvXM;IAOI,8BAAA;EtEkvXV;;EsEzvXM;IAOI,gCAAA;EtEsvXV;;EsE7vXM;IAOI,8BAAA;EtE0vXV;;EsEjwXM;IAOI,4BAAA;EtE8vXV;;EsErwXM;IAOI,kCAAA;EtEkwXV;;EsEzwXM;IAOI,iCAAA;EtEswXV;;EsE7wXM;IAOI,+BAAA;EtE0wXV;;EsEjxXM;IAOI,iCAAA;EtE8wXV;;EsErxXM;IAOI,+BAAA;EtEkxXV;;EsEzxXM;IAOI,0BAAA;EtEsxXV;;EsE7xXM;IAOI,gCAAA;EtE0xXV;;EsEjyXM;IAOI,+BAAA;EtE8xXV;;EsEryXM;IAOI,6BAAA;EtEmhVV;;EAixCA;IA9wCA,+BAAA;EsE7hVM;;EtEgiVN;IsEhiVM,6BAAA;EtEizXN;;EsEjzXM;IAOI,iBAAA;EtE+hVV;;EAixCA;IA9wCA,uBAAA;EsEziVM;;EtE4iVN;IsE5iVM,sBAAA;EtE6zXN;;EsE7zXM;IAOI,oBAAA;EtE2iVV;;EAixCA;IA9wCA,sBAAA;EsErjVM;;EtEwjVN;IsExjVM,oBAAA;EtEy0XN;;EsEz0XM;IAOI,qBAAA;EtEujVV;;EAixCA;IA9wCA,2BAAA;EsEjkVM;;EtEokVN;IsEpkVM,0BAAA;EtEq1XN;;EsEr1XM;IAOI,wBAAA;EtEmkVV;;EAixCA;IA9wCA,0BAAA;EsE7kVM;;EtEglVN;IsEhlVM,wBAAA;EtEi2XN;;EsEj2XM;IAAA,wBAAA;EtEu2XN;;EsEv2XM;IAAA,8BAAA;EtE62XN;;EsE72XM;IAAA,6BAAA;EtEm3XN;;EsEn3XM;IAAA,2BAAA;EtEy3XN;;EsEz3XM;IAAA,6BAAA;EtE+3XN;;EsE/3XM;IAAA,2BAAA;EtEq4XN;;EsEr4XM;IAOI,2BAAA;EtEmnVV;;EAixCA;IsEp4XU,4BAAA;EtEunVV;;EAixCA;IsEx4XU,6BAAA;EtE2nVV;AAgxCF;;AAEA;EA9wCE;IsEtoVM,sBAAA;EtEu5XN;;EA7wCA;IsE1oVM,uBAAA;EtE25XN;;EA7wCA;IsE9oVM,sBAAA;EtE+5XN;;EA7wCA;IsE3oVU,8BAAA;EtE65XV;;EsEp6XM;IAOI,4BAAA;EtEmpVV;;EAixCA;IA7wCA,2BAAA;EsE9pVM;;EtEg7XN;IsEh7XM,iCAAA;EtEm7XN;;EsEn7XM;ItEwqVN,2BAAA;EsExqVM;;EtE2qVN;IsE3qVM,0BAAA;EtE47XN;;EsE57XM;IAOI,gCAAA;EtE0qVV;;EAixCA;IA9wCA,yBAAA;EsEprVM;;EtEurVN;IsEvrVM,wBAAA;EtEw8XN;;EsEx8XM;IAOI,+BAAA;EtEsrVV;;EAixCA;IA9wCA,yBAAA;EsEhsVM;;EtEmsVN;IsEnsVM,6BAAA;EtEo9XN;;EsEp9XM;IAOI,8BAAA;EtEksVV;;EAixCA;IsEn9XU,wBAAA;EtEwsVV;;EAixCA;IsEz9XU,+BAAA;EtE8sVV;;EAixCA;IA9wCA,wBAAA;EsExtVM;;EtE2tVN;IAGA,yBAAA;EsE9tVM;;EtEiuVN;IsEjuVM,8BAAA;EtEq/XN;;EsEr/XM;IAOI,iCAAA;EtEsuVV;;EAixCA;IsEv/XU,sCAAA;EtE6uVV;;EAixCA;IsE9/XU,yCAAA;EtEmgYV;;EsE1gYM;ItEgwVN,uBAAA;EsEhwVM;;EtEkhYN;IsE3gYU,uBAAA;EtE+gYV;;EsEthYM;IAOI,yBAAA;EtEqwVV;;EAixCA;IA7wCA,yBAAA;EsEhxVM;;EtEkiYN;IsEliYM,0BAAA;EtEqiYN;;EA7wCA;IsEjxVU,4BAAA;EtEmiYV;;EsE1iYM;IAOI,kCAAA;EtEyxVV;;EAixCA;IsE1iYU,sCAAA;EtE+xVV;;EAixCA;IsEhjYU,oCAAA;EtEqyVV;;EAixCA;IsEtjYU,kCAAA;EtE2yVV;;EAixCA;IsE5jYU,yCAAA;EtEizVV;;EAixCA;IsEzkYM,wCAAA;EtE4kYN;;EsE5kYM;IAAA,wCAAA;EtEklYN;;EsEllYM;IAAA,kCAAA;EtEwlYN;;EsExlYM;IAAA,gCAAA;EtE8lYN;;EsE9lYM;IAAA,8BAAA;EtEomYN;;EsEpmYM;IAAA,gCAAA;EtE0mYN;;EsE1mYM;IAAA,+BAAA;EtEgnYN;;EsEhnYM;ItEq2VN,oCAAA;EsEr2VM;;EtEw2VN;IsEj2VU,kCAAA;EtEo2VV;;EAixCA;IsE5nYM,gCAAA;EtE+nYN;;EsE/nYM;ItEo3VN,uCAAA;EsEp3VM;;EtEu3VN;IsEh3VU,sCAAA;EtEm3VV;;EAixCA;IsE3oYM,iCAAA;EtE8oYN;;EsE9oYM;ItEm4VN,2BAAA;EsEn4VM;;EtEs4VN;IsE/3VU,iCAAA;EtEk4VV;;EAixCA;IsE1pYM,+BAAA;EtE6pYN;;EAEA;IsE/pYM,6BAAA;EtEkqYN;;EAEA;IsEpqYM,+BAAA;EtEuqYN;;EAEA;IsEzqYM,8BAAA;EtE4qYN;;EAEA;IsEvqYU,oBAAA;EtE2qYV;;EAvxCA;IA4xCE,mBsEhrYQ;EtEirYV;;EsExrYM;IAAA,mBAAA;EtE8rYN;;EsE9rYM;ItEw6VR,mBAAA;Ea36VI;;EbysYF;IsE/rYU,mBAAA;EtEw6VV;;EA6xCA;IsErsYU,mBAAA;EtEysYV;;EsEhtYM;ItEw7VN,mBAAA;EsEx7VM;;EtEwtYN;IsEjtYU,mBAAA;EtEqtYV;;EsE5tYM;IAOI,oBAAA;EtEytYV;;EsEhuYM;IAOI,0BAAA;EtE67VV;;EAkyCA;IA/xCA,yBAAA;EsEv8VM;;EtE08VN;IsE18VM,uBAAA;EtE4uYN;;EsE5uYM;IAOI,yBAAA;EtEy8VV;;EAkyCA;IA/xCA,uBAAA;EsEn9VM;;EtEs9VN;IsEt9VM,uBAAA;EtEwvYN;;EsExvYM;IAOI,0BAAA;IAAA,yBAAA;EtEsvYV;;EsE7vYM;IAOI,gCAAA;IAAA,+BAAA;EtE2vYV;;EsElwYM;IAOI,+BAAA;ItE29VV,8BAAA;EsEl+VM;;EtEywYN;IACE,6BsEnwYQ;ItE89VV,4BAAA;EsEr+VM;;EtE8wYN;IACE,+BsExwYQ;ItEywYR,8BsEzwYQ;EtEi+VV;;EA2yCA;IsE5wYU,6BAAA;ItE8wYR,4BsE9wYQ;EtE+wYV;;EsEtxYM;IAOI,6BAAA;IAAA,4BAAA;EtEoxYV;;EA7yCA;IsE9+VM,wBAAA;IAOI,2BAAA;EtEyxYV;;EAEA;IAjzCA,8BAAA;IsEj/VM,iCAAA;EtEqyYN;;EAEA;IAnzCA,6BAAA;IsEp/VM,gCAAA;EtE0yYN;;EAEA;IArzCA,2BAAA;IsEv/VM,8BAAA;EtE+yYN;;EArzCA;IsE1/VM,6BAAA;IAOI,gCAAA;EtE6yYV;;EsEpzYM;IAOI,2BAAA;ItEizYR,8BsEjzYQ;EtEy/VV;;EA2zCA;IACE,2BsErzYQ;ItE4/VV,8BAAA;EsEngWM;;EtEg0YN;IA1zCA,wBAAA;EsEtgWM;;EtEo0YN;IACE,8BsE9zYQ;EtEkgWV;;EA+zCA;IACE,6BsEl0YQ;EtEm0YV;;EsE10YM;IAOI,2BAAA;EtEu0YV;;EA/zCA;IsE/gWM,6BAAA;EtEk1YN;;EAEA;IAl0CA,2BAAA;EsElhWM;;EtEw1YN;IAn0CA,2BAAA;EsErhWM;;EtE41YN;IACE,0BsEt1YQ;EtEihWV;;EAw0CA;IACE,gCsE11YQ;EtE21YV;;EsEl2YM;IAOI,+BAAA;EtE+1YV;;EAx0CA;IsE9hWM,6BAAA;EtE02YN;;EAEA;IA30CA,+BAAA;EsEjiWM;;EtEg3YN;IACE,6BsE12YQ;EtE6hWV;;EAg1CA;IACE,6BsE92YQ;EtE+2YV;;EsEt3YM;IAOI,2BAAA;EtEm3YV;;EsE13YM;IAOI,iCAAA;EtEu3YV;;EsE93YM;IAOI,gCAAA;EtE23YV;;EsEl4YM;IAOI,8BAAA;EtE+3YV;;EsEt4YM;IAOI,gCAAA;EtEm4YV;;EsE14YM;IAOI,8BAAA;EtEu4YV;;EsE94YM;IAOI,8BAAA;EtE24YV;;EsEl5YM;IAOI,yBAAA;EtE+4YV;;EsEt5YM;IAOI,+BAAA;EtEm5YV;;EsE15YM;IAOI,8BAAA;EtEu5YV;;EsE95YM;IAOI,4BAAA;EtE25YV;;EsEl6YM;IAOI,8BAAA;EtE+5YV;;EsEt6YM;IAOI,4BAAA;EtEm6YV;;EA51CA;IsE9kWM,4BAAA;EtE86YN;;EAEA;IA/1CA,2BAAA;EsEjlWM;;EtEo7YN;IACE,0BsE96YQ;EtE6kWV;;EAo2CA;IACE,wBsEl7YQ;EtEm7YV;;EsE17YM;IAOI,0BAAA;EtEu7YV;;EAp2CA;IsE1lWM,wBAAA;EtEk8YN;;EAEA;IAv2CA,iCAAA;IsE7lWM,gCAAA;EtEu8YN;;EAEA;IAz2CA,gCAAA;IsEhmWM,+BAAA;EtE48YN;;EAEA;IA32CA,8BAAA;IsEnmWM,6BAAA;EtEi9YN;;EsEj9YM;IAOI,gCAAA;ItEkmWV,+BAAA;EsEzmWM;;EtE4mWN;IsE5mWM,8BAAA;IAOI,6BAAA;EtEwmWV;;EA82CA;IA32CA,+BAAA;IsElnWM,kCAAA;EtEg+YN;;EsEh+YM;IAOI,8BAAA;ItEinWV,iCAAA;EsExnWM;;EtEu+YN;IA32CA,4BAAA;IsE5nWM,+BAAA;EtE0+YN;;EA12CA;IsEhoWM,8BAAA;IAOI,iCAAA;EtEw+YV;;EsE/+YM;IAOI,4BAAA;IAAA,+BAAA;EtEioWV;;EA82CA;IsE/+YU,+BAAA;EtEqoWV;;EA82CA;IsEn/YU,8BAAA;EtEyoWV;;EA82CA;IsEv/YU,4BAAA;EtE6oWV;;EA82CA;IsE3/YU,8BAAA;EtEipWV;;EA82CA;IsE//YU,4BAAA;EtEqpWV;;EA82CA;IsEngZU,iCAAA;EtEypWV;;EA82CA;IsEvgZU,gCAAA;EtE6pWV;;EA82CA;IsE3gZU,8BAAA;EtEiqWV;;EA82CA;IsE/gZU,gCAAA;EtEqqWV;;EA82CA;IsEnhZU,8BAAA;EtEyqWV;;EA82CA;IA32CA,kCAAA;EsEnrWM;;EtEsrWN;IsEtrWM,iCAAA;EtEoiZN;;EsEpiZM;IAOI,+BAAA;EtEqrWV;;EA82CA;IA32CA,iCAAA;EsE/rWM;;EtEksWN;IsElsWM,+BAAA;EtEgjZN;;EsEhjZM;IAOI,gCAAA;EtEisWV;;EA82CA;IA32CA,+BAAA;EsE3sWM;;EtE8sWN;IsE9sWM,6BAAA;EtE4jZN;;EsE5jZM;IAOI,+BAAA;EtE6sWV;;EA82CA;IA32CA,6BAAA;EsEvtWM;;EtE0tWN;IsE1tWM,qBAAA;EtEwkZN;;EsExkZM;IAOI,2BAAA;EtEytWV;;EA82CA;IA32CA,0BAAA;EsEnuWM;;EtEsuWN;IsEtuWM,wBAAA;EtEolZN;;EsEplZM;IAOI,0BAAA;EtEquWV;;EA82CA;IA32CA,wBAAA;EsE/uWM;;EtEkvWN;IsElvWM,2BAAA;IAOI,0BAAA;EtE8uWV;;EA82CA;IA32CA,iCAAA;IsExvWM,gCAAA;EtEsmZN;;EsEtmZM;IAOI,gCAAA;ItEuvWV,+BAAA;EsE9vWM;;EtEiwWN;IsEjwWM,8BAAA;IAOI,6BAAA;EtE6vWV;;EA82CA;IA32CA,gCAAA;IsEvwWM,+BAAA;EtEqnZN;;EsErnZM;IAOI,8BAAA;ItEswWV,6BAAA;EsE7wWM;;EtEgxWN;IsEhxWM,yBAAA;IAOI,4BAAA;EtE4wWV;;EA82CA;IsE1nZU,+BAAA;ItEgxWV,kCAAA;EsEvxWM;;EtEsoZN;IA32CA,8BAAA;IsE3xWM,iCAAA;EtEyoZN;;EA12CA;IsE/xWM,4BAAA;IAOI,+BAAA;EtEuoZV;;EsE9oZM;IAOI,8BAAA;IAAA,iCAAA;EtEgyWV;;EA82CA;IsE9oZU,4BAAA;ItEoyWV,+BAAA;EsE3yWM;;EtE0pZN;IA32CA,yBAAA;EsE/yWM;;EtE8pZN;IA32CA,+BAAA;EsEnzWM;;EtEkqZN;IA32CA,8BAAA;EsEvzWM;;EtEsqZN;IA32CA,4BAAA;EsE3zWM;;EtE8zWN;IsE9zWM,8BAAA;EtE4qZN;;EsE5qZM;IAOI,4BAAA;EtE6zWV;;EA82CA;IA32CA,2BAAA;EsEv0WM;;EtE00WN;IsE10WM,iCAAA;EtEwrZN;;EsExrZM;IAOI,gCAAA;EtEy0WV;;EA82CA;IA32CA,8BAAA;EsEn1WM;;EtEs1WN;IsEt1WM,gCAAA;EtEosZN;;EsEpsZM;IAOI,8BAAA;EtEq1WV;;EA82CA;IA32CA,4BAAA;EsE/1WM;;EtEk2WN;IsEl2WM,kCAAA;EtEgtZN;;EsEhtZM;IAOI,iCAAA;EtEi2WV;;EA82CA;IA32CA,+BAAA;EsE32WM;;EtE82WN;IsE92WM,iCAAA;EtE4tZN;;EsE5tZM;IAOI,+BAAA;EtE62WV;;EA82CA;IA32CA,0BAAA;EsEv3WM;;EtE03WN;IsE13WM,gCAAA;EtEwuZN;;EsExuZM;IAOI,+BAAA;EtEy3WV;;EA82CA;IA32CA,6BAAA;EsEn4WM;;EtEs4WN;IsEt4WM,+BAAA;EtEovZN;;EsEpvZM;IAOI,6BAAA;EtEivZV;;EsExvZM;IAOI,iBAAA;EtEqvZV;;EsE5vZM;IAOI,uBAAA;EtEyvZV;;EsEhwZM;IAOI,sBAAA;EtE6vZV;;EsEpwZM;IAOI,oBAAA;EtEiwZV;;EsExwZM;IAOI,sBAAA;EtEqwZV;;EsE5wZM;IAOI,oBAAA;EtEywZV;;EsEhxZM;IAOI,qBAAA;EtE6wZV;;EsEpxZM;IAOI,2BAAA;EtEixZV;;EsExxZM;IAOI,0BAAA;EtEqxZV;;EsE5xZM;IAOI,wBAAA;EtEyxZV;;EsEhyZM;IAOI,0BAAA;EtE6xZV;;EsEpyZM;IAOI,wBAAA;EtEq7WV;;EA82CA;IsEnyZU,wBAAA;EtE27WV;;EA82CA;IsEzyZU,8BAAA;EtEi8WV;;EA82CA;IsE/yZU,6BAAA;EtEu8WV;;EA82CA;IsErzZU,2BAAA;EtE68WV;;EA82CA;IsE3zZU,6BAAA;EtEm9WV;;EA82CA;IsEj0ZU,2BAAA;EtEy9WV;;EA82CA;IA32CA,2BAAA;EsEn+WM;;EtEs+WN;IsEt+WM,4BAAA;EtEo1ZN;;EsEp1ZM;IAOI,6BAAA;EtEq+WV;AA62CF;;AAEA;EsE31ZQ;IAOI,sBAAA;EtE2+WV;;EA82CA;IA32CA,uBAAA;EsEr/WM;;EtEw/WN;IsEx/WM,sBAAA;EtEs2ZN;;EsEt2ZM;ItE8/WN,8BAAA;EsE9/WM;;EtEigXN;IsE1/WU,4BAAA;EtE6/WV;;EA82CA;IsEl3ZM,2BAAA;EtEq3ZN;;EsEr3ZM;ItE6gXN,iCAAA;EsE7gXM;;EtEghXN;IsEzgXU,2BAAA;EtE4gXV;;EA82CA;IA32CA,0BAAA;EsEthXM;;EtEyhXN;IsEzhXM,gCAAA;EtEu4ZN;;EsEv4ZM;IAOI,yBAAA;EtEwhXV;;EA82CA;IA32CA,wBAAA;EsEliXM;;EtEqiXN;IsEriXM,+BAAA;EtEm5ZN;;EAEA;IA72CA,yBAAA;EsExiXM;;EtEy5ZN;IACE,6BsEn5ZQ;EtEoiXV;;EAk3CA;IACE,8BsEv5ZQ;EtEw5ZV;;EsE/5ZM;ItEo6ZJ,wBsE75ZQ;EtE0iXV;;EAs3CA;IAn3CA,+BAAA;EsEpjXM;;EtE66ZN;IACE,wBsEv6ZQ;EtEgjXV;;EA03CA;IsE16ZU,yBAAA;EtEsjXV;;EA03CA;IsEv7ZM,8BAAA;EtE47ZN;;EsE57ZM;IAOI,iCAAA;EtEokXV;;EA03CA;IsE97ZU,sCAAA;EtEm8ZV;;EsE18ZM;IAAA,yCAAA;EtEi9ZN;;EA13CA;IA+3CE,uBsE/8ZQ;EtEmlXV;;EA+3CA;IsEl9ZU,uBAAA;EtEylXV;;EA+3CA;IsE/9ZM,yBAAA;EtEk+ZN;;EsEl+ZM;ItEymXN,yBAAA;EsEzmXM;;EtE4mXN;IsErmXU,0BAAA;EtEwmXV;;EA+3CA;IsE9+ZM,4BAAA;EtEi/ZN;;EAEA;IsEn/ZM,kCAAA;EtEs/ZN;;EAEA;IsEj/ZU,sCAAA;EtEonXV;;EAm4CA;IAh4CA,oCAAA;EsE9nXM;;EtEogaN;IAn4CA,kCAAA;EsEjoXM;;EtE0gaN;IAt4CA,yCAAA;EsEpoXM;;EtEghaN;IAEE,wCsE3gaQ;EtEgoXV;;EA84CA;IAGE,wCsEjhaQ;EtEmoXV;;EAi5CA;IA94CA,kCAAA;EsE7oXM;;EtEiiaN;IsEjiaM,gCAAA;EtEqiaN;;EAl5CA;IAu5CE,8BsEniaQ;EtE+oXV;;EAu5CA;IsE7iaM,gCAAA;EtEijaN;;EAr5CA;IA05CE,+BsE/iaQ;EtEwpXV;;EA05CA;IAEE,oCsEpjaQ;EtE2pXV;;EA45CA;IAEE,kCsEzjaQ;EtE8pXV;;EA85CA;IAEE,gCsE9jaQ;EtEiqXV;;EAg6CA;IAEE,uCsEnkaQ;EtEoqXV;;EAk6CA;IA/5CA,sCAAA;EsE9qXM;;EtEklaN;IAj6CA,iCAAA;EsEjrXM;;EtEulaN;IAn6CA,2BAAA;EsEprXM;;EtE4laN;IAr6CA,iCAAA;EsEvrXM;;EtEimaN;IAv6CA,+BAAA;EsE1rXM;;EtEsmaN;IAz6CA,6BAAA;EsE7rXM;;EtE2maN;IA36CA,+BAAA;EsEhsXM;;EtEgnaN;IsEhnaM,8BAAA;EtEmnaN;;EA76CA;IAk7CE,oBsEjnaQ;EtEksXV;;EAk7CA;IsE3naM,mBAAA;EtE+naN;;EAh7CA;IAq7CE,mBsE7naQ;EtE2sXV;;EAq7CA;IsEvoaM,mBAAA;EtE2oaN;;EAn7CA;IAw7CE,mBsEzoaQ;EtEotXV;;EAw7CA;IsEnpaM,mBAAA;EtEupaN;;EAt7CA;IA27CE,mBsErpaQ;EtE6tXV;;EA27CA;IAx7CA,mBAAA;EsEvuXM;;EtEqqaN;IACE,oBsE/paQ;EtEmuXV;;EA+7CA;IACE,0BsEnqaQ;EtEoqaV;;EsE3qaM;IAOI,yBAAA;EtEwqaV;;EA/7CA;IsEhvXM,uBAAA;EtEmraN;;EAEA;IAl8CA,yBAAA;EsEnvXM;;EtEyraN;IACE,uBsEnraQ;EtE+uXV;;EAu8CA;IACE,uBsEvraQ;EtEwraV;;EsE/raM;IAOI,0BAAA;ItE4raR,yBsE5raQ;EtE6raV;;EsEpsaM;IAOI,gCAAA;ItEwvXV,+BAAA;EsE/vXM;;EtEkwXN;IsElwXM,+BAAA;IAOI,8BAAA;EtE8vXV;;EA28CA;IAx8CA,6BAAA;IsExwXM,4BAAA;EtEmtaN;;EsEntaM;IAOI,+BAAA;ItEuwXV,8BAAA;EsE9wXM;;EtEixXN;IsEjxXM,6BAAA;IAOI,4BAAA;EtEstaV;;EsE7taM;IAOI,6BAAA;IAAA,4BAAA;EtEkxXV;;EA28CA;IsE7taU,wBAAA;ItEsxXV,2BAAA;EsE7xXM;;EtEyuaN;IAx8CA,8BAAA;IsEjyXM,iCAAA;EtE4uaN;;EAv8CA;IsEryXM,6BAAA;IAOI,gCAAA;EtE0uaV;;EsEjvaM;IAOI,2BAAA;IAAA,8BAAA;EtEsyXV;;EA28CA;IsEjvaU,6BAAA;ItE0yXV,gCAAA;EsEjzXM;;EtE6vaN;IAx8CA,2BAAA;IsErzXM,8BAAA;EtEgwaN;;EAv8CA;IsEzzXM,2BAAA;IAOI,8BAAA;EtE8vaV;;EsErwaM;IAOI,wBAAA;EtEkwaV;;EsEzwaM;IAOI,8BAAA;EtEswaV;;EsE7waM;IAOI,6BAAA;EtE0waV;;EsEjxaM;IAOI,2BAAA;EtEq0XV;;EA28CA;IAx8CA,6BAAA;EsE/0XM;;EtEk1XN;IsEl1XM,2BAAA;EtE6xaN;;EsE7xaM;IAOI,2BAAA;EtEi1XV;;EA28CA;IAx8CA,0BAAA;EsE31XM;;EtE81XN;IsE91XM,gCAAA;EtEyyaN;;EsEzyaM;IAOI,+BAAA;EtE61XV;;EA28CA;IAx8CA,6BAAA;EsEv2XM;;EtE02XN;IsE12XM,+BAAA;EtEqzaN;;EsErzaM;IAOI,6BAAA;EtEy2XV;;EA28CA;IAx8CA,6BAAA;EsEn3XM;;EtEs3XN;IsEt3XM,2BAAA;EtEi0aN;;EsEj0aM;IAOI,iCAAA;EtEq3XV;;EA28CA;IAx8CA,gCAAA;EsE/3XM;;EtEk4XN;IsEl4XM,8BAAA;EtE60aN;;EsE70aM;IAOI,gCAAA;EtEi4XV;;EA28CA;IAx8CA,8BAAA;EsE34XM;;EtE84XN;IsE94XM,8BAAA;EtEy1aN;;EsEz1aM;IAOI,yBAAA;EtE64XV;;EA28CA;IAx8CA,+BAAA;EsEv5XM;;EtE05XN;IsE15XM,8BAAA;EtEq2aN;;EsEr2aM;IAOI,4BAAA;EtEy5XV;;EA28CA;IAx8CA,8BAAA;EsEn6XM;;EtEs6XN;IsEt6XM,4BAAA;EtEi3aN;;EsEj3aM;IAOI,4BAAA;EtEq6XV;;EA28CA;IsEh3aU,2BAAA;EtEy6XV;;EA28CA;IsEp3aU,0BAAA;EtE66XV;;EA28CA;IsEx3aU,wBAAA;EtEi7XV;;EA28CA;IsE53aU,0BAAA;EtEq7XV;;EA28CA;IsEh4aU,wBAAA;EtEy7XV;;EA28CA;IsEp4aU,iCAAA;ItE67XV,gCAAA;EsEp8XM;;EtEg5aN;IAx8CA,gCAAA;IsEx8XM,+BAAA;EtEm5aN;;EAv8CA;IsE58XM,8BAAA;IAOI,6BAAA;EtEi5aV;;EsEx5aM;IAOI,gCAAA;IAAA,+BAAA;EtE68XV;;EA28CA;IAx8CA,8BAAA;IsEv9XM,6BAAA;EtEk6aN;;EsEl6aM;IAOI,+BAAA;ItEs9XV,kCAAA;EsE79XM;;EtEg+XN;IsEh+XM,8BAAA;IAOI,iCAAA;EtE49XV;;EA28CA;IAx8CA,4BAAA;IsEt+XM,+BAAA;EtEi7aN;;EsEj7aM;IAOI,8BAAA;ItEq+XV,iCAAA;EsE5+XM;;EtE++XN;IsE/+XM,4BAAA;IAOI,+BAAA;EtE2+XV;;EA28CA;IAx8CA,+BAAA;EsEr/XM;;EtEw/XN;IsEx/XM,8BAAA;EtEm8aN;;EsEn8aM;IAOI,4BAAA;EtEu/XV;;EA28CA;IAx8CA,8BAAA;EsEjgYM;;EtEogYN;IsEpgYM,4BAAA;EtE+8aN;;EsE/8aM;IAOI,iCAAA;EtEmgYV;;EA28CA;IAx8CA,gCAAA;EsE7gYM;;EtEghYN;IsEhhYM,8BAAA;EtE29aN;;EsE39aM;IAOI,gCAAA;EtE+gYV;;EA28CA;IAx8CA,8BAAA;EsEzhYM;;EtE4hYN;IsE5hYM,kCAAA;EtEu+aN;;EsEv+aM;IAOI,iCAAA;EtE2hYV;;EA28CA;IsEt+aU,+BAAA;EtE+hYV;;EA28CA;IsE1+aU,iCAAA;EtEmiYV;;EA28CA;IsE9+aU,+BAAA;EtEuiYV;;EA28CA;IsEl/aU,gCAAA;EtE2iYV;;EA28CA;IsEt/aU,+BAAA;EtE+iYV;;EA28CA;IsE1/aU,6BAAA;EtEmjYV;;EA28CA;IsE9/aU,+BAAA;EtEujYV;;EA28CA;IsElgbU,6BAAA;EtE2jYV;;EA28CA;IsEtgbU,qBAAA;EtE+jYV;;EA28CA;IsE1gbU,2BAAA;EtEmkYV;;EA28CA;IsE9gbU,0BAAA;EtEukYV;;EA28CA;IsElhbU,wBAAA;EtE2kYV;;EA28CA;IAx8CA,0BAAA;EsErlYM;;EtEwlYN;IsExlYM,wBAAA;EtEmibN;;EsEnibM;IAOI,2BAAA;ItEulYV,0BAAA;EsE9lYM;;EtEimYN;IsEjmYM,iCAAA;IAOI,gCAAA;EtE6lYV;;EA28CA;IAx8CA,gCAAA;IsEvmYM,+BAAA;EtEkjbN;;EsEljbM;IAOI,8BAAA;ItEsmYV,6BAAA;EsE7mYM;;EtEgnYN;IsEhnYM,gCAAA;IAOI,+BAAA;EtE4mYV;;EA28CA;IAx8CA,8BAAA;IsEtnYM,6BAAA;EtEikbN;;EsEjkbM;IAOI,yBAAA;ItEqnYV,4BAAA;EsE5nYM;;EtE+nYN;IsE/nYM,+BAAA;IAOI,kCAAA;EtE2nYV;;EA28CA;IAx8CA,8BAAA;IsEroYM,iCAAA;EtEglbN;;EsEhlbM;IAOI,4BAAA;ItEooYV,+BAAA;EsE3oYM;;EtE8oYN;IsE9oYM,8BAAA;IAOI,iCAAA;EtE0oYV;;EA28CA;IAx8CA,4BAAA;IsEppYM,+BAAA;EtE+lbN;;EsE/lbM;IAOI,yBAAA;EtEmpYV;;EA28CA;IAx8CA,+BAAA;EsE7pYM;;EtEgqYN;IsEhqYM,8BAAA;EtE2mbN;;EsE3mbM;IAOI,4BAAA;EtE+pYV;;EA28CA;IAx8CA,8BAAA;EsEzqYM;;EtE4qYN;IsE5qYM,4BAAA;EtEunbN;;EsEvnbM;IAOI,2BAAA;EtE2qYV;;EA28CA;IAx8CA,iCAAA;EsErrYM;;EtEwrYN;IsExrYM,gCAAA;EtEmobN;;EsEnobM;IAOI,8BAAA;EtEurYV;;EA28CA;IACE,gCsEnobQ;EtEoobV;;EsE3obM;IAOI,8BAAA;EtEwobV;;EA38CA;IsEpsYM,4BAAA;EtEmpbN;;EAEA;IA98CA,kCAAA;EsEvsYM;;EtEypbN;IACE,iCsEnpbQ;EtEmsYV;;EAm9CA;IACE,+BsEvpbQ;EtEwpbV;;EsE/pbM;IAOI,iCAAA;EtE4pbV;;EAn9CA;IsEhtYM,+BAAA;EtEuqbN;;EsEvqbM;IAOI,0BAAA;EtE+sYV;;EAu9CA;IAp9CA,gCAAA;EACF;;EsE1tYQ;IAOI,+BAAA;EtEutYV;;EAu9CA;IAp9CA,6BAAA;EsEjuYM;;EtEouYN;IsEpuYM,+BAAA;EtE2rbN;;EAn9CF;IuEpwYA,6BAAA;ED4BQ;;EtE4uYN;IsE5uYM,iBAAA;EtEmsbN;;EsEnsbM;IAOI,uBAAA;EtE2uYV;;EAu9CA;IAp9CA,sBAAA;EsErvYM;;EtEwvYN;IsExvYM,oBAAA;EtE+sbN;;EsE/sbM;IAOI,sBAAA;EtEuvYV;;EAu9CA;IAp9CA,oBAAA;EsEjwYM;;EtEytbN;IsEltbU,qBAAA;EtE6vYV;;EAy9CA;IsEttbU,2BAAA;EtEwtbV;;EsE/tbM;IAOI,0BAAA;EtEmwYV;;EsE1wYM;IAOI,wBAAA;EtEuwYZ;;EsE9wYQ;IAOI,0BAAA;EtE2wYZ;;EsElxYQ;IAOI,wBAAA;EtE+wYZ;;EsEtxYQ;ItEovbJ,wBAAwB;EsEpvbpB;;EtE8xYR;IsEvxYY,8BAAA;EtE2xYZ;;EsElyYQ;ItEgwbJ,6BAA6B;EsEhwbzB;;EtE0yYR;IsEnyYY,2BAAA;EtEuyYZ;;EsE9yYQ;ItE4wbJ,6BAA6B;EsE5wbzB;;EtEszYR;IsE/yYY,2BAAA;EtEmzYZ;;EsE1zYQ;IAOI,2BAAA;EtEuzYZ;;EsE9zYQ;IAOI,4BAAA;EtE2zYZ;;EsEl0YQ;IAOI,6BAAA;EtE+zYZ;AA09CA;;AAEA;EAx9CA;IA09CI,sBAAsB;EsEpyblB;;EtE80YR;IA09CI,uBAAuB;EsExybnB;;EtEk1YR;IA09CI,sBAAsB;EsE5yblB;;EtEs1YR;IsEt1YQ,8BAAA;EAOI;;EtE6ybV;IsE7ybU,4BAAA;EtEu1YZ;;EsE91YQ;ItEk2YR,2BAAA;EA09CE;;EsErzbU;ItEyzbR,iCAAiC;EsEh0b7B;;EtE02YR;IsE12YQ,2BAAA;EAOI;;EtEi0bV;IsEx0bM,0BAAA;EAOI;;EtEq0bV;IsE50bM,gCAAA;EAOI;;EtEy0bV;IsEh1bM,yBAAA;EAOI;;EtE60bV;IsEp1bM,wBAAA;EAOI;;EtEi1bV;IsEx1bM,+BAAA;EAOI;;EtEq1bV;IsE51bM,yBAAA;EAOI;;EtEy1bV;IsEh2bM,6BAAA;EAOI;;EtE61bV;IsEp2bM,8BAAA;EAOI;;EtEi2bV;IAt9CF,wBAAA;EA09CE;;EsEr2bU;IAPJ,+BAAA;EAOI;;EtE62bV;IsEp3bM,wBAAA;EAOI;;EtEi3bV;IAt9CF,yBAAA;EA09CE;;EsEr3bU;IAAA,8BAAA;EtEm6YZ;;EsE16YQ;IAAA,iCAAA;EAOI;;EtEq4bV;IAIE,sCAAsC;EsEh5blC;;EtE07YR;IAIA,yCAAA;EA09CE;;EsEj5bU;IAPJ,uBAAA;EAOI;;EtEy5bV;IAt9CF,uBAAA;EA09CE;;EsE75bU;ItEi6bR,yBAAyB;EsEx6brB;;EtEk9YR;IsEl9YQ,yBAAA;EAOI;;EtE+8YZ;IsEt9YQ,0BAAA;EAOI;;EtEm9YZ;IsE19YQ,4BAAA;EAOI;;EtEu9YZ;IsE99YQ,kCAAA;EAOI;;EtE29YZ;IsE39YY,sCAAA;EtE47bV;;EAEA;IAGE,oCsEj8bQ;EtEm+YZ;;EsE1+YQ;ItE8+YR,kCAAA;EAi+CE;;EsEx8bU;ItE68bR,yCAAyC;EsEp9brC;;EtEu9bN;IAEE,wCAAwC;EsEz9bpC;;EtE0/YR;IsEn/YY,wCAAA;EtEu/YZ;;EwErjZI;IAEE,kCAAA;EACA;;EAEF;IAEE,gCAAA;EACE;;EAEA;IxE8hcJ,8BwE7hcI;ExEyjZR;;EwEvjZU;IAGA,gCAAA;EACA;;EAEA;IAGA,+BAAA;EACA;;ExEgicR;IwE9hcQ,oClE+MsB;EkE9MtB;;EACA;IAEF,kCAAA;EACE;;EAEA;IAEA,gCAAA;EACA;;EAEA;IxEmicN,uCwElicM;EACA;;EACA;IACA,sCAAA;ExE0jZV;;EwEvjZU;IxE0jZV,iCAAA;EwExjZQ;;ExEuicN;IwElicE,2BAAA;EACE;;EAEF;IxEyjZJ,iCAAA;EA8+CE;;EyE/lcA;IACA,+BAAA;EACE;;EACA;IzEwnZJ,6BAAA;EA8+CE;;EyEzlcM;IAEA,+BAAA;EACA;;EACA;IACA,8BAAA;EzE8lcN;;EA/+CF;I0EnoZE,oBAAA;E1EuoZF;;E0EhoZA;I1EsncI,mBAAmB;E0EnncvB;;E1EqoZA;I0EjoZE,mBAAA;E1EqoZF;;E0EnoZA;IAGE,mBAAA;EACA;;E1EwncA;I0EjncE,mBAAA;EACA;;E1EsncF;I0E/mcA,mBpEhCY;ENkqZd;;E0EhoZI;I1EsncA,mBAAmB;E0EhncvB;;EAEE;I1EoncE,mBAAmB;E0EjncvB;;E1EoncE;IACE,oBAAoB;E0EjnctB;;EAEA;I1EkoZF,0BAAA;EAk/CE;;E0E/mcA;IACA,yBAAA;E1EioZF;;E0E/nZI;IACA,uBAAA;EACA;;E1EoncF;I0EhncA,yBAAA;EATA;;E1E4oZF;I0E1oZE,uBAAA;EACE;;EAEA;I1E4oZJ,uBAAA;EAk/CE;;E0EnocA;IACA,0BAAA;I1EqpZF,yBAAA;E0EppZE;;EAEE;IACA,gCAAA;I1EspZJ,+BAAA;EAk/CE;;E0E7ocA;IACA,+BAAA;I1E+pZF,8BAAA;E0E9pZE;;EAEE;IACA,6BAAA;I1EgqZJ,4BAAA;EAk/CE;;E0EvpcA;IACA,+BAAA;I1EyqZF,8BAAA;E0ExqZE;;EAEE;IACA,6BAAA;I1E0qZJ,4BAAA;EAk/CE;;E0EjqcA;IACA,6BAAA;I1EmrZF,4BAAA;E0ElrZE;;EAEE;IACA,wBAAA;I1EorZJ,2BAAA;EAk/CE;;E0E3qcA;IACA,8BAAA;I1E6rZF,iCAAA;E0E5rZE;;EAEE;IACA,6BAAA;I1E8rZJ,gCAAA;EAk/CE;;E0ErrcA;IACA,2BAAA;I1EusZF,8BAAA;E0EtsZE;;EAEE;IACA,6BAAA;I1EwsZJ,gCAAA;EAk/CE;;E0E9qcE;IACA,2BAAA;I1EgsZJ,8BAAA;EAk/CE;;E0EnrcE;IACA,2BAAA;I1EqsZJ,8BAAA;EAk/CE;;E0ExrcE;IACA,wBAAA;E1E0sZJ;;E0E5sZE;IACE,8BAAA;EACA;;E1EiscF;I0EnscA,6BAAA;EACE;;E1EqtZJ;IAk/CI,2BAA2B;E0Exsc7B;;EAEE;I1EytZJ,6BAAA;EAk/CE;;E0E5scE;IACA,2BAAA;E1E8tZJ;;E0EhuZE;IACE,2BAAA;EACA;;E1EqtcF;I0E3scF,0BAAA;EACE;;EAKA;IACA,gCAAA;EACA;;E1EytZF;I0EvtZI,+BAAA;EACE;;E1EytZN;IAo/CI,6BAA6B;E0E1sc/B;;E1E6scA;IAl/CA,+BAAA;E0EvtZE;;E1E0tZF;IACF,6BAAA;EAo/CE;;E0EltcE;IACE,6BAAA;E1EytZJ;;EA8/CA;IA3/CA,2BAAA;EACF;;E0EptZE;IACA,iCAAA;E1EutZF;;E0ErtZI;IACA,gCAAA;EACA;;EAEA;IACA,8BAAA;EACA;;E1EwtZJ;I0EttZE,gCAAA;EACE;;E1EytZJ;IA8/CI,8BAA8B;E0EltchC;;EAEE;I1EutZJ,8BAAA;E0ErtZE;;E1EwtZF;IA8/CI,yBAAyB;E0Ehtc7B;;E1EmtcE;IACE,+B0EntcF;EACA;;EAAA;IACA,8BAAA;E1EstcA;;EAjgDF;IAogDI,4BAA4B;E0Evtc9B;;EAEA;IACA,8BAAA;EACA;;EAEA;I1EstZF,4BAAA;EAogDE;;E0EvtcA;IAAK,4BAAA;E1E2tcL;;EAlgDA;I0ExtZA,2BAAA;E1E8tcA;;EAEA;IApgDA,0BAAA;E0E3tZA;;E1EmucA;IACE,wB0EpuckD;E1E+tZpD;;EAwgDA;I0E1ucA,0BAAA;EACA;;E1E6ucA;IACE,wB0E9ucgD;E1EytZlD;;EAwhDA;I0EhvcmD,iCAAA;I1EkvcjD,gC0ElvciD;E1E4tZnD;;EAyhDA;I0EpvcoD,gCAAA;I1EsvclD,+B0EtvckD;E1E+tZpD;;E0EztZE;IACE,8BAAA;I1EovcF,6B0EpvcE;E1E4tZN;;E0EztZM;I1EqvcF,gC0ErvcE;I1E4tZN,+BAAA;E0E1tZI;;E1EuvcF;IA1hDF,8BAAA;IA4hDI,6BAA6B;E2Ep6cjC;;E3E44ZA;IA4hDI,+BAA+B;I2E95cjC,kCAAA;EACE;;EACA;IACE,8BAAA;IACA,iCAAA;EACA;;EACA;IACA,4BAAA;I3Es4ZN,+BAAA;E2Ej4ZM;;EAEE;IACA,8BAAA;I3Em4ZR,iCAAA;EA6hDE;;E2Ev5cE;I3E83ZJ,4BAAA;I2E73ZI,+BAAA;EACE;;EAEA;IACA,+BAAA;EACA;;EAEA;IAEA,8BAAA;EAAA;;E3Eg4ZN;I2E53ZE,4BAAA;EACE;;E3E25cF;I4E18cF,8BAAA;EACE;;E5Eg7ZF;IA8hDI,4BAA4B;E4E18chC;;E5Eg7ZA;IA8hDI,iCAAiC;E4Et8cnC;;EAEE;IACA,gCAAA;EACA;;EAEA;IACA,8BAAA;E5E26ZJ;;E4Et6ZE;IACE,gCAAA;EACA;;EAEA;IACA,8BAAA;EACA;;E5E06ZJ;IA8hDI,kCAAkC;E4Ej8cpC;;EAEE;IACA,iCAAA;E5Es6ZJ;;E4En6ZI;IACA,+BAAA;EACA;;E5Eo8cF;I4E37cF,iCAAA;EACE;;E5E87cA;Ial7cE,+BAAA;E+DPF;;E5Eg6ZA;IACF,gCAAA;E6E39ZE;;EAEE;I7E69ZJ,+BAAA;E6E19ZI;;EAEE;I7E49ZN,6BAAA;EA8hDE;;E8E9/cI;IACA,+BAAA;E9Eo+ZN;;E8El+ZQ;I9Eq+ZR,6BAAA;EA8hDE;;E8E1/cE;IACA,qBAAA;EACA;;E9E8/cF;I8Ez/cE,2BAAA;EACE;;EAEF;IACE,0BAAA;E9E89ZN;;E8Ev9ZA;IACE,wBAAA;E9E09ZF;;E8Ex9ZA;I9Ew/cI,0BAA0B;E8Et/c5B;;E9E49ZF;IA8hDI,wBAAwB;E8Er/c5B;;E9E29ZA;I8Ez9ZE,2BAAA;IACE,0BAAA;EACA;;E9E49ZJ;I8Ez9ZE,iCAAA;IACE,gCAAA;E9E29ZJ;;E8Ex9ZI;IACA,gCAAA;I9E29ZJ,+BAAA;E8E19ZI;;EAEE;IACA,8BAAA;I9E49ZN,6BAAA;E8Ez9ZE;;E9E49ZF;IA8hDI,gCAAgC;I8Ep/cpC,+BAAA;EACE;;EAEA;I9Ey9ZF,8BAAA;IA8hDI,6BAA6B;E8En/cjC;;EAEE;I9Ew9ZF,yBAAA;IA8hDI,4BAA4B;E8En/c9B;;E9Ey9ZF;IA8hDI,+BAA+B;I8Ej/cnC,kCAAA;EACE;;EAEE;IACE,8BAAA;IAAA,iCxE8I0B;EwE7I1B;;EAEA;IACA,4BAAA;I9Es9ZN,+BAAA;E8En9ZM;;E9Es9ZN;I8El9ZI,8BAAA;IACE,iCxE5GQ;EwE6GR;;E9Em/cJ;I8E5+cA,4BAAA;IACE,+BAAA;EACA;;EAEA;IACA,yBAAA;E9Eg9ZJ;;E8E78ZI;IAAA,+BAAA;EAAA;;E9Ei/cF;IACE,8B8Ej/cA;E9Eg9ZJ;;E8E78ZI;I9Eg9ZJ,4BAAA;EAmiDE;;E8E3+cI;I9E48ZN,8BAAA;E8E38ZM;;E9E88ZN;IAmiDI,4BAA4B;E8Ez+chC;;EACE;IAAA,2BAAA;EACA;;E9E8+cA;IACE,iC8E/+cF;EACA;;E9Ei/cA;I8Eh/cA,gCAAA;E9Ek/cA;;EAxiDF;I8Ex8ZE,8BAAA;EACE;;E9E28ZJ;IA2iDI,gCAAgC;E8E7+c9B;;EAEE;IACA,8BAAA;EACA;;EACA;IAAA,4BAAA;EACA;;E9Ek/cN;I8Ej/cM,kCAAA;E9Em/cN;;E8El/cM;IACA,iCAAA;EAAA;;EAGA;IACE,+BAAA;EACA;;E9Es/cR;Ia3mdE,iCAAA;EiE+HF;;E9Eg/cA;I8E9+cE,+BAAA;E9Eg/cF;;EAEA;I8E9+cE,0BAAA;E9Eg/cF;;E8E9+cE;IACE,gCAAA;E9Ei/cJ;;EAEA;IACE,+B8En/cE;E9Eo/cJ;;EAEA;IArjDA,6BAAA;E8E77ZE;;E9Es/cF;I8En/cI,+BAAA;E9Eq/cJ;;E8E/+cE;IACE,6BAAA;E9E27ZJ;;EAyjDA;I8El/cM,iBAAA;E9Eo/cN;;EAEA;I8En/cM,uBAAA;E9E47ZN;;Ea3kaE;IiEwJF,sBAAA;E9Eg/cA;;EAEA;I8E/+cE,oBAAA;E9Ei/cF;;EAEA;I8Ej/cE,sBAAA;E9Em/cF;;EAEA;IACE,oB8En/cA;E9Eu7ZF;;EA+jDA;IA5jDA,qBAAA;E8Ep7ZE;;E9Eo/cF;IA7jDA,2BAAA;EACF;;E8E76ZE;IACE,0BAAA;E9E8+cF;;EAEA;I8E7+cE,wBAAA;E9E++cF;;EAEA;IA9jDA,0BAAA;E8E/6ZE;;E9Ei/cF;IACE,wB8Ej/cE;E9Ei7ZJ;;EAmkDA;I8Eh/cI,wBAAA;E9Eo/cJ;;EAnkDA;I8E76ZI,8BAAA;E9Es/cJ;;EAEA;I8E/+cE,6BAAA;E9Em/cF;;E8Ej/cI;I9Es/cF,2B8Er/cI;E9E86ZN;;EA0kDA;I8Ep/cM,6BAAA;E9Ew/cN;;EAEA;Ia5sdE,2BAAA;EiE8NF;;E9Eo/cA;I8Ej/cE,2BAAA;E9Em/cF;;EAEA;I8Ep/cE,4BAAA;E9Es/cF;;EAEA;IACE,6B8Et/cA;E9Ew6ZF;AAglDF;;AAEA;EA/kDE;IACF,sBAAA;E+EptaA;;E/EutaA;IAilDI,uBAAuB;E+EnydzB;;EAEE;IACA,sBAAA;EACA;;EAEA;IACA,8BAAA;EACE;;EAGJ;I/EstaF,4BAAA;EAilDE;;E+E9xdI;I/EktaN,2BAAA;EAilDE;;E+E3xdA;IAEA,iCAAA;E/E8saF;;E+EtsaA;IAEE,2BAAA;EACA;;EAEA;I/EysaF,0BAAA;EAilDE;;E+EpxdI;I/EusaN,gCAAA;E+ErsaI;;E/EwsaJ;I+EtsaM,yBAAA;EACE;;E/EyxdN;I+ErxdA,wBAAA;EACE;;EACA;IACE,+BAAA;E/EwsaN;;EavsaI;IkEGA,yBAAA;E/EwxdF;;EA9kDF;I+EpsaA,6BAAA;EACE;;E/EusaF;I+ErsaE,8BAAA;EACE;;EAEA;IlEfA,wBAAA;EkEoBF;;E/EuxdA;I+EnxdI,+BzE2Z8B;EN4yZlC;;E+EjsaF;IACE,wBAAA;EACA;;EAEA;IAEA,yBAAA;EAAA;;EAEA;IAKA,8BAAA;E/EqxdA;;EAjlDA;IAulDE,iC+EpxdF;E/EisaF;;E+E9raA;IAIE,sCAAA;EACA;;EACA;IAGA,yCAAA;E/EisaF;;E+E/raA;I/EmsaA,uBAAA;EAwlDE;;E+ExwdQ;IAGE,uBAAA;E/E2wdV;;EAEA;I+EvwdY,yBAAA;E/E0wdZ;;EAEA;I+Exwdc,yBAAA;E/Ekrad;;EA2lDA;I+Epwdc,0BAAA;E/Euwdd;;EAxlDA;I+ExqaQ,4BAAA;E/E2qaR;;Ea3xaE;IkEuHM,kCAAA;E/EmwdR;;EAEA;I+EhwdQ,sCzEnMI;ENu8dZ;;E+EhwdU;I/E0qaV,oCAAA;E+EtqaU;;E/EowdV;I+Ejwdc,kCAAA;E/Eyqad;;EA8lDA;I+EhwdU,yCAAA;E/EowdV;;EAEA;I+ElwdY,wCAAA;E/EqwdZ;;E+E9vdM;I/EuqaN,wCAAA;E+EjqaM;;E/EgwdN;I+E1vdM,kCAAA;E/E8vdN;;EA1lDA;I+EtvaQ,gCAAA;E/Es1dR;;EAEA;I+En1dU,8BAAA;E/E0vaV;;EA+lDA;I+Ej1dc,gCAAA;E/Eq1dd;;E+E/0dY;IAGE,+BAAA;E/Ek1dd;;EA7lDA;I+E9uaQ,oCAAA;E/EivaR;;Eaj2aE;IkEuHM,kCAAA;E/E80dR;;EAEA;I+E50dQ,gCAAA;E/E+0dR;;EA9lDA;I+E3uaY,uCAAA;E/E80dZ;;E+E30dU;I/E+0dR,sC+E90dU;E/E8uaZ;;EAmmDA;I+E50dU,iCAAA;E/E+0dV;;EA/lDA;I+E3uaY,2BAAA;E/E+0dZ;;EA/lDA;I+E5uac,iCAAA;E/E+uad;;EAmmDA;IA/lDA,+BAAA;E+EvuaM;;E/E20dN;IA/lDA,6BAAA;E+EtuaM;;E/E00dN;IA/lDF,+BAAA;Ea75aI;;EbigeF;I+E95dU,8BAAA;E/Ei6dV;;EAEA;I+E55dc,oBAAA;E/Eg6dd;;EAEA;I+Ez5dY,mBAAA;E/E65dZ;;EAEA;IAjmDA,mBAAA;E+ErzaM;;E/EwzaN;I+EjzaM,mBAAA;E/Ey5dN;;EAEA;I+Et5dQ,mBAAA;E/E05dR;;EAnmDA;I+EhzaY,mBAAA;E/EozaZ;;EAumDA;I+Ev5dY,mBAAA;E/E25dZ;;E+Ev5dU;I/EszaV,mBAAA;E+ElzaU;;E/E25dV;I+Ex5dY,oBAAA;E/EozaZ;;EAwmDA;IArmDA,0BAAA;E+E/yaM;;E/Ew5dN;IArmDA,yBAAA;E+E7yaM;;E/Es5dN;I+En5dQ,uBAAA;E/E+yaR;;EAwmDA;I+El5dQ,yBAAA;E/E8yaR;;Eal+aE;IkEgGM,uBAAA;E/E4+dR;;EAEA;I+E1+dU,uBAAA;E/E4+dV;;EArmDA;I+El4aY,0BAAA;IACE,yBAAA;E/E2+dd;;EAEA;I+E1+dc,gCzEuEgB;IN6za9B,+BAAA;E+E93aY;;E/Ey+dZ;I+Et+dc,+BAAA;IACA,8BAAA;E/Ew+dd;;E+En+dM;IACE,6BAAA;I/E63aR,4BAAA;EACF;;E+Ex3aQ;IACE,+BAAA;I/Eo+dN,8B+Ep+dM;E/Eq+dR;;EAEA;I+En+dQ,6BAAA;IACA,4BzEnMI;ENwqeZ;;E+Ej+dU;IACE,6BAAA;IACA,4BAAA;E/E03aZ;;EA4mDA;IACE,wB+Ep+dU;I/E03aZ,2BAAA;E+Ez3aY;;E/E43aZ;I+Ex3aU,8BAAA;IACE,iCAAA;E/Eq+dZ;;E+El+dU;IACE,6BAAA;IACA,gCAAA;E/Eq+dZ;;E+En+dY;IACE,2BAAA;I/E23ad,8BAAA;E+Er3aM;;E/Em+dN;IA1mDA,6BAAA;I+En3aM,gCAAA;E/Eg+dN;;EAEA;IA1mDA,2BAAA;I+El3aM,8BAAA;E/E+9dN;;EAzmDA;IACF,2BAAA;IazibI,8BAAA;EkEgGM;;E/EwjeR;I+ErjeU,wBAAA;E/EujeV;;EAEA;IA3mDA,8BAAA;E+Ex8aY;;E/EujeZ;I+Epjec,6BAAA;E/Esjed;;EA3mDA;I+Ep8aY,2BAAA;E/EmjeZ;;EAEA;I+Ejjec,6BAAA;E/Emjed;;E+E9ieM;IACE,2BAAA;E/Em8aR;;EanjbE;IkEsHI,2BAAA;E/E+ieN;;EAEA;I+E9ieQ,0BAAA;E/EgjeR;;EAEA;I+E9ieQ,gCAAA;E/Ei8aR;;EAinDA;I+E7ieY,+BAAA;E/Eg8aZ;;EAinDA;IACE,6B+E/ieU;E/Eg8aZ;;EAknDA;IA/mDA,+BAAA;E+E97aU;;E/EijeV;IA/mDA,6BAAA;E+E97aU;;E/EijeV;I+E9ieY,6BAAA;E/Eg8aZ;;EAknDA;IA/mDA,2BAAA;E+E37aM;;E/E8ieN;IA/mDA,iCAAA;E+Ez7aM;;E/E4ieN;I+EzieQ,gCAAA;E/E27aR;;EAknDA;I+ExieQ,8BAAA;E/E07aR;;E+E9gbQ;IACE,gCAAA;EACA;;EAEA;IACA,8BAAA;EAAA;;EAIE;IACE,8BAAA;EACA;;EAEA;IAAA,yBAAA;E/E+gbhB;;E+ExgbgB;IACA,+BAAA;EACA;;EACA;I/E2gbhB,8BAAA;E+EtgbQ;;E/EygbR;I+ElgbQ,4BAAA;EACE;;EACA;IACA,8BAAA;EACA;;EAEA;IACA,4BAAA;E/EogbV;;E+Ehgbc;IACA,4BAAA;E/Emgbd;;E+Ehgbc;I/EuneV,2B+EvneU;E/Emgbd;;E+EjgbgB;I/EogbhB,0BAAA;E+EjgbY;;EAEE;I/Emgbd,wBAAA;E+EjgbY;;EAEE;IACA,0BAAA;E/Emgbd;;E+EjgbgB;I/EogbhB,wBAAA;E+E9/aQ;;EAEE;I/EggbV,iCAAA;I+E5/aQ,gCAAA;EACE;;EAEA;I/E8/aV,gCAAA;I+E3/aQ,+BAAA;EACE;;E/E8/aV;IAsnDI,8BAA8B;I+Ezme9B,6BAAA;EACE;;EAEA;I/Es/aN,gCAAA;I+Er/aM,+BAAA;EACE;;EAEA;IACA,8BAAA;IACA,6BAAA;EACA;;EACA;IACE,+BAAA;IACA,kCAAA;E/E6meR;;E+E3meM;IACE,8BAAA;IACA,iCAAA;E/E8meR;;E+E5meQ;IACE,4BAAA;IACA,+BAAA;EACA;;EAEA;IACA,8BAAA;IACA,iCAAA;EACA;;EAGJ;IACE,4BAAA;I/Eu/aV,+BAAA;E+Ep/aM;;EAEE;IACA,+BzEhQM;EyEiQN;;EAEA;IACA,8BAAA;EACA;;EAEA;IACA,4BAAA;E/Es/aR;;E+Ej/aU;IACE,8BAAA;E/Eo/aV;;EaxtbE;IkE4OA,4BAAA;E/EumeF;;EAEA;IAtnDA,iCAAA;E+E9+aM;;E/Ei/aN;I+E/+aQ,gCAAA;E/EwmeR;;EAEA;I+ExmeU,8BAAA;E/E0meV;;EAEA;IACE,gC+E5meQ;E/E6meV;;EAEA;IA5nDA,8BAAA;E+Eh/aU;;E/Em/aV;I+Eh/aU,kCAAA;E/E+meV;;E+E5meU;IACE,iCAAA;E/E+meZ;;E+E3meQ;IACE,+BAAA;E/E8meV;;EAEA;IACE,iC+E9meQ;E/Ei/aV;;EAgoDA;Iat4eE,+BAAA;EkE+RF;;E/E2meA;I+ExmeE,gCzEmJW;ENu9db;;EAEA;I+ExmeE,+BzEgJY;EN09dd;;EAEA;I+ExmeE,6BAAA;E/E0meF;;E+EvmeE;IACE,+BzElJwB;EN4ve5B;;EAEA;I+ExmeI,6BAAA;E/E0meJ;;EAEA;I+EzmeI,qBAAA;E/E4+aJ;;EAioDA;IA9nDA,2BAAA;E+Ez+aA;;E/E2meA;I+ExmeE,0BAAA;E/E0meF;;EA7nDF;I+Ev+aA,wBAAA;EACE;;E/E0+aF;IAgoDI,0BAA0B;E+Erme9B;;EAEE;IACA,wBAAA;EACA;;EAEA;IACA,2BAAA;IACA,0BAAA;EACA;;EAEA;I/Ew+aF,iCAAA;IAgoDI,gCAAgC;E+EtmepC;;EACE;IACA,gCAAA;IACQ,+BAAA;EACR;;EAEA;IACA,8BAAA;IACA,6BAAA;EACA;;E/E0meA;I+ExmeF,gCAAA;IACE,+BAAA;E/E0+aF;;E+Ex+aA;IACE,8BAAA;IACA,6BAAA;E/E2meA;;EAEA;I+E3meF,yBAAA;IACE,4BAAA;E/E4+aF;;E+E1+aA;IACE,+BAAA;I/E8meE,kC+E9meF;EACA;;E/EgneA;I+E9meA,8BAAA;I/E6+aF,iCAAA;EAooDE;;E+E9meA;IACA,4BAAA;IAAA,+BAAA;E/E8+aF;;E+E5+aA;IACE,8BAAA;I/EmneE,iC+EnneF;EACA;;E/EqneA;I+EnneA,4BAAA;I/E++aF,+BAAA;EAuoDE;;EgFnifE;IACA,yBAAA;EhFg6bJ;;EgF15bE;IACE,+BAAA;EhF65bJ;;EgF35bM;IhF85bN,8BAAA;EgF55bI;;EhF+5bJ;IgF35bE,4BAAA;EACE;;EAEA;IhF65bJ,8BAAA;EgF55bI;;EAEE;IhF85bN,4BAAA;EAuoDE;;EiFjkfA;IACA,2BAAA;EACA;;EAEA;IACA,iCAAA;EjF87bF;;EiF37bA;IACE,gCAAA;EjF87bF;;EiF37bA;IACE,8BAAA;EACA;;EjFqkfA;IiFlkfF,gCAAA;EACE;;EjF87bF;IAwoDI,8BAA8B;EiFnkflC;;EjF+7bA;IAwoDI,4BAA4B;EiFnkfhC;;EjF+7bA;IiF77bE,kCAAA;EACE;;EjFukfF;IiFnkfF,iCAAA;EACE;;EjF+7bF;IAwoDI,+BAA+B;EiFnkfnC;;EAEE;IACA,iCAAA;EACA;;EjFskfA;IiFlkfF,+BAAA;EACE;;EjF87bF;IAwoDI,0BAA0B;Ea9if1B;;EbijfF;IiFlkfE,gCAAA;EjF67bF;;EkF5+bF;IlFsnfI,+BAA+B;EkFpnfjC;;ElFunfA;IkFrnfF,6BAAA;EACE;;ElFi/bF;IAwoDI,+BAA+B;EkFpnfnC;;EAEE;IACA,6BAAA;EACA;;EAEA;IACA,iBAAA;ElF++bF;;EkF3+bA;IACE,uBAAA;EACA;;EAEA;IACA,sBAAA;EACA;;ElFsnfA;IkFhnfF,oBAAA;EACE;;ElF4+bF;IkF1+bE,sBAAA;EACE;;EAEA;IACA,oBAAA;EACA;;EAEA;IACA,qBAAA;ElF4+bJ;;EkFz+bA;IACE,2BAAA;EACA;;ElFonfA;ImFxqfA,0BAAA;EACE;;EnF2qfF;ImFtqfF,wBAAA;EACE;;EACA;IACE,0BAAA;EnFkicJ;;EmF/hcI;IACA,wBAAA;EACA;;EAEA;IAGA,wBAAA;EnFkicJ;;EmF7hcA;IAGE,8B7EFY;E6EGZ;;EAEA;InFkicF,6BAAA;EmF/hcE;;EAEE;IAGA,2BAAA;EACA;;EnFkicJ;IoFxkcE,6B9E8sBkC;EN83apC;;Ea1gcI;Ib+gcF,2BAAA;EACF;;EqFjlcE;IACA,2BAAA;EACA;;ErFqlcF;IAwoDI,4BAA4B;Ea9pf5B;;EbiqfF;IAtoDA,6BAAA;EACF;AsFnmcA;;AtFsmcA;EAwoDE;IsFzufF,gCAAA;EACE;;EACA;IAAA,8BAAA;EtFomcF;;EsFlmcI;IACA,iCAAA;EtFqmcJ;;EsFhmcA;IACE,gCAAA;EACA;AtF4ufF;;AAEA;EsF3ufA;IACE,0BAAA;EACA;;EAEA;IAAA,gCAAA;EAAA;;EtFgvfA;IACE,yBsFhvfF;EACA;;EtFkvfA;IA9oDF,wBAAA;EAgpDE;;EsFjvfA;IACA,+BAAA;EACA;;EACA;IAAA,yBAAA;EACA;;EtFuvfA;IsFtvfA,6BAAA;EtFwvfA;;EAnpDF;IAspDI,8BAA8B;EsFzvflC;;EAEE;IAEA,wBAAA;EAAA;;EtF8vfA;IAGE,+BsF/vfF;EtFgwfA;;EAEA;IsFhwfF,wBAAA;EACE;AtFkwfF;;AAEA;EsFjwfE,sBAAA;AtFmwfF;;AAEA;EACE,sBsFrwfA;AtFswfF;;AAEA;EAhqDA,sBAAA;AAkqDA;;AAEA;EsFvwfE,sBAAA;AtFywfF;;AAEA;EsFzwfE,sBAAA;AtF2wfF;;AAEA;EsF3wfE,sBAAA;AtF6wfF;;AArqDA;EAwqDE,sBAAsB;AsF9wfxB;;AtFixfA;EsF9wfE,sBAAA;AtFgxfF;;AAEA;EsFhxfE,uBAAA;AtFkxfF;;AAEA;EACE,uBsFpxfA;AtFqxfF;;AAEA;EsFnxfA,uBAAA;AtFqxfA;;AAEA;EsFnxfE,uBAAA;AtFwmcF;;AsFtmcA;EACE,uBAAA;AtFymcF;;AsFtmcA;EtFsxfE,uBAAuB;AACzB;;AAEA;EsFzxfA,uBAAA;AAQA;;AtFwmcA;EA8qDE,uBAAuB;AsFlxfzB;;AtFwmcA;EA8qDE,uBAAuB;AsFhxfvB;;AtFsmcF;EsFnmcE,uBAAA;AtFkxfF;;AAEA;EsF9wfA,uBAAA;AtFgxfA;;AAEA;EsF9wfE,uBAAA;AtFgxfF;;AAEA;EsF/wfE,uBAAA;AtFixfF;;AAEA;EsFhxfA,wBAAA;AtFkxfA;;AAEA;EA7qDA,wBAAA;AA+qDA;;AAEA;EACE,wBsFlxfE;AtFmxfJ;;AsF9wfA;EtFixfE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AsF5wfA;EACE,wBhF5IY;AN25fd;;AAEA;EsF7wfE,wBAAA;AtF+wfF;;AA5qDA;EsFhmcE,wBAAA;AtFgxfF;;AAEA;EsF9wfI,wBAAA;AtFgxfJ;;AA7qDA;EAgrDE,wBAAwB;AsF3wfxB;;AtF+lcF;EsF7lcI,wBAAA;AtF8wfJ;;AA7qDA;EsF5lcG,wBAAA;AtF6wfH;;AA7qDA;EsF1lcE,wBAAA;AtF2wfF;;AsFvwfE;EACC,qBAAA;AtF0wfH;;AAEA;EsFxwfG,qBAAA;AtF0wfH;;AAEA;EsFtwfC,qBAAA;AtFwwfD;;AsFtwfE;EACC,qBAAA;AtFywfH;;AAEA;EsFvwfG,sBAAA;AtFywfH;;AsFvwfG;EACC,sBAAA;AtF0wfJ;;AAEA;EsFxwfI,qBAAA;AtF0wfJ;;AA7qDA;EAgrDE,uBAAuB;Aa55frB;;Ab+5fJ;EACE,uBsFrwfE;AtFswfJ;;AAEA;EACE,uBsFrwfE;AtFswfJ;;AAEA;EA9qDE,uBAAA;AACF;;AAirDA;EsFnwfE,uBAAA;AtFslcF;;AsFplcA;EACE,uBAAA;AtFswfF;;AAEA;EsFnwfA,uBAAA;AtFqwfA;;AAEA;EA/qDA,uBAAA;AAirDA;;AAEA;EA/qDA,uBAAA;AsFplcE;;AtFuwfF;EsFrwfI,+BAAA;AtFwwfJ;;AAhrDA;EsFplcM,+BAAA;AtFulcN;;AAorDA;EsFtwfM,+BAAA;AtFulcN;;AAorDA;EsFtwfI,+BAAA;AtFywfJ;;AAEA;EsFtwfM,6BAAA;AtFywfN;;AAEA;EAjrDA,+BAAA;AsFrlcI;;AtFwlcJ;Ea1ycI,6BAAA;Abg+fJ;;AAEA;EAEE,6BsFtwfE;AtFuwfJ;;AAEA;EsFpwfE,6BAAA;AtFuwfF;;AAjrDA;EsF/kcC,+BAAA;AtFowfD;;AAEA;EsFnwfE,oCAAA;AtFqwfF;;AAEA;EsFlwfE,gBAAA;EtFilcF,sCAAA;EsFhlcE,wCAAA;AtFswfF;;AAnrDA;EsFhlcE,kBAAA;AtFuwfF;;AAprDA;EsFhlcE,uBAAA;EACC,kBAAA;EtFklcH,gBAAA;EsF/kcG,2BAAA;AtFklcH;;AsF7kcA;EACE,+CAAA;AtFuwfF;;AAEA;EAvrDE,WAAA;EsF9kcA,yCAAA;EtFwwfA,WsFvwfE;EtFwwfF,WsFxwfE;EtFywfF,csFxwfE;EtFglcF,kBAAA;EsF9kcA,QAAA;EtFywfA,WsFxwfE;EtF0wfF,2BsFzwfE;EtFilcJ,gCAAA;EsF5lcA,wBAAA;EACE,UAAA;AtFyxfF;;AAEA;EAzsDE,WAAA;EsF9kcA,yCAAA;EtF0xfA,WsFzxfE;EtF0xfF,WsF1xfE;EtF2xfF,csF1xfE;EtFglcF,kBAAA;EsF9kcA,QAAA;EtF2xfA,WsF1xfE;EtF4xfF,2BsF3xfE;EtFilcJ,gCAAA;EA8sDE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EsFtxfE,yBAAA;AtFyxfF;;AAEA;EAEE,wBsF3xfA;AtF4xfF;;AAEA;EACE,YsF9xfA;AtF+xfF;;AAEA;EsF9xfA,aAAA;AtFgyfA;;AAEA;EsF7xfA,oBAAA;AtF+xfA;;AAEA;EAjtDA,cAAA;AsF5kcE;;AtFiyfF;EsF9xfI,wBAAA;AtFgyfJ;;AAEA;EsF9xfI,YAAA;EACA,eAAA;EtF8kcJ,cAAA;EsF5kcE,YAAA;EAGE,aAAA;EAGA,mBAAA;AtFgyfJ;;AAhtDA;EAmtDE,UAAU;Aa/kgBR;;AbklgBJ;EACE,UsF/xfE;AtFgyfJ;;AAEA;;;;;EA7sDA,oCAAA;AAmtDA;;AAEA;EAjtDA,gBAAA;AAmtDA;;AAEA;EAjtDA,sBAAA;EAmtDE,iBAAiB;EsF1xfnB,gBAAA;EACE,qBAAA;AtF0kcF;;AuF59cA;;;;EAIE,8BAAA;EACA,yBAAA;EACA,wCAAA;AvFirgBF;;AAEA;EAjtDA,2BAAA;EAmtDE,cAAc;AuFhrgBhB;;AvFi+cA;;;;EAIA,2BAAA;EAmtDE,cAAc;AuFlrgBhB;;AvFm+cA;EAmtDE,uBAAuB;EuFnrgBzB,gCAAA;EACE,2BAAA;AvFqrgBF;;AAEA;;;;EA9sDA,8BAAA;EAmtDE,gCAAgC;EuFrrgBlC,yBAAA;AvFurgBA;;AAhtDA;EAmtDE,cAAc;EuFtrgBhB,yCAAA;AvFwrgBA;;AAhtDA;;;EuFj+cE,sBjFkrBiB;EiFjrBjB,oCjFirBiB;EiFhrBjB,gCAAA;AvFurgBF;;AAEA;EAltDA,cAAA;EAotDE,uCAAuC;AuFvrgBzC;;AvF0rgBA;;;EAjtDA,sBAAA;EAqtDE,oCAAoC;EuFvrgBtC,gCAAA;AvFyrgBA;;AAEA;EuFzrgBE,cAAA;EvFq+cF,yCAAA;AuFp+cE;;AvFu+cF;;;EAGA,sBAAA;EuFp+cE,oCAAA;EACE,gCAAA;AvFs+cJ;;AuFj+cA;EACC,cAAA;EAAA,yCAAA;AvF2rgBD;;AAttDA;;;EuFj+cI,sBAAA;EvFq+cJ,oCAAA;EuFp+cI,gCAAA;AvF8rgBJ;;AAttDA;EAytDE,cAAc;EuFzrgBhB,yCAAA;AvF2rgBA;;AAEA;;;EuFzrgBE,sBAAA;EvFm+cF,oCAAA;EuFl+cG,gCAAA;AvF8rgBH;;AuF5rgBK;EACE,cAAA;EvFq+cP,wCAAA;AuFl+cK;;AvF+rgBL;;;EuF1rgBM,sBAAA;EvF8rgBJ,oCuF9rgBI;EvFo+cN,gCAAA;AA4tDA;;AAEA;EuFzrgBE,cAAA;EACA,0CAAA;AvF2rgBF;;AAztDA;;;EAGA,sBAAA;EuFh+cM,oCAAA;EACE,gCAAA;AvFk+cR;;AuF59cA;EACE,cjFkmBgB;EiFjmBhB,uCjFimBgB;AN83blB;;AuF79cA;;;EvFk+cA,sBAAA;EA4tDE,oCAAoC;EuF1rgBtC,gCAAA;AvF4rgBA;;AAztDA;EA4tDE,yBAAyB;EuF3rgB3B,yCAAA;AvF6rgBA;;AAztDA;EA4tDE,yBAAyB;EuF5rgB3B,uCAAA;AvF8rgBA;;AAztDA;EA4tDE,yBAAyB;EuF7rgB3B,yCAAA;AvF+rgBA;;AAztDA;EavjdI,yBAAA;E0EiFJ,yCAAA;AvFosgBA;;AAEA;EA1tDA,yBAAA;EA4tDE,yCAAyC;AuFhsgB3C;;AvFmsgBA;EA1tDA,yBAAA;EalkdI,wCAAA;Ab+xgBJ;;AAEA;EA1tDE,yBAAA;EACF,0CAAA;AA4tDA;;AAEA;EuFjsgBE,yBAAA;EACA,uCAAA;AvFw+cF;;AA6tDA;EuFjsgBI,4RAAA;EACA,yDAAA;EACA,uDAAA;EACA,+DAAA;EACA,qBAAA;AvFosgBJ;;AAztDA;EuFp+cA,0CAAA;AvFksgBA;;AAYA;EuFnsgBI;IACA,mEAAA;EACA;;EAEA;IACA,mEAAA;EACA;AvFqsgBJ;;AAEA;EuFpsgBI,kBAAA;EAAA,kBAAA;AvF0+cJ;;AA+tDA;EuFtsgBK,aAAA;EACA,cjF/LS;EiFgMT,kBAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;EAEA,2BAAA;AvFwsgBL;;AAEA;EuFvsgBK,UAAA;EAAA,mBAAA;AvF2+cL;;AAiuDA;EuFxsgBK,UAAA;EvF2+cL,kBAAA;AuF1+cK;;AvF6+cL;EuFt+cC,cAAA;AvFusgBD;;AA9tDA;EwFrsdE,mBAAA;EAEF,aAAA;EAEE,uBAAA;AxF26gBF;;AAEA;EAnuDA,oCAAA;EAquDE,qBAAqB;EwF56gBrB,WAAA;EACE,WAAA;ExF0sdJ,kBAAA;EAquDE,UAAU;AwFv6gBV;;AxF87gBF;EAruDA;IwFpsdI,oCAAA;IxFusdJ,mBAAA;EAuuDE;;EwFv6gBA;IxFosdF,oCAAA;IwFlsdA,qBAAA;EACE;;ExF46gBA;IwFz6gBF,oCAAA;IxF46gBI,mBAAmB;EACrB;AACF;;AAEA;EwFh7gBA,sCAAA;AAYE;;AxFy6gBF;EAEE,qBAAqB;AwFr6gBrB;;AxFw6gBF;EAEE,qBAAqB;AwFl6gBrB;;AxF+rdF;EAuuDE,sBAAsB;AwFh6gBxB;;AxF6rdA;EwF3rdE,kBAAA;AxFm6gBF;;AwFh6gBE;EACE,kBAAA;ExF6rdJ,gBAAA;EwF1rdI,UAAA;ExF6rdJ,gCAAA;EwF1rdI,UAAA;AxFk6gBJ;;AAEA;EwF35gBA,mBAAA;EACE,eAAA;EACA,UAAA;AxF65gBF;;AAEA;EACE,gBwF75gBA;AxF85gBF;;AAEA;EwF55gBE,WAAA;ExFurdF,kBAAA;EwFtrdE,WAAA;EACE,WAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,6DAAA;EACA,UAAA;AxF+5gBJ;;AAEA;EACE,UwF/5gBE;AxFg6gBJ;;AAEA;EwF95gBE,mFAAA;AxFi6gBF;;AAEA;EwF75gBA,wBAAA;AxF+5gBA;;AAvuDA;EA0uDE,gBAAgB;EwF35gBhB,kCAAA;EACE,iBAAA;ExF65gBF,oBwF75gBE;EACA,gBAAA;EAAA,sBAAA;ExFordJ,YAAA;AwFnrdI;;AxFi6gBJ;EACE,gBwFh6gBI;ExFqrdN,kCAAA;EA6uDE,iBAAiB;EwF35gBjB,oBAAA;EACE,gBAAA;ExF65gBF,sBwF75gBE;EACA,YAAA;AxF85gBJ;;AwF75gBI;EACE,kBAAA;EACA,WAAA;ExFg6gBJ,SwFh6gBI;AxFkrdN;;AyF/0dA;EzFikhBE,kBAAkB;EyF/jhBlB,WAAA;EzFk1dF,SAAA;AAgvDA;;AAEA;EA9uDA,gBAAA;AAgvDA;;AAEA;EACE;IACE,gByFpkhBF;EzFqkhBA;AAjvDF;;AyFl1dA;EACE,YAAA;EzFq1dF,mBAAA;AAmvDA;;AAEA;EAjvDA,6BAAA;EyF/0dG,wBAAA;AzFmkhBH;;AyFhkhBG;EACC,uBAAA;EzFi1dJ,6BAAA;AyF/0dG;;AzFk1dH;EyF/0dG,wBAAA;AzFmkhBH;;AyF9jhBK;EACC,eAAA;EzF+0dN,mBAAA;EAmvDE,oBAAoB;A0FpmhBpB;;A1FumhBF;E0FpmhBI,iCAAA;A1FsmhBJ;;AAEA;E0FpmhBI,iCAAA;A1FsmhBJ;;A0FnmhBE;EACE,6BAAA;A1FsmhBJ;;AAEA;;E0FnmhBE,kDAAA;EACE,6BpFnBU;ANynhBd;;AAhvDA;E0Fn3dI,+CAAA;A1FumhBJ;;A0FnmhBE;EACE,mBAAA;E1Fo3dJ,gBAAA;E0Fl3dE,yBAAA;A1FsmhBF;;AAEA;EAjvDA,eAAA;A0Fl3dE;;A1FumhBF;EAjvDA,uBAAA;E0Fl3dE,oCAAA;A1FsmhBF;;AAEA;E0FnmhBA,uBAAA;EACE,wBAAA;EACA,0CAAA;A1FqmhBF;;AAEA;E0FpmhBA,mBAAA;A1FsmhBA;;AAEA;E0FrmhBA,eAAA;EACC,mBAAA;EACA,sBAAA;A1Fq3dD;;A0Fn3dA;EACE,eAAA;EACA,mBAAA;A1FwmhBF;;AAEA;E0FtmhBE,oBAAA;A1FwmhBF;;AAEA;EACE,qB0FxmhBA;A1FymhBF;;AAEA;E0FtmhBE,gCAAA;E1Fs3dF,SAAA;EAovDE,qBAAqB;E0FvmhBtB,iBAAA;EACC,gBAAA;A1Fs3dF;;A0Fl3dC;EACC,eAAA;A1FwmhBF;;AAEA;;E0FnmhBG,gBAAA;E1Fm3dH,wBAAA;AAovDA;;AAEA;EAlvDA,YAAA;EAovDE,cAAc;E0FjmhBhB,oBAAA;EACC,qBAAA;E1Fg3dD,YAAA;AAovDA;;AAEA;E2FlshBC,aAAA;EAGC,mBAAA;A3FsshBF;;AAEA;E2FlshBA,UAAA;A3FoshBA;;A2FlshBC;EACC,yBAAA;A3FqshBF;;AAEA;;E2FlshBE,wBAAA;A3Fk9dF;;AAqvDA;E2FlshBG,aAAA;EAKD,mBAAA;E3Fo9dF,mBAAA;E2F/8dI,mBAAA;EACA,WAAA;A3FqshBJ;;AAEA;EAnvDA,eAAA;E2F78dE,gBAAA;A3FmshBF;;A2F/rhBG;EACC,2BAAA;E3F88dJ,cAAA;E2F38dI,aAAA;EACC,gBAAA;EAMD,oBAAA;EAGA,mBAAA;E3F28dJ,uBAAA;E2Fr8dI,kBAAA;EAEC,gCAAA;A3Fu8dL;;AAuvDA;E2FvrhBE,6BAAA;EACA,sBAAA;A3Fo8dF;;AAuvDA;E2FvrhBG;IAAA,WAAA;I3F2rhBC,sBAAsB;I2FvrhB1B,eAAA;IACC,OAAA;I3Fk8dD,MAAA;IAwvDI,UAAU;I2FxrhBd,gBAAA;EACC;;E3F2rhBC;I4FlxhBA,aAAA;ICHF,mBAAA;IACE,mBAAA;IACA,eAAA;EACA;;EAEA;IACA,UAAA;IACA,kBAAA;I7FqieF,gCAAA;E6FnieE;;EAGE;IACA,YAAA;EACA;;E7FoieJ;I6F9heI,aAAA;IACA,UAAA;IACA,mBAAA;IACA,kBAAA;E7FkieJ;A6F9heE;;A7F0xhBF;E6FvxhBI;IACA,YAAA;IACA,OAAA;I7F2xhBA,sCAAsC;IAEtC,eAAe;I6FtxhBf,MAAA;IACA,UAAA;IACA,gBAAA;IAIF,4BAAA;EACE;;EAEA;I7FsxhBA,kB6FtxhBA;EACA;;EAEA;IAEA,eAAA;E7FuxhBF;AA1vDF;;AA6vDA;E6FpxhBI;IACA,WAAA;IACA,sBAAA;IACA,eAAA;IACA,QAAA;IACA,MAAA;IACA,gBAAA;I7FuxhBA,U6FvxhBA;E7F2heJ;;E6FxheM;IAGA,mBAAA;EACA;;EAEA;IAGA,aAAA;I7F0xhBF,mB6FxxhBE;E7F2heN;;E6FrheI;;;;IAIA,UAAA;IACA,aAAA;IACA,kBAAA;IAIF,gCAAA;IACE,mBAAA;EACA;;EAEA;IACA,YAAA;EACA;;EAEA;I7FwheJ,oBAAA;EA+vDE;;E6F9whBA;;;;IAOA,aAAA;IACA,UAAA;I7FkheF,mBAAA;IankeI,gCAAA;EgFuDF;A7F8whBF;;AAEA;EA7vDE;I6F7geE,YAAA;IACE,QAAA;I7FiheJ,sCAAA;I6F5geI,eAAA;I7F+geJ,MAAA;IACF,UAAA;I6FxgeC,2BAAA;EACA;;E7F0whBC;I6FvwhBD,eAAA;EACA;A7F0whBD;;AAEA;EA7vDA,YAAA;AA+vDA;;AAEA;E6FzwhBC,oBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;E7F6geD,cAAA;EA+vDE,iBAAiB;A6FzwhBnB;;A7F4whBA;E6FzwhBC,oBAAA;A7F2whBD;;AAEA;E6FzwhBC,gBAAA;A7F2whBD;;AAEA;E6F1whBC,oBAAA;EACA,wBAAA;A7F4whBD;;AA7vDA;E6F5geC,gBAAA;EACC,SAAA;EACA,iCAAA;A7F6whBF;;AAEA;E6F3whBE,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;A7F8geF;;AAiwDA;E6F3whBE,WAAA;A7F6whBF;;AAEA;E6F3whBE,WAAA;A7F6whBF;;AAEA;E6F5whBE,wBAAA;A7F8whBF;;AAEA;E6F3whBA,WAAA;A7F6whBA;;AAEA;E6F3whBC,wBAAA;A7F6whBD;;AAEA;EAhwDA;I6F3geC,yBAAA;EACC;A7F8whBF;;AAEA;E6F5whBE,iBAAA;EACA,oBAAA;A7F8whBF;;AA/vDA;EAkwDE,YAAY;E6F3whBd,cAAA;EACC,WAAA;A7F6whBD;;AAEA;E6F5whBC;IACA,iBAAA;IACA,oBAAA;EACA;;E7F6geD;IAmwDI,YAAY;E6F7whBhB;A7F+whBA;;AAEA;E6F7whBC,gBAAA;EAAA,kCAAA;E7F6geD,eAAA;EAowDE,SAAS;E6F9whBV,wBAAA;EAEA,gCAAA;EACA,uBAAA;EACA,SAAA;A7FixhBD;;AAEA;EAnwDA;I6F3geA,wBAAA;EACC;A7FkxhBD;;AAEA;E6F/whBC,wBAAA;A7FkxhBD;;AAEA;E6FjxhBA,gBAAA;EACC,kCAAA;EACA,eAAA;EACA,QAAA;E7FoxhBC,wBAAwB;E8FxhiBxB,gCxFFY;EwFGZ,uBxFHY;EwFIZ,SAAA;E9F2hiBA,gB8F3hiBA;A9FuxeF;;A8FrxeA;EAEE,wBAAA;A9FwxeF;;A8FtxeA;EACE;I9FyxeF,SAAA;IAswDI,kBAAkB;I8F7hiBtB,UAAA;IACE,cAAA;I9FgiiBE,gCAAgC;E8F9hiBpC;;E9F4xeA;IAswDI,SAAS;I8F/hiBb,mBAAA;IACE,UAAA;I9FkiiBE,gCAAgC;E8F9hiBpC;;E9F4xeA;IAswDI,MAAM;I8F/hiBV,mBAAA;IACE,UAAA;IAEA,gCAAA;EACA;;EAEA;IACA,kBAAA;EACA;A9FiiiBF;;A8FhiiBE;EACE;I9F8xeJ,+CAAA;I8F3xeE,kBAAA;IACE,OAAA;I9F6xeJ,QAAA;I8F5xeI,SAAA;IACE,gBAAA;I9F8xeN,4CAAA;EAuwDE;;E8F9hiBA;I9F2xeF,kBAAA;IAuwDI,WAAW;E8FhiiBf;;E9F6xeA;I8F1xeA,gBAAA;EACE;;E9FoiiBA;I8FliiBF,aAAA;EACE;;EAEA;I9F8xeF,kBAAA;IAuwDI,mBAAmB;E8FniiBvB;;EAEE;IACA,2CAAA;I9F+xeF,iBAAA;IAuwDI,kBAAkB;E8FpiiBtB;;EAEE;IACA,iBAAA;E9FgyeF;;E8F9xeA;IACE,gBAAA;IACA,WAAA;EACA;;E9FwiiBA;I8FtiiBF,qCAAA;IACE,iBAAA;I9FwiiBE,c8FxiiBF;E9FkyeF;;E8FhyeA;IACE,qCAAA;I9F0iiBE,4B8F1iiBF;E9FmyeF;AAywDA;;AAEA;EAvwDA;IAywDI,SAAS;I8FtiiBb,kBAAA;IACE,UAAA;I9FgyeF,cAAA;I8F9xeA,gCAAA;EACE;;E9F0iiBA;I8FxiiBF,SAAA;IACE,mBAAA;IACA,UAAA;I9FmyeF,gCAAA;EAywDE;;E8FviiBA;I9FkyeF,MAAA;I8FhyeE,mBAAA;IACE,UAAA;I9F2iiBA,gCAAgC;EahliBhC;;EbmliBF;I8FpiiBE,kBAAA;E9FsiiBF;AACF;;A+F7piBA;EACE;I/Fy5eF,+CAAA;IAywDI,kBAAkB;I+F/piBtB,OAAA;IACE,QAAA;IACA,SAAA;IACA,gBAAA;IACA,4CAAA;EACA;;E/FkqiBA;I+F/piBF,kBAAA;IACE,WAAA;EACA;;E/FkqiBA;I+F9piBA,gBAAA;EACA;;E/FkqiBA;I+FhqiBF,aAAA;EACE;;E/FmqiBA;I+FjqiBF,kBAAA;IACE,mBzFpBY;EN+6ed;;E+Fz5eA;IACE,2CAAA;I/F45eF,iBAAA;IAywDI,kBAAkB;E+FlqiBtB;;EAEE;I/F45eF,iBAAA;EAywDE;;E+FhqiBA;I/F25eF,gBAAA;I+F15eE,WAAA;EACE;;E/FqqiBF;I+FlqiBF,qCAAA;IACE,iBAAA;I/F45eF,cAAA;EAywDE;;E+FhqiBA;IACA,qCAAA;IACA,4BAAA;E/FmqiBA;AACF;;AAEA;EAxwDA;IA0wDI,SAAS;I+FnqiBb,kBAAA;IACE,UAAA;IACA,cAAA;IAEA,gCAAA;EACA;;E/F65eF;IA0wDI,SAAS;I+FpqiBb,mBAAA;IACE,UAAA;IAEA,gCAAA;EACA;;EAEA;I/F65eF,MAAA;IA0wDI,mBAAmB;I+FrqiBvB,UAAA;IAEE,gCAAA;E/F85eF;;E+F55eA;IACE,kBAAA;E/F+5eF;AA0wDA;;AAEA;EAxwDA;I+F95eA,+CAAA;IACE,kBAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,gBAAA;IACA,4CAAA;EACA;;EAEA;IACA,kBAAA;I/Fi6eF,WAAA;EA0wDE;;E+FvqiBA;I/Fk6eA,gBAAA;EACF;;E+F15eI;IACA,aAAA;E/F65eJ;;E+Fz5eI;IACA,kBAAA;IACA,mBAAA;EACA;;EAEF;IAEE,2CAAA;IACA,iBAAA;IACA,kBAAA;E/F25eJ;;EgGlhfA;IAGI,iBAAA;EACA;;EAEA;IACA,gBAAA;IACA,WAAA;EACA;;EAEA;IACA,qCAAA;IACA,iBAAA;IACA,cAAA;EACA;;EAEA;IACA,qCAAA;IACA,4BAAA;EACA;AhG4xiBJ;;AgGxxiBI;EACA;IACA,SAAA;IhGkhfJ,kBAAA;IgGhhfI,UAAA;IACE,cAAA;IAIF,gCAAA;EACE;;EAEA;IhGyxiBF,SgGzxiBE;IACA,mBAAA;IACA,UAAA;IAGF,gCAAA;EACE;;EhGghfN;IgG3gfI,MAAA;IACE,mBAAA;IhG6gfN,UAAA;IgG1gfM,gCAAA;EhG6gfN;;EgG1gfM;IhGuxiBF,kBgGvxiBE;EhG6gfN;AgG3gfI;;AhGyxiBJ;EA1wDA;IgG3gfQ,+CAAA;IACA,kBAAA;IhG8gfR,OAAA;IgG3gfI,QAAA;IACE,SAAA;IACA,gBAAA;IhG6gfN,4CAAA;EgG3gfI;;EAEE;IACA,kBAAA;IACA,WAAA;EACA;;EAIF;IAEE,gBAAA;EhG2gfN;;EgGtgfM;IACA,aAAA;EACA;;EAIF;IACE,kBAAA;IhGugfN,mBAAA;EgGpgfI;;EhGugfJ;IgGlgfI,2CAAA;IACE,iBAAA;IACA,kBAAA;EhGogfN;;EgGjgfM;IACA,iBAAA;EhGogfN;;EgGlgfQ;IhGqgfR,gBAAA;IgGhgfI,WAAA;EACE;;EAGF;IACE,qCAAA;IhGigfN,iBAAA;IgG7/eI,cAAA;EACE;;EAIF;IACE,qCAAA;IhGwwiBF,4BgGxwiBE;EhG6/eN;AgG3/eI;;AhG0wiBJ;EA5wDA;IgGz/eI,SAAA;IACE,kBAAA;IhGwwiBF,UgGxwiBE;IhG2/eN,cAAA;IgGz/eQ,gCAAA;EhG4/eR;;EgGz/eQ;IhG4/eR,SAAA;IgGz/eI,mBAAA;IACE,UAAA;IACA,gCAAA;EACE;;EAKJ;IACE,MAAA;IACA,mBAAA;IhGy/eN,UAAA;IgGv/eQ,gCAAA;EhG0/eR;;EgGp/eM;IACA,kBAAA;EhGu/eN;AgGr/eI;;AhGswiBJ;EA7wDA;IgGp/eM,+CAAA;IhGu/eN,kBAAA;IgGn/eI,OAAA;IACE,QAAA;IACA,SAAA;IhGq/eN,gBAAA;IgGn/eI,4CAAA;EACE;;EAEF;IACE,kBAAA;IhGq/eN,WAAA;EgGn/eI;;EhGs/eJ;IgG9+eU,gBAAA;EhGi/eV;;EgGt+egB;IhGy+ehB,aAAA;Ea5mfI;;Eb63iBF;IA7wDA,kBAAA;IACF,mBAAA;EajnfI;;Ebk4iBF;IA7wDA,2CAAA;IACF,iBAAA;IatnfI,kBAAA;EmFkJQ;;EhGw+eV;IACF,iBAAA;Ea3nfI;;Eb44iBF;IA7wDA,gBAAA;IACF,WAAA;EahofI;;Ebi5iBF;IA7wDA,qCAAA;IACF,iBAAA;IgGn/eY,cAAA;EACE;;EAQV;IACE,qCAAA;IhG++eN,4BAAA;EgG3+eI;AhG2viBJ;;AgGrviBM;EACE,SAAA;EhG0+eR,kBAAA;EgGx+eM,UAAA;EACE,cAAA;EAKJ,gCAAA;AhGqviBJ;;AgGhviBM;EAEE,SAAA;EhGo+eR,mBAAA;EgGl+eM,UAAA;EhGq+eN,gCAAA;AgGj+eM;;AhGo+eN;EA+wDE,MAAM;EgG1uiBJ,mBAAA;EACE,UAAA;EAAA,gCAAA;AhG8uiBN;;AAEA;EgG9uiBM,kBAAA;AhGgviBN;;AAEA;EgGhviBM,+CAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EAAA,gBAAA;EhG89eN,4CAAA;AgG79eM;;AhGg+eN;EgG79eM,kBAAA;EACE,WAAA;AhG+9eR;;AAwxDA;EAEE,gBAAgB;AgGhviBlB;;AhG69eA;EAuxDE,aAAa;AgG/uiBb;;AhG49eF;EgGz9eE,kBAAA;EACE,mBAAA;AhG29eJ;;AiGvwfA;EjGgijBE,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EAExB,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EAExB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,iEAAiE;AACnE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,OAAO;EACP,cAAc;EACd,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IAGE,aAAa;IAGb,mBAAmB;IAGnB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,QAAQ;IAER,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,aAAa;IACb,SAAS;IACT,WAAW;IAIX,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IAEvB,eAAe;IACf,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,qBAAqB;EACvB;AACF;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EAEE,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EAEE,gCAAgC;EAEhC,wBAAwB;EACxB,WAAW;EACX,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;EAER,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,0CAA0C;EAC1C,QAAQ;EAER,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAElB,8BAA8B;AAChC;;AAEA;EAEE,2CAA2C;EAC3C,WAAW;EAEX,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;EAYE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;EAYE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,OAAO;EACP,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,uBAAuB;EAEvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAGhB,oBAAoB;EAGpB,mBAAmB;EAGnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAGhB,oBAAoB;EAGpB,mBAAmB;EAGnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAGhB,oBAAoB;EAGpB,mBAAmB;EAGnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EAGd,oBAAoB;EAGpB,mBAAmB;EAGnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAGhB,oBAAoB;EAGpB,mBAAmB;EAGnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EAGd,oBAAoB;EAGpB,mBAAmB;EAGnB,uBAAuB;AACzB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;CAKC;AACD;EACE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,cAAc;EAEd,gCAAgC;EAChC,YAAY;EACZ,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;;;;;;;CAOC;AACD;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,WAAW;EACX,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAElB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,UAAU;EACV,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,UAAU;EACV,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EAEE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EAGE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,iCAAiC;EACjC,WAAW;EACX,YAAY;EAEZ,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EAEE,oDAAoD;EACpD,oDAAoD;EACpD,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAsBA;EACE;IAEE,0BAA0B;IAC1B,oDAAoD;EACtD;;EAEA;IAEE,2BAA2B;IAC3B,oDAAoD;EACtD;;EAEA;IAEE,0BAA0B;IAC1B,oDAAoD;EACtD;AACF;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EAGZ,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EAErB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EAGV,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAGE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EAGE,oBAAoB;EACpB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,MAAM;EAEN,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,2BAA2B;EAC3B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,MAAM;AACR;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAE7B,+CAA+C;EAC/C,eAAe;EACf,mBAAmB;EAEnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAEhB,6BAA6B;EAC7B,cAAc;EAEd,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,mBAAmB;EACnB,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EAER,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,kBAAkB;EAElB,gCAAgC;EAChC,4CAA4C;EAC5C,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;;;;;;;;CAQC;AACD;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,SAAS;EAET,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAE7B,8CAA8C;EAE9C,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EAEE,gCAAgC;EAEhC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EAEtB,wBAAwB;AAC1B;;AAEA;EAEE,8CAA8C;EAE9C,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EAEpC,sCAAsC;AACxC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAG5B,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,8BAA8B;EAC9B,0DAAmV;AACrV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EAER,2BAA2B;EAC3B,aAAa;EACb,yDAAiP;EACjP,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,UAAU;EAEV,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EAGE,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EAEnB,wFAAwF;AAC1F;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EAET,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;;EAIE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,SAAS;EAET,+BAA+B;EAC/B,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAElB,2DAA2D;AAC7D;;AAEA;EACE,SAAS;EACT,QAAQ;EAER,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EAEnB,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,WAAW;EACX,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,cAAc;EACd,kBAAkB;EAElB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0DAA4D;AAC9D;;AAEA;;EAEE;;IAEE,YAAY;IACZ,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;EAEjC,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;EACZ,oCAAoC;EAEpC,iFAAiF;EAEjF,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EAEnB,2CAA2C;EAC3C,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EAEnB,+HAA+H;AACjI;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,UAAU;EAEV,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,+DAA+D;EAC/D,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAElB,+CAA+C;AACjD;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EAEV,gCAAgC;AAClC;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;EAGE,4CAA4C;EAC5C,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,6BAA6B;EAC7B,WAAW;EACX,+BAA+B;AACjC;;AAEA;;;;;;;;;EASE,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;EAGE,4CAA4C;EAC5C,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EAEE,6DAA6D;AAC/D;;AAEA;;;EAIE,uCAAuC;AACzC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE;;;IAGE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EAExB,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,OAAO;EACP,QAAQ;EAER,6DAA6D;EAC7D,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;EACrB,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;EAC5C,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,qDAAqD;EAErD,gBAAgB;EAChB,gDAAgD;EAChD,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAEE,kDAAkD;AACpD;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,0DAA0D;EAC1D,mCAAmC;AACrC;;AAEA;EACE,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,sCAAsC;EACtC,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,sDAAsD;AACxD;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;;;;;;EAME,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;;EAIE,2BAA2B;AAC7B;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EAEE,yHAAyH;AAC3H;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EAEvB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EAErB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,WAAW;AACX;;EAEE,gCAAgC;EAChC,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,yBAAyB;;AAE3B;;;;;;;;;;;;;AAaA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAK1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;AAC3B;;;;;;;;;;;;;;;;AAgBA,yEAAyE;;AAEzE;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sEAAsE;EACtE,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,sEAAsE;EACtE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sEAAsE;AACxE;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;AAChC;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,UAAU;EACV,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;EAEE,cAAc;;AAEhB;;AAEA;EACE,aAAa;AACf;;AAEA,8CAA8C;;;AAG9C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,UAAU;EACV,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,yCAAyC;AAC3C;;;;AAIA,wCAAwC;AACxC;EACE,oBAAoB;EACpB,eAAe;EACf,gEAAgE;EAChE,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,YAAY;;EAEZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;;AAEd;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,IAAI;;EAEJ;IACE,wBAAwB;EAC1B;;EAEA,MAAM;AACR;;;;;AAKA;EACE,aAAa;EACb,gEAAgE;EAChE,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,2DAA2D;EAC3D,wBAAwB;EACxB,6CAA6C;EAC7C,iBAAiB;EACjB,qEAAqE;EACrE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,4CAA4C;AAC9C;;AAEA,8BAA8B;;AAE9B;EACE,eAAe;AACjB","sourcesContent":["@charset \"UTF-8\";\n/*!\n * Bootstrap  v5.3.2 (https://getbootstrap.com/)\n * Copyright 2011-2023 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root,\n[data-bs-theme=light] {\n  --bs-blue: #007bff;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #e83e8c;\n  --bs-red: #d6293e;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #f7c32e;\n  --bs-green: #0cbc87;\n  --bs-teal: #20c997;\n  --bs-cyan: #4f9ef8;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray-100: #f7f8f9;\n  --bs-gray-200: #eff2f6;\n  --bs-gray-300: #eef0f2;\n  --bs-gray-400: #e1e4e6;\n  --bs-gray-500: #a1a1a8;\n  --bs-gray-600: #676a79;\n  --bs-gray-700: #29292e;\n  --bs-gray-800: #14191e;\n  --bs-gray-900: #0f0f10;\n  --bs-primary: #0f6fec;\n  --bs-secondary: #14191e;\n  --bs-success: #0cbc87;\n  --bs-info: #4f9ef8;\n  --bs-warning: #f7c32e;\n  --bs-danger: #d6293e;\n  --bs-light: #eef0f2;\n  --bs-dark: #14191e;\n  --bs-primary-rgb: 15, 111, 236;\n  --bs-secondary-rgb: 20, 25, 30;\n  --bs-success-rgb: 12, 188, 135;\n  --bs-info-rgb: 79, 158, 248;\n  --bs-warning-rgb: 247, 195, 46;\n  --bs-danger-rgb: 214, 41, 62;\n  --bs-light-rgb: 238, 240, 242;\n  --bs-dark-rgb: 20, 25, 30;\n  --bs-primary-text-emphasis: #0b4ea5;\n  --bs-secondary-text-emphasis: #0e1215;\n  --bs-success-text-emphasis: #08845f;\n  --bs-info-text-emphasis: #376fae;\n  --bs-warning-text-emphasis: #ad8920;\n  --bs-danger-text-emphasis: #961d2b;\n  --bs-light-text-emphasis: #29292e;\n  --bs-dark-text-emphasis: #0e1215;\n  --bs-primary-bg-subtle: #cfe2fb;\n  --bs-secondary-bg-subtle: #d0d1d2;\n  --bs-success-bg-subtle: #cef2e7;\n  --bs-info-bg-subtle: #dcecfe;\n  --bs-warning-bg-subtle: #fdf3d5;\n  --bs-danger-bg-subtle: #f7d4d8;\n  --bs-light-bg-subtle: #fbfcfc;\n  --bs-dark-bg-subtle: #d0d1d2;\n  --bs-primary-border-subtle: #9fc5f7;\n  --bs-secondary-border-subtle: #a1a3a5;\n  --bs-success-border-subtle: #9ee4cf;\n  --bs-info-border-subtle: #b9d8fc;\n  --bs-warning-border-subtle: #fce7ab;\n  --bs-danger-border-subtle: #efa9b2;\n  --bs-light-border-subtle: #eff2f6;\n  --bs-dark-border-subtle: #a1a3a5;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: \"Inter\", sans-serif;\n  --bs-body-font-size: 0.9375rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #676a79;\n  --bs-body-color-rgb: 103, 106, 121;\n  --bs-body-bg: #eff2f6;\n  --bs-body-bg-rgb: 239, 242, 246;\n  --bs-emphasis-color: #000;\n  --bs-emphasis-color-rgb: 0, 0, 0;\n  --bs-secondary-color: rgba(103, 106, 121, 0.5);\n  --bs-secondary-color-rgb: 103, 106, 121;\n  --bs-secondary-bg: #eff2f6;\n  --bs-secondary-bg-rgb: 239, 242, 246;\n  --bs-tertiary-color: rgba(103, 106, 121, 0.5);\n  --bs-tertiary-color-rgb: 103, 106, 121;\n  --bs-tertiary-bg: #f7f8f9;\n  --bs-tertiary-bg-rgb: 247, 248, 249;\n  --bs-heading-color: var(--bs-gray-800);\n  --bs-link-color: #0f6fec;\n  --bs-link-color-rgb: 15, 111, 236;\n  --bs-link-decoration: none;\n  --bs-link-hover-color: #0c59bd;\n  --bs-link-hover-color-rgb: 12, 89, 189;\n  --bs-code-color: #d63384;\n  --bs-highlight-color: #212529;\n  --bs-highlight-bg: #fff3cd;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: rgba(0, 0, 0, 0.1);\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.4rem;\n  --bs-border-radius-sm: 0.2rem;\n  --bs-border-radius-lg: 0.7rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-xxl: 2rem;\n  --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: 0px 0px 20px rgba(93, 83, 84, 0.15);\n  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(83, 88, 93, 0.15);\n  --bs-box-shadow-lg: 0 1rem 3rem rgba(83, 88, 93, 0.15);\n  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --bs-focus-ring-width: 0.25rem;\n  --bs-focus-ring-opacity: 0.25;\n  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);\n  --bs-form-valid-color: #198754;\n  --bs-form-valid-border-color: #198754;\n  --bs-form-invalid-color: #dc3545;\n  --bs-form-invalid-border-color: #dc3545;\n}\n\n[data-bs-theme=dark] {\n  color-scheme: dark;\n  --bs-body-color: #eef0f2;\n  --bs-body-color-rgb: 238, 240, 242;\n  --bs-body-bg: #0f0f10;\n  --bs-body-bg-rgb: 15, 15, 16;\n  --bs-emphasis-color: #fff;\n  --bs-emphasis-color-rgb: 255, 255, 255;\n  --bs-secondary-color: rgba(238, 240, 242, 0.5);\n  --bs-secondary-color-rgb: 238, 240, 242;\n  --bs-secondary-bg: #14191e;\n  --bs-secondary-bg-rgb: 20, 25, 30;\n  --bs-tertiary-color: rgba(238, 240, 242, 0.5);\n  --bs-tertiary-color-rgb: 238, 240, 242;\n  --bs-tertiary-bg: #121417;\n  --bs-tertiary-bg-rgb: 18, 20, 23;\n  --bs-primary-text-emphasis: #6fa9f4;\n  --bs-secondary-text-emphasis: #727578;\n  --bs-success-text-emphasis: #6dd7b7;\n  --bs-info-text-emphasis: #95c5fb;\n  --bs-warning-text-emphasis: #fadb82;\n  --bs-danger-text-emphasis: #e67f8b;\n  --bs-light-text-emphasis: #f7f8f9;\n  --bs-dark-text-emphasis: #eef0f2;\n  --bs-primary-bg-subtle: #03162f;\n  --bs-secondary-bg-subtle: #040506;\n  --bs-success-bg-subtle: #02261b;\n  --bs-info-bg-subtle: #102032;\n  --bs-warning-bg-subtle: #312709;\n  --bs-danger-bg-subtle: #2b080c;\n  --bs-light-bg-subtle: #14191e;\n  --bs-dark-bg-subtle: #0a0d0f;\n  --bs-primary-border-subtle: #09438e;\n  --bs-secondary-border-subtle: #0c0f12;\n  --bs-success-border-subtle: #077151;\n  --bs-info-border-subtle: #2f5f95;\n  --bs-warning-border-subtle: #94751c;\n  --bs-danger-border-subtle: #801925;\n  --bs-light-border-subtle: #29292e;\n  --bs-dark-border-subtle: #14191e;\n  --bs-heading-color: inherit;\n  --bs-link-color: #0f6fec;\n  --bs-link-hover-color: #0c59bd;\n  --bs-link-color-rgb: 15, 111, 236;\n  --bs-link-hover-color-rgb: 12, 89, 189;\n  --bs-code-color: #e685b5;\n  --bs-highlight-color: #eef0f2;\n  --bs-highlight-bg: #664d03;\n  --bs-border-color: #29292e;\n  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);\n  --bs-form-valid-color: #75b798;\n  --bs-form-valid-border-color: #75b798;\n  --bs-form-invalid-color: #ea868f;\n  --bs-form-invalid-border-color: #ea868f;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: var(--bs-gray-500);\n  border: 0;\n  border-top: var(--bs-border-width) solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  line-height: 1.25;\n  color: var(--bs-heading-color);\n}\n\nh1, .h1 {\n  font-size: calc(1.359375rem + 1.3125vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 2.34375rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.3125rem + 0.75vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 1.875rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.2890625rem + 0.46875vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.640625rem;\n  }\n}\n\nh4, .h4 {\n  font-size: calc(1.265625rem + 0.1875vw);\n}\n@media (min-width: 1200px) {\n  h4, .h4 {\n    font-size: 1.40625rem;\n  }\n}\n\nh5, .h5 {\n  font-size: 1.171875rem;\n}\n\nh6, .h6 {\n  font-size: 0.9375rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall, .small {\n  font-size: 0.875em;\n}\n\nmark, .mark {\n  padding: 0.1875em;\n  color: var(--bs-highlight-color);\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: none;\n}\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 0.875em;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 0.2rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-secondary-color);\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.171875rem;\n  font-weight: 400;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 700;\n  line-height: 1.25;\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 700;\n  line-height: 1.25;\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 700;\n  line-height: 1.25;\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 700;\n  line-height: 1.25;\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 700;\n  line-height: 1.25;\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 700;\n  line-height: 1.25;\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--bs-body-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 96%;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 100%;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 100%;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1200px;\n  }\n}\n:root {\n  --bs-breakpoint-xs: 0;\n  --bs-breakpoint-sm: 576px;\n  --bs-breakpoint-md: 768px;\n  --bs-breakpoint-lg: 992px;\n  --bs-breakpoint-xl: 1200px;\n  --bs-breakpoint-xxl: 1400px;\n}\n\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 3rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 3rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n.table {\n  --bs-table-color-type: initial;\n  --bs-table-bg-type: initial;\n  --bs-table-color-state: initial;\n  --bs-table-bg-state: initial;\n  --bs-table-color: var(--bs-emphasis-color);\n  --bs-table-bg: var(--bs-body-bg);\n  --bs-table-border-color: var(--bs-border-color);\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: var(--bs-emphasis-color);\n  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);\n  --bs-table-active-color: var(--bs-emphasis-color);\n  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);\n  --bs-table-hover-color: var(--bs-emphasis-color);\n  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);\n  width: 100%;\n  margin-bottom: 1rem;\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n  background-color: var(--bs-table-bg);\n  border-bottom-width: var(--bs-border-width);\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: calc(var(--bs-border-width) * 2) solid var(--bs-gray-500);\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.25rem 0.25rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: var(--bs-border-width) 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 var(--bs-border-width);\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-active {\n  --bs-table-color-state: var(--bs-table-active-color);\n  --bs-table-bg-state: var(--bs-table-active-bg);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-color-state: var(--bs-table-hover-color);\n  --bs-table-bg-state: var(--bs-table-hover-bg);\n}\n\n.table-primary {\n  --bs-table-color: #000;\n  --bs-table-bg: #cfe2ff;\n  --bs-table-border-color: #a6b5cc;\n  --bs-table-striped-bg: #c5d7f2;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #bacbe6;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #bfd1ec;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #000;\n  --bs-table-bg: #e2e3e5;\n  --bs-table-border-color: #b5b6b7;\n  --bs-table-striped-bg: #d7d8da;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #cbccce;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #d1d2d4;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #000;\n  --bs-table-bg: #d1e7dd;\n  --bs-table-border-color: #a7b9b1;\n  --bs-table-striped-bg: #c7dbd2;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #bcd0c7;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #c1d6cc;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #000;\n  --bs-table-bg: #cff4fc;\n  --bs-table-border-color: #a6c3ca;\n  --bs-table-striped-bg: #c5e8ef;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #badce3;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #bfe2e9;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #000;\n  --bs-table-bg: #fff3cd;\n  --bs-table-border-color: #ccc2a4;\n  --bs-table-striped-bg: #f2e7c3;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #e6dbb9;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #ece1be;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #000;\n  --bs-table-bg: #f8d7da;\n  --bs-table-border-color: #c6acae;\n  --bs-table-striped-bg: #eccccf;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #dfc2c4;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #e5c7ca;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #000;\n  --bs-table-bg: #f8f9fa;\n  --bs-table-border-color: #c6c7c8;\n  --bs-table-striped-bg: #ecedee;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #dfe0e1;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #e5e6e7;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #fff;\n  --bs-table-bg: #212529;\n  --bs-table-border-color: #4d5154;\n  --bs-table-striped-bg: #2c3034;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: #373b3e;\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: #323539;\n  --bs-table-hover-color: #fff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.8rem + 1px);\n  padding-bottom: calc(0.8rem + 1px);\n  font-size: 1rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.4rem + 1px);\n  padding-bottom: calc(0.4rem + 1px);\n  font-size: 0.8125rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 1rem;\n  font-size: 0.9375rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-gray-700);\n  appearance: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid var(--bs-gray-400);\n  border-radius: 0.4rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: var(--bs-gray-700);\n  background-color: #fff;\n  border-color: #0f6fec;\n  outline: 0;\n  box-shadow: none;\n}\n.form-control::-webkit-date-and-time-value {\n  min-width: 85px;\n  height: 1.5em;\n  margin: 0;\n}\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n.form-control::placeholder {\n  color: var(--bs-gray-500);\n  opacity: 1;\n}\n.form-control:disabled {\n  background-color: var(--bs-gray-200);\n  border-color: var(--bs-border-color);\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n  color: var(--bs-body-color);\n  background-color: var(--bs-tertiary-bg);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: all 0.3s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: var(--bs-secondary-bg);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.25em + 0.8rem + 2px);\n  padding: 0.4rem 0.8rem;\n  font-size: 0.8125rem;\n  border-radius: 0.2rem;\n}\n.form-control-sm::file-selector-button {\n  padding: 0.4rem 0.8rem;\n  margin: -0.4rem -0.8rem;\n  margin-inline-end: 0.8rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.25em + 1.6rem + 2px);\n  padding: 0.8rem 1.5rem;\n  font-size: 1rem;\n  border-radius: 0.2rem;\n}\n.form-control-lg::file-selector-button {\n  padding: 0.8rem 1.5rem;\n  margin: -0.8rem -1.5rem;\n  margin-inline-end: 1.5rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 1rem + 2px);\n}\ntextarea.form-control-sm {\n  min-height: calc(1.25em + 0.8rem + 2px);\n}\ntextarea.form-control-lg {\n  min-height: calc(1.25em + 1.6rem + 2px);\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 1rem + 2px);\n  padding: 0.5rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: 0.4rem;\n}\n.form-control-color::-webkit-color-swatch {\n  border: 0 !important;\n  border-radius: 0.4rem;\n}\n.form-control-color.form-control-sm {\n  height: calc(1.25em + 0.8rem + 2px);\n}\n.form-control-color.form-control-lg {\n  height: calc(1.25em + 1.6rem + 2px);\n}\n\n.form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  display: block;\n  width: 100%;\n  padding: 0.5rem 2.25rem 0.5rem 1rem;\n  font-size: 0.9375rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-gray-700);\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: 0.4rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: #0f6fec;\n  outline: 0;\n  box-shadow: 0 0 0 0 rgba(15, 111, 236, 0.25);\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 1rem;\n  background-image: none;\n}\n.form-select:disabled {\n  background-color: var(--bs-secondary-bg);\n  border-color: var(--bs-border-color);\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 var(--bs-gray-700);\n}\n\n.form-select-sm {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.875rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.25rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n\n[data-bs-theme=dark] .form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23eef0f2' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check {\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5em;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.5em;\n}\n\n.form-check-reverse {\n  padding-right: 1.5em;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -1.5em;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: var(--bs-gray-200);\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  margin-top: 0.25em;\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  print-color-adjust: exact;\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: #0f6fec;\n  outline: 0;\n  box-shadow: 0 0 0 0 rgba(15, 111, 236, 0.25);\n}\n.form-check-input:checked {\n  background-color: #0f6fec;\n  border-color: #0f6fec;\n}\n.form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #0f6fec;\n  border-color: #0f6fec;\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.5em;\n}\n.form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: var(--bs-form-switch-bg);\n  background-position: left center;\n  border-radius: 2em;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%230f6fec'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 2.5em;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -2.5em;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  appearance: none;\n  background-color: transparent;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #eff2f6, none;\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #eff2f6, none;\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  appearance: none;\n  background-color: #0f6fec;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: #b7d4f9;\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  appearance: none;\n  background-color: #0f6fec;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: #b7d4f9;\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: #a1a1a8;\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: #a1a1a8;\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  height: 100%;\n  padding: 1rem 0.75rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: 1px solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 0.75rem;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:focus ~ label::after,\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n.form-floating > .form-control-plaintext ~ label::after,\n.form-floating > .form-select ~ label::after {\n  position: absolute;\n  inset: 1rem 0.375rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: #fff;\n  border-radius: 0.4rem;\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: 1px 0;\n}\n.form-floating > :disabled ~ label,\n.form-floating > .form-control:disabled ~ label {\n  color: #6c757d;\n}\n.form-floating > :disabled ~ label::after,\n.form-floating > .form-control:disabled ~ label::after {\n  background-color: var(--bs-gray-200);\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.9375rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-gray-700);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-gray-200);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 0.4rem;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.8rem 1.5rem;\n  font-size: 1rem;\n  border-radius: 0.2rem;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.4rem 0.8rem;\n  font-size: 0.8125rem;\n  border-radius: 0.2rem;\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 3.25rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: calc(1px * -1);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-valid-color);\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  color: #fff;\n  background-color: var(--bs-success);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: var(--bs-form-valid-color);\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: var(--bs-form-valid-color);\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-invalid-color);\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  color: #fff;\n  background-color: var(--bs-danger);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: var(--bs-form-invalid-color);\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: var(--bs-form-invalid-color);\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 1rem;\n  --bs-btn-padding-y: 0.5rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 0.9375rem;\n  --bs-btn-font-weight: 500;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: var(--bs-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: 1px;\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: 0.4rem;\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: none;\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0 rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  transition: all 0.3s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n}\n\n.btn-primary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #0f6fec;\n  --bs-btn-border-color: #0f6fec;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0d5ec9;\n  --bs-btn-hover-border-color: #0c59bd;\n  --bs-btn-focus-shadow-rgb: 51, 133, 239;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0c59bd;\n  --bs-btn-active-border-color: #0b53b1;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #0f6fec;\n  --bs-btn-disabled-border-color: #0f6fec;\n}\n\n.btn-secondary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #14191e;\n  --bs-btn-border-color: #14191e;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #11151a;\n  --bs-btn-hover-border-color: #101418;\n  --bs-btn-focus-shadow-rgb: 55, 60, 64;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #101418;\n  --bs-btn-active-border-color: #0f1317;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #14191e;\n  --bs-btn-disabled-border-color: #14191e;\n}\n\n.btn-success {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #0cbc87;\n  --bs-btn-border-color: #0cbc87;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0aa073;\n  --bs-btn-hover-border-color: #0a966c;\n  --bs-btn-focus-shadow-rgb: 48, 198, 153;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0a966c;\n  --bs-btn-active-border-color: #098d65;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #0cbc87;\n  --bs-btn-disabled-border-color: #0cbc87;\n}\n\n.btn-info {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #4f9ef8;\n  --bs-btn-border-color: #4f9ef8;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #4386d3;\n  --bs-btn-hover-border-color: #3f7ec6;\n  --bs-btn-focus-shadow-rgb: 105, 173, 249;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #3f7ec6;\n  --bs-btn-active-border-color: #3b77ba;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #4f9ef8;\n  --bs-btn-disabled-border-color: #4f9ef8;\n}\n\n.btn-warning {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #f7c32e;\n  --bs-btn-border-color: #f7c32e;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #f8cc4d;\n  --bs-btn-hover-border-color: #f8c943;\n  --bs-btn-focus-shadow-rgb: 210, 166, 39;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #f9cf58;\n  --bs-btn-active-border-color: #f8c943;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #f7c32e;\n  --bs-btn-disabled-border-color: #f7c32e;\n}\n\n.btn-danger {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #d6293e;\n  --bs-btn-border-color: #d6293e;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #b62335;\n  --bs-btn-hover-border-color: #ab2132;\n  --bs-btn-focus-shadow-rgb: 220, 73, 91;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #ab2132;\n  --bs-btn-active-border-color: #a11f2f;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #d6293e;\n  --bs-btn-disabled-border-color: #d6293e;\n}\n\n.btn-light {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #eef0f2;\n  --bs-btn-border-color: #eef0f2;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #caccce;\n  --bs-btn-hover-border-color: #bec0c2;\n  --bs-btn-focus-shadow-rgb: 202, 204, 206;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #bec0c2;\n  --bs-btn-active-border-color: #b3b4b6;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #eef0f2;\n  --bs-btn-disabled-border-color: #eef0f2;\n}\n\n.btn-dark {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #14191e;\n  --bs-btn-border-color: #14191e;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #373c40;\n  --bs-btn-hover-border-color: #2c3035;\n  --bs-btn-focus-shadow-rgb: 55, 60, 64;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #43474b;\n  --bs-btn-active-border-color: #2c3035;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #14191e;\n  --bs-btn-disabled-border-color: #14191e;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #0f6fec;\n  --bs-btn-border-color: #0f6fec;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0f6fec;\n  --bs-btn-hover-border-color: #0f6fec;\n  --bs-btn-focus-shadow-rgb: 15, 111, 236;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0f6fec;\n  --bs-btn-active-border-color: #0f6fec;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #0f6fec;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0f6fec;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #14191e;\n  --bs-btn-border-color: #14191e;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #14191e;\n  --bs-btn-hover-border-color: #14191e;\n  --bs-btn-focus-shadow-rgb: 20, 25, 30;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #14191e;\n  --bs-btn-active-border-color: #14191e;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #14191e;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #14191e;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #0cbc87;\n  --bs-btn-border-color: #0cbc87;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0cbc87;\n  --bs-btn-hover-border-color: #0cbc87;\n  --bs-btn-focus-shadow-rgb: 12, 188, 135;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0cbc87;\n  --bs-btn-active-border-color: #0cbc87;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #0cbc87;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0cbc87;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #4f9ef8;\n  --bs-btn-border-color: #4f9ef8;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #4f9ef8;\n  --bs-btn-hover-border-color: #4f9ef8;\n  --bs-btn-focus-shadow-rgb: 79, 158, 248;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #4f9ef8;\n  --bs-btn-active-border-color: #4f9ef8;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #4f9ef8;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #4f9ef8;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #f7c32e;\n  --bs-btn-border-color: #f7c32e;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #f7c32e;\n  --bs-btn-hover-border-color: #f7c32e;\n  --bs-btn-focus-shadow-rgb: 247, 195, 46;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #f7c32e;\n  --bs-btn-active-border-color: #f7c32e;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #f7c32e;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f7c32e;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #d6293e;\n  --bs-btn-border-color: #d6293e;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #d6293e;\n  --bs-btn-hover-border-color: #d6293e;\n  --bs-btn-focus-shadow-rgb: 214, 41, 62;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #d6293e;\n  --bs-btn-active-border-color: #d6293e;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #d6293e;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #d6293e;\n  --bs-gradient: none;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #eef0f2;\n  --bs-btn-border-color: #eef0f2;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #eef0f2;\n  --bs-btn-hover-border-color: #eef0f2;\n  --bs-btn-focus-shadow-rgb: 238, 240, 242;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #eef0f2;\n  --bs-btn-active-border-color: #eef0f2;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #eef0f2;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #eef0f2;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #14191e;\n  --bs-btn-border-color: #14191e;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #14191e;\n  --bs-btn-hover-border-color: #14191e;\n  --bs-btn-focus-shadow-rgb: 20, 25, 30;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #14191e;\n  --bs-btn-active-border-color: #14191e;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #14191e;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #14191e;\n  --bs-gradient: none;\n}\n\n.btn-link {\n  --bs-btn-font-weight: 500;\n  --bs-btn-color: var(--bs-link-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: var(--bs-link-hover-color);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: var(--bs-link-hover-color);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: var(--bs-gray-400);\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: 0 0 0 #000;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  text-decoration: none;\n}\n.btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n.btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-padding-y: 0.8rem;\n  --bs-btn-padding-x: 1.5rem;\n  --bs-btn-font-size: 1rem;\n  --bs-btn-border-radius: 0.2rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.4rem;\n  --bs-btn-padding-x: 0.8rem;\n  --bs-btn-font-size: 0.8125rem;\n  --bs-btn-border-radius: 0.2rem;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 15rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 1rem;\n  --bs-dropdown-spacer: 0;\n  --bs-dropdown-font-size: 0.9375rem;\n  --bs-dropdown-color: var(--bs-body-color);\n  --bs-dropdown-bg: #fff;\n  --bs-dropdown-border-color: rgba(0, 0, 0, 0.06);\n  --bs-dropdown-border-radius: 0.4rem;\n  --bs-dropdown-border-width: 1px;\n  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));\n  --bs-dropdown-divider-bg: rgba(0, 0, 0, 0.1);\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: 0px 20px 30px rgba(83, 88, 93, 0.1), 0px 0px 30px rgba(83, 88, 93, 0.2);\n  --bs-dropdown-link-color: var(--bs-gray-600);\n  --bs-dropdown-link-hover-color: #0f6fec;\n  --bs-dropdown-link-hover-bg: transparent;\n  --bs-dropdown-link-active-color: #0f6fec;\n  --bs-dropdown-link-active-bg: transparent;\n  --bs-dropdown-link-disabled-color: var(--bs-gray-600);\n  --bs-dropdown-item-padding-x: 1.2rem;\n  --bs-dropdown-item-padding-y: 0.4rem;\n  --bs-dropdown-header-color: var(--bs-gray-800);\n  --bs-dropdown-header-padding-x: 1rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 500;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.8203125rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: var(--bs-gray-300);\n  --bs-dropdown-bg: var(--bs-gray-800);\n  --bs-dropdown-border-color: rgba(0, 0, 0, 0.06);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: var(--bs-gray-300);\n  --bs-dropdown-link-hover-color: #fff;\n  --bs-dropdown-divider-bg: rgba(255, 255, 255, 0.1);\n  --bs-dropdown-link-hover-bg: transparent;\n  --bs-dropdown-link-active-color: #0f6fec;\n  --bs-dropdown-link-active-bg: transparent;\n  --bs-dropdown-link-disabled-color: var(--bs-gray-500);\n  --bs-dropdown-header-color: var(--bs-gray-500);\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: 0.4rem;\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: calc(1px * -1);\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.6rem;\n  padding-left: 0.6rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 1.125rem;\n  padding-left: 1.125rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: calc(1px * -1);\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 0.75rem;\n  --bs-nav-link-padding-y: 0.25rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-body-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-gray-500) !important;\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  background: none;\n  border: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-link:focus-visible {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.nav-link.disabled, .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: 1px;\n  --bs-nav-tabs-border-color: rgba(0, 0, 0, 0.1);\n  --bs-nav-tabs-border-radius: 0.4rem;\n  --bs-nav-tabs-link-hover-border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1);\n  --bs-nav-tabs-link-active-color: #29292e;\n  --bs-nav-tabs-link-active-bg: #eff2f6;\n  --bs-nav-tabs-link-active-border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) #eff2f6;\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: 0.4rem;\n  --bs-nav-pills-link-active-color: #fff;\n  --bs-nav-pills-link-active-bg: #0d6efd;\n}\n.nav-pills .nav-link {\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-underline {\n  --bs-nav-underline-gap: 1rem;\n  --bs-nav-underline-border-width: 0.125rem;\n  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n  gap: var(--bs-nav-underline-gap);\n}\n.nav-underline .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: var(--bs-nav-underline-border-width) solid transparent;\n}\n.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {\n  border-bottom-color: currentcolor;\n}\n.nav-underline .nav-link.active,\n.nav-underline .show > .nav-link {\n  font-weight: 700;\n  color: var(--bs-nav-underline-link-active-color);\n  border-bottom-color: currentcolor;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0;\n  --bs-navbar-color: var(--bs-gray-600);\n  --bs-navbar-hover-color: #0f6fec;\n  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);\n  --bs-navbar-active-color: #0f6fec;\n  --bs-navbar-brand-padding-y: 10px;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 1.25rem;\n  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-nav-link-padding-x: 1rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0;\n  --bs-navbar-toggler-font-size: 1.25rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2833, 37, 41, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);\n  --bs-navbar-toggler-border-radius: var(--bs-border-radius);\n  --bs-navbar-toggler-focus-width: 0;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.25rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n  color: var(--bs-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  color: var(--bs-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=dark] {\n  --bs-navbar-color: #fff;\n  --bs-navbar-hover-color: #0f6fec !important;\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #0f6fec !important;\n  --bs-navbar-brand-color: #fff;\n  --bs-navbar-brand-hover-color: #fff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='%23ffffff' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n[data-bs-theme=dark] .navbar-toggler-icon {\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='%23ffffff' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1.25rem;\n  --bs-card-spacer-x: 1.25rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-title-color: var(--bs-heading-color);\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: 1px;\n  --bs-card-border-color: rgba(0, 0, 0, 0.09);\n  --bs-card-border-radius: 0.4rem;\n  --bs-card-box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.04);\n  --bs-card-inner-border-radius: calc(0.4rem - 1px);\n  --bs-card-cap-padding-y: 1.25rem;\n  --bs-card-cap-padding-x: 1.25rem;\n  --bs-card-cap-bg: #fff;\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: #fff;\n  --bs-card-img-overlay-padding: 1.25rem;\n  --bs-card-group-margin: 0.75rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  color: var(--bs-body-color);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n  color: var(--bs-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--bs-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: #676a79;\n  --bs-accordion-bg: #fff;\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: rgba(103, 106, 121, 0.125);\n  --bs-accordion-border-width: var(--bs-border-width);\n  --bs-accordion-border-radius: var(--bs-border-radius);\n  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-accordion-btn-padding-x: 1.25rem;\n  --bs-accordion-btn-padding-y: 1rem;\n  --bs-accordion-btn-color: var(--bs-body-color);\n  --bs-accordion-btn-bg: var(--bs-accordion-bg);\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.25rem;\n  --bs-accordion-btn-icon-transform: rotate(-180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230e64d4'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-border-color: none;\n  --bs-accordion-btn-focus-box-shadow: none;\n  --bs-accordion-body-padding-x: 1.25rem;\n  --bs-accordion-body-padding-y: 1rem;\n  --bs-accordion-active-color: #0e64d4;\n  --bs-accordion-active-bg: #e7f1fd;\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 0.9375rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  border-color: var(--bs-accordion-btn-focus-border-color);\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush .accordion-collapse {\n  border-width: 0;\n}\n.accordion-flush .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {\n  border-radius: 0;\n}\n\n[data-bs-theme=dark] .accordion-button::after {\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236fa9f4'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23a1a1a8'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0.5rem;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-bg: transparent;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: var(--bs-gray-500);\n  --bs-breadcrumb-item-padding-x: 0.8rem;\n  --bs-breadcrumb-item-active-color: var(--bs-gray-500);\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.8rem;\n  --bs-pagination-padding-y: 0.4rem;\n  --bs-pagination-font-size: 1rem;\n  --bs-pagination-color: var(--bs-gray-600);\n  --bs-pagination-bg: #fff;\n  --bs-pagination-border-width: 1px;\n  --bs-pagination-border-color: var(--bs-gray-300);\n  --bs-pagination-border-radius: 0.4rem;\n  --bs-pagination-hover-color: #fff;\n  --bs-pagination-hover-bg: #0f6fec;\n  --bs-pagination-hover-border-color: #0f6fec;\n  --bs-pagination-focus-color: var(--bs-link-hover-color);\n  --bs-pagination-focus-bg: var(--bs-gray-200);\n  --bs-pagination-focus-box-shadow: 0 0 0 0 rgba(15, 111, 236, 0.25);\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-bg: #0f6fec;\n  --bs-pagination-active-border-color: #0f6fec;\n  --bs-pagination-disabled-color: var(--bs-gray-400);\n  --bs-pagination-disabled-bg: #fff;\n  --bs-pagination-disabled-border-color: var(--bs-gray-300);\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: calc(var(--bs-border-width) * -1);\n}\n.page-item .page-link {\n  border-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: 1.171875rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-lg);\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.5rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.8203125rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-sm);\n}\n\n.badge {\n  --bs-badge-padding-x: 0.65em;\n  --bs-badge-padding-y: 0.35em;\n  --bs-badge-font-size: 0.85em;\n  --bs-badge-font-weight: 400;\n  --bs-badge-color: #fff;\n  --bs-badge-border-radius: var(--bs-border-radius);\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1rem;\n  --bs-alert-padding-y: 1rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: var(--bs-border-radius);\n  --bs-alert-link-color: inherit;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n  color: var(--bs-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n\n.alert-primary {\n  --bs-alert-color: var(--bs-primary-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-text-emphasis);\n}\n\n.alert-secondary {\n  --bs-alert-color: var(--bs-secondary-text-emphasis);\n  --bs-alert-bg: var(--bs-secondary-bg-subtle);\n  --bs-alert-border-color: var(--bs-secondary-border-subtle);\n  --bs-alert-link-color: var(--bs-secondary-text-emphasis);\n}\n\n.alert-success {\n  --bs-alert-color: var(--bs-success-text-emphasis);\n  --bs-alert-bg: var(--bs-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-border-subtle);\n  --bs-alert-link-color: var(--bs-success-text-emphasis);\n}\n\n.alert-info {\n  --bs-alert-color: var(--bs-info-text-emphasis);\n  --bs-alert-bg: var(--bs-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-border-subtle);\n  --bs-alert-link-color: var(--bs-info-text-emphasis);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--bs-warning-text-emphasis);\n  --bs-alert-bg: var(--bs-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-warning-text-emphasis);\n}\n\n.alert-danger {\n  --bs-alert-color: var(--bs-danger-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-text-emphasis);\n}\n\n.alert-light {\n  --bs-alert-color: var(--bs-light-text-emphasis);\n  --bs-alert-bg: var(--bs-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-border-subtle);\n  --bs-alert-link-color: var(--bs-light-text-emphasis);\n}\n\n.alert-dark {\n  --bs-alert-color: var(--bs-dark-text-emphasis);\n  --bs-alert-bg: var(--bs-dark-bg-subtle);\n  --bs-alert-border-color: var(--bs-dark-border-subtle);\n  --bs-alert-link-color: var(--bs-dark-text-emphasis);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n.progress,\n.progress-stacked {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.75rem;\n  --bs-progress-bg: rgba(0, 0, 0, 0.1);\n  --bs-progress-border-radius: var(--bs-border-radius);\n  --bs-progress-box-shadow: var(--bs-box-shadow-inset);\n  --bs-progress-bar-color: #fff;\n  --bs-progress-bar-bg: #0d6efd;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: var(--bs-gray-600);\n  --bs-list-group-bg: transparent;\n  --bs-list-group-border-color: var(--bs-border-color);\n  --bs-list-group-border-width: var(--bs-border-width);\n  --bs-list-group-border-radius: 0.4rem;\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: var(--bs-secondary-color);\n  --bs-list-group-action-hover-color: var(--bs-gray-700);\n  --bs-list-group-action-hover-bg: var(--bs-light);\n  --bs-list-group-action-active-color: var(--bs-body-color);\n  --bs-list-group-action-active-bg: var(--bs-light);\n  --bs-list-group-disabled-color: var(--bs-secondary-color);\n  --bs-list-group-disabled-bg: var(--bs-body-bg);\n  --bs-list-group-active-color: #fff;\n  --bs-list-group-active-bg: #0f6fec;\n  --bs-list-group-active-border-color: #0f6fec;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.list-group-item-action:active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  --bs-list-group-color: var(--bs-primary-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);\n}\n\n.list-group-item-secondary {\n  --bs-list-group-color: var(--bs-secondary-text-emphasis);\n  --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);\n}\n\n.list-group-item-success {\n  --bs-list-group-color: var(--bs-success-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);\n}\n\n.list-group-item-info {\n  --bs-list-group-color: var(--bs-info-text-emphasis);\n  --bs-list-group-bg: var(--bs-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n  --bs-list-group-active-color: var(--bs-info-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);\n}\n\n.list-group-item-warning {\n  --bs-list-group-color: var(--bs-warning-text-emphasis);\n  --bs-list-group-bg: var(--bs-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-warning-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);\n}\n\n.list-group-item-danger {\n  --bs-list-group-color: var(--bs-danger-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);\n}\n\n.list-group-item-light {\n  --bs-list-group-color: var(--bs-light-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);\n}\n\n.list-group-item-dark {\n  --bs-list-group-color: var(--bs-dark-text-emphasis);\n  --bs-list-group-bg: var(--bs-dark-bg-subtle);\n  --bs-list-group-border-color: var(--bs-dark-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);\n}\n\n.btn-close {\n  --bs-btn-close-color: #000;\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.75;\n  --bs-btn-close-focus-shadow: 0 0 0 0 rgba(15, 111, 236, 0.25);\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.4rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n[data-bs-theme=dark] .btn-close {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 1.5rem;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: ;\n  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-border-width: var(--bs-border-width);\n  --bs-toast-border-color: var(--bs-border-color-translucent);\n  --bs-toast-border-radius: var(--bs-border-radius);\n  --bs-toast-box-shadow: var(--bs-box-shadow);\n  --bs-toast-header-color: var(--bs-secondary-color);\n  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-header-border-color: var(--bs-border-color-translucent);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: ;\n  --bs-modal-bg: #fff;\n  --bs-modal-border-color: var(--bs-border-color-translucent);\n  --bs-modal-border-width: 0;\n  --bs-modal-border-radius: 0.4rem;\n  --bs-modal-box-shadow: var(--bs-box-shadow-sm);\n  --bs-modal-inner-border-radius: 0.4rem;\n  --bs-modal-header-padding-x: 1rem;\n  --bs-modal-header-padding-y: 1rem;\n  --bs-modal-header-padding: 1rem 1rem;\n  --bs-modal-header-border-color: var(--bs-border-color);\n  --bs-modal-header-border-width: var(--bs-border-width);\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: var(--bs-border-color);\n  --bs-modal-footer-border-width: var(--bs-border-width);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #000;\n  --bs-backdrop-opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: var(--bs-box-shadow);\n  }\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --bs-tooltip-zindex: 1080;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 0.5rem;\n  --bs-tooltip-padding-y: 0.25rem;\n  --bs-tooltip-margin: ;\n  --bs-tooltip-font-size: 0.75rem;\n  --bs-tooltip-color: var(--bs-body-bg);\n  --bs-tooltip-bg: var(--bs-emphasis-color);\n  --bs-tooltip-border-radius: var(--bs-border-radius);\n  --bs-tooltip-opacity: 0.9;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  margin: var(--bs-tooltip-margin);\n  font-family: \"Inter\", sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 0.875rem;\n  --bs-popover-bg: var(--bs-white);\n  --bs-popover-border-width: var(--bs-border-width);\n  --bs-popover-border-color: var(--bs-border-color-translucent);\n  --bs-popover-border-radius: var(--bs-border-radius-lg);\n  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));\n  --bs-popover-box-shadow: var(--bs-box-shadow);\n  --bs-popover-header-padding-x: 1rem;\n  --bs-popover-header-padding-y: 0.5rem;\n  --bs-popover-header-font-size: 1rem;\n  --bs-popover-header-color: inherit;\n  --bs-popover-header-bg: var(--bs-secondary-bg);\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 1rem;\n  --bs-popover-body-color: var(--bs-body-color);\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: \"Inter\", sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #fff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n.carousel-dark .carousel-caption {\n  color: #000;\n}\n\n[data-bs-theme=dark] .carousel .carousel-control-prev-icon,\n[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,\n[data-bs-theme=dark].carousel .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {\n  color: #000;\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.25em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    --bs-spinner-animation-speed: 1.5s;\n  }\n}\n.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1.5rem;\n  --bs-offcanvas-padding-y: 1rem;\n  --bs-offcanvas-color: var(--bs-body-color);\n  --bs-offcanvas-bg: #fff;\n  --bs-offcanvas-border-width: var(--bs-border-width);\n  --bs-offcanvas-border-color: rgba(0, 0, 0, 0.1);\n  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);\n  --bs-offcanvas-transition: transform 0.3s ease-in-out;\n  --bs-offcanvas-title-line-height: 1.5;\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  transition: var(--bs-offcanvas-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.offcanvas.showing, .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.5;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n.offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));\n  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));\n  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--bs-offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-primary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: RGBA(12, 89, 189, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(12, 89, 189, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: RGBA(16, 20, 24, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(16, 20, 24, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-success:hover, .link-success:focus {\n  color: RGBA(10, 150, 108, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(10, 150, 108, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-info:hover, .link-info:focus {\n  color: RGBA(63, 126, 198, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(63, 126, 198, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: RGBA(249, 207, 88, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(249, 207, 88, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: RGBA(171, 33, 50, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(171, 33, 50, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light:hover, .link-light:focus {\n  color: RGBA(241, 243, 245, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(241, 243, 245, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: RGBA(16, 20, 24, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(16, 20, 24, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-body-emphasis:hover, .link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  backface-visibility: hidden;\n}\n.icon-link > .bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .icon-link > .bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 1rem !important;\n}\n\n.me-4 {\n  margin-right: 1.5rem !important;\n}\n\n.me-5 {\n  margin-right: 3rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 1rem !important;\n}\n\n.ms-4 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-5 {\n  margin-left: 3rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.m-n1 {\n  margin: -0.25rem !important;\n}\n\n.m-n2 {\n  margin: -0.5rem !important;\n}\n\n.m-n3 {\n  margin: -1rem !important;\n}\n\n.m-n4 {\n  margin: -1.5rem !important;\n}\n\n.m-n5 {\n  margin: -3rem !important;\n}\n\n.mx-n1 {\n  margin-right: -0.25rem !important;\n  margin-left: -0.25rem !important;\n}\n\n.mx-n2 {\n  margin-right: -0.5rem !important;\n  margin-left: -0.5rem !important;\n}\n\n.mx-n3 {\n  margin-right: -1rem !important;\n  margin-left: -1rem !important;\n}\n\n.mx-n4 {\n  margin-right: -1.5rem !important;\n  margin-left: -1.5rem !important;\n}\n\n.mx-n5 {\n  margin-right: -3rem !important;\n  margin-left: -3rem !important;\n}\n\n.my-n1 {\n  margin-top: -0.25rem !important;\n  margin-bottom: -0.25rem !important;\n}\n\n.my-n2 {\n  margin-top: -0.5rem !important;\n  margin-bottom: -0.5rem !important;\n}\n\n.my-n3 {\n  margin-top: -1rem !important;\n  margin-bottom: -1rem !important;\n}\n\n.my-n4 {\n  margin-top: -1.5rem !important;\n  margin-bottom: -1.5rem !important;\n}\n\n.my-n5 {\n  margin-top: -3rem !important;\n  margin-bottom: -3rem !important;\n}\n\n.mt-n1 {\n  margin-top: -0.25rem !important;\n}\n\n.mt-n2 {\n  margin-top: -0.5rem !important;\n}\n\n.mt-n3 {\n  margin-top: -1rem !important;\n}\n\n.mt-n4 {\n  margin-top: -1.5rem !important;\n}\n\n.mt-n5 {\n  margin-top: -3rem !important;\n}\n\n.me-n1 {\n  margin-right: -0.25rem !important;\n}\n\n.me-n2 {\n  margin-right: -0.5rem !important;\n}\n\n.me-n3 {\n  margin-right: -1rem !important;\n}\n\n.me-n4 {\n  margin-right: -1.5rem !important;\n}\n\n.me-n5 {\n  margin-right: -3rem !important;\n}\n\n.mb-n1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.mb-n2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.mb-n3 {\n  margin-bottom: -1rem !important;\n}\n\n.mb-n4 {\n  margin-bottom: -1.5rem !important;\n}\n\n.mb-n5 {\n  margin-bottom: -3rem !important;\n}\n\n.ms-n1 {\n  margin-left: -0.25rem !important;\n}\n\n.ms-n2 {\n  margin-left: -0.5rem !important;\n}\n\n.ms-n3 {\n  margin-left: -1rem !important;\n}\n\n.ms-n4 {\n  margin-left: -1.5rem !important;\n}\n\n.ms-n5 {\n  margin-left: -3rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 1rem !important;\n}\n\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 1rem !important;\n}\n\n.pe-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 1rem !important;\n}\n\n.ps-4 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-5 {\n  padding-left: 3rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 1rem !important;\n}\n\n.gap-4 {\n  gap: 1.5rem !important;\n}\n\n.gap-5 {\n  gap: 3rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 3rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 1rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 3rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.359375rem + 1.3125vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.3125rem + 0.75vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.2890625rem + 0.46875vw) !important;\n}\n\n.fs-4 {\n  font-size: calc(1.265625rem + 0.1875vw) !important;\n}\n\n.fs-5 {\n  font-size: 1.171875rem !important;\n}\n\n.fs-6 {\n  font-size: 0.9375rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 400 !important;\n}\n\n.fw-normal {\n  font-weight: 500 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-n1 {\n  z-index: -1 !important;\n}\n\n.z-0 {\n  z-index: 0 !important;\n}\n\n.z-1 {\n  z-index: 1 !important;\n}\n\n.z-2 {\n  z-index: 2 !important;\n}\n\n.z-3 {\n  z-index: 3 !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .m-sm-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-sm-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-sm-n3 {\n    margin: -1rem !important;\n  }\n  .m-sm-n4 {\n    margin: -1.5rem !important;\n  }\n  .m-sm-n5 {\n    margin: -3rem !important;\n  }\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-sm-n3 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-sm-n4 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-sm-n5 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .my-sm-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-sm-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-sm-n3 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-sm-n4 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-sm-n5 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .mt-sm-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-sm-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-sm-n3 {\n    margin-top: -1rem !important;\n  }\n  .mt-sm-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-sm-n5 {\n    margin-top: -3rem !important;\n  }\n  .me-sm-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-sm-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-sm-n3 {\n    margin-right: -1rem !important;\n  }\n  .me-sm-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .me-sm-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-sm-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-sm-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-sm-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-sm-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-sm-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ms-sm-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-sm-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-sm-n3 {\n    margin-left: -1rem !important;\n  }\n  .ms-sm-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-sm-n5 {\n    margin-left: -3rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-sm-3 {\n    gap: 1rem !important;\n  }\n  .gap-sm-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-sm-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-sm-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-sm-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-sm-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-sm-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-sm-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-sm-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-sm-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-sm-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-sm-5 {\n    column-gap: 3rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-md-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-md-3 {\n    margin-right: 1rem !important;\n  }\n  .me-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-5 {\n    margin-right: 3rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .m-md-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-md-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-md-n3 {\n    margin: -1rem !important;\n  }\n  .m-md-n4 {\n    margin: -1.5rem !important;\n  }\n  .m-md-n5 {\n    margin: -3rem !important;\n  }\n  .mx-md-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-md-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-md-n3 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-md-n4 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-md-n5 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .my-md-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-md-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-md-n3 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-md-n4 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-md-n5 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .mt-md-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-md-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-md-n3 {\n    margin-top: -1rem !important;\n  }\n  .mt-md-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-md-n5 {\n    margin-top: -3rem !important;\n  }\n  .me-md-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-md-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-md-n3 {\n    margin-right: -1rem !important;\n  }\n  .me-md-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .me-md-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-md-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-md-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-md-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-md-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-md-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ms-md-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-md-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-md-n3 {\n    margin-left: -1rem !important;\n  }\n  .ms-md-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-md-n5 {\n    margin-left: -3rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-md-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-md-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-md-3 {\n    gap: 1rem !important;\n  }\n  .gap-md-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-md-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-md-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-md-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-md-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-md-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-md-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-md-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-md-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-md-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-md-5 {\n    column-gap: 3rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .m-lg-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-lg-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-lg-n3 {\n    margin: -1rem !important;\n  }\n  .m-lg-n4 {\n    margin: -1.5rem !important;\n  }\n  .m-lg-n5 {\n    margin: -3rem !important;\n  }\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-lg-n3 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-lg-n4 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-lg-n5 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .my-lg-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-lg-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-lg-n3 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-lg-n4 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-lg-n5 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .mt-lg-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-lg-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-lg-n3 {\n    margin-top: -1rem !important;\n  }\n  .mt-lg-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-lg-n5 {\n    margin-top: -3rem !important;\n  }\n  .me-lg-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-lg-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-lg-n3 {\n    margin-right: -1rem !important;\n  }\n  .me-lg-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .me-lg-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-lg-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-lg-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-lg-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-lg-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-lg-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ms-lg-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-lg-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-lg-n3 {\n    margin-left: -1rem !important;\n  }\n  .ms-lg-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-lg-n5 {\n    margin-left: -3rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-lg-3 {\n    gap: 1rem !important;\n  }\n  .gap-lg-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-lg-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-lg-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-lg-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-lg-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-lg-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-lg-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-lg-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-lg-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-lg-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-lg-5 {\n    column-gap: 3rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .m-xl-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-xl-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-xl-n3 {\n    margin: -1rem !important;\n  }\n  .m-xl-n4 {\n    margin: -1.5rem !important;\n  }\n  .m-xl-n5 {\n    margin: -3rem !important;\n  }\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-xl-n3 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-xl-n4 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xl-n5 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .my-xl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-xl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-xl-n3 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-xl-n4 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xl-n5 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .mt-xl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-xl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-xl-n3 {\n    margin-top: -1rem !important;\n  }\n  .mt-xl-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xl-n5 {\n    margin-top: -3rem !important;\n  }\n  .me-xl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-xl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-xl-n3 {\n    margin-right: -1rem !important;\n  }\n  .me-xl-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xl-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-xl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-xl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-xl-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-xl-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xl-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ms-xl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-xl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-xl-n3 {\n    margin-left: -1rem !important;\n  }\n  .ms-xl-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xl-n5 {\n    margin-left: -3rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xl-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xl-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xl-5 {\n    column-gap: 3rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xxl-3 {\n    margin: 1rem !important;\n  }\n  .m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-5 {\n    margin: 3rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .m-xxl-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-xxl-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-xxl-n3 {\n    margin: -1rem !important;\n  }\n  .m-xxl-n4 {\n    margin: -1.5rem !important;\n  }\n  .m-xxl-n5 {\n    margin: -3rem !important;\n  }\n  .mx-xxl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-xxl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-xxl-n3 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-xxl-n4 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xxl-n5 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .my-xxl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-xxl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-xxl-n3 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-xxl-n4 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xxl-n5 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .mt-xxl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-xxl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-xxl-n3 {\n    margin-top: -1rem !important;\n  }\n  .mt-xxl-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xxl-n5 {\n    margin-top: -3rem !important;\n  }\n  .me-xxl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-xxl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-xxl-n3 {\n    margin-right: -1rem !important;\n  }\n  .me-xxl-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xxl-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-xxl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-xxl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-xxl-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-xxl-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xxl-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ms-xxl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-xxl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-xxl-n3 {\n    margin-left: -1rem !important;\n  }\n  .ms-xxl-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xxl-n5 {\n    margin-left: -3rem !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xxl-3 {\n    padding: 1rem !important;\n  }\n  .p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-5 {\n    padding: 3rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xxl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xxl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xxl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xxl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xxl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xxl-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xxl-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxl-5 {\n    column-gap: 3rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.34375rem !important;\n  }\n  .fs-2 {\n    font-size: 1.875rem !important;\n  }\n  .fs-3 {\n    font-size: 1.640625rem !important;\n  }\n  .fs-4 {\n    font-size: 1.40625rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\n.w-20px {\n  width: 20px !important;\n}\n\n.w-30px {\n  width: 30px !important;\n}\n\n.w-40px {\n  width: 40px !important;\n}\n\n.w-50px {\n  width: 50px !important;\n}\n\n.w-60px {\n  width: 60px !important;\n}\n\n.w-70px {\n  width: 70px !important;\n}\n\n.w-80px {\n  width: 80px !important;\n}\n\n.w-90px {\n  width: 90px !important;\n}\n\n.w-100px {\n  width: 100px !important;\n}\n\n.w-150px {\n  width: 150px !important;\n}\n\n.w-200px {\n  width: 200px !important;\n}\n\n.w-300px {\n  width: 300px !important;\n}\n\n.w-400px {\n  width: 400px !important;\n}\n\n.h-20px {\n  height: 20px !important;\n}\n\n.h-30px {\n  height: 30px !important;\n}\n\n.h-40px {\n  height: 40px !important;\n}\n\n.h-50px {\n  height: 50px !important;\n}\n\n.h-60px {\n  height: 60px !important;\n}\n\n.h-70px {\n  height: 70px !important;\n}\n\n.h-80px {\n  height: 80px !important;\n}\n\n.h-90px {\n  height: 90px !important;\n}\n\n.h-100px {\n  height: 100px !important;\n}\n\n.h-150px {\n  height: 150px !important;\n}\n\n.h-200px {\n  height: 200px !important;\n}\n\n.h-300px {\n  height: 300px !important;\n}\n\n.h-400px {\n  height: 400px !important;\n}\n\n.fill-primary {\n  fill: #0f6fec !important;\n}\n\n.fill-secondary {\n  fill: #14191e !important;\n}\n\n.fill-success {\n  fill: #0cbc87 !important;\n}\n\n.fill-info {\n  fill: #4f9ef8 !important;\n}\n\n.fill-warning {\n  fill: #f7c32e !important;\n}\n\n.fill-danger {\n  fill: #d6293e !important;\n}\n\n.fill-light {\n  fill: #eef0f2 !important;\n}\n\n.fill-dark {\n  fill: #14191e !important;\n}\n\n.fill-white {\n  fill: #fff !important;\n}\n\n.z-index-0 {\n  z-index: 0 !important;\n}\n\n.z-index-1 {\n  z-index: 1 !important;\n}\n\n.z-index-9 {\n  z-index: 9 !important;\n}\n\n.z-index-99 {\n  z-index: 99 !important;\n}\n\n.z-index-n9 {\n  z-index: -9 !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-1 {\n  opacity: 0.1 !important;\n}\n\n.opacity-2 {\n  opacity: 0.2 !important;\n}\n\n.opacity-3 {\n  opacity: 0.3 !important;\n}\n\n.opacity-4 {\n  opacity: 0.4 !important;\n}\n\n.opacity-5 {\n  opacity: 0.5 !important;\n}\n\n.opacity-6 {\n  opacity: 0.6 !important;\n}\n\n.opacity-7 {\n  opacity: 0.7 !important;\n}\n\n.opacity-8 {\n  opacity: 0.8 !important;\n}\n\n.opacity-9 {\n  opacity: 0.9 !important;\n}\n\n.blur-1 {\n  filter: blur(0.2rem) !important;\n}\n\n.blur-2 {\n  filter: blur(0.4rem) !important;\n}\n\n.blur-3 {\n  filter: blur(0.6rem) !important;\n}\n\n.blur-4 {\n  filter: blur(0.8rem) !important;\n}\n\n.blur-5 {\n  filter: blur(1rem) !important;\n}\n\n.blur-6 {\n  filter: blur(1.2rem) !important;\n}\n\n.blur-7 {\n  filter: blur(2rem) !important;\n}\n\n.blur-8 {\n  filter: blur(5rem) !important;\n}\n\n.blur-9 {\n  filter: blur(9rem) !important;\n}\n\n.border-dashed {\n  border-style: dashed !important;\n}\n\n.rounded-start-top-0 {\n  border-top-left-radius: 0 !important;\n}\n\n.accordion.accordion-icon .accordion-item {\n  box-shadow: none;\n  border-radius: var(--bs-border-radius);\n  border: 1px solid var(--bs-border-color);\n}\n.accordion.accordion-icon .accordion-header {\n  position: relative;\n}\n.accordion.accordion-icon .accordion-header .accordion-button {\n  background: transparent;\n  font-size: inherit;\n  transition: none;\n  box-shadow: none !important;\n}\n.accordion.accordion-icon .accordion-header .accordion-button[aria-expanded=true] {\n  border-bottom: 1px solid var(--bs-border-color);\n}\n.accordion.accordion-icon .accordion-header .accordion-button:after {\n  content: \"\";\n  background: var(--bs-gray-800) !important;\n  width: 10px;\n  height: 2px;\n  display: block;\n  position: absolute;\n  top: 47%;\n  right: 20px;\n  transform: translateY(-50%);\n  transition: all 0.3s ease-in-out;\n  transform: rotateZ(0deg);\n  z-index: 9;\n}\n.accordion.accordion-icon .accordion-header .accordion-button:before {\n  content: \"\";\n  background: var(--bs-gray-800) !important;\n  width: 10px;\n  height: 2px;\n  display: block;\n  position: absolute;\n  top: 47%;\n  right: 20px;\n  transform: translateY(-50%);\n  transition: all 0.3s ease-in-out;\n  transform: rotateZ(0deg);\n  z-index: 9;\n}\n.accordion.accordion-icon .accordion-header .accordion-button[aria-expanded=false]:after {\n  transform: rotateZ(90deg);\n}\n.accordion.accordion-icon .accordion-header .accordion-button[aria-expanded=true]:before {\n  transform: rotateZ(0deg);\n}\n.accordion.accordion-icon .accordion-collapse {\n  border: none;\n}\n.accordion.accordion-icon .accordion-body {\n  padding: 1rem;\n}\n\n.breadcrumb-item {\n  font-size: 0.8125rem;\n}\n.breadcrumb-item a {\n  color: #676a79;\n}\n.breadcrumb-item a:hover {\n  color: var(--bs-primary);\n}\n\n.breadcrumb.breadcrumb-dots .breadcrumb-item + .breadcrumb-item::before {\n  content: \"•\";\n  font-size: 22px;\n  line-height: 0;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.btn-link {\n  padding: 0;\n}\n\n.btn {\n  outline: 0;\n}\n\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  border-color: transparent !important;\n}\n\n.input-group .btn {\n  margin-bottom: 0;\n}\n\n.btn-xs {\n  padding: 0.4rem 0.6rem;\n  font-size: 0.6rem;\n  line-height: 1.2;\n  border-radius: 0.2rem;\n}\n\n.btn-light.active, .btn-light:active, .btn-light:focus, .btn-light:hover {\n  background: var(--bs-gray-400);\n  color: var(--bs-gray-900);\n  border: 1px solid transparent !important;\n}\n\n.btn-white {\n  background: var(--bs-white);\n  color: #14191e;\n}\n.btn-white.active, .btn-white:active, .btn-white:focus, .btn-white:hover {\n  background: var(--bs-white);\n  color: #14191e;\n}\n\n.btn-outline-light {\n  background: transparent;\n  border-color: var(--bs-gray-400);\n  color: var(--bs-body-color);\n}\n\n.btn-outline-light:hover,\n.btn-outline-light:focus,\n.btn-outline-light:active,\n.btn-check:checked + .btn-outline-light {\n  background: var(--bs-gray-400);\n  border-color: var(--bs-gray-400);\n  color: var(--bs-gray-800);\n}\n\n.btn-primary-soft {\n  color: #0f6fec;\n  background-color: rgba(15, 111, 236, 0.1);\n}\n.btn-primary-soft:active, .btn-primary-soft:hover, .btn-primary-soft:focus {\n  color: #fff !important;\n  background-color: #0f6fec !important;\n  border-color: #0f6fec !important;\n}\n\n.btn-secondary-soft {\n  color: #14191e;\n  background-color: rgba(20, 25, 30, 0.1);\n}\n.btn-secondary-soft:active, .btn-secondary-soft:hover, .btn-secondary-soft:focus {\n  color: #fff !important;\n  background-color: #14191e !important;\n  border-color: #14191e !important;\n}\n\n.btn-success-soft {\n  color: #0cbc87;\n  background-color: rgba(12, 188, 135, 0.1);\n}\n.btn-success-soft:active, .btn-success-soft:hover, .btn-success-soft:focus {\n  color: #fff !important;\n  background-color: #0cbc87 !important;\n  border-color: #0cbc87 !important;\n}\n\n.btn-info-soft {\n  color: #4f9ef8;\n  background-color: rgba(79, 158, 248, 0.1);\n}\n.btn-info-soft:active, .btn-info-soft:hover, .btn-info-soft:focus {\n  color: #fff !important;\n  background-color: #4f9ef8 !important;\n  border-color: #4f9ef8 !important;\n}\n\n.btn-warning-soft {\n  color: #f7c32e;\n  background-color: rgba(247, 195, 46, 0.1);\n}\n.btn-warning-soft:active, .btn-warning-soft:hover, .btn-warning-soft:focus {\n  color: #000 !important;\n  background-color: #f7c32e !important;\n  border-color: #f7c32e !important;\n}\n\n.btn-danger-soft {\n  color: #d6293e;\n  background-color: rgba(214, 41, 62, 0.1);\n}\n.btn-danger-soft:active, .btn-danger-soft:hover, .btn-danger-soft:focus {\n  color: #fff !important;\n  background-color: #d6293e !important;\n  border-color: #d6293e !important;\n}\n\n.btn-light-soft {\n  color: #eef0f2;\n  background-color: rgba(238, 240, 242, 0.1);\n}\n.btn-light-soft:active, .btn-light-soft:hover, .btn-light-soft:focus {\n  color: #000 !important;\n  background-color: #eef0f2 !important;\n  border-color: #eef0f2 !important;\n}\n\n.btn-dark-soft {\n  color: #14191e;\n  background-color: rgba(20, 25, 30, 0.1);\n}\n.btn-dark-soft:active, .btn-dark-soft:hover, .btn-dark-soft:focus {\n  color: #fff !important;\n  background-color: #14191e !important;\n  border-color: #14191e !important;\n}\n\n.btn-primary-soft-hover:hover:hover {\n  color: #0f6fec !important;\n  background-color: rgba(15, 111, 236, 0.1);\n}\n\n.btn-secondary-soft-hover:hover:hover {\n  color: #14191e !important;\n  background-color: rgba(20, 25, 30, 0.1);\n}\n\n.btn-success-soft-hover:hover:hover {\n  color: #0cbc87 !important;\n  background-color: rgba(12, 188, 135, 0.1);\n}\n\n.btn-info-soft-hover:hover:hover {\n  color: #4f9ef8 !important;\n  background-color: rgba(79, 158, 248, 0.1);\n}\n\n.btn-warning-soft-hover:hover:hover {\n  color: #f7c32e !important;\n  background-color: rgba(247, 195, 46, 0.1);\n}\n\n.btn-danger-soft-hover:hover:hover {\n  color: #d6293e !important;\n  background-color: rgba(214, 41, 62, 0.1);\n}\n\n.btn-light-soft-hover:hover:hover {\n  color: #eef0f2 !important;\n  background-color: rgba(238, 240, 242, 0.1);\n}\n\n.btn-dark-soft-hover:hover:hover {\n  color: #14191e !important;\n  background-color: rgba(20, 25, 30, 0.1);\n}\n\n.btn-dashed {\n  background: linear-gradient(90deg, var(--bs-border-color) 50%, transparent 50%), linear-gradient(0deg, var(--bs-border-color) 50%, transparent 50%), linear-gradient(90deg, var(--bs-border-color) 50%, transparent 50%), linear-gradient(0deg, var(--bs-border-color) 50%, transparent 50%);\n  background-repeat: repeat-x, repeat-y, repeat-x, repeat-y;\n  background-size: 10px 2px, 2px 10px, 10px 2px, 2px 10px;\n  background-position: left top, right top, left bottom, left top;\n  padding: 0.5rem, 1rem;\n}\n.btn-dashed:hover {\n  animation: border-dance 4s infinite linear;\n}\n\n@keyframes border-dance {\n  0% {\n    background-position: left top, right top, right bottom, left bottom;\n  }\n  100% {\n    background-position: right top, right bottom, left bottom, left top;\n  }\n}\n.btn-loader {\n  position: relative;\n  text-align: center;\n}\n.btn-loader .load-icon {\n  display: none;\n  margin: 0 auto;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.btn-loader .load-text {\n  opacity: 1;\n  visibility: visible;\n}\n\n.btn-loader.active .load-text {\n  opacity: 0;\n  visibility: hidden;\n}\n.btn-loader.active .load-icon {\n  display: block;\n}\n\n.spinner-dots {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.spinner-dot {\n  background-color: var(--bs-gray-500);\n  display: inline-block;\n  height: 4px;\n  margin: 2px;\n  border-radius: 50%;\n  width: 4px;\n}\n\n@keyframes dot {\n  0% {\n    background-color: var(--bs-gray-500);\n    transform: scale(1);\n  }\n  50% {\n    background-color: var(--bs-gray-600);\n    transform: scale(1.3);\n  }\n  100% {\n    background-color: var(--bs-gray-500);\n    transform: scale(1);\n  }\n}\n.btn-link-loader.active .spinner-dots .spinner-dot {\n  animation: dot ease-in-out 1s infinite;\n}\n.btn-link-loader.active .spinner-dots .spinner-dot:nth-of-type(2) {\n  animation-delay: 0.2s;\n}\n.btn-link-loader.active .spinner-dots .spinner-dot:nth-of-type(3) {\n  animation-delay: 0.3s;\n}\n\n.card.overflow-hidden {\n  will-change: transform;\n}\n\n.card .card-image {\n  position: relative;\n}\n.card .card-image .card-element-hover {\n  visibility: hidden;\n  margin-top: 20px;\n  opacity: 0;\n  transition: all 0.3s ease-in-out;\n  z-index: 9;\n}\n.card:hover .card-image .card-element-hover {\n  visibility: visible;\n  margin-top: 0px;\n  opacity: 1;\n}\n\n.card.card-overlay-bottom {\n  overflow: hidden;\n}\n.card.card-overlay-bottom:before {\n  content: \"\";\n  position: absolute;\n  height: 50%;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(transparent), to(black));\n  background-image: linear-gradient(180deg, transparent, black);\n  z-index: 1;\n}\n.card .card-img-overlay {\n  z-index: 2;\n}\n\n.dropdown-menu {\n  box-shadow: 0px 20px 30px rgba(83, 88, 93, 0.1), 0px 0px 30px rgba(83, 88, 93, 0.2);\n}\n\n.dropdown-item.active {\n  color: var(--bs-primary);\n}\n\n.dropdown-toggle:after {\n  content: \"\\f078\";\n  font-family: \"Font Awesome 6 Free\";\n  font-size: 0.5rem;\n  margin-left: 0.35rem;\n  font-weight: 900;\n  vertical-align: middle;\n  border: none;\n}\n\n.dropup .dropdown-toggle:after {\n  content: \"\\f077\";\n  font-family: \"Font Awesome 6 Free\";\n  font-size: 0.7rem;\n  margin-left: 0.35rem;\n  font-weight: 900;\n  vertical-align: middle;\n  border: none;\n}\n\n.dropdown-menu .dropdown-toggle:after {\n  position: absolute;\n  right: 25px;\n  top: 10px;\n}\n.dropdown-menu .dropdown-toggle:before {\n  position: absolute;\n  right: 25px;\n  top: 10px;\n}\n\n.dropdown-menu-size-md {\n  min-width: 22rem;\n}\n\n@media (max-width: 575.98px) {\n  .dropdown-menu-size-md {\n    min-width: 16rem;\n  }\n}\n.list-group-borderless .list-group-item {\n  border: none;\n  padding: 0.425rem 0;\n}\n.list-group-borderless a.list-group-item:hover {\n  background-color: transparent;\n  color: var(--bs-primary);\n}\n\n.nav .nav-item .nav-link {\n  background: transparent;\n  border: 1px solid transparent;\n}\n.nav .nav-item .nav-link.active {\n  color: var(--bs-primary);\n}\n\n.nav-pills .nav-link {\n  cursor: pointer;\n  margin-bottom: 15px;\n  padding: 0.5rem 1rem;\n}\n\n.nav-pills.nav-pills-light .nav-link:hover {\n  background-color: var(--bs-light);\n}\n.nav-pills.nav-pills-light .nav-link.active {\n  background-color: var(--bs-light);\n}\n\n.nav-pills-soft .nav-link:hover {\n  border: 1px solid transparent;\n}\n\n.nav-pills-soft .nav-link.active,\n.nav-pills-soft .show > .nav-link {\n  background-color: rgba(var(--bs-primary-rgb), 0.1);\n  border: 1px solid transparent;\n}\n\n.nav.nav-bottom-line {\n  border-bottom: solid 1px var(--bs-border-color);\n}\n.nav.nav-bottom-line .nav-link {\n  border: transparent;\n  font-weight: 600;\n  padding: 0.75rem 0.975rem;\n}\n.nav.nav-bottom-line .nav-item:first-child .nav-link {\n  padding-left: 0;\n}\n.nav.nav-bottom-line .nav-link {\n  background: transparent;\n  border-bottom: 3px solid transparent;\n}\n.nav.nav-bottom-line .nav-link.active {\n  background: transparent;\n  color: var(--bs-primary);\n  border-bottom: 3px solid var(--bs-primary);\n}\n.nav.nav-bottom-line .nav-item {\n  margin-bottom: -2px;\n}\n\n.nav.flex-column:not(.nav-pills) .nav-link {\n  padding-left: 0;\n  padding-top: 0.3rem;\n  padding-bottom: 0.3rem;\n}\n\n.tab-content {\n  padding: 25px 0;\n  margin-bottom: 20px;\n}\n\n.nav-tabs .nav-link {\n  padding: 0.5rem 1rem;\n}\n\n.nav-tabs-white {\n  border-radius: 0.4rem;\n}\n.nav-tabs-white .nav-item .nav-link {\n  transition: all 0.3s ease-in-out;\n  border: 0;\n  border-radius: 0.4rem;\n  margin-right: 4px;\n  font-weight: 600;\n}\n.nav-tabs-white .nav-item:last-child .nav-link {\n  margin-right: 0;\n}\n.nav-tabs-white .nav-item .nav-link.active, .nav-tabs-white .nav-item .nav-link:hover {\n  background: #fff;\n  color: var(--bs-primary);\n}\n\n.nav.nav-divider .nav-item + .nav-item:before {\n  content: \"•\";\n  color: inherit;\n  padding-left: 0.6rem;\n  padding-right: 0.6rem;\n  opacity: 0.8;\n}\n.nav.nav-divider .nav-item {\n  display: flex;\n  align-items: center;\n}\n.nav.nav-divider .nav-link {\n  padding: 0;\n}\n\n.nav-link-secondary .nav-item .nav-link {\n  color: var(--bs-gray-800);\n}\n.nav-link-secondary .nav-item .nav-link:hover, .nav-link-secondary .nav-item .nav-link.active {\n  color: var(--bs-primary);\n}\n\n.nav-stack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n  gap: 0.7rem;\n}\n.nav-stack .nav-link {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.nav .nav-item .nav-link .nav-icon {\n  background: var(--bs-light);\n  height: 2.1rem;\n  width: 2.1rem;\n  font-size: 1.1em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.3s ease-in-out;\n}\n.nav .nav-item .nav-link:hover .nav-icon {\n  background: var(--bs-primary);\n  color: var(--bs-white);\n}\n\n@media (min-width: 992px) {\n  .nav-sidenav {\n    width: 5rem;\n    transition: width 0.3s;\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 9;\n    margin-top: 56px;\n  }\n  .nav-sidenav .nav-link {\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    padding-left: 0;\n  }\n  .nav-sidenav .nav-text {\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.2s ease-in-out;\n  }\n  .sidebar-start-enabled .nav-sidenav {\n    width: 270px;\n  }\n  .sidebar-start-enabled .nav-sidenav .nav-text {\n    display: flex;\n    opacity: 1;\n    visibility: visible;\n    padding-left: 10px;\n  }\n}\n@media (max-width: 991.98px) {\n  .nav-sidenav {\n    width: 270px;\n    left: 0;\n    transition: transform 0.3s ease-in-out;\n    position: fixed;\n    top: 0;\n    z-index: 9;\n    margin-top: 56px;\n    transform: translateX(-100%);\n  }\n  .nav-sidenav .nav-text {\n    padding-left: 10px;\n  }\n  .sidebar-start-enabled .nav-sidenav {\n    transform: none;\n  }\n}\n@media (min-width: 992px) {\n  .sidebar-end {\n    width: 5rem;\n    transition: width 0.3s;\n    position: fixed;\n    right: 0;\n    top: 0;\n    margin-top: 56px;\n    z-index: 9;\n  }\n  .sidebar-end .sidebar-end-alignment {\n    align-items: center;\n  }\n  .sidebar-end .nav-link {\n    display: flex;\n    align-items: center;\n  }\n  .sidebar-end .contact-name, .sidebar-end .contact-search, .sidebar-end .contact-title, .sidebar-end .contact-status {\n    opacity: 0;\n    display: none;\n    visibility: hidden;\n    transition: all 0.5s ease-in-out;\n    white-space: nowrap;\n  }\n  .sidebar-end-enabled .sidebar-end {\n    width: 270px;\n  }\n  .sidebar-end-enabled .sidebar-end .sidebar-end-alignment {\n    align-items: inherit;\n  }\n  .sidebar-end-enabled .sidebar-end .contact-name, .sidebar-end-enabled .sidebar-end .contact-search, .sidebar-end-enabled .sidebar-end .contact-title, .sidebar-end-enabled .sidebar-end .contact-status {\n    display: flex;\n    opacity: 1;\n    visibility: visible;\n    transition: all 0.2s ease-in-out;\n  }\n}\n@media (max-width: 991.98px) {\n  .sidebar-end {\n    width: 270px;\n    right: 0;\n    transition: transform 0.3s ease-in-out;\n    position: fixed;\n    top: 0;\n    z-index: 9;\n    transform: translateX(100%);\n  }\n  .sidebar-end-enabled .sidebar-end {\n    transform: none;\n  }\n}\nheader {\n  height: 56px;\n}\n\n.navbar-nav .nav-link {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  text-transform: capitalize;\n  line-height: 56px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.navbar-nav .nav-link .nav-icon {\n  margin-right: 0.3rem;\n}\n.navbar-nav .nav-item:last-child .nav-link {\n  padding-right: 0;\n}\n\n.offcanvas .navbar-nav .nav-link {\n  line-height: inherit;\n  padding: 0.25rem 0.75rem;\n}\n\n.navbar-toggler {\n  margin-bottom: 0;\n  border: 0;\n  background-color: var(--bs-light);\n}\n\n.navbar-transparent {\n  background: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.navbar-dark .navbar-top span:not(.dropdown-item-text) {\n  color: #fff;\n}\n.navbar-dark .navbar-top a:not(.dropdown-item) {\n  color: #fff;\n}\n.navbar-dark .navbar-top a:not(.dropdown-item):hover {\n  color: var(--bs-primary);\n}\n\n.navbar-dark .nav .nav-link {\n  color: #fff;\n}\n.navbar-dark .nav .nav-link:hover {\n  color: var(--bs-primary);\n}\n\n@media (max-width: 991.98px) {\n  .navbar-dark .navbar-nav .nav-link {\n    color: var(--bs-gray-600);\n  }\n}\n.navbar-brand {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.navbar-brand .navbar-brand-item {\n  height: 36px;\n  display: block;\n  width: auto;\n}\n\n@media (max-width: 991.98px) {\n  .navbar-brand {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n  .navbar-brand .navbar-brand-item {\n    height: 36px;\n  }\n}\n.navbar .dropdown-menu .dropdown-submenu.dropend .dropdown-toggle:after {\n  content: \"\\f00d\";\n  font-family: \"Font Awesome 6 Free\";\n  font-size: 10px;\n  top: 10px;\n  transform: rotate(45deg);\n  transition: all 0.3s ease-in-out;\n  border: none !important;\n  margin: 0;\n}\n\n@media (hover: hover) {\n  .navbar .dropdown-menu .dropdown-submenu.dropend:hover > .dropdown-toggle:after {\n    transform: rotate(90deg);\n  }\n}\n.navbar .dropdown-menu .dropdown-submenu.dropend .dropdown-opened.dropdown-toggle:after {\n  transform: rotate(90deg);\n}\n\n.navbar .dropdown-menu .dropdown-submenu.dropstart .dropdown-toggle:before {\n  content: \"\\f00d\";\n  font-family: \"Font Awesome 6 Free\";\n  font-size: 10px;\n  top: 8px;\n  transform: rotate(45deg);\n  transition: all 0.3s ease-in-out;\n  border: none !important;\n  margin: 0;\n  font-weight: 900;\n}\n\n.navbar .dropdown-menu .dropdown-submenu.dropstart:hover > .dropdown-toggle:before {\n  transform: rotate(90deg);\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    top: 120%;\n    visibility: hidden;\n    opacity: 0;\n    display: block;\n    transition: all 0.1s ease-in-out;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown:hover > .dropdown-menu {\n    top: 100%;\n    visibility: visible;\n    opacity: 1;\n    transition: all 0.3s ease-in-out;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-submenu:hover > .dropdown-menu {\n    top: 0;\n    visibility: visible;\n    opacity: 1;\n    transition: all 0.3s ease-in-out;\n  }\n  .navbar-expand-sm .dropdown-submenu {\n    position: relative;\n  }\n}\n@media (max-width: 575.98px) {\n  .navbar-expand-sm .navbar-collapse {\n    box-shadow: 0px 10px 30px rgba(83, 88, 93, 0.2);\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 100%;\n    background: #fff;\n    border-top: 1px solid var(--bs-border-color);\n  }\n  .navbar-expand-sm .navbar-collapse .navbar-nav .dropdown-toggle::after {\n    position: absolute;\n    right: 25px;\n  }\n  .navbar-expand-sm .navbar-collapse .navbar-nav .dropdown-menu {\n    box-shadow: none;\n  }\n  .navbar-expand-sm .navbar-collapse .navbar-nav .dropdown-menu:before {\n    content: none;\n  }\n  .navbar-expand-sm .navbar-collapse .navbar-nav .dropdown-submenu .dropdown-menu {\n    padding-left: 20px;\n    padding-bottom: 0px;\n  }\n  .navbar-expand-sm .navbar-collapse .navbar-nav > .nav-item {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n    padding: 5px 30px;\n    position: relative;\n  }\n  .navbar-expand-sm .navbar-collapse .navbar-nav > .nav-item .nav-link {\n    line-height: 40px;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n  }\n  .navbar-expand-sm .navbar-nav .nav-item > .dropdown-menu {\n    background: rgba(103, 106, 121, 0.04);\n    padding: 20px 0px;\n    margin: 10px 0;\n  }\n  .navbar-expand-sm .navbar-nav .nav-item > .dropdown-menu .dropdown-submenu .dropdown-menu {\n    background: rgba(103, 106, 121, 0.06);\n    padding: 10px 0px !important;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    top: 120%;\n    visibility: hidden;\n    opacity: 0;\n    display: block;\n    transition: all 0.1s ease-in-out;\n  }\n  .navbar-expand-md .navbar-nav .dropdown:hover > .dropdown-menu {\n    top: 100%;\n    visibility: visible;\n    opacity: 1;\n    transition: all 0.3s ease-in-out;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-submenu:hover > .dropdown-menu {\n    top: 0;\n    visibility: visible;\n    opacity: 1;\n    transition: all 0.3s ease-in-out;\n  }\n  .navbar-expand-md .dropdown-submenu {\n    position: relative;\n  }\n}\n@media (max-width: 767.98px) {\n  .navbar-expand-md .navbar-collapse {\n    box-shadow: 0px 10px 30px rgba(83, 88, 93, 0.2);\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 100%;\n    background: #fff;\n    border-top: 1px solid var(--bs-border-color);\n  }\n  .navbar-expand-md .navbar-collapse .navbar-nav .dropdown-toggle::after {\n    position: absolute;\n    right: 25px;\n  }\n  .navbar-expand-md .navbar-collapse .navbar-nav .dropdown-menu {\n    box-shadow: none;\n  }\n  .navbar-expand-md .navbar-collapse .navbar-nav .dropdown-menu:before {\n    content: none;\n  }\n  .navbar-expand-md .navbar-collapse .navbar-nav .dropdown-submenu .dropdown-menu {\n    padding-left: 20px;\n    padding-bottom: 0px;\n  }\n  .navbar-expand-md .navbar-collapse .navbar-nav > .nav-item {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n    padding: 5px 30px;\n    position: relative;\n  }\n  .navbar-expand-md .navbar-collapse .navbar-nav > .nav-item .nav-link {\n    line-height: 40px;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n  }\n  .navbar-expand-md .navbar-nav .nav-item > .dropdown-menu {\n    background: rgba(103, 106, 121, 0.04);\n    padding: 20px 0px;\n    margin: 10px 0;\n  }\n  .navbar-expand-md .navbar-nav .nav-item > .dropdown-menu .dropdown-submenu .dropdown-menu {\n    background: rgba(103, 106, 121, 0.06);\n    padding: 10px 0px !important;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    top: 120%;\n    visibility: hidden;\n    opacity: 0;\n    display: block;\n    transition: all 0.1s ease-in-out;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown:hover > .dropdown-menu {\n    top: 100%;\n    visibility: visible;\n    opacity: 1;\n    transition: all 0.3s ease-in-out;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-submenu:hover > .dropdown-menu {\n    top: 0;\n    visibility: visible;\n    opacity: 1;\n    transition: all 0.3s ease-in-out;\n  }\n  .navbar-expand-lg .dropdown-submenu {\n    position: relative;\n  }\n}\n@media (max-width: 991.98px) {\n  .navbar-expand-lg .navbar-collapse {\n    box-shadow: 0px 10px 30px rgba(83, 88, 93, 0.2);\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 100%;\n    background: #fff;\n    border-top: 1px solid var(--bs-border-color);\n  }\n  .navbar-expand-lg .navbar-collapse .navbar-nav .dropdown-toggle::after {\n    position: absolute;\n    right: 25px;\n  }\n  .navbar-expand-lg .navbar-collapse .navbar-nav .dropdown-menu {\n    box-shadow: none;\n  }\n  .navbar-expand-lg .navbar-collapse .navbar-nav .dropdown-menu:before {\n    content: none;\n  }\n  .navbar-expand-lg .navbar-collapse .navbar-nav .dropdown-submenu .dropdown-menu {\n    padding-left: 20px;\n    padding-bottom: 0px;\n  }\n  .navbar-expand-lg .navbar-collapse .navbar-nav > .nav-item {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n    padding: 5px 30px;\n    position: relative;\n  }\n  .navbar-expand-lg .navbar-collapse .navbar-nav > .nav-item .nav-link {\n    line-height: 40px;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n  }\n  .navbar-expand-lg .navbar-nav .nav-item > .dropdown-menu {\n    background: rgba(103, 106, 121, 0.04);\n    padding: 20px 0px;\n    margin: 10px 0;\n  }\n  .navbar-expand-lg .navbar-nav .nav-item > .dropdown-menu .dropdown-submenu .dropdown-menu {\n    background: rgba(103, 106, 121, 0.06);\n    padding: 10px 0px !important;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    top: 120%;\n    visibility: hidden;\n    opacity: 0;\n    display: block;\n    transition: all 0.1s ease-in-out;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown:hover > .dropdown-menu {\n    top: 100%;\n    visibility: visible;\n    opacity: 1;\n    transition: all 0.3s ease-in-out;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-submenu:hover > .dropdown-menu {\n    top: 0;\n    visibility: visible;\n    opacity: 1;\n    transition: all 0.3s ease-in-out;\n  }\n  .navbar-expand-xl .dropdown-submenu {\n    position: relative;\n  }\n}\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl .navbar-collapse {\n    box-shadow: 0px 10px 30px rgba(83, 88, 93, 0.2);\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 100%;\n    background: #fff;\n    border-top: 1px solid var(--bs-border-color);\n  }\n  .navbar-expand-xl .navbar-collapse .navbar-nav .dropdown-toggle::after {\n    position: absolute;\n    right: 25px;\n  }\n  .navbar-expand-xl .navbar-collapse .navbar-nav .dropdown-menu {\n    box-shadow: none;\n  }\n  .navbar-expand-xl .navbar-collapse .navbar-nav .dropdown-menu:before {\n    content: none;\n  }\n  .navbar-expand-xl .navbar-collapse .navbar-nav .dropdown-submenu .dropdown-menu {\n    padding-left: 20px;\n    padding-bottom: 0px;\n  }\n  .navbar-expand-xl .navbar-collapse .navbar-nav > .nav-item {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n    padding: 5px 30px;\n    position: relative;\n  }\n  .navbar-expand-xl .navbar-collapse .navbar-nav > .nav-item .nav-link {\n    line-height: 40px;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n  }\n  .navbar-expand-xl .navbar-nav .nav-item > .dropdown-menu {\n    background: rgba(103, 106, 121, 0.04);\n    padding: 20px 0px;\n    margin: 10px 0;\n  }\n  .navbar-expand-xl .navbar-nav .nav-item > .dropdown-menu .dropdown-submenu .dropdown-menu {\n    background: rgba(103, 106, 121, 0.06);\n    padding: 10px 0px !important;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    top: 120%;\n    visibility: hidden;\n    opacity: 0;\n    display: block;\n    transition: all 0.1s ease-in-out;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown:hover > .dropdown-menu {\n    top: 100%;\n    visibility: visible;\n    opacity: 1;\n    transition: all 0.3s ease-in-out;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-submenu:hover > .dropdown-menu {\n    top: 0;\n    visibility: visible;\n    opacity: 1;\n    transition: all 0.3s ease-in-out;\n  }\n  .navbar-expand-xxl .dropdown-submenu {\n    position: relative;\n  }\n}\n@media (max-width: 1399.98px) {\n  .navbar-expand-xxl .navbar-collapse {\n    box-shadow: 0px 10px 30px rgba(83, 88, 93, 0.2);\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 100%;\n    background: #fff;\n    border-top: 1px solid var(--bs-border-color);\n  }\n  .navbar-expand-xxl .navbar-collapse .navbar-nav .dropdown-toggle::after {\n    position: absolute;\n    right: 25px;\n  }\n  .navbar-expand-xxl .navbar-collapse .navbar-nav .dropdown-menu {\n    box-shadow: none;\n  }\n  .navbar-expand-xxl .navbar-collapse .navbar-nav .dropdown-menu:before {\n    content: none;\n  }\n  .navbar-expand-xxl .navbar-collapse .navbar-nav .dropdown-submenu .dropdown-menu {\n    padding-left: 20px;\n    padding-bottom: 0px;\n  }\n  .navbar-expand-xxl .navbar-collapse .navbar-nav > .nav-item {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n    padding: 5px 30px;\n    position: relative;\n  }\n  .navbar-expand-xxl .navbar-collapse .navbar-nav > .nav-item .nav-link {\n    line-height: 40px;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-item > .dropdown-menu {\n    background: rgba(103, 106, 121, 0.04);\n    padding: 20px 0px;\n    margin: 10px 0;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-item > .dropdown-menu .dropdown-submenu .dropdown-menu {\n    background: rgba(103, 106, 121, 0.06);\n    padding: 10px 0px !important;\n  }\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  top: 120%;\n  visibility: hidden;\n  opacity: 0;\n  display: block;\n  transition: all 0.1s ease-in-out;\n}\n.navbar-expand .navbar-nav .dropdown:hover > .dropdown-menu {\n  top: 100%;\n  visibility: visible;\n  opacity: 1;\n  transition: all 0.3s ease-in-out;\n}\n.navbar-expand .navbar-nav .dropdown-submenu:hover > .dropdown-menu {\n  top: 0;\n  visibility: visible;\n  opacity: 1;\n  transition: all 0.3s ease-in-out;\n}\n.navbar-expand .dropdown-submenu {\n  position: relative;\n}\n.navbar-expand .navbar-collapse {\n  box-shadow: 0px 10px 30px rgba(83, 88, 93, 0.2);\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 100%;\n  background: #fff;\n  border-top: 1px solid var(--bs-border-color);\n}\n.navbar-expand .navbar-collapse .navbar-nav .dropdown-toggle::after {\n  position: absolute;\n  right: 25px;\n}\n.navbar-expand .navbar-collapse .navbar-nav .dropdown-menu {\n  box-shadow: none;\n}\n.navbar-expand .navbar-collapse .navbar-nav .dropdown-menu:before {\n  content: none;\n}\n.navbar-expand .navbar-collapse .navbar-nav .dropdown-submenu .dropdown-menu {\n  padding-left: 20px;\n  padding-bottom: 0px;\n}\n.navbar-expand .navbar-collapse .navbar-nav > .nav-item {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 5px 30px;\n  position: relative;\n}\n.navbar-expand .navbar-collapse .navbar-nav > .nav-item .nav-link {\n  line-height: 40px;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: static;\n  float: none;\n}\n.navbar-expand .navbar-nav .nav-item > .dropdown-menu {\n  background: rgba(103, 106, 121, 0.04);\n  padding: 20px 0px;\n  margin: 10px 0;\n}\n.navbar-expand .navbar-nav .nav-item > .dropdown-menu .dropdown-submenu .dropdown-menu {\n  background: rgba(103, 106, 121, 0.06);\n  padding: 10px 0px !important;\n}\n\n.navbar.navbar-icon .navbar-nav .nav-item {\n  position: relative;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.navbar.navbar-icon .navbar-nav .nav-item .nav-link {\n  font-size: 1.3rem;\n  color: var(--bs-gray-700);\n  padding: 0 1.2rem;\n  margin-right: 0.5rem;\n  margin-left: 0.5rem;\n  position: relative;\n}\n.navbar.navbar-icon .navbar-nav .nav-item .nav-link:hover {\n  color: var(--bs-primary);\n  box-shadow: inset 0px 4px 0px var(--bs-primary);\n}\n.navbar.navbar-icon .navbar-nav .nav-item .nav-link.active {\n  color: var(--bs-primary);\n  box-shadow: inset 0px 4px 0px var(--bs-primary);\n}\n.navbar.navbar-icon .navbar-nav .nav-item .nav-link.active:before {\n  position: absolute;\n  top: 100%;\n  width: 0;\n  height: 0;\n  content: \"\";\n  border-style: solid;\n  border-width: 10px 10px 0 10px;\n  border-color: var(--bs-white) transparent transparent transparent;\n}\n.navbar.navbar-icon .navbar-nav .nav-item .nav-link:last-child {\n  padding-right: 1.2rem;\n}\n.navbar.navbar-icon .navbar-nav .nav-item .notif-badge {\n  width: 6px;\n  height: 6px;\n  background: #d6293e;\n  border-radius: 50%;\n  position: absolute;\n  top: inherit;\n  bottom: 10px;\n  right: 0;\n  left: 0;\n  margin: 0 auto;\n  z-index: 1;\n}\n@media (min-width: 992px) {\n  .navbar.navbar-icon .navbar-nav .nav-item .nav-link .nav-text {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .navbar.navbar-icon .navbar-collapse {\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n  }\n  .navbar.navbar-icon .navbar-collapse .navbar-nav .nav-item {\n    padding: 0 10px;\n  }\n  .navbar.navbar-icon .navbar-collapse .navbar-nav .nav-item .nav-link {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1rem;\n    padding: 0.2rem 1.2rem;\n  }\n  .navbar.navbar-icon .navbar-collapse .navbar-nav .nav-item .nav-link::before {\n    display: none;\n  }\n  .navbar.navbar-icon .navbar-collapse .navbar-nav .nav-item .nav-link .nav-text {\n    margin-left: 0.4rem;\n  }\n  .navbar.navbar-icon .navbar-collapse .navbar-nav .nav-item .nav-link .badge-notif.badge-notif-bottom {\n    position: static;\n    margin: inherit;\n  }\n  .navbar.navbar-icon .navbar-collapse .navbar-nav .nav-item .notif-badge {\n    bottom: inherit;\n    right: inherit;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-vertical {\n    bottom: 0;\n    display: block;\n    max-width: 300px;\n    position: fixed;\n    z-index: 9;\n    height: 100vh;\n    top: 56px;\n    width: 100%;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n  .navbar-vertical .offcanvas-start {\n    top: 1.5rem;\n    left: inherit;\n    position: relative;\n    width: auto;\n    border: none !important;\n    transform: none;\n    height: calc(100% - 6rem);\n    visibility: visible !important;\n  }\n  .navbar-vertical + .page-content {\n    margin-left: calc(300px + 1.5rem);\n  }\n  .page-content {\n    position: relative;\n    height: 100%;\n    display: block;\n    padding: 0 0.7rem 0 0;\n  }\n}\nheader.fixed-top + main {\n  padding-top: calc(1.5rem + 56px);\n  margin-bottom: 1.5rem;\n}\n\n.navbar-toggler .navbar-toggler-animation {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  background-image: none;\n  position: relative;\n  height: 18px;\n  width: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-toggler .navbar-toggler-animation span {\n  transition: all 0.3s ease-in-out;\n  -webkit-transform: rotateZ(0deg);\n  transform: rotateZ(0deg);\n  height: 2px;\n  background: var(--bs-gray-600);\n  display: block;\n  position: absolute;\n  width: 100%;\n  border-radius: 30px;\n}\n\n.navbar-toggler .navbar-toggler-animation span:nth-child(1) {\n  top: 10%;\n}\n\n.navbar-toggler .navbar-toggler-animation span:nth-child(2) {\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.navbar-toggler .navbar-toggler-animation span:nth-child(3) {\n  bottom: 10%;\n}\n\n.navbar-toggler[data-bs-toggle=collapse][aria-expanded=true] .navbar-toggler-animation span:nth-child(1) {\n  transform: rotateZ(45deg) translateY(-50%);\n  top: 47%;\n  transform-origin: 47% 0;\n  width: 100%;\n}\n\n.navbar-toggler[data-bs-toggle=collapse][aria-expanded=true] .navbar-toggler-animation span:nth-child(2) {\n  visibility: hidden;\n  transition: all 0s ease-in-out;\n}\n\n.navbar-toggler[data-bs-toggle=collapse][aria-expanded=true] .navbar-toggler-animation span:nth-child(3) {\n  transform: rotateZ(-45deg) translateY(-50%);\n  bottom: 42%;\n  transform-origin: 50% 0;\n  width: 100%;\n}\n\n.pagination .page-item {\n  margin-bottom: 5px;\n  float: left;\n}\n\n.pagination-light .page-item {\n  margin: 2px;\n}\n.pagination-light .page-item.active .page-link {\n  background-color: var(--bs-primary) !important;\n}\n.pagination-light .page-item.disabled .page-link {\n  background-color: transparent !important;\n}\n.pagination-light .page-link {\n  border-color: var(--bs-light);\n  background-color: var(--bs-light);\n  border-radius: 0.2rem;\n}\n.pagination-light .page-link:hover {\n  background-color: #0f6fec;\n  border-color: #0f6fec;\n}\n\nbody {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  height: 100%;\n  overflow-x: hidden;\n  z-index: 0;\n  position: relative;\n}\n\nmain {\n  background-color: var(--bs-body-bg);\n}\n\nheader {\n  position: relative;\n  z-index: 1020;\n}\n\na {\n  transition: all 0.3s ease-in-out;\n}\n\n*:focus {\n  outline: none !important;\n}\n\nh1 > a, h2 > a, h3 > a, h4 > a, h5 > a, h6 > a, .h1 > a, .h2 > a, .h3 > a, .h4 > a, .h5 > a, .h6 > a {\n  color: var(--bs-gray-800);\n}\nh1 > a:hover, h2 > a:hover, h3 > a:hover, h4 > a:hover, h5 > a:hover, h6 > a:hover, .h1 > a:hover, .h2 > a:hover, .h3 > a:hover, .h4 > a:hover, .h5 > a:hover, .h6 > a:hover {\n  color: var(--bs-primary);\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\nvideo {\n  background-size: cover;\n  display: table-cell;\n  vertical-align: middle;\n  width: 100%;\n}\n\nsection {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\n@media (max-width: 767.98px) {\n  section {\n    padding-top: 4rem;\n    padding-bottom: 3rem;\n  }\n}\nsmall,\n.small {\n  font-weight: 400;\n}\n\n.smaller {\n  font-size: 60%;\n  font-weight: 500;\n}\n\n.dropcap {\n  font-size: 4em;\n  font-weight: bold;\n  display: block;\n  float: left;\n  margin: 0.04em 0.2em 0 0;\n  color: var(--bs-gray-800);\n  line-height: 1;\n}\n\n.bg-overlay {\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n\n.blockquote {\n  position: relative;\n  padding-left: 80px;\n}\n.blockquote:before {\n  content: '\"';\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 8rem;\n  line-height: 0.8em;\n  font-weight: 700;\n  color: var(--bs-primary);\n}\n\n.blockquote-footer {\n  margin-top: 12px;\n  padding-left: 80px;\n}\n\na.badge:hover {\n  color: #fff;\n}\n\n.badge-unread {\n  background: var(--bs-light);\n}\n.badge-unread:hover {\n  background: var(--bs-light);\n}\n.badge-unread:before {\n  content: \"\";\n  width: 7px;\n  height: 7px;\n  background: var(--bs-primary);\n  border-radius: 50%;\n  position: absolute;\n  top: 40px;\n  left: 4px;\n}\n\n.badge-notif {\n  width: 8px;\n  height: 8px;\n  background: #d6293e;\n  border-radius: 50%;\n  position: absolute;\n  top: 0;\n  right: -3px;\n  z-index: 1;\n}\n.badge-notif.badge-notif-bottom {\n  width: 6px;\n  height: 6px;\n  top: inherit;\n  bottom: 5px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n\n.offcanvas-sm {\n  width: 270px;\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-start {\n    width: 260px !important;\n  }\n}\n.toast-chat {\n  position: fixed;\n  right: calc(400px + 1rem);\n  bottom: 0;\n  z-index: 11;\n}\n\n@media (max-width: 575.98px) {\n  .toast {\n    width: 288px;\n  }\n}\n.bg-mode {\n  background: #fff;\n}\n\n.grayscale {\n  filter: grayscale(100%);\n  transition: all 0.6s ease;\n}\n.grayscale:hover {\n  filter: none;\n  -webkit-filter: grayscale(0%);\n}\n\n.fw-icon {\n  text-align: center;\n  width: 1.25em;\n  display: inline-block;\n}\n\n.icon-xs {\n  height: 1.5rem;\n  width: 1.5rem;\n  font-size: 0.6em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-sm {\n  height: 2rem;\n  width: 2rem;\n  font-size: 0.7em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-md {\n  height: 2.5rem;\n  width: 2.5rem;\n  font-size: 0.9em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-lg {\n  height: 3rem;\n  width: 3rem;\n  font-size: 1em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-xl {\n  height: 4rem;\n  width: 4rem;\n  font-size: 1.6em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-xxl {\n  height: 5.125rem;\n  width: 5.125rem;\n  font-size: 2em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.plyr__control--overlaid,\n.plyr--video .plyr__control.plyr__tab-focus,\n.plyr--video .plyr__control:hover,\n.plyr--video .plyr__control[aria-expanded=true] {\n  background: var(--bs-primary);\n}\n\n.plyr--full-ui input[type=range] {\n  color: var(--bs-primary);\n}\n\n/* rtl:raw:\n.glightbox-clean .gclose, .glightbox-modern .gclose{\n  right: auto !important;\n  left: 20px;\n}\n*/\n.password-strength-meter {\n  background-color: var(--bs-gray-200) !important;\n}\n\n.glightbox-clean .gslide-description {\n  background: #fff;\n}\n\n.plyr__controls-none .plyr__controls {\n  display: none;\n}\n.plyr__controls-none .plyr--video {\n  border-radius: 20px;\n}\n\n.nav-search .dropdown-menu {\n  top: 120%;\n  visibility: hidden;\n  opacity: 0;\n  display: block;\n  transition: all 0.3s ease-in-out;\n  width: 300px;\n  left: auto;\n  right: 0;\n}\n\n.nav-search .dropdown-menu.show {\n  top: 100%;\n  visibility: visible;\n  opacity: 1;\n}\n\n@media (max-width: 575.98px) {\n  .nav-search .dropdown-menu {\n    width: 100%;\n  }\n}\n/* rtl:raw:\n  .rtl-flip {\n    transform: scaleX(-1);\n  }\n  .rtl-flip.bi:before{\n    transform: inherit;\n  }\n*/\n.preloader {\n  background-color: #fff;\n  position: fixed;\n  z-index: 1190;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n}\n.preloader .preloader-item {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  text-align: center;\n  transform: translate(-50%, -50%);\n}\n\n.comment-wrap .comment-item {\n  position: relative;\n}\n.comment-wrap .comment-item .avatar {\n  position: relative;\n  z-index: 1;\n}\n.comment-wrap .comment-item:last-child .comment-line-inner {\n  background: var(--bs-light);\n  height: 20px;\n}\n.comment-wrap .comment-item-nested {\n  padding-left: 2.75rem;\n}\n.comment-wrap > .comment-item .comment-line-inner {\n  position: absolute;\n  left: 16px;\n  top: 0;\n  width: 2px;\n  background-color: var(--bs-light);\n  height: 100%;\n}\n\n.comment-item-nested .comment-item {\n  position: relative;\n}\n.comment-item-nested .comment-item .comment-line-inner {\n  position: absolute;\n  left: -28px;\n  top: 0;\n  width: 2px;\n  background-color: var(--bs-light);\n  height: 100%;\n}\n.comment-item-nested .comment-item .comment-line-inner:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 20px;\n  height: 2px;\n  width: 26px;\n  background: var(--bs-light);\n}\n\n@media (min-width: 992px) {\n  .rounded-end-lg-0 {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .rounded-start-lg-0 {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .border-end-lg-0 {\n    border-right: 0;\n  }\n}\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.flip-horizontal {\n  transform: scaleX(-1);\n  display: inline-block;\n}\n\n.timeline {\n  width: 100%;\n}\n.timeline .timeline-item {\n  display: flex;\n  width: 100%;\n  margin-bottom: 1.5rem;\n  position: relative;\n}\n.timeline .timeline-item:last-child {\n  margin-bottom: 0;\n}\n.timeline .timeline-item .timeline-icon {\n  margin-right: 0.8rem;\n  position: relative;\n  position: relative;\n}\n.timeline .timeline-item .timeline-content {\n  width: 100%;\n}\n.timeline .timeline-item:before {\n  content: \"\";\n  position: absolute;\n  width: 2px;\n  height: calc(100% - 1rem);\n  background-color: var(--bs-light);\n  top: 2.5rem;\n  left: 1.5rem;\n  transform: translatex(-50%);\n}\n.timeline .timeline-item:last-child:before {\n  height: calc(100% - 2.5rem);\n}\n\n@media (min-width: 992px) {\n  .card-chat {\n    height: calc(100vh - 5.1125rem - 1.5rem);\n  }\n  .card-chat-list {\n    height: calc(100vh - 10.112rem - 1.5rem);\n  }\n  .chat-conversation-content {\n    height: calc(100% - 5.25rem);\n  }\n  .chat-tab-list {\n    height: calc(100% - 0.75rem);\n  }\n}\n.typing .dot {\n  animation: TypingAnimation 1.8s infinite ease-in-out;\n  background-color: rgba(var(--bs-secondary-rgb), 0.7);\n  border-radius: 50%;\n  height: 7px;\n  margin-right: 4px;\n  vertical-align: middle;\n  width: 7px;\n  display: inline-block;\n}\n.typing .dot:nth-child(1) {\n  animation-delay: 200ms;\n}\n.typing .dot:nth-child(2) {\n  animation-delay: 300ms;\n}\n.typing .dot:nth-child(3) {\n  animation-delay: 400ms;\n}\n.typing .dot:last-child {\n  margin-right: 0;\n}\n\n@keyframes TypingAnimation {\n  0% {\n    transform: translateY(0px);\n    background-color: rgba(var(--bs-secondary-rgb), 0.7);\n  }\n  28% {\n    transform: translateY(-7px);\n    background-color: rgba(var(--bs-secondary-rgb), 0.4);\n  }\n  44% {\n    transform: translateY(0px);\n    background-color: rgba(var(--bs-secondary-rgb), 0.2);\n  }\n}\n.bi::before,\n[class^=bi-]::before,\n[class*=\" bi-\"]::before {\n  line-height: 1.5;\n}\n\n.fakepasswordicon {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.fakepasswordicon.fa-eye:before {\n  content: \"\\f06e\" !important;\n}\n\n.ticket-border {\n  border-left: 2px dashed var(--bs-gray-900);\n  padding-left: 50px;\n  position: relative;\n}\n.ticket-border:before {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: #fff;\n  content: \"\";\n  top: -50px;\n  left: -25px;\n  position: absolute;\n}\n.ticket-border:after {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: #fff;\n  content: \"\";\n  bottom: -50px;\n  left: -25px;\n  position: absolute;\n}\n\n@media (max-width: 575.98px) {\n  .ticket-border {\n    padding-left: 0;\n    border: 0;\n  }\n  .ticket-border:after, .ticket-border:before {\n    display: none;\n  }\n}\n.plyr--audio .plyr__controls {\n  background: transparent;\n}\n\n.plyr--audio .plyr__control.plyr__tab-focus, .plyr--audio .plyr__control:hover, .plyr--audio .plyr__control[aria-expanded=true] {\n  background: var(--bs-primary);\n}\n\n[data-autoresize] {\n  resize: none;\n}\n\n.tooltip-text-start .tooltip-inner {\n  text-align: left;\n}\n\n[class*=status-]:before {\n  content: \"\";\n  position: absolute;\n  z-index: 1;\n  border-radius: 100%;\n  border: 2px solid #fff;\n  height: 12px;\n  width: 12px;\n  right: -2px;\n  top: -2px;\n}\n\n.status-online:before {\n  background-color: #0cbc87;\n}\n\n.status-away:before {\n  background-color: #f7c32e;\n}\n\n.status-offline:before {\n  background-color: #d6293e;\n}\n\n.avatar.avatar-lg[class*=status-]:before {\n  right: 2px;\n  top: 2px;\n}\n\n.avatar.avatar-xl[class*=status-]:before {\n  right: 4px;\n  top: 4px;\n}\n\n.avatar.avatar-xxl[class*=status-]:before {\n  right: 12px;\n  top: 12px;\n}\n\n.avatar.avatar-xxxl[class*=status-]:before {\n  right: 18px;\n  top: 18px;\n}\n\n.avatar {\n  height: 3rem;\n  width: 3rem;\n  position: relative;\n  display: inline-block;\n  flex-shrink: 0 !important;\n}\n\n.avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar-group {\n  padding: 0;\n  display: flex;\n}\n.avatar-group > li {\n  position: relative;\n}\n.avatar-group > li:not(:last-child) {\n  margin-right: -0.8rem;\n}\n.avatar-group .avatar-img {\n  border: 2px solid #fff;\n}\n\n.avatar-group-two {\n  display: inline-flex;\n  padding: 0;\n}\n.avatar-group-two > li {\n  margin-top: 0.8rem;\n  position: relative;\n}\n.avatar-group-two > li:not(:last-child) {\n  margin-right: -1.2rem;\n  margin-top: 0;\n}\n\n.avatar-group-three {\n  display: inline-flex;\n  padding: 0;\n  padding-right: 1.2rem;\n  position: relative;\n}\n.avatar-group-three > li {\n  position: relative;\n}\n.avatar-group-three > li:not(:last-child) {\n  margin-right: -1.2rem;\n}\n.avatar-group-three > li:last-child {\n  position: absolute;\n  bottom: -30px;\n  left: 50%;\n  top: 0;\n  transform: translate(-50%, 50%);\n}\n\n.avatar-group-four {\n  display: inline-grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n  grid-template-columns: auto auto;\n  gap: 0px 0px;\n}\n.avatar-group-four li {\n  margin: 0;\n}\n.avatar-group-four li:not(:last-child) {\n  margin: 0;\n}\n\n.avatar-xxs {\n  height: 1.5rem;\n  width: 1.5rem;\n}\n\n.avatar-xs {\n  height: 2.1875rem;\n  width: 2.1875rem;\n}\n\n.avatar-sm {\n  height: 2.5rem;\n  width: 2.5rem;\n}\n\n.avatar-lg {\n  height: 4rem;\n  width: 4rem;\n}\n\n.avatar-xl {\n  height: 5.125rem;\n  width: 5.125rem;\n}\n\n.avatar-xxl {\n  height: 5.125rem;\n  width: 5.125rem;\n}\n@media (min-width: 768px) {\n  .avatar-xxl {\n    width: 8rem;\n    height: 8rem;\n  }\n}\n\n.avatar-xxxl {\n  height: 8rem;\n  width: 8rem;\n}\n@media (min-width: 768px) {\n  .avatar-xxxl {\n    width: 11rem;\n    height: 11rem;\n  }\n}\n\n.avatar-story {\n  position: relative;\n  padding: 4px;\n  z-index: 1;\n}\n.avatar-story:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  border-radius: 50%;\n  border: 2px solid var(--bs-primary);\n  z-index: -1;\n}\n\n.avatar-uploader {\n  position: relative;\n}\n.avatar-uploader .avatar-edit {\n  position: absolute;\n  right: 0;\n  z-index: 1;\n  top: 0;\n}\n.avatar-uploader .avatar-edit input {\n  display: none;\n}\n.avatar-uploader .avatar-edit input + label {\n  display: inline-block;\n  width: 34px;\n  height: 34px;\n  margin-bottom: 0;\n  border-radius: 100%;\n  background: #eff2f6;\n  border: 1px solid transparent;\n  box-shadow: 0px 0px 20px rgba(93, 83, 84, 0.15);\n  cursor: pointer;\n  font-weight: normal;\n  transition: all 0.3s ease-in-out;\n}\n.avatar-uploader .avatar-edit input + label:after {\n  content: \"\\f303\";\n  font-family: \"Font Awesome 6 Free\";\n  color: #14191e;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  text-align: center;\n  font-weight: 900;\n  transform: translate(0, -56%);\n  margin: 0 auto;\n  transition: all 0.3s ease-in-out;\n}\n.avatar-uploader .avatar-edit input + label:hover {\n  background: var(--bs-primary);\n  border-color: var(--bs-primary);\n}\n.avatar-uploader .avatar-edit input + label:hover:after {\n  color: #fff;\n}\n.avatar-uploader img#avatar-preview {\n  object-fit: cover;\n}\n\n.tns-outer {\n  position: relative;\n}\n\n.tns-item {\n  touch-action: pan-y;\n  user-select: none;\n}\n\n.tiny-slider .item {\n  position: relative;\n}\n\n.tns-controls [data-controls] {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  border-radius: 0.4rem;\n  display: block;\n  z-index: 9;\n  text-align: center;\n  transition: all 0.3s ease-in-out;\n  background: rgba(var(--bs-primary-rgb), 0.3);\n  color: #fff;\n  border: none;\n  padding: 0;\n  margin: 0 5px;\n}\n.tns-controls [data-controls]:hover {\n  background-color: var(--bs-primary);\n  color: #fff;\n}\n.tns-controls [data-controls] i {\n  line-height: inherit;\n}\n\n.tns-controls [data-controls=prev] {\n  left: 0;\n}\n\n.tns-controls [data-controls=next] {\n  right: 0;\n}\n\n/* rtl:raw:\n.tiny-slider .tns-controls [data-controls]{\n  transform: scaleX(-1) translateY(-50%);\n}\n.tns-visually-hidden {\n  right: -10000em !important;\n  left: 0 !important;\n}\n*/\n.arrow-dark [data-controls] {\n  background: #14191e;\n  color: #fff;\n}\n\n.arrow-white [data-controls] {\n  background-color: #eff2f6;\n  color: #676a79;\n}\n\n.arrow-round [data-controls] {\n  border-radius: 50%;\n}\n\n.arrow-hover {\n  overflow: hidden;\n}\n.arrow-hover [data-controls=prev] {\n  left: -60px;\n}\n.arrow-hover [data-controls=next] {\n  right: -60px;\n}\n.arrow-hover:hover [data-controls=prev] {\n  left: 0px;\n}\n.arrow-hover:hover [data-controls=next] {\n  right: 0px;\n}\n\n.tns-nav {\n  position: absolute;\n  top: 100%;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  width: auto;\n  text-align: center;\n  white-space: nowrap;\n}\n.tns-nav [data-nav] {\n  position: relative;\n  display: inline-block;\n  margin: 0 4px;\n  padding: 0;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  overflow: hidden;\n  background-color: transparent;\n  box-shadow: inset 0 0 0 2px var(--bs-gray-500);\n  transition: all 0.3s ease-in-out;\n  border: 0;\n}\n.tns-nav .tns-nav-active {\n  background-color: #fff;\n}\n\n.dots-inside .tns-nav {\n  top: auto;\n  padding-bottom: 20px;\n}\n\n.dots-white .tns-nav [data-nav] {\n  box-shadow: inset 0 0 0 2px #fff;\n  transition: all 0.3s ease-in-out;\n}\n.dots-white .tns-nav [data-nav]:after {\n  background-color: #fff;\n  box-shadow: 0 0 1px #fff;\n}\n\n.dots-dark .tns-nav [data-nav] {\n  box-shadow: inset 0 0 0 2px var(--bs-gray-800);\n  transition: all 0.3s ease-in-out;\n}\n.dots-dark .tns-nav [data-nav]:after {\n  background-color: var(--bs-gray-800);\n  box-shadow: 0 0 1px var(--bs-gray-800);\n}\n\n.gslide-description.description-left,\n.gslide-description.description-right {\n  max-width: 360px;\n}\n\n.gdesc-inner {\n  width: 100%;\n}\n\n.glightbox-container .gslide {\n  user-select: inherit;\n}\n\n.glightbox-clean .gslide-desc {\n  font-family: \"Inter\", sans-serif;\n}\n\n.glightbox-mobile .glightbox-container .gslide-desc .bg-light {\n  background: #14191e !important;\n}\n.glightbox-mobile .glightbox-container .gslide-desc .form-control {\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.glightbox-mobile .glightbox-container .gslide-desc .text-secondary {\n  color: #fff !important;\n}\n.glightbox-mobile .glightbox-container .gslide-desc .dropdown-menu {\n  background: #14191e !important;\n}\n.glightbox-mobile .glightbox-container .gslide-desc a {\n  font-weight: normal;\n}\n.glightbox-mobile .glightbox-container .gslide-desc .nav.nav-divider .nav-item {\n  color: #fff !important;\n}\n\n.choices .choices__inner {\n  background-color: #fff;\n  color: var(--bs-gray-700);\n  border: 1px solid var(--bs-gray-400);\n  line-height: 1.5;\n  border-radius: 0.4rem;\n  min-height: auto;\n  padding: 0.5rem 1rem !important;\n  font-size: 0.9375rem;\n}\n.choices .choices__list--multiple .choices__item {\n  background-color: var(--bs-light);\n  border: 1px solid var(--bs-light);\n  border-radius: 0.4rem;\n  color: var(--bs-gray-700);\n}\n.choices .choices__list--dropdown {\n  background: #fff;\n  border: 1px solid var(--bs-gray-400);\n  visibility: visible !important;\n}\n.choices .choices__list--dropdown .choices__item--selectable.is-highlighted {\n  background-color: var(--bs-light);\n}\n.choices .choices__list--dropdown .choices__item {\n  color: var(--bs-gray-600);\n}\n.choices .choices__input {\n  background: transparent;\n  padding: 0;\n  color: var(--bs-gray-700);\n}\n.choices .choices__list--dropdown,\n.choices .choices__list[aria-expanded] {\n  margin-top: 0px;\n}\n.choices.is-open .choices__list--dropdown, .choices.is-open .choices__list[aria-expanded] {\n  margin-top: -1px;\n}\n\n.choices[data-type*=select-one] .choices__input {\n  background: var(--bs-white);\n  color: var(--bs-body-color);\n  border-color: var(--bs-gray-400) !important;\n}\n\n.choices__list--single {\n  padding: 0;\n}\n\n.choices[data-type*=select-multiple] .choices__button, .choices[data-type*=text] .choices__button {\n  border-left: 1px solid #14191e;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n}\n\n.choices[data-type*=select-one]:after {\n  content: \"\";\n  height: 10px;\n  width: 10px;\n  border: none;\n  border-width: 5px;\n  position: absolute;\n  right: 11.5px;\n  top: 50%;\n  transform: translateY(-50%);\n  margin-top: 0;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 16px 12px;\n}\n\n.choices[data-type*=select-one].is-open:after {\n  margin-top: 0;\n}\n\n.choices[data-type*=select-one] .choices__input {\n  background: #fff;\n  border-color: #fff;\n}\n\n.choices.is-focused .choices__inner {\n  border-color: var(--bs-primary);\n}\n\n.choices[data-type*=select-one] .choices__list > .choices__list > .choices__item--selectable, .choices[data-type*=select-multiple] .choices__list > .choices__list > .choices__item--selectable {\n  padding-right: 0px;\n}\n\n.choices[data-type*=select-one] .choices__list > .choices__list > .choices__item--selectable::after, .choices[data-type*=select-multiple] .choices__list > .choices__list > .choices__item--selectable::after {\n  display: none;\n}\n\n.dropzone {\n  min-height: auto;\n  border-radius: 0.4rem;\n  position: relative;\n  z-index: 0;\n  border: 2px dashed #eef0f2;\n}\n.dropzone .dz-preview.dz-image-preview {\n  background: transparent;\n}\n\n.dropzone-custom {\n  position: relative;\n}\n.dropzone-custom .dz-cover-preview {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0;\n}\n.dropzone-custom .dz-cover-preview .dz-cover-preview-wrap {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  border: 0 !important;\n  overflow: hidden;\n}\n.dropzone-custom .dz-preview {\n  min-height: auto;\n  margin: 0;\n  width: 100%;\n}\n.dropzone-custom .dz-preview.dz-cover-preview .dz-cover-preview-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 0.375rem;\n}\n.dropzone-custom.dropzone-cover .dz-message {\n  padding: 6rem 2rem;\n}\n.dropzone-custom.dropzone-cover.dz-file-processing .dz-message {\n  display: none;\n}\n.dropzone-custom.dropzone-cover.dz-file-processing.dz-file-complete .dz-message {\n  display: block;\n}\n.dropzone-custom.dropzone-cover.dz-max-files-reached .dz-message {\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #fff;\n  opacity: 0;\n  transition: all 0.2s ease-in-out;\n  border-color: transparent;\n}\n.dropzone-custom.dropzone-cover .dz-preview.dz-cover-preview .dz-cover-preview-img {\n  width: 100%;\n  height: 100%;\n}\n.dropzone-custom .dz-message {\n  position: relative;\n  padding: 2rem;\n  margin: 0;\n}\n.dropzone-custom.dropzone .dz-preview {\n  display: inline-flex;\n}\n\n.dropzone-custom.dz-clickable .dz-message, .dropzone.dz-clickable .dz-message * {\n  cursor: pointer;\n}\n\n.dropzone-custom.dropzone-cover.dz-max-files-reached:focus .dz-message, .dropzone.dropzone-cover.dz-max-files-reached:hover .dz-message {\n  opacity: 1;\n}\n\n.os-theme-dark > .os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle,\n.os-theme-dark > .os-scrollbar:hover > .os-scrollbar-track > .os-scrollbar-handle {\n  background: rgba(var(--bs-secondary-rgb), 0.15);\n}\n\n.iphone-x {\n  position: relative;\n  margin: 40px auto;\n  width: 360px;\n  height: 780px;\n  background-color: #14191e;\n  border-radius: 40px;\n  box-shadow: 0px 0px 0px 11px #14191e, 0px 0px 0px 13px #14191e, 0px 0px 0px 20px #101418;\n}\n.iphone-x:before, .iphone-x:after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.iphone-x:after {\n  bottom: 7px;\n  width: 140px;\n  height: 4px;\n  background-color: #eef0f2;\n  border-radius: 10px;\n}\n.iphone-x:before {\n  top: 0px;\n  width: 56%;\n  height: 30px;\n  background-color: #14191e;\n  border-radius: 0px 0px 40px 40px;\n}\n.iphone-x i,\n.iphone-x b,\n.iphone-x s,\n.iphone-x span {\n  position: absolute;\n  display: block;\n  color: transparent;\n}\n.iphone-x i {\n  top: 0px;\n  left: 50%;\n  transform: translate(-50%, 6px);\n  height: 8px;\n  width: 15%;\n  background-color: #000;\n  border-radius: 8px;\n  box-shadow: inset 0px -3px 3px 0px rgba(255, 255, 255, 0.2);\n}\n.iphone-x b {\n  left: 10%;\n  top: 0px;\n  transform: translate(180px, 4px);\n  width: 12px;\n  height: 12px;\n  background-color: #000;\n  border-radius: 12px;\n  box-shadow: inset 0px -3px 2px 0px rgba(255, 255, 255, 0.2);\n}\n.iphone-x b:after {\n  content: \"\";\n  position: absolute;\n  background-color: rgba(15, 111, 236, 0.5);\n  width: 6px;\n  height: 6px;\n  top: 2px;\n  left: 2px;\n  top: 3px;\n  left: 3px;\n  display: block;\n  border-radius: 4px;\n  box-shadow: inset 0px -2px 2px rgba(0, 0, 0, 0.5);\n}\n.iphone-x s {\n  top: 50px;\n  text-align: center;\n  text-decoration: none;\n  width: 100%;\n  font-size: 70px;\n  font-weight: 100;\n  padding-top: 60px;\n}\n.iphone-x span {\n  bottom: 50px;\n  width: 40px;\n  height: 40px;\n  background-color: rgba(0, 0, 0, 0.3);\n  border-radius: 50%;\n  left: 30px;\n}\n.iphone-x span + span {\n  left: auto;\n  right: 30px;\n}\n\n.iphone-x.iphone-x-small {\n  margin: 40px auto;\n  width: 300px;\n  height: 600px;\n}\n\n.iphone-x.iphone-x-half {\n  height: 300px;\n  background-image: url(../images/mockup/app-placeholder3.jpg);\n}\n\n@media (max-width: 575.98px) {\n  .iphone-x, .iphone-x.iphone-x-small {\n    width: 260px;\n    height: 540px;\n    background-size: 100%;\n  }\n  .iphone-x.iphone-x-half {\n    width: 240px;\n    height: 280px;\n    background-size: 100%;\n  }\n  .iphone-x b {\n    left: -6%;\n  }\n}\n.mac_container {\n  width: 100%;\n  margin: 10px auto;\n}\n\n.mac_scaler {\n  margin: auto;\n  width: 100%;\n  padding-top: 57.875%;\n  height: 0px;\n  position: relative;\n}\n\n.mac_holder {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  width: 100%;\n  height: 100%;\n}\n\n.mac_screen {\n  margin: auto;\n  background: #14191e;\n  width: 86%;\n  height: 100%;\n  border-top-left-radius: 2% 3%;\n  border-top-right-radius: 2% 3%;\n  border-bottom-left-radius: 5% 3%;\n  border-bottom-right-radius: 5% 3%;\n  box-sizing: border-box;\n  padding: 3%;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid #eef0f2;\n}\n.mac_screen:before {\n  content: \"\";\n  position: absolute;\n  right: 0.3%;\n  top: 0.5%;\n  width: 36.5%;\n  height: 35%;\n  border: 1px solid #14191e;\n  border-bottom: none;\n  border-left: none;\n  border-top-right-radius: 4.5% 7%;\n}\n.mac_screen:after {\n  content: \"\";\n  position: absolute;\n  right: -25%;\n  top: -25%;\n  width: 40%;\n  height: 150%;\n  background: rgba(238, 240, 242, 0.2);\n  background: linear-gradient(rgba(255, 255, 255, 0.2), rgba(238, 240, 242, 0) 40%);\n  transform: rotate(-30deg);\n}\n\n.mac_camera {\n  background: #333;\n  border-radius: 50%;\n  width: 1%;\n  height: 1.5%;\n  position: absolute;\n  left: 49.5%;\n  top: 2%;\n}\n.mac_camera:after {\n  content: \"\";\n  position: absolute;\n  left: 35%;\n  top: 40%;\n  width: 30%;\n  height: 30%;\n  border-radius: 50%;\n  background: #777;\n}\n\n.mac_bottom {\n  background: #e9e9e9;\n  background: linear-gradient(#ccc 50%, #444);\n  width: 100%;\n  height: 3%;\n  position: relative;\n  top: -1.7%;\n  border-bottom-left-radius: 6% 50%;\n  border-bottom-right-radius: 6% 50%;\n}\n\n.mac_bottom_top_half {\n  width: 100%;\n  height: 50%;\n  background: #e9e9e9;\n  background: linear-gradient(90deg, #aaa, #f3f3f3 0.5%, #aaa 2.5%, #f3f3f3 5.5%, #f3f3f3 94.5%, #aaa 97.5%, #f3f3f3 99.5%, #aaa);\n}\n\n.mac_bottom:after {\n  content: \"\";\n  position: absolute;\n  right: 1%;\n  bottom: 11%;\n  width: 98%;\n  height: 0%;\n  box-shadow: 1px 0px 8px 1px #333;\n}\n\n.mac_thumb_space {\n  background: #bbb;\n  background: radial-gradient(90% 150% at 50% 1%, #eee 49%, #888);\n  margin: auto;\n  width: 15%;\n  height: 60%;\n  border-bottom-left-radius: 8% 100%;\n  border-bottom-right-radius: 8% 100%;\n}\n\n.mac_screen_content {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n}\n\n.flatpickr-calendar {\n  background: #fff;\n  border-color: #fff;\n  box-shadow: 0px 0px 20px rgba(93, 83, 84, 0.15);\n}\n\n.flatpickr-current-month .flatpickr-monthDropdown-months, .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {\n  background: #fff;\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n.flatpickr-calendar.arrowBottom:before, .flatpickr-calendar.arrowBottom:after {\n  border-top-color: #fff;\n}\n\n.flatpickr-calendar.arrowTop:before, .flatpickr-calendar.arrowTop:after, .flatpickr-current-month .numInputWrapper span.arrowUp:after {\n  border-bottom-color: #fff;\n}\n\n.flatpickr-current-month .numInputWrapper span.arrowDown:after {\n  border-top-color: var(--bs-gray-500);\n}\n\n.flatpickr-current-month .numInputWrapper span.arrowUp:after {\n  border-bottom-color: var(--bs-gray-500);\n}\n\n.flatpickr-months {\n  position: relative;\n}\n\n.flatpickr-months .flatpickr-prev-month, .flatpickr-months .flatpickr-next-month {\n  border-radius: 0.4rem;\n  margin: 3px;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n  padding: 0;\n  transition: all 0.3s ease-in-out;\n}\n.flatpickr-months .flatpickr-prev-month svg, .flatpickr-months .flatpickr-next-month svg {\n  height: 12px;\n  width: 12px;\n}\n.flatpickr-months .flatpickr-prev-month:hover, .flatpickr-months .flatpickr-next-month:hover {\n  background: rgba(var(--bs-primary-rgb), 0.1);\n}\n.flatpickr-months .flatpickr-prev-month:hover svg, .flatpickr-months .flatpickr-next-month:hover svg {\n  fill: var(--bs-primary);\n}\n\n.flatpickr-day, span.flatpickr-weekday, .flatpickr-months .flatpickr-month {\n  color: var(--bs-gray-500);\n}\n\n.flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover, .flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay, .flatpickr-day.notAllowed, .flatpickr-day.notAllowed.prevMonthDay, .flatpickr-day.notAllowed.nextMonthDay {\n  color: var(--bs-gray-400);\n}\n\n.flatpickr-months .flatpickr-prev-month, .flatpickr-months .flatpickr-next-month {\n  fill: var(--bs-gray-500);\n}\n\n.flatpickr-day.today, .flatpickr-day.today:hover, .flatpickr-day.today:focus {\n  background: rgba(var(--bs-primary-rgb), 0.1);\n  color: var(--bs-primary);\n  border-color: rgba(var(--bs-primary-rgb), 0.1);\n}\n\n.flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay {\n  background: var(--bs-primary);\n  color: #fff;\n  border-color: var(--bs-primary);\n}\n\n.flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange, .flatpickr-day:hover, .flatpickr-day.prevMonthDay:hover, .flatpickr-day.nextMonthDay:hover, .flatpickr-day:focus, .flatpickr-day.prevMonthDay:focus, .flatpickr-day.nextMonthDay:focus {\n  background: var(--bs-light);\n  border-color: var(--bs-light);\n  color: var(--bs-gray-500);\n}\n\n.flatpickr-day.today.inRange, .flatpickr-day.prevMonthDay.today.inRange, .flatpickr-day.nextMonthDay.today.inRange {\n  background: rgba(var(--bs-primary-rgb), 0.1);\n  color: var(--bs-primary);\n  border-color: rgba(var(--bs-primary-rgb), 0.1);\n}\n\n.flatpickr-day.inRange {\n  box-shadow: -5px 0 0 var(--bs-light), 5px 0 0 var(--bs-light);\n}\n\n.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {\n  box-shadow: -10px 0 0 var(--bs-primary);\n}\n\n.flatpickr-input:disabled, .flatpickr-input[readonly] {\n  background-color: #fff;\n}\n\n.flatpickr-time input:hover, .flatpickr-time .flatpickr-am-pm:hover, .flatpickr-time input:focus, .flatpickr-time .flatpickr-am-pm:focus {\n  background: var(--bs-light);\n}\n\n.flatpickr-calendar.hasTime .flatpickr-time {\n  border-top-color: rgba(0, 0, 0, 0.1);\n}\n\n.flatpickr-current-month {\n  font-size: 120%;\n  padding: 9.48px 0 0 0;\n  border-radius: 0.4rem;\n}\n\n.flatpickr-time input {\n  color: var(--bs-gray-500);\n}\n.flatpickr-time .flatpickr-am-pm {\n  color: var(--bs-gray-500);\n}\n\n@media (max-width: 575.98px) {\n  .flatpickr-calendar, .flatpickr-days, .dayContainer {\n    width: 100%;\n    min-width: 100%;\n    max-width: 100%;\n  }\n}\n.stories .story > .item-link {\n  text-decoration: none;\n  color: var(--bs-gray-800);\n}\n\n.stories .story > .item-link > .item-preview {\n  border-radius: 50%;\n  padding: 2px;\n  background: var(--bs-primary);\n  height: 5.125rem !important;\n  width: 5.125rem !important;\n}\n\n.stories.carousel .story {\n  height: auto !important;\n  width: 5.125rem !important;\n}\n\n.stories .story > .item-link > .item-preview img {\n  border-radius: 50%;\n  border: 2px solid #fff;\n}\n\n.stories .story.seen {\n  opacity: 0.5;\n}\n\n.stories .story.seen > a > .item-preview {\n  background: #a1a1a8;\n}\n\n.stories .story.seen > a {\n  color: #676a79 !important;\n}\n\n.stories.carousel .story > .item-link > .info .name {\n  font-weight: 500;\n  font-size: 0.8203125rem;\n}\n\n#zuck-modal-content .story-viewer .head .right {\n  padding: 0px 30px;\n}\n#zuck-modal-content .story-viewer .head .right .close {\n  color: #fff;\n}\n\n#zuck-modal.with-effects {\n  height: 100vh !important;\n}\n\n.stories-square.stories .story > .item-link > .item-preview {\n  border-radius: 5px;\n  height: 150px !important;\n  object-fit: cover;\n  width: auto !important;\n  max-height: inherit !important;\n  padding: 0 !important;\n}\n\n.stories-square.stories.carousel .story {\n  border-radius: 0;\n  height: 150px !important;\n  position: relative;\n  width: 120px !important;\n  max-width: inherit !important;\n  margin-bottom: 4px;\n}\n\n.stories-square.stories.carousel .story > .item-link > .info {\n  position: absolute;\n  left: 10px;\n  bottom: 6px;\n  color: #fff;\n  text-align: left;\n  z-index: 1;\n}\n\n.stories-square.stories.carousel .story > .item-link > .item-preview img {\n  border-radius: 5px;\n  border: none;\n}\n\n.stories-square.stories .story.seen > a > .item-preview {\n  background: transparent;\n}\n\n.stories-square.stories .item-preview {\n  position: relative;\n}\n\n.stories-square.stories .item-preview:before {\n  content: \"\";\n  position: absolute;\n  height: 50%;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(transparent), to(black));\n  background-image: linear-gradient(180deg, transparent, black);\n  z-index: 1;\n}\n\n@media (max-width: 1024px) {\n  #zuck-modal-content .story-viewer.with-back-button .head .left > .back {\n    color: #fff;\n  }\n}\n.scroll-enable.stories.carousel::-webkit-scrollbar-track {\n  border-radius: 5px;\n  background-color: #fff;\n}\n.scroll-enable.stories.carousel::-webkit-scrollbar {\n  width: 5px;\n  height: 8px;\n  border-radius: 5px;\n  background-color: #fff;\n}\n.scroll-enable.stories.carousel::-webkit-scrollbar-thumb {\n  border-radius: 5px;\n  -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);\n  background-color: #e1e4e6;\n}\n\n[data-bs-theme=dark] {\n  --bs-gray-100: #313235;\n  --bs-gray-200: #464950;\n  --bs-gray-300: #5f5f68;\n  --bs-gray-400: #a1a1a8;\n  --bs-gray-500: #bfc0c9;\n  --bs-gray-600: #c5c6cc;\n  --bs-gray-700: #ffffffb3;\n  --bs-gray-800: #fffffff9;\n  --bs-gray-900: #fff;\n  --bs-light: #202227;\n  --bs-secondary-rgb: 197, 198, 204;\n  --bs-body-bg: #191a1f;\n  --bs-body-color: #a1a1a8;\n  --bs-body-color-rgb: 161, 161, 168;\n  --bs-mode:#0f0f10;\n  --bs-mode-rgb:15, 15, 16;\n  --bs-border-color: rgba(255, 255, 255, 0.07);\n  --bs-card-bg-dark: #141519;\n  --bs-heading-color: var(--bs-gray-900);\n}\n[data-bs-theme=dark] .navbar {\n  --bs-navbar-color: var(--bs-gray-600);\n  --bs-navbar-disabled-color: var(--bs-gray-400);\n}\n[data-bs-theme=dark] .navbar-dark {\n  --bs-navbar-color: var(--bs-gray-900);\n}\n[data-bs-theme=dark] .dropdown-menu {\n  --bs-dropdown-bg: var(--bs-mode);\n  --bs-dropdown-link-disabled-color: var(--bs-gray-200);\n  box-shadow: none;\n  --bs-dropdown-divider-bg: var(--bs-border-color);\n  border: 1px solid var(--bs-border-color);\n}\n[data-bs-theme=dark] .alert-light {\n  --bs-alert-bg: var(--bs-gray-600);\n  --bs-alert-border-color: var(--bs-gray-600);\n}\n[data-bs-theme=dark] .bg-light {\n  background-color: var(--bs-light) !important;\n}\n[data-bs-theme=dark] .btn-dark {\n  --bs-btn-bg: var(--bs-mode);\n}\n[data-bs-theme=dark] .btn-close {\n  filter: invert(1) grayscale(100%) brightness(300%);\n}\n[data-bs-theme=dark] .btn-secondary-soft {\n  background-color: rgba(var(--bs-secondary-rgb), 0.1);\n  color: var(--bs-gray-600);\n}\n[data-bs-theme=dark] .btn-secondary-soft:hover {\n  background-color: rgba(var(--bs-secondary-rgb)) !important;\n  color: var(--bs-body-bg) !important;\n}\n[data-bs-theme=dark] .btn-secondary-soft-hover:hover {\n  background-color: rgba(var(--bs-secondary-rgb), 0.1);\n  color: var(--bs-gray-600) !important;\n}\n[data-bs-theme=dark] .btn-light {\n  --bs-btn-bg: var(--bs-light);\n  --bs-btn-color: var(--bs-gray-800);\n  --bs-btn-border-color: var(--bs-light);\n  --bs-btn-active-bg: var(--bs-gray-200);\n  --bs-btn-active-color: var(--bs-gray-800);\n}\n[data-bs-theme=dark] .modal {\n  --bs-modal-bg: var(--bs-body-bg);\n  --bs-modal-footer-border-color: var(--bs-border-color);\n}\n[data-bs-theme=dark] .card {\n  --bs-card-cap-bg: var(--bs-card-bg-dark) !important;\n  --bs-card-bg: var(--bs-card-bg-dark) !important;\n  --bs-card-border-color: var(--bs-light);\n}\n[data-bs-theme=dark] .offcanvas, [data-bs-theme=dark] .offcanvas-xxl, [data-bs-theme=dark] .offcanvas-xl, [data-bs-theme=dark] .offcanvas-lg, [data-bs-theme=dark] .offcanvas-md, [data-bs-theme=dark] .offcanvas-sm {\n  --bs-offcanvas-bg: var(--bs-body-bg);\n}\n[data-bs-theme=dark] .popover {\n  --bs-popover-bg:var(--bs-body-bg);\n}\n[data-bs-theme=dark] .accordion {\n  --bs-accordion-bg: var(--bs-body-bg);\n  --bs-accordion-active-bg: var(--bs-body-bg);\n}\n[data-bs-theme=dark] .accordion-item {\n  background-color: var(--bs-body-bg);\n  color: var(--bs-gray-400);\n}\n[data-bs-theme=dark] .accordion-item .accordion-button {\n  color: var(--bs-gray-400);\n}\n[data-bs-theme=dark] .bg-mode {\n  background: var(--bs-mode);\n}\n[data-bs-theme=dark] hr {\n  color: var(--bs-gray-300);\n}\n[data-bs-theme=dark] .fill-secondary {\n  fill: rgba(var(--bs-secondary-rgb)) !important;\n}\n[data-bs-theme=dark] .shadow, [data-bs-theme=dark] .shadow-lg, [data-bs-theme=dark] .shadow-sm {\n  box-shadow: none !important;\n}\n[data-bs-theme=dark] .navbar-nav .dropdown .dropdown-submenu:hover > .dropdown-menu {\n  box-shadow: none;\n}\n[data-bs-theme=dark] .iphone-x {\n  box-shadow: 0px 0px 0px 11px var(--bs-gray-600), 0px 0px 0px 13px var(--bs-gray-600), 0px 0px 0px 20px var(--bs-gray-400);\n}\n[data-bs-theme=dark] .iphone-x:after {\n  background-color: var(--bs-light);\n}\n[data-bs-theme=dark] .iphone-x:before {\n  background-color: var(--bs-gray-600);\n}\n[data-bs-theme=dark] .mac_screen {\n  background: var(--bs-gray-700);\n}\n[data-bs-theme=dark] .mac_screen:before {\n  border: none;\n}\n[data-bs-theme=dark] .form-control {\n  background-color: var(--bs-body-bg);\n  border-color: var(--bs-gray-100);\n}\n[data-bs-theme=dark] .form-control:focus {\n  border-color: var(--bs-primary);\n}\n[data-bs-theme=dark] .choices .choices__inner {\n  background-color: var(--bs-body-bg);\n  border: 1px solid var(--bs-gray-100);\n}\n[data-bs-theme=dark] .choices .choices__list--dropdown {\n  background-color: var(--bs-body-bg);\n  border: 1px solid var(--bs-gray-100);\n}\n[data-bs-theme=dark] .choices[data-type*=select-one] .choices__input {\n  background: var(--bs-body-bg);\n}\n[data-bs-theme=dark] .flatpickr-calendar {\n  background: var(--bs-mode);\n  border-color: var(--bs-mode);\n}\n[data-bs-theme=dark] .flatpickr-current-month .flatpickr-monthDropdown-months, [data-bs-theme=dark] .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {\n  background: var(--bs-mode);\n}\n[data-bs-theme=dark] .flatpickr-calendar.arrowBottom:before, [data-bs-theme=dark] .flatpickr-calendar.arrowBottom:after {\n  border-top-color: var(--bs-mode);\n}\n[data-bs-theme=dark] .flatpickr-calendar.arrowTop:before, [data-bs-theme=dark] .flatpickr-calendar.arrowTop:after, [data-bs-theme=dark] .flatpickr-current-month .numInputWrapper span.arrowUp:after {\n  border-bottom-color: var(--bs-mode);\n}\n[data-bs-theme=dark] .nav-tabs-white .nav-item .nav-link.active, [data-bs-theme=dark] .nav-tabs-white .nav-item .nav-link:hover {\n  background: var(--bs-mode);\n}\n[data-bs-theme=dark] .navbar.navbar-icon .navbar-nav .nav-item .nav-link.active:before {\n  border-color: var(--bs-mode) transparent transparent transparent;\n}\n@media (max-width: 575.98px) {\n  [data-bs-theme=dark] .navbar-expand-sm .navbar-collapse {\n    background: var(--bs-mode) !important;\n  }\n}\n@media (max-width: 767.98px) {\n  [data-bs-theme=dark] .navbar-expand-md .navbar-collapse {\n    background: var(--bs-mode) !important;\n  }\n}\n@media (max-width: 991.98px) {\n  [data-bs-theme=dark] .navbar-expand-lg .navbar-collapse {\n    background: var(--bs-mode) !important;\n  }\n}\n@media (max-width: 1199.98px) {\n  [data-bs-theme=dark] .navbar-expand-xl .navbar-collapse {\n    background: var(--bs-mode) !important;\n  }\n}\n@media (max-width: 1399.98px) {\n  [data-bs-theme=dark] .navbar-expand-xxl .navbar-collapse {\n    background: var(--bs-mode) !important;\n  }\n}\n[data-bs-theme=dark] .navbar-expand .navbar-collapse {\n  background: var(--bs-mode) !important;\n}\n[data-bs-theme=dark] .glightbox-clean .gslide-description {\n  background: var(--bs-mode);\n}\n[data-bs-theme=dark] .preloader {\n  background-color: var(--bs-mode);\n}\n[data-bs-theme=dark] .ticket-border:before {\n  background: var(--bs-mode);\n}\n[data-bs-theme=dark] .ticket-border:after {\n  background: var(--bs-mode);\n}\n[data-bs-theme=dark] .stories .story > .item-link > .item-preview img {\n  border: 2px solid var(--bs-mode);\n}\n[data-bs-theme=dark] .scroll-enable.stories.carousel::-webkit-scrollbar-track {\n  background-color: var(--bs-gray-200);\n}\n[data-bs-theme=dark] .scroll-enable.stories.carousel::-webkit-scrollbar {\n  background-color: var(--bs-gray-200);\n}\n[data-bs-theme=dark] .scroll-enable.stories.carousel::-webkit-scrollbar-thumb {\n  background-color: var(--bs-gray-400);\n}\n\n.modeswitch-item .btn-modeswitch {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: translateX(-14%);\n  height: 40px;\n  width: 40px;\n  background: var(--bs-light);\n  border-radius: 0.4rem;\n  transition: all 1s;\n}\n.modeswitch-item .btn-modeswitch svg {\n  fill: var(--bs-gray-900);\n}\n.modeswitch-item .btn-modeswitch.active {\n  background: var(--bs-primary);\n}\n.modeswitch-item .btn-modeswitch.active svg {\n  fill: var(--bs-white);\n}\n\n.dark-mode-item {\n  display: none !important;\n}\n\n[data-bs-theme=dark] .dark-mode-item {\n  display: inline-block !important;\n}\n[data-bs-theme=dark] .light-mode-item {\n  display: none !important;\n}\n\n/*User CSS*/",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Variables\r\n// Bootstrap variable overrides by theme author\r\n\r\n// Color system\r\n\r\n$white:       #fff;\r\n$gray-100:    #f7f8f9;\r\n$gray-200:    #eff2f6;\r\n$gray-300:    #eef0f2;\r\n$gray-400:    #e1e4e6;\r\n$gray-500:    #a1a1a8;\r\n$gray-600:    #676a79;\r\n$gray-700:    #29292e;\r\n$gray-800:    #14191e;\r\n$gray-900:    #0f0f10;\r\n$black:       #000;\r\n\r\n// scss-docs-start gray-colors-map\r\n$grays: (\r\n  \"100\": $gray-100,\r\n  \"200\": $gray-200,\r\n  \"300\": $gray-300,\r\n  \"400\": $gray-400,\r\n  \"500\": $gray-500,\r\n  \"600\": $gray-600,\r\n  \"700\": $gray-700,\r\n  \"800\": $gray-800,\r\n  \"900\": $gray-900\r\n);\r\n\r\n$blue:        #007bff;\r\n$indigo:      #6610f2;\r\n$purple:      #6f42c1;\r\n$pink:        #e83e8c;\r\n$red:         #d6293e;\r\n$orange:      #fd7e14;\r\n$yellow:      #f7c32e;\r\n$green:       #0cbc87; \r\n$teal:        #20c997;\r\n$cyan:        #4f9ef8; \r\n\r\n// scss-docs-start colors-map\r\n$colors: (\r\n\t\"blue\":       $blue,\r\n\t\"indigo\":     $indigo,\r\n\t\"purple\":     $purple,\r\n\t\"pink\":       $pink,\r\n\t\"red\":        $red,\r\n\t\"orange\":     $orange,\r\n\t\"yellow\":     $yellow,\r\n\t\"green\":      $green,\r\n\t\"teal\":       $teal,\r\n\t\"cyan\":       $cyan,\r\n\t\"black\":      $black,\r\n\t\"white\":      $white\r\n);\r\n\r\n$primary:     #0f6fec;\r\n$secondary:   $gray-800;\r\n$success:     $green;\r\n$info:        $cyan;\r\n$warning:     $yellow;\r\n$danger:      $red;\r\n$light:       $gray-300;\r\n$dark:        $gray-800;\r\n\r\n\r\n// theme colors map\r\n\r\n$theme-colors: (\r\n  \"primary\":    $primary,\r\n  \"secondary\":  $secondary,\r\n  \"success\":    $success,\r\n  \"info\":       $info,\r\n  \"warning\":    $warning,\r\n  \"danger\":     $danger,\r\n  \"light\":      $light,\r\n  \"dark\":       $dark\r\n);\r\n// scss-docs-end theme-colors-map\r\n\r\n// scss-docs-start theme-text-variables\r\n$primary-text-emphasis:   shade-color($primary, 30%);\r\n$secondary-text-emphasis: shade-color($secondary, 30%);\r\n$success-text-emphasis:   shade-color($success, 30%);\r\n$info-text-emphasis:      shade-color($info, 30%);\r\n$warning-text-emphasis:   shade-color($warning, 30%);\r\n$danger-text-emphasis:    shade-color($danger, 30%);\r\n$light-text-emphasis:     $gray-700;\r\n$dark-text-emphasis:      shade-color($dark, 30%);\r\n// scss-docs-end theme-text-variables\r\n\r\n// scss-docs-start theme-bg-subtle-variables\r\n$primary-bg-subtle:       tint-color($primary, 80%);\r\n$secondary-bg-subtle:     tint-color($secondary, 80%);\r\n$success-bg-subtle:       tint-color($success, 80%);\r\n$info-bg-subtle:          tint-color($info, 80%);\r\n$warning-bg-subtle:       tint-color($warning, 80%);\r\n$danger-bg-subtle:        tint-color($danger, 80%);\r\n$light-bg-subtle:         mix($gray-100, $white);\r\n$dark-bg-subtle:          tint-color($dark, 80%);\r\n// scss-docs-end theme-bg-subtle-variables\r\n\r\n// scss-docs-start theme-border-subtle-variables\r\n$primary-border-subtle:   tint-color($primary, 60%);\r\n$secondary-border-subtle: tint-color($secondary, 60%);\r\n$success-border-subtle:   tint-color($success, 60%);\r\n$info-border-subtle:      tint-color($info, 60%);\r\n$warning-border-subtle:   tint-color($warning, 60%);\r\n$danger-border-subtle:    tint-color($danger, 60%);\r\n$light-border-subtle:     $gray-200;\r\n$dark-border-subtle:      tint-color($dark, 60%);\r\n// scss-docs-end theme-border-subtle-variables\r\n\r\n// scss-docs-start theme-colors-rgb\r\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\");\r\n\r\n$soft-alpha:          .1;\r\n\r\n\r\n// theme soft colors map\r\n\r\n$theme-soft-colors: (\r\n  \"white-soft\":      rgba($white, $soft-alpha + 0.2),\r\n  \"primary-soft\":    rgba($primary, $soft-alpha),\r\n  \"secondary-soft\":  rgba($secondary, $soft-alpha),\r\n  \"success-soft\":    rgba($success, $soft-alpha),\r\n  \"info-soft\":       rgba($info, $soft-alpha),\r\n  \"warning-soft\":    rgba($warning, $soft-alpha + 0.05),\r\n  \"danger-soft\":     rgba($danger, $soft-alpha),\r\n  \"light-soft\":      rgba($light, $soft-alpha),\r\n  \"dark-soft\":       rgba($dark, $soft-alpha)\r\n);\r\n\r\n// The contrast ratio to reach against white\r\n$min-contrast-ratio:   2;\r\n\r\n// Options\r\n//\r\n// Quickly modify global styling\r\n\r\n$enable-negative-margins:     true;\r\n$enable-dark-mode:            true;\r\n\r\n\r\n// Prefix for :root CSS variables\r\n\r\n$variable-prefix:             bs- ; // Deprecated in v5.2.0 for the shorter `$prefix`\r\n$prefix:                      $variable-prefix;\r\n\r\n\r\n// Spacers\r\n\r\n$spacer: 1rem;\r\n$spacers: (\r\n  0: 0,\r\n  1: $spacer * .25,\r\n  2: $spacer * .5,\r\n  3: $spacer,\r\n  4: $spacer * 1.5,\r\n  5: $spacer * 3,\r\n);\r\n\r\n\r\n// Body\r\n\r\n$body-bg:                   $gray-200;\r\n$body-color:                $gray-600;\r\n\r\n$body-emphasis-color:       $black;\r\n\r\n$body-secondary-color:      rgba($body-color, .5);\r\n$body-secondary-bg:         $gray-200;\r\n\r\n$body-tertiary-color:       rgba($body-color, .5);\r\n$body-tertiary-bg:          $gray-100;\r\n\r\n$emphasis-color:            $black;\r\n\r\n// scss-docs-start utilities-colors\r\n$utilities-colors: $theme-colors-rgb;\r\n// scss-docs-end utilities-colors\r\n\r\n// Links\r\n\r\n$link-color:                $primary;\r\n$link-decoration:           none;\r\n$link-shade-percentage:     20%;\r\n$link-hover-color:          shift-color($primary, $link-shade-percentage);\r\n$link-hover-decoration:     null;\r\n\r\n\r\n// Grid breakpoints extend\r\n\r\n$grid-breakpoints: (\r\n  xs: 0,\r\n  sm: 576px,\r\n  md: 768px,\r\n  lg: 992px,\r\n  xl: 1200px,\r\n  xxl: 1400px\r\n);\r\n\r\n\r\n// Define the maximum width of `.container`\r\n\r\n$container-max-widths: (\r\n  sm: 96%,\r\n  md: 100%,\r\n  lg: 100%,\r\n  xl: 1140px,\r\n  xxl: 1200px\r\n);\r\n\r\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\r\n\r\n\r\n// Specify the width of the gutters.\r\n \r\n$grid-gutter-width:           1.5rem; // 30px\r\n\r\n\r\n// Container padding\r\n\r\n$container-padding-x:         $grid-gutter-width;\r\n\r\n\r\n// Components\r\n$border-style:              solid;\r\n$border-width:              1px;\r\n$border-color:              rgba($black, .1);\r\n\r\n$border-radius:             .40rem;\r\n$border-radius-sm:          .2rem;\r\n$border-radius-lg:          .7rem;\r\n\r\n$box-shadow:                  0px 0px 20px rgba(93, 83, 84, 0.15);\r\n$box-shadow-sm:               0 .125rem .25rem rgba(83, 88, 93, .15);\r\n$box-shadow-lg:               0 1rem 3rem rgba(83, 88, 93, .15);\r\n\r\n$component-active-color:        $white;\r\n$component-active-bg:           $primary;\r\n\r\n$transition-base:               all .3s ease-in-out;\r\n\r\n\r\n// Fonts\r\n//\r\n// Font Families\r\n\r\n$font-family-base:           'Inter', sans-serif;\r\n\r\n\r\n// Font Sizes\r\n\r\n$font-size-xs:                .8125rem;\r\n$font-size-base:              0.9375rem;\r\n$font-size-lg:                $font-size-base * 1.25;\r\n$font-size-sm:                $font-size-base * .875;\r\n\r\n$font-weight-light:           400;\r\n$font-weight-normal:          500;\r\n$font-weight-bold:            700;\r\n\r\n\r\n// Line Height\r\n\r\n$line-height-base:            1.5;\r\n$line-height-sm:              1.25;\r\n$line-height-lg:              2;\r\n\r\n\r\n// Headings\r\n\r\n$h1-font-size:                $font-size-base * 2.5;\r\n$h2-font-size:                $font-size-base * 2;\r\n$h3-font-size:                $font-size-base * 1.75;\r\n$h4-font-size:                $font-size-base * 1.5;\r\n$h5-font-size:                $font-size-base * 1.25;\r\n$h6-font-size:                $font-size-base;\r\n\r\n\r\n// font sizes\r\n\r\n$font-sizes: (\r\n  1: $h1-font-size,\r\n  2: $h2-font-size,\r\n  3: $h3-font-size,\r\n  4: $h4-font-size,\r\n  5: $h5-font-size,\r\n  6: $h6-font-size\r\n);\r\n\r\n$headings-margin-bottom:        .5rem;\r\n$headings-font-family:          'Inter', sans-serif;\r\n$headings-font-weight:          $font-weight-bold;\r\n$headings-line-height:          $line-height-sm;\r\n$headings-color:                var(--#{$prefix}gray-800);\r\n\r\n\r\n// display headings\r\n\r\n$display-font-sizes: (\r\n  1: 5rem,\r\n  2: 4.5rem,\r\n  3: 4rem,\r\n  4: 3.5rem,\r\n  5: 3rem,\r\n  6: 2.5rem\r\n);\r\n\r\n$display-font-weight:         $font-weight-bold;\r\n$display-line-height:         $headings-line-height;\r\n\r\n$lead-font-size:              $font-size-base * 1.25;\r\n$lead-font-weight:            $font-weight-light;\r\n\r\n$small-font-size:             .875em;\r\n\r\n$hr-color:                    var(--#{$prefix}gray-500);\r\n\r\n\r\n// Buttons + Forms\r\n\r\n$input-btn-padding-y:         .5rem;\r\n$input-btn-padding-x:         1rem;\r\n$input-btn-font-size:         $font-size-base;\r\n$input-btn-line-height:       $line-height-base;\r\n\r\n$input-btn-focus-width:       0;\r\n$input-btn-focus-color:       rgba($component-active-bg, .25);\r\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color;\r\n\r\n$input-btn-padding-y-sm:      .4rem;\r\n$input-btn-padding-x-sm:      .8rem;\r\n$input-btn-font-size-sm:      $font-size-xs;\r\n$input-btn-line-height-sm:    $line-height-sm;\r\n\r\n$input-btn-padding-y-lg:      .8rem;\r\n$input-btn-padding-x-lg:      1.5rem;\r\n$input-btn-font-size-lg:      1rem;\r\n$input-btn-line-height-lg:    $line-height-lg;\r\n\r\n$input-btn-border-width:      $border-width;\r\n\r\n\r\n// Buttons\r\n\r\n$btn-padding-y:               $input-btn-padding-y;\r\n$btn-padding-x:               $input-btn-padding-x;\r\n$btn-font-size:               $input-btn-font-size;\r\n$btn-line-height:             $input-btn-line-height;\r\n\r\n$btn-padding-y-sm:            $input-btn-padding-y-sm;\r\n$btn-padding-x-sm:            $input-btn-padding-x-sm;\r\n$btn-font-size-sm:            $input-btn-font-size-sm;\r\n$btn-line-height-sm:          $input-btn-line-height-sm;\r\n\r\n$btn-padding-y-lg:            $input-btn-padding-y-lg;\r\n$btn-padding-x-lg:            $input-btn-padding-x-lg;\r\n$btn-font-size-lg:            $input-btn-font-size-lg;\r\n$btn-line-height-lg:          $input-btn-line-height-lg;\r\n\r\n$btn-border-width:            $input-btn-border-width;\r\n\r\n$btn-font-weight:             $font-weight-normal;\r\n$btn-box-shadow:              none;\r\n$btn-focus-width:             $input-btn-focus-width;\r\n$btn-focus-box-shadow:        none;\r\n$btn-disabled-opacity:        .65;\r\n$btn-active-box-shadow:       none;\r\n\r\n$btn-link-color:              var(--#{$prefix}link-color);\r\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color);\r\n$btn-link-disabled-color:     var(--#{$prefix}gray-400);\r\n\r\n\r\n// Button border radius\r\n\r\n$btn-border-radius:           $border-radius;\r\n$btn-border-radius-sm:        $border-radius-sm;\r\n$btn-border-radius-lg:        $border-radius-sm;\r\n\r\n$btn-transition:              $transition-base;\r\n\r\n\r\n// Forms\r\n\r\n$input-padding-y:                       $input-btn-padding-y;\r\n$input-padding-x:                       $input-btn-padding-x;\r\n$input-font-size:                       $input-btn-font-size;\r\n$input-line-height:                     $input-btn-line-height;\r\n\r\n$input-padding-y-sm:                    $input-btn-padding-y-sm;\r\n$input-padding-x-sm:                    $input-btn-padding-x-sm;\r\n$input-font-size-sm:                    $input-btn-font-size-sm;\r\n$input-line-height-sm:                  $input-btn-line-height-sm;\r\n\r\n$input-padding-y-lg:                    $input-btn-padding-y-lg;\r\n$input-padding-x-lg:                    $input-btn-padding-x-lg;\r\n$input-font-size-lg:                    $input-btn-font-size-lg;\r\n$input-line-height-lg:                  $input-btn-line-height-lg;\r\n\r\n$input-bg:                              $white;\r\n$input-disabled-bg:                     var(--#{$prefix}gray-200);\r\n$input-disabled-border-color:           $input-border-color;\r\n\r\n$input-color:                           var(--#{$prefix}gray-700);\r\n$input-border-color:                    var(--#{$prefix}gray-400);\r\n$input-border-width:                    $input-btn-border-width;\r\n$input-box-shadow:                      unset;\r\n\r\n$input-border-radius:                   $border-radius;\r\n$input-border-radius-sm:                $border-radius-sm;\r\n$input-border-radius-lg:                $border-radius-sm;\r\n\r\n$input-focus-bg:                        $white;\r\n$input-focus-border-color:              $primary;\r\n$input-focus-color:                     $input-color;\r\n$input-focus-width:                     $input-border-width;\r\n$input-focus-box-shadow:                none;\r\n\r\n$input-placeholder-color:               var(--#{$prefix}gray-500);\r\n\r\n$input-height-border:                   $input-border-width * 2;\r\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false));\r\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false));\r\n$input-height-lg:                       add($input-line-height-sm * 1em, add($input-padding-y-lg * 2, $input-height-border, false));\r\n\r\n$form-check-input-bg:                     var(--#{$prefix}gray-200);\r\n$form-check-input-border:                 1px solid rgba(0, 0, 0, .25);\r\n$form-check-input-border-radius:          .25em;\r\n$form-check-radio-border-radius:          50%;\r\n$form-check-input-focus-border:           $input-focus-border-color;\r\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow;\r\n\r\n$form-check-input-checked-color:          $component-active-color;\r\n$form-check-input-checked-bg-color:       $component-active-bg;\r\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color;\r\n\r\n$form-check-input-indeterminate-color:          $component-active-color;\r\n$form-check-input-indeterminate-bg-color:       $component-active-bg;\r\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color;\r\n\r\n$form-switch-focus-color:         $input-focus-border-color;\r\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\r\n\r\n// scss-docs-start input-group-variables\r\n$input-group-addon-border-color:        $border-color;\r\n$input-group-addon-bg:                  var(--#{$prefix}gray-200);\r\n$input-group-addon-color:                $input-color;\r\n\r\n\r\n$form-select-padding-y:             $input-padding-y;\r\n$form-select-padding-x:             $input-padding-x;\r\n$form-select-font-size:             $input-font-size;\r\n$form-select-font-weight:           $input-font-weight;\r\n$form-select-line-height:           $input-line-height;\r\n$form-select-color:                 $input-color;\r\n$form-select-border-radius:         $border-radius;\r\n\r\n$form-select-focus-border-color:    $input-focus-border-color;\r\n$form-select-focus-box-shadow:      $input-btn-focus-box-shadow;\r\n\r\n$form-select-disabled-border-color:     $input-disabled-border-color;\r\n\r\n$form-range-thumb-bg:                      $component-active-bg;\r\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%);\r\n$form-range-thumb-disabled-bg:             $gray-500;\r\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1);\r\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow;\r\n\r\n\r\n// Z-index \r\n$zindex-header:                     $zindex-sticky;\r\n\r\n\r\n// Navs \r\n\r\n$nav-link-padding-y:                .25rem;\r\n$nav-link-padding-x:                .75rem;\r\n$nav-link-font-size:                null;\r\n$nav-link-font-weight:              null;\r\n$nav-link-color:                    var(--#{$prefix}body-color);\r\n$nav-link-hover-color:              null;\r\n$nav-link-disabled-color:           var(--#{$prefix}gray-500) !important;\r\n\r\n$nav-tabs-border-color:             $border-color;\r\n$nav-tabs-border-width:             $border-width;\r\n$nav-tabs-border-radius:            $border-radius;\r\n$nav-tabs-link-hover-border-color:  $nav-tabs-border-color $nav-tabs-border-color $nav-tabs-border-color;\r\n$nav-tabs-link-active-color:        $gray-700;\r\n$nav-tabs-link-active-bg:           $body-bg;\r\n$nav-tabs-link-active-border-color: $nav-tabs-border-color $nav-tabs-border-color $body-bg;\r\n\r\n$nav-pills-border-radius:           $border-radius;\r\n\r\n\r\n// Navbar\r\n\r\n$navbar-width: 300px;\r\n$navbar-height: 56px;\r\n\r\n$navbar-padding-y:                  0;\r\n$navbar-padding-x:                  0;\r\n\r\n$navbar-nav-link-padding-x:         1rem;\r\n$navbar-nav-link-font-size:         $font-size-base;\r\n$navbar-nav-link-font-weight:       600;\r\n$navbar-nav-link-text-transform:    capitalize;\r\n\r\n$navbar-brand-height:               36px; //Logo height\r\n$navbar-brand-padding-y:            10px;\r\n$nav-link-line-height:              $navbar-height;\r\n\r\n$sticky-navbar-brand-height:        22px; //sticky Logo height\r\n$sticky-navbar-brand-padding-y:     10px;\r\n$sticky-nav-link-line-height:       $navbar-height;\r\n\r\n$mobile-navbar-brand-height:        $navbar-brand-height; //mobile Logo height\r\n$mobile-navbar-brand-padding-y:     10px;\r\n\r\n$navbar-toggler-padding-x:          0;\r\n$navbar-toggler-focus-width:        $btn-focus-width;\r\n\r\n$navbar-dark-color:                 $white;\r\n$navbar-dark-hover-color:           $primary !important;\r\n$navbar-dark-active-color:          $primary !important;\r\n$navbar-dark-disabled-color:        rgba($white, .25);\r\n$navbar-dark-toggler-icon-bg:       str-replace(url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='#ffffff' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\"), \"#\", \"%23\");\r\n\r\n$navbar-light-color:                var(--#{$prefix}gray-600);\r\n$navbar-light-hover-color:          $primary;\r\n$navbar-light-active-color:         $primary;\r\n$navbar-light-disabled-color:       rgba($black, .3);\r\n$navbar-light-toggler-border-color: rgba($black, .1);\r\n\r\n$navbar-primary-color:              $white;\r\n$navbar-text-primary-hover-color:        var(--#{$prefix}gray-800);\r\n$navbar-primary-active-color:       var(--#{$prefix}gray-800);\r\n$navbar-primary-disabled-color:     rgba($white, .25);\r\n$navbar-primary-toggler-icon-bg:    str-replace(url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='#ffffff' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\"), \"#\", \"%23\");\r\n\r\n\r\n// Dropdowns\r\n\r\n$dropdown-min-width:                15rem;\r\n$dropdown-padding-y:                1rem;\r\n$dropdown-spacer:                   0;\r\n$dropdown-font-size:                $font-size-base;\r\n$dropdown-color:                    var(--#{$prefix}body-color);\r\n$dropdown-bg:                       $white;\r\n$dropdown-border-color:             rgba($black, .06);\r\n$dropdown-border-radius:            $border-radius;\r\n$dropdown-border-width:             1px;\r\n\r\n$dropdown-divider-bg:               $border-color;\r\n$dropdown-divider-margin-y:         $spacer * .5;\r\n$dropdown-box-shadow:               0px 20px 30px rgba(83, 88, 93, 0.10), 0px 0px 30px rgba(83, 88, 93, 0.20);\r\n\r\n$dropdown-link-color:               var(--#{$prefix}gray-600);\r\n$dropdown-link-hover-color:         $primary;\r\n$dropdown-link-hover-bg:            transparent;\r\n\r\n$dropdown-link-active-color:        $primary;\r\n$dropdown-link-active-bg:           $dropdown-link-hover-bg;\r\n\r\n$dropdown-link-disabled-color:      var(--#{$prefix}gray-600);\r\n\r\n$dropdown-item-font-weight:         $font-weight-light;\r\n\r\n$dropdown-item-padding-y:           .40rem;\r\n$dropdown-item-padding-x:           1.2rem;\r\n\r\n$dropdown-header-color:             var(--#{$prefix}gray-800);\r\n$dropdown-header-font-size:         $font-size-base;\r\n$dropdown-header-font-weight:       $font-weight-bold;\r\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x;\r\n\r\n$dropdown-dark-color:               var(--#{$prefix}gray-300);\r\n$dropdown-dark-bg:                  var(--#{$prefix}gray-800);\r\n$dropdown-dark-border-color:        $dropdown-border-color;\r\n$dropdown-dark-divider-bg:          rgba($white, .10);\r\n$dropdown-dark-link-color:          $dropdown-dark-color;\r\n$dropdown-dark-link-hover-color:    $white;\r\n$dropdown-dark-link-hover-bg:       $dropdown-link-hover-bg;\r\n$dropdown-dark-link-active-color:   $dropdown-link-active-color;\r\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg;\r\n$dropdown-dark-link-disabled-color: var(--#{$prefix}gray-500);\r\n$dropdown-dark-header-color:        var(--#{$prefix}gray-500);\r\n\r\n\r\n// Pagination\r\n\r\n$pagination-padding-y:              .4rem;\r\n$pagination-padding-x:              0.8rem;\r\n$pagination-padding-y-sm:           .25rem;\r\n$pagination-padding-x-sm:           .5rem;\r\n$pagination-padding-y-lg:           .75rem;\r\n$pagination-padding-x-lg:           1.5rem;\r\n\r\n$pagination-color:                  var(--#{$prefix}gray-600);\r\n$pagination-bg:                     $white;\r\n$pagination-border-width:           $border-width;\r\n$pagination-border-radius:          $border-radius;\r\n$pagination-border-color:           var(--#{$prefix}gray-300);\r\n\r\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow;\r\n$pagination-focus-outline:          0;\r\n$pagination-focus-color:            var(--#{$prefix}link-hover-color);\r\n$pagination-focus-bg:               var(--#{$prefix}gray-200);\r\n\r\n$pagination-hover-color:            $white;\r\n$pagination-hover-bg:               $primary;\r\n$pagination-hover-border-color:     $primary;\r\n\r\n$pagination-active-color:           $component-active-color;\r\n$pagination-active-bg:              $component-active-bg;\r\n$pagination-active-border-color:    $pagination-active-bg;\r\n\r\n$pagination-disabled-color:         var(--#{$prefix}gray-400);\r\n$pagination-disabled-bg:            $white;\r\n$pagination-disabled-border-color:  var(--#{$prefix}gray-300);\r\n\r\n\r\n// table  \r\n\r\n$table-group-separator-color:        var(--#{$prefix}gray-500);\r\n\r\n\r\n// Cards\r\n\r\n$card-spacer-y:                     1.25rem;\r\n$card-spacer-x:                     1.25rem;\r\n$card-border-radius:                $border-radius;\r\n$card-border-width:                 1px;\r\n$card-title-color:                  var(--#{$prefix}heading-color);\r\n$card-border-color:                 rgba($black, .09);\r\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width);\r\n$card-bg:                           $white;\r\n$card-cap-bg:                       $white;\r\n$card-box-shadow:                   0px 0px 24px rgba(0, 0, 0, 0.04);\r\n$card-cap-padding-y:                $card-spacer-y;\r\n$card-cap-padding-x:                $card-spacer-x;\r\n\r\n$card-img-overlay-padding:          1.25rem;\r\n\r\n$card-group-margin:                 $grid-gutter-width * .5;\r\n\r\n\r\n// Accordion\r\n$accordion-bg:                            $white;\r\n$accordion-color:                         $body-color;\r\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%);\r\n$accordion-button-active-color:           shade-color($primary, 10%);\r\n$accordion-border-color:                  rgba($body-color, .125);\r\n$accordion-button-focus-border-color:     none;\r\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow;\r\n$accordion-icon-color:                    $accordion-color;\r\n$accordion-icon-active-color:             $accordion-button-active-color;\r\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\r\n$accordion-button-active-icon-white:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$white}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\r\n$accordion-button-active-icon-dark:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$gray-500}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\r\n\r\n\r\n// Tooltips\r\n\r\n$tooltip-font-size:                 12px;\r\n\r\n\r\n// Badges\r\n\r\n$badge-font-weight:             $font-weight-light;\r\n$badge-font-size:               0.85em;\r\n$badge-pill-border-radius:      $border-radius;\r\n\r\n// Popover-variables\r\n$popover-bg:                        var(--#{$prefix}white);\r\n\r\n\r\n// Modals popup\r\n\r\n$modal-content-border-width:        0;\r\n$modal-content-border-radius:       $border-radius;\r\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width);\r\n$modal-content-bg:                  $white;\r\n\r\n// Progress bars\r\n\r\n$progress-bg:                       $border-color;\r\n\r\n\r\n// List group\r\n\r\n$list-group-color:                  var(--#{$prefix}gray-600);\r\n$list-group-bg:                     transparent;\r\n$list-group-border-radius:          $border-radius;\r\n$list-group-hover-bg:               var(--#{$prefix}light);\r\n$list-group-active-color:           $component-active-color;\r\n$list-group-active-bg:              $component-active-bg;\r\n$list-group-active-border-color:    $list-group-active-bg;\r\n$list-group-action-hover-color:     var(--#{$prefix}gray-700);\r\n$list-group-action-active-color:    var(--#{$prefix}body-color);\r\n$list-group-action-active-bg:       var(--#{$prefix}light);\r\n\r\n\r\n// Breadcrumbs\r\n\r\n$breadcrumb-padding-y:              .5rem;\r\n$breadcrumb-padding-x:              0;\r\n$breadcrumb-item-padding-x:         .8rem;\r\n\r\n$breadcrumb-bg:                     transparent;\r\n$breadcrumb-divider-color:          var(--#{$prefix}gray-500);\r\n$breadcrumb-active-color:           var(--#{$prefix}gray-500);\r\n$breadcrumb-divider:                quote(\"/\");\r\n$breadcrumb-divider-flipped:        $breadcrumb-divider;\r\n\r\n\r\n// Close\r\n\r\n$btn-close-focus-shadow:            $input-btn-focus-box-shadow;\r\n\r\n\r\n// Offcanvas\r\n\r\n$offcanvas-padding-x:               $grid-gutter-width;\r\n$offcanvas-border-color:            $border-color;\r\n$offcanvas-horizontal-width-sm:     270px;\r\n$offcanvas-bg-color:                $white;\r\n\r\n\r\n// Avatar\r\n\r\n$avatar-size-base: 3rem;\r\n$avatar-size-xxs: 1.5rem;\r\n$avatar-size-xs: 2.1875rem;\r\n$avatar-size-sm: 2.5rem;\r\n$avatar-size-lg: 4rem;\r\n$avatar-size-xl: 5.125rem;\r\n$avatar-size-xxl: 8rem;\r\n$avatar-size-xxxl: 11rem;\r\n\r\n$fa-font-family:        'Font Awesome 6 Free';  // If you are changing from free to pro. Change font-family here","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","//\n// accordion.scss\n// Extended from Bootstrap\n//\n\n// Additional style for theme\n// \n\n// Accordion collapse plus/minus icon\n.accordion{\n  &.accordion-icon{\n    .accordion-item {\n      box-shadow: none;\n      border-radius: $accordion-border-radius;\n      border: 1px solid var(--#{$prefix}border-color);\n    }\n    .accordion-header{\n      position: relative;\n      .accordion-button{\n        background:transparent;\n        font-size: inherit;\n        transition: none;\n        box-shadow: none !important;\n        &[aria-expanded=true] {\n          border-bottom: 1px solid var(--#{$prefix}border-color);\n        }\n        &:after {\n          content:\"\";\n          background: var(--#{$prefix}gray-800) !important;\n          width: 10px;\n          height: 2px;\n          display: block;\n          position: absolute;\n          top: 47%;\n          right: 20px;\n          transform: translateY(-50%);\n          transition: $transition-base;\n          transform: rotateZ(0deg);\n          z-index: 9;\n        }\n        &:before {\n          content:\"\";\n          background: var(--#{$prefix}gray-800) !important;\n          width: 10px;\n          height: 2px;\n          display: block;\n          position: absolute;\n          top: 47%;\n          right: 20px;\n          transform: translateY(-50%);\n          transition: $transition-base;\n          transform: rotateZ(0deg);\n          z-index: 9;\n        }\n        &[aria-expanded=false]:after {\n          transform: rotateZ(90deg);\n        }\n        &[aria-expanded=true]:before {\n          transform: rotateZ(0deg);\n        }\n      }\n    }\n    .accordion-collapse{\n      border: none;\n    }\n    .accordion-body {\n      padding: 1rem;\n    }\n  }\n}","// \n// breadcrumb.scss\n// Extended from Bootstrap\n// \n\n// \n// Bootstrap Overrides\n//\n.breadcrumb-item{\n  font-size: $font-size-xs;\n  a{\n    color: $body-color;\n    &:hover{\n      color: var(--bs-primary);\n    }\n  }\n}\n\n// \n// Additional style for theme\n// \n.breadcrumb.breadcrumb-dots{\n  .breadcrumb-item{\n    + .breadcrumb-item{\n      &::before{\n        content: \"•\";\n        font-size: 22px;\n        line-height: 0;\n        height: 100%;\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n}","// \r\n// buttons.scss\r\n// Extended from Bootstrap\r\n// \r\n\r\n//\r\n// Bootstrap Overrides\r\n//\r\n\r\n.btn-link{\r\n  padding: 0;\r\n}\r\n\r\n// \r\n// Additional styles for theme\r\n// \r\n\r\n.btn{\r\n  outline: 0;\r\n}\r\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show{\r\n  border-color: transparent !important;\r\n}\r\n.input-group .btn{\r\n  margin-bottom: 0;\r\n}\r\n.btn-xs{\r\n  padding: 0.4rem 0.6rem;\r\n  font-size: 0.6rem;\r\n  line-height: 1.2;\r\n  border-radius: $btn-border-radius-sm;\r\n}\r\n\r\n// button light\r\n.btn-light{\r\n  &.active, &:active, &:focus, &:hover{\r\n    background: var(--#{$prefix}gray-400);\r\n    color: var(--#{$prefix}gray-900);\r\n    border: 1px solid transparent !important;\r\n  }\r\n}\r\n\r\n// button white\r\n.btn-white{\r\n  background: var(--#{$prefix}white);\r\n  color: $dark;\r\n  &.active, &:active, &:focus, &:hover{\r\n    background: var(--#{$prefix}white);\r\n    color: $dark;\r\n  }\r\n}\r\n\r\n// button outline light\r\n.btn-outline-light{\r\n  background: transparent;\r\n  border-color: var(--#{$prefix}gray-400);\r\n  color: var(--#{$prefix}body-color);\r\n}\r\n.btn-outline-light:hover,\r\n.btn-outline-light:focus,\r\n.btn-outline-light:active,\r\n.btn-check:checked + .btn-outline-light{\r\n  background: var(--#{$prefix}gray-400);\r\n  border-color: var(--#{$prefix}gray-400);\r\n  color: var(--#{$prefix}gray-800);\r\n}\r\n\r\n// button soft\r\n@mixin button-soft-variant($color, $soft-background: rgba($color, .1)) {\r\n  color: $color;\r\n  background-color: $soft-background;\r\n  &:active, &:hover, &:focus {\r\n    color: color-contrast($color) !important;\r\n    background-color: $color !important;\r\n    border-color: $color !important; \r\n  }\r\n}\r\n@each $color, $value in $theme-colors {\r\n  .btn-#{$color}-soft {\r\n    @include button-soft-variant($value);\r\n  }\r\n}\r\n\r\n// button soft hover\r\n@mixin button-soft-variant-hover($color, $soft-background: rgba($color, .1)){\r\n  &:hover {\r\n    color: $color !important;\r\n    background-color: $soft-background;\r\n  }\r\n}\r\n@each $color, $value in $theme-colors{\r\n  .btn-#{$color}-soft-hover:hover{\r\n    @include button-soft-variant-hover($value);\r\n  }\r\n}\r\n\r\n// button dashed\r\n.btn-dashed{\r\n  background: \r\n  linear-gradient(90deg, var(--#{$prefix}border-color) 50%, transparent 50%),\r\n  linear-gradient(0deg, var(--#{$prefix}border-color) 50%, transparent 50%),\r\n  linear-gradient(90deg, var(--#{$prefix}border-color) 50%, transparent 50%),\r\n  linear-gradient(0deg, var(--#{$prefix}border-color) 50%, transparent 50%);\r\n  background-repeat: repeat-x, repeat-y, repeat-x, repeat-y;\r\n  background-size: 10px 2px, 2px 10px, 10px 2px, 2px 10px;\r\n  background-position: left top, right top, left bottom, left top;\r\n  padding: $btn-padding-y, $btn-padding-x;\r\n    &:hover{\r\n      animation: border-dance 4s infinite linear;\r\n    }\r\n  }\r\n  @keyframes border-dance{\r\n    0%{\r\n      background-position: left top, right top, right bottom, left bottom;\r\n    }\r\n    100% {\r\n      background-position: right top, right bottom, left bottom, left top;\r\n    }\r\n  }\r\n \r\n// button loader\r\n.btn-loader{\r\n  position: relative;\r\n  text-align: center;\r\n  .load-icon{\r\n    display: none;\r\n    margin: 0 auto;\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n  }\r\n  .load-text{\r\n    opacity: 1;\r\n    visibility: visible;\r\n  }\r\n}\r\n.btn-loader.active{\r\n  .load-text{\r\n    opacity: 0;\r\n    visibility: hidden;\r\n  }\r\n  .load-icon{\r\n    display: block;\r\n  }\r\n}\r\n\r\n// Spinner dots\r\n.spinner-dots{\r\n  align-items: center;\r\n  display: flex;\r\n  justify-content: center;\r\n  }\r\n  .spinner-dot{\r\n  background-color: var(--#{$prefix}gray-500);\r\n  display: inline-block;\r\n  height: 4px;\r\n  margin: 2px;\r\n  border-radius: 50%;\r\n  width: 4px;\r\n  }\r\n  @keyframes dot{\r\n  0% { background-color: var(--#{$prefix}gray-500); transform: scale(1); }\r\n  50% { background-color: var(--#{$prefix}gray-600); transform: scale(1.3); }\r\n  100% { background-color: var(--#{$prefix}gray-500); transform: scale(1); }\r\n}\r\n\r\n// button link loader active\r\n.btn-link-loader.active {\r\n  .spinner-dots { \r\n    .spinner-dot { \r\n      animation: dot ease-in-out 1s infinite;\r\n    }\r\n    .spinner-dot:nth-of-type(2) {\r\n      animation-delay: 0.2s;\r\n    }\r\n    .spinner-dot:nth-of-type(3) {\r\n    animation-delay: 0.3s;\r\n    }\r\n  }\r\n}\r\n","// \n// card.scss\n// Extended from Bootstrap\n//\n\n// Quick fix for border radius issue in safari\n.card.overflow-hidden {\n  will-change: transform;\n}\n\n// \n// Additional styles for theme\n// \n\n// Hovering on card to show element\n.card{\n  .card-image{\n    position: relative;\n    .card-element-hover{\n      visibility: hidden;\n      margin-top: 20px;\n      opacity: 0;\n      transition: $transition-base;\n      z-index: 9;\n    }\n  }\n  &:hover{\n    .card-image{\n      .card-element-hover{\n        visibility: visible;\n        margin-top: 0px;\n        opacity: 1;\n      }\n    }\n  }\n}\n\n// Card overlay on bottom\n.card{\n  &.card-overlay-bottom{\n    overflow: hidden;\n    &:before {\n      content: \"\";\n      position: absolute;\n      height: 50%;\n      width: 100%;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      background-image: -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba($black, 1)));\n      background-image: linear-gradient(180deg, transparent, rgba($black, 1));\n      z-index: 1;\n    }\n  }\n  .card-img-overlay{\n    z-index: 2;\n  }\n}","// \r\n// dropdowns.scss\r\n// Extended from Bootstrap\r\n// \r\n\r\n// \r\n// Bootstrap Overrides\r\n//\r\n.dropdown-menu {\r\n  box-shadow: $dropdown-box-shadow;\r\n}\r\n\r\n// dropdown item active\r\n.dropdown-item.active {\r\n  color: var(--bs-primary);\r\n}\r\n\r\n// Dropdown arrows\r\n// Replace original arrows with Custom icons\r\n// \r\n.dropdown-toggle {\r\n  &:after {\r\n    content: \"\\f078\";\r\n    font-family: $fa-font-family;\r\n    font-size: 0.5rem;\r\n    margin-left: 0.35rem;\r\n    font-weight: 900;\r\n    vertical-align: middle;\r\n    border: none;\r\n  }\r\n}\r\n\r\n.dropup .dropdown-toggle {\r\n  &:after {\r\n    content: \"\\f077\";\r\n    font-family: $fa-font-family;\r\n    font-size: 0.7rem;\r\n    margin-left: 0.35rem;\r\n    font-weight: 900;\r\n    vertical-align: middle;\r\n    border: none;\r\n  }\r\n}\r\n\r\n// Dropdown overrides for navbar only\r\n.dropdown-menu .dropdown-toggle {\r\n  &:after {\r\n    position: absolute;\r\n    right: 25px;\r\n    top: 10px\r\n  }\r\n  &:before {\r\n    position: absolute;\r\n    right: 25px;\r\n    top: 10px\r\n  }\r\n}\r\n\r\n// \r\n// Additional style for theme\r\n// \r\n\r\n// dropdown menu md size\r\n.dropdown-menu-size-md{\r\n  min-width: 22rem;\r\n}\r\n\r\n// dropdown breakpoint\r\n@include media-breakpoint-down(sm) {\r\n  .dropdown-menu-size-md{\r\n    min-width: 16rem;\r\n  }\r\n}","// \r\n// list-group.scss\r\n// Extended from Bootstrap\r\n// \r\n\r\n// \r\n// Additional style for theme\r\n// \r\n\r\n// list group borderless\r\n.list-group-borderless {\r\n  .list-group-item {\r\n    border: none;\r\n    padding: 0.425rem 0;\r\n  }\r\n  a.list-group-item {\r\n    &:hover {\r\n      background-color: transparent;\r\n      color: var(--bs-primary);\r\n    }\r\n  }\r\n}","// \n// nav.scss\n// Extended from Bootstrap\n// \n\n// \n// Additional style for theme\n// \n\n\n// Nav link active color\n.nav {\n  .nav-item{ \n    .nav-link{\n      background: transparent;\n      border: 1px solid transparent;\n      &.active{\n        color: var(--#{$prefix}primary);\n      }\n    }\n  }\n}\n\n// Pills\n.nav-pills{\n  .nav-link{\n    cursor: pointer;\n    margin-bottom: 15px;\n    padding: 0.5rem 1rem;\n  }\n}\n.nav-pills.nav-pills-light{\n  .nav-link{\n    &:hover{\n      background-color: var(--#{$prefix}light);\n    }\n    &.active{\n      background-color: var(--#{$prefix}light);\n    }\n  }\n}\n\n\n//Nav pills primary soft\n.nav-pills-soft .nav-link:hover{\n  border: 1px solid transparent;\n}\n.nav-pills-soft .nav-link.active,\n.nav-pills-soft .show > .nav-link {\n  background-color: rgba(var(--#{$prefix}primary-rgb), 0.1);\n  border: 1px solid transparent;\n}\n\n// tab line\n.nav.nav-bottom-line{ \n  border-bottom: solid 1px var(--#{$prefix}border-color);\n  .nav-link{\n    border: transparent;\n    font-weight: 600;\n    padding: ($nav-link-padding-y * 3) ($nav-link-padding-x * 1.3);\n  }\n  .nav-item:first-child .nav-link{\n    padding-left: 0;\n  }\n  .nav-link{\n    background: transparent;\n    border-bottom: 3px solid transparent;\n    &.active {\n      background: transparent;\n      color: var(--bs-primary);\n      border-bottom: 3px solid var(--bs-primary);\n    }\n  }\n  .nav-item{\n    margin-bottom: -2px;\n  }\n}\n\n// nav\n.nav.flex-column:not(.nav-pills) .nav-link{\n  padding-left: 0;\n  padding-top: 0.30rem;\n  padding-bottom: 0.30rem;\n}\n\n// Tab content\n.tab-content{\n  padding: 25px 0;\n  margin-bottom: 20px;\n}\n.nav-tabs{\n  .nav-link{\n    padding: 0.5rem 1rem;\n  }\n}\n\n// nav tabs white\n.nav-tabs-white{\n  border-radius: $border-radius;\n  .nav-item{\n    .nav-link{\n      transition: $transition-base;\n      border: 0;\n      border-radius: $border-radius;\n      margin-right: 4px;\n      font-weight: 600;\n    }\n    &:last-child{\n      .nav-link{\n        margin-right: 0;\n      }\n    }\n    .nav-link.active, .nav-link:hover{\n      background: $white;\n      color: var(--#{$prefix}primary);\n    }\n  }\n}\n\n// nav divider\n.nav.nav-divider{\n  .nav-item+.nav-item:before{\n    content: \"\\2022\";\n    color: inherit;\n    padding-left: .6rem;\n    padding-right: .6rem;\n    opacity: 0.8;\n  }\n  .nav-item{\n    display: flex;\n    align-items: center;\n  }\n  .nav-link{\n    padding: 0;\n  }\n}\n\n// nav link secondary\n.nav-link-secondary {\n  .nav-item{ \n    .nav-link{\n      color: $headings-color;\n      &:hover, &.active{\n        color: var(--bs-primary);\n      }\n    }\n  }\n}\n\n// nav stack \n.nav-stack{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n  gap: 0.7rem;\n  .nav-link{\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n// nav icon\n.nav{\n  .nav-item{\n    .nav-link{\n      .nav-icon{\n        background: var(--bs-light);\n        height: 2.1rem;\n        width: 2.1rem;\n        font-size: 1.1em;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 50%;\n        transition: $transition-base;\n      } \n      &:hover{\n        .nav-icon{\n          background:  var(--bs-primary);\n          color:  var(--bs-white);\n        }\n      }\n    } \n  }\n}\n\n// nav sidenav breakpoint up for nav sidenav\n@include media-breakpoint-up(lg){\n  // nav sidenav\n  .nav-sidenav{\n    width: 5rem;\n    transition: width 0.3s;\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 9;\n    margin-top: $navbar-height;\n    .nav-link{\n      display: flex;\n      align-items: center;\n      white-space: nowrap;\n      padding-left: 0;\n    }\n    .nav-text{\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.2s ease-in-out;\n    }\n  }\n  \n  // sidebar start enabled\n  .sidebar-start-enabled{\n    .nav-sidenav {\n      width: 270px;\n      .nav-text{\n        display: flex;\n        opacity: 1;\n        visibility: visible;\n        padding-left: 10px;\n      }\n    }\n  }\n}\n\n// nav sidenav breakpoint down for nav sidenav\n@include media-breakpoint-down(lg){\n  // nav sidenav\n  .nav-sidenav{\n    width: 270px;\n    left: 0;\n    transition: transform .3s ease-in-out;\n    position: fixed;\n    top: 0;\n    z-index: 9;\n    margin-top: $navbar-height;\n    transform: translateX(-100%);\n    .nav-text{\n      padding-left: 10px;\n    }\n  }\n  .sidebar-start-enabled{\n    .nav-sidenav{\n      transform: none;\n    }\n  }\n}\n\n\n// Nav breakpoint up for sidebar end\n@include media-breakpoint-up(lg){\n  \n  // sidebar end\n  .sidebar-end{\n    width: 5rem;\n    transition: width 0.3s;\n    position: fixed;\n    right: 0;\n    top: 0;\n    margin-top: $navbar-height;\n    z-index: 9;\n    .sidebar-end-alignment{\n      align-items: center;\n    }\n    .nav-link{\n      display: flex;\n      align-items: center;\n    }\n    .contact-name, .contact-search, .contact-title, .contact-status{\n      opacity: 0;\n      display: none;\n      visibility: hidden;\n      transition: all 0.5s ease-in-out;\n      white-space: nowrap;\n    }\n  }\n  \n  // sidebar end enabled\n  .sidebar-end-enabled{\n    .sidebar-end{\n      width: 270px;\n      .sidebar-end-alignment{\n        align-items: inherit;\n      }\n      .contact-name, .contact-search, .contact-title, .contact-status{\n        display: flex;\n        opacity: 1;\n        visibility: visible;\n        transition: all 0.2s ease-in-out;\n      }\n    }\n  }\n}\n\n// sidebar end breakpoint down for sidebar end\n@include media-breakpoint-down(lg){ \n  \n  // sidebar-end\n  .sidebar-end{\n    width: 270px;\n    right: 0;\n    transition: transform .3s ease-in-out;\n    position: fixed;\n    top: 0;\n    z-index: 9;\n    transform: translateX(100%);\n  }\n  .sidebar-end-enabled{\n    .sidebar-end{\n      transform: none;\n    }\n  }\n}","// \n// navbar.scss\n// Extended from Bootstrap\n// \n\n// \n// Bootstrap Overrides and Additional style for theme\n// \n\nheader {\n  height: $navbar-height;\n}\n\n.navbar-nav {\n  .nav-link {\n    font-size: $navbar-nav-link-font-size;\n    font-weight: $navbar-nav-link-font-weight;\n    text-transform: $navbar-nav-link-text-transform;\n    line-height: $nav-link-line-height;\n    padding-top: 0; \n    padding-bottom: 0; \n    .nav-icon {\n      margin-right: 0.3rem;\n    }\n  }\n  .nav-item:last-child .nav-link {\n    padding-right: 0;\n  }\n}\n\n// Navbar inside offcanvas\n.offcanvas {\n  .navbar-nav {\n    .nav-link {\n      line-height: inherit;\n      padding: $nav-link-padding-y $nav-link-padding-x;\n    }\n  }\n}\n\n// navbar toggler\n.navbar-toggler{ \n  margin-bottom: 0; \n  border: 0;\n  background-color: var(--#{$prefix}light);\n} \n\n//\n// header Styles\n//\n\n// Navbar transparent\n.navbar-transparent {\n  background: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n// Navbar dark\n  .navbar-dark .navbar-top {\n    span:not(.dropdown-item-text){\n      color: $white;\n    }\n    a:not(.dropdown-item){\n      color: $white;\n      &:hover {\n        color: var(--bs-primary);\n      }\n    }\n  }\n  .navbar-dark .nav .nav-link{\n    color: $white;\n    &:hover {\n      color: var(--bs-primary);\n    }\n  }\n  @include media-breakpoint-down(lg) {\n    .navbar-dark .navbar-nav .nav-link {\n      color: $dropdown-link-color;\n    }\n  }\n\n// Navbar brand (Logo) \n.navbar-brand {\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  .navbar-brand-item {\n    height: $navbar-brand-height;\n    display: block;\n    width: auto;\n  }\n}\n\n@include media-breakpoint-down(lg) {\n  .navbar-brand {\n    padding-top: $mobile-navbar-brand-padding-y;\n    padding-bottom: $mobile-navbar-brand-padding-y;\n    .navbar-brand-item {\n      height: $mobile-navbar-brand-height;\n    }\n  }\n}\n\n// Toggle plus icon for navbar dropdown submenu only\n.navbar .dropdown-menu .dropdown-submenu.dropend .dropdown-toggle:after {\n  content: \"\\f00d\";\n  font-family: $fa-font-family;\n  font-size: 10px;\n  top: 10px;\n  transform: rotate(45deg);\n  transition: $transition-base;\n  border: none !important;\n  margin: 0;\n}\n\n// Toggle plus icon position change in none touch devices on hover\n@media (hover: hover) {\n  .navbar .dropdown-menu .dropdown-submenu.dropend:hover > .dropdown-toggle:after {\n    transform: rotate(90deg);\n  }\n}\n\n// Toggle plus icon position change in touch devices on touch\n.navbar .dropdown-menu .dropdown-submenu.dropend .dropdown-opened.dropdown-toggle:after {\n  transform: rotate(90deg);\n}\n\n.navbar .dropdown-menu .dropdown-submenu.dropstart .dropdown-toggle:before {\n  content: \"\\f00d\";\n  font-family: $fa-font-family;\n  font-size: 10px;\n  top: 8px;\n  transform: rotate(45deg);\n  transition: $transition-base;\n  border: none !important;\n  margin: 0;\n  font-weight: 900;\n}\n.navbar .dropdown-menu .dropdown-submenu.dropstart:hover > .dropdown-toggle:before {\n  transform: rotate(90deg);\n}\n\n// navbar expand xl \n\n// `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n    \n    // Styling for navbar-expand\n    &#{$infix} {\n\n      // Navbar styling for navbar expand\n      @include media-breakpoint-up($next) {\n        .navbar-nav {\n          .dropdown-menu {\n            top: 120%;\n            visibility: hidden;\n            opacity: 0;\n            display: block;\n            transition: all 0.1s ease-in-out;\n          }\n          .dropdown {\n            &:hover {\n              >.dropdown-menu {\n                top: 100%;\n                visibility: visible;\n                opacity: 1;\n                transition: $transition-base;\n              }\n            }\n          }\n          .dropdown-submenu {\n            &:hover {\n              >.dropdown-menu {\n                top: 0;\n                visibility: visible;\n                opacity: 1;\n                transition: $transition-base;\n              }\n            }\n          }\n        }\n        .dropdown-submenu {\n          position: relative;\n        }\n      }\n\n      // Navbar styling for navbar collapse\n      @include media-breakpoint-down($next) {\n        .navbar-collapse{\n          box-shadow: 0px 10px 30px rgba(83, 88, 93, .2);\n          position: absolute;\n          left: 0;\n          right: 0;\n          top: 100%;\n          background: $white;\n          border-top: 1px solid var(--#{$prefix}border-color);\n          .navbar-nav {\n            // dropdown toggle down arrow position\n            .dropdown-toggle::after {\n              position: absolute;\n              right: 25px;\n            }\n            .dropdown-menu {\n              box-shadow: none;\n              &:before {\n                content: none;\n              }\n            }\n            .dropdown-submenu .dropdown-menu{\n              padding-left: 20px;  \n              padding-bottom: 0px;\n            }\n            > .nav-item{ \n              border-bottom: 1px solid rgba($black, 0.1);\n              padding: 5px 30px; \n              position: relative;\n              .nav-link{\n                line-height: 40px;\n              }\n            }\n          }\n        }\n        // Submenu open under submenu\n        .navbar-nav .dropdown-menu {\n          position: static;\n          float: none;\n        }\n      \n        // Menu 1st level dropdown bg color and padding in responsive\n        .navbar-nav .nav-item > .dropdown-menu{\n          background: rgba($body-color, 0.04);\n          padding: 20px 0px;\n          margin: 10px 0;\n        }\n        // Menu levels dropdown bg color and padding in responsive\n        .navbar-nav .nav-item > .dropdown-menu .dropdown-submenu .dropdown-menu {\n          background: rgba($body-color, 0.06);\n          padding: 10px 0px !important;\n        }\n      }\n    }\n  }\n}\n \n// navbar-icon\n.navbar.navbar-icon {\n  .navbar-nav {\n    .nav-item {\n      position: relative;\n      padding-top: 0;\n      padding-bottom: 0;\n      .nav-link {\n        font-size: 1.3rem;\n        color:  var(--bs-gray-700);\n        padding: 0 1.2rem;\n        margin-right: 0.5rem;\n        margin-left: 0.5rem;\n        position: relative;\n        &:hover {\n          color: var(--bs-primary);\n          box-shadow: inset 0px 4px 0px var(--bs-primary);\n        }\n        &.active {\n          color: var(--bs-primary);\n          box-shadow: inset 0px 4px 0px var(--bs-primary);\n\n          &:before {\n            position: absolute;\n            top: 100%;\n            width: 0;\n            height: 0;\n            content: \"\";\n            border-style: solid;\n            border-width: 10px 10px 0 10px;\n            border-color: var(--bs-white) transparent transparent transparent;\n          }\n        }\n        &:last-child {\n          padding-right: 1.2rem;\n        }\n      }\n      .notif-badge {\n        width: 6px;\n        height: 6px;\n        background: $danger;\n        border-radius: 50%;\n        position: absolute;\n        top: inherit;\n        bottom: 10px;\n        right: 0;\n        left: 0;\n        margin: 0 auto;\n        z-index: 1;\n      }\n\n      @include media-breakpoint-up(lg){ \n        .nav-link {\n          .nav-text {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n\n  @include media-breakpoint-down(lg){ \n    .navbar-collapse  {\n      width: 100%;\n      margin: 0 auto;\n      text-align: center;\n      .navbar-nav {\n        .nav-item {\n          padding: 0 10px;\n          .nav-link {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 1rem;\n            padding: 0.2rem 1.2rem;\n            &::before {\n              display: none;\n            }\n            .nav-text {\n              margin-left: 0.4rem;\n            }\n            .badge-notif.badge-notif-bottom {\n              position: static;\n              margin: inherit;\n            }\n          }\n          .notif-badge { \n            bottom: inherit;\n            right: inherit;\n            top: 50%;\n            transform: translateY(-50%);\n          }\n        }\n      }\n    }\n  }\n}\n\n// Navbar vertical\n@include media-breakpoint-up(lg) {\n  .navbar-vertical {\n    bottom: 0;\n    display: block;\n    max-width: $navbar-width;\n    position: fixed;\n    z-index: 9;\n    height: 100vh;\n    top: $navbar-height;\n    width: 100%;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    \n    .offcanvas-start {\n      top: $grid-gutter-width;\n      left: inherit;\n      position: relative;\n      width: auto;\n      border: none !important;\n      transform: none;\n      height: calc(100% - $grid-gutter-width * 4);\n      visibility: visible !important;\n    }\n  }\n  .navbar-vertical + .page-content {\n    margin-left: calc($navbar-width + 1.5rem);\n  }\n  .page-content {\n    position: relative;\n    height: 100%;\n    display: block;\n    padding: 0 0.7rem 0 0;\n  }\n}\n\n// Header fixed top\nheader.fixed-top + main {\n  padding-top: calc($grid-gutter-width + $navbar-height);\n  margin-bottom: $grid-gutter-width;\n}\n\n// Navbar toggler icon animation\n.navbar-toggler .navbar-toggler-animation {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  background-image: none;\n  position: relative;\n  height: 18px;\n  width: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n.navbar-toggler .navbar-toggler-animation span {\n  transition: all 0.3s ease-in-out;\n  -webkit-transform: rotateZ(0deg);\n          transform: rotateZ(0deg);\n  height: 2px;\n  background: var(--#{$prefix}gray-600);\n  display: block;\n  position: absolute;\n  width: 100%;\n  border-radius: 30px;\n}\n.navbar-toggler .navbar-toggler-animation span:nth-child(1) {\n  top: 10%;\n}\n.navbar-toggler .navbar-toggler-animation span:nth-child(2) {\n  top: 50%;\n  transform: translateY(-50%);\n}\n.navbar-toggler .navbar-toggler-animation span:nth-child(3) {\n  bottom: 10%;\n}\n.navbar-toggler[data-bs-toggle=collapse][aria-expanded=true] .navbar-toggler-animation span:nth-child(1) {\n  transform: rotateZ(45deg) translateY(-50%);\n  top: 47%;\n  transform-origin: 47% 0;\n  width: 100%;\n}\n.navbar-toggler[data-bs-toggle=collapse][aria-expanded=true] .navbar-toggler-animation span:nth-child(2) {\n  visibility: hidden;\n  transition: all 0s ease-in-out;\n}\n.navbar-toggler[data-bs-toggle=collapse][aria-expanded=true] .navbar-toggler-animation span:nth-child(3) {\n  transform: rotateZ(-45deg) translateY(-50%);\n  bottom: 42%;\n  transform-origin: 50% 0;\n  width: 100%;\n}\n \n","// \n// pagination.scss\n// Extended from Bootstrap\n// \n\n// \n// Additional style for theme\n//\n\n// For better breakpoint\n.pagination{\n  .page-item{\n    margin-bottom: 5px;\n    float: left;\n  }\n}\n\n// pagination bordered\n.pagination-light{\n  .page-item{\n    margin: 2px;\n    &.active .page-link{\n      background-color: var(--bs-primary) !important;\n    }\n    &.disabled .page-link{\n      background-color: transparent !important;\n    }\n  }\n  .page-link{\n    border-color: var(--#{$prefix}light);\n    background-color: var(--#{$prefix}light);\n    border-radius: $border-radius-sm;\n    &:hover{\n      background-color: $pagination-hover-bg;\n      border-color: $pagination-hover-border-color;\n    }\n  }\n}","// \n// reboot.scss\n// Extended from Bootstrap\n// \n\nbody{\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  height: 100%;\n  overflow-x: hidden;\n  z-index: 0;\n  position: relative;\n}\n\nmain{\n  background-color: var(--#{$prefix}body-bg);\n}\n\nheader{\n  position: relative;\n  z-index: $zindex-header;\n}\n\na{\n  transition: $transition-base;\n}\n\n*:focus{\n  outline: none !important;\n}\n\n%heading > a{\n  color: $headings-color;\n  &:hover{\n    color: var(--bs-primary);\n  }\n}\n\nimg{\n  max-width: 100%;\n  height: auto;\n}\n\nvideo{\n  background-size: cover;\n  display: table-cell;\n  vertical-align: middle;\n  width: 100%;\n}\n\n// Section padding top and bottom\nsection{\n  padding-top: ($spacer * 1.5);\n  padding-bottom: ($spacer * 1.5);\n}\n\n@include media-breakpoint-down(md) {\n  section{\n    padding-top: ($spacer * 4);\n    padding-bottom: ($spacer * 3);\n  }\n}\n","// \n// type.scss\n// Extended from Bootstrap\n// \n\n// \n// Additional style for theme\n//\n\n//\n// Emphasis\n//\nsmall,\n.small{\n  font-weight: $font-weight-light;\n}\n.smaller{\n  font-size: 60%;\n  font-weight: $font-weight-normal;\n}\n\n// dropcap\n.dropcap{\n  font-size: 4em;\n  font-weight: bold;\n  display: block;\n  float: left;\n  margin: .04em .2em 0 0;\n  color: $headings-color;\n  line-height: 1;\n}\n\n// Background overlay. Use with bootstrap bg colors and bg opacity classes like this >> bg-overlay bg-dark bg-opacity-10\n.bg-overlay{\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n\n//\n// blockquote\n//\n.blockquote{\n  position: relative;\n  padding-left: 80px;\n  &:before{\n    content: '\"';\n    position: absolute;\n    top: 0;\n    left: 0;\n    font-size: 8rem;\n    line-height: 0.8em;\n    font-weight: $font-weight-bold;\n    color: var(--bs-primary);\n  }\n}\n.blockquote-footer{\n  margin-top: 12px;\n  padding-left: 80px;\n}\n","// \n// badge.scss\n// Extended from Bootstrap\n// \n\n// \n// Additional style for theme\n//\na.badge{\n  &:hover{\n    color: $white;\n  }\n}\n\n// unread notification\n.badge-unread{\n  background: var(--#{$prefix}light);\n  &:hover{\n    background: var(--#{$prefix}light);\n  }\n  &:before{\n    content: \"\";\n    width: 7px;\n    height: 7px;\n    background: var(--#{$prefix}primary);\n    border-radius: 50%;\n    position: absolute;\n    top: 40px;\n    left: 4px;\n  }\n}\n\n// notification badge\n.badge-notif{\n  width: 8px;\n  height: 8px;\n  background: $danger;\n  border-radius: 50%;\n  position: absolute;\n  top: 0;\n  right: -3px;\n  z-index: 1;\n  &.badge-notif-bottom {\n    width: 6px;\n    height: 6px;\n    top: inherit;\n    bottom: 5px;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n  }\n}\n","// \n// offcanvas.scss\n// Extended from Bootstrap\n// \n\n// \n// Additional style for theme\n//\n\n.offcanvas-sm {\n  width: $offcanvas-horizontal-width-sm;\n} \n\n@include media-breakpoint-down(md) { \n  .offcanvas-start {\n    width: 260px !important;\n  }\n}","// \n// toasts.scss\n// Extended from Bootstrap\n// \n\n// \n// Additional style for theme\n//\n\n// toast chat\n.toast-chat{\n  position: fixed;\n  right: calc($offcanvas-horizontal-width + 1rem);\n  bottom: 0;\n  z-index: 11;\n}\n\n// toast breakpoint\n@include media-breakpoint-down(sm){\n  .toast{\n    width: 288px;\n  }\n }","// \r\n// general.scss\r\n// Theme general elements and helper styling\r\n\r\n// Bg white and dark according to theme mode\r\n.bg-mode{\r\n  background: $white;\r\n}\r\n\r\n// Filter\r\n.grayscale{\r\n  filter: grayscale(100%);\r\n  transition: all .6s ease;\r\n  &:hover {\r\n    filter: none;\r\n    -webkit-filter: grayscale(0%);\r\n  }\r\n}\r\n\r\n// Fixed width icon\r\n.fw-icon{\r\n  text-align: center;\r\n  width: 1.25em;\r\n  display: inline-block;\r\n}\r\n.icon-xs{\r\n  height: 1.5rem;\r\n  width: 1.5rem;\r\n  font-size: 0.6em;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.icon-sm{\r\n  height: 2rem;\r\n  width: 2rem;\r\n  font-size: 0.7em;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.icon-md {\r\n  height: 2.5rem;\r\n  width: 2.5rem;\r\n  font-size: 0.9em;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.icon-lg{\r\n  height: 3rem;\r\n  width: 3rem;\r\n  font-size: 1em;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.icon-xl{\r\n  height: 4rem;\r\n  width: 4rem;\r\n  font-size: 1.6em;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.icon-xxl{\r\n  height: 5.125rem;\r\n  width: 5.125rem;\r\n  font-size: 2em;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n// GLightbox and plyr controls theme\r\n.plyr__control--overlaid, \r\n.plyr--video .plyr__control.plyr__tab-focus, \r\n.plyr--video .plyr__control:hover, \r\n.plyr--video .plyr__control[aria-expanded=true]{\r\n  background: var(--bs-primary);\r\n}\r\n.plyr--full-ui input[type=range]{\r\n  color: var(--bs-primary);\r\n}\r\n\r\n/* rtl:raw:\r\n.glightbox-clean .gclose, .glightbox-modern .gclose{\r\n  right: auto !important;\r\n  left: 20px;\r\n}\r\n*/\r\n\r\n// password strength meter\r\n.password-strength-meter{\r\n  background-color: $input-group-addon-bg !important;\r\n}\r\n\r\n.glightbox-clean .gslide-description {\r\n  background: $white;\r\n}\r\n\r\n// Plyr controls none\r\n.plyr__controls-none{\r\n  .plyr__controls {\r\n    display: none;\r\n  }\r\n  .plyr--video {\r\n    border-radius: 20px;\r\n  }\r\n} \r\n\r\n// Search\r\n.nav-search .dropdown-menu{\r\n  top: 120%;\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  display: block;\r\n  transition: $transition-base;\r\n  width: 300px;\r\n  left: auto;\r\n  right: 0;\r\n}\r\n.nav-search .dropdown-menu.show{\r\n  top: 100%;\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n@include media-breakpoint-down(sm) {\r\n  .nav-search .dropdown-menu{\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n// To flip element in RTL\r\n/* rtl:raw:\r\n  .rtl-flip {\r\n    transform: scaleX(-1);\r\n  }\r\n  .rtl-flip.bi:before{\r\n    transform: inherit;\r\n  }\r\n*/\r\n\r\n// pre loader\r\n.preloader {\r\n  background-color: $white;\r\n  position: fixed;\r\n  z-index: 1190;\r\n  height: 100%;\r\n  width: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  .preloader-item {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    text-align: center;\r\n    transform: translate(-50%, -50%);\r\n  }\r\n}\r\n\r\n// nested comment\r\n\r\n.comment-wrap {\r\n  .comment-item {\r\n    position: relative;\r\n    .avatar {\r\n      position: relative;\r\n      z-index: 1;\r\n    }\r\n    &:last-child {\r\n\t\t\t.comment-line-inner {\r\n\t\t\t\tbackground: var(--bs-light);\r\n\t\t\t\theight: 20px;\r\n\t\t\t}\r\n\t\t}\r\n  }\r\n  .comment-item-nested {\r\n    padding-left: 2.75rem;\r\n  }\r\n\t& > .comment-item {\r\n\t\t.comment-line-inner {\r\n\t\t\tposition: absolute;\r\n\t\t\tleft: 16px;\r\n\t\t\ttop: 0;\r\n\t\t\twidth: 2px;\r\n\t\t\tbackground-color: var(--bs-light);\r\n\t\t\theight: 100%;\r\n\t\t}\r\n\t}\r\n}\r\n.comment-item-nested {\r\n\t.comment-item {\r\n    position: relative;\r\n\t\t.comment-line-inner {\r\n\t\t\tposition: absolute;\r\n\t\t\tleft: -28px;\r\n\t\t\ttop: 0;\r\n\t\t\twidth: 2px;\r\n\t\t\tbackground-color: var(--bs-light);\r\n\t\t\theight: 100%;\r\n\t\t\t&:before {\r\n\t\t\t\tcontent: \"\";\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\tleft: 0;\r\n\t\t\t\ttop: 20px;\r\n\t\t\t\theight: 2px;\r\n\t\t\t\twidth: 26px;\r\n\t\t\t\tbackground: var(--bs-light);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Rounded Helper\r\n@include media-breakpoint-up(lg) {\r\n  .rounded-end-lg-0 {\r\n    border-top-right-radius:0;\r\n    border-bottom-right-radius:0;\r\n  }\r\n  .rounded-start-lg-0{\r\n    border-top-left-radius:0;\r\n    border-bottom-left-radius:0;\r\n  }\r\n  .border-end-lg-0{\r\n    border-right: 0;\r\n  }\r\n}\r\n\r\n.rounded-top-0 {\r\n  border-top-left-radius: 0 !important;\r\n  border-top-right-radius: 0 !important;\r\n}\r\n.rounded-bottom-0 {\r\n  border-bottom-left-radius: 0 !important;\r\n  border-bottom-right-radius: 0 !important;\r\n}\r\n\r\n// flip-horizontal\r\n.flip-horizontal {\r\n  transform: scaleX(-1);\r\n  display: inline-block;\r\n}\r\n\r\n// Timeline\r\n.timeline{\r\n  width: 100%;\r\n  .timeline-item{\r\n    display: flex;\r\n    width: 100%;\r\n    margin-bottom: 1.5rem;\r\n    position: relative;\r\n    &:last-child{\r\n      margin-bottom: 0;\r\n    }\r\n    .timeline-icon{\r\n      margin-right: 0.8rem;\r\n      position: relative;\r\n      position: relative;\r\n    }\r\n    .timeline-content{\r\n      width: 100%;\r\n    }\r\n    &:before{\r\n      content: \"\";\r\n      position: absolute;\r\n      width: 2px;\r\n      height: calc(100% - 1rem);\r\n      background-color: var(--#{$prefix}light);\r\n      top: 2.5rem;\r\n      left: 1.5rem;\r\n      transform: translatex(-50%);\r\n    }\r\n    &:last-child:before {\r\n      height: calc(100% - 2.5rem);\r\n    }\r\n  }\r\n}\r\n\r\n// Card chat height calculation\r\n@include media-breakpoint-up(lg) {\r\n  .card-chat {\r\n    height: calc(100vh - 5.1125rem - 1.5rem);\r\n  }\r\n  .card-chat-list {\r\n    height: calc(100vh - 10.112rem - 1.5rem);\r\n  }\r\n  .chat-conversation-content {\r\n    height: calc(100% - 5.25rem);\r\n  }\r\n  .chat-tab-list {\r\n    height: calc(100% - 0.75rem);\r\n  }\r\n }\r\n\r\n// Typing Dot animation for chat \r\n.typing {\r\n\t.dot {\r\n\t\tanimation: TypingAnimation 1.8s infinite ease-in-out;\r\n\t\tbackground-color: rgba(var(--#{$prefix}secondary-rgb), 0.7);\r\n\t\tborder-radius: 50%;\r\n\t\theight: 7px;\r\n\t\tmargin-right: 4px;\r\n\t\tvertical-align: middle;\r\n\t\twidth: 7px;\r\n\t\tdisplay: inline-block;\r\n\t\t&:nth-child(1) {\r\n\t\t\tanimation-delay: 200ms;\r\n\t\t}\r\n\t\t&:nth-child(2) {\r\n\t\t\tanimation-delay: 300ms;\r\n\t\t}\r\n\t\t&:nth-child(3) {\r\n\t\t\tanimation-delay: 400ms;\r\n\t\t}\r\n\t\t&:last-child {\r\n\t\t\tmargin-right: 0;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@keyframes TypingAnimation {\r\n  0% {\r\n    transform: translateY(0px);\r\n    background-color: rgba(var(--#{$prefix}secondary-rgb), 0.7); \r\n  }\r\n  28% {\r\n    transform: translateY(-7px);\r\n    background-color: rgba(var(--#{$prefix}secondary-rgb), 0.4);\r\n  }\r\n  44% {\r\n    transform: translateY(0px);\r\n    background-color: rgba(var(--#{$prefix}secondary-rgb), 0.2);\r\n  }\r\n}\r\n\r\n// bootstrap icon line height\r\n.bi::before,\r\n[class^=\"bi-\"]::before,\r\n[class*=\" bi-\"]::before { \r\n  line-height: 1.5;\r\n}\r\n\r\n// Fake password icon \r\n.fakepasswordicon { \r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n.fakepasswordicon.fa-eye:before {\r\n  content: \"\\f06e\" !important;\r\n}\r\n\r\n// ticket\r\n.ticket-border {\r\n  border-left: 2px dashed var(--#{$prefix}gray-900);\r\n  padding-left: 50px;\r\n  position: relative;\r\n  &:before {\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 50%;\r\n    background: $white;\r\n    content: \"\";\r\n    top: -50px;\r\n    left: -25px;\r\n    position: absolute;\r\n  }\r\n  &:after {\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 50%;\r\n    background: $white;\r\n    content: \"\";\r\n    bottom: -50px;\r\n    left: -25px;\r\n    position: absolute;\r\n  }\r\n}\r\n@include media-breakpoint-down(sm) { \r\n  .ticket-border {\r\n    padding-left: 0;\r\n    border: 0;\r\n    &:after, &:before { \r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n// .plyr--audio .plyr__controls\r\n.plyr--audio .plyr__controls {\r\n  background: transparent;\r\n}\r\n\r\n.plyr--audio .plyr__control.plyr__tab-focus, .plyr--audio .plyr__control:hover, .plyr--audio .plyr__control[aria-expanded=true] {\r\n  background: var(--bs-primary);\r\n}\r\n\r\n// Disable textarea resizing\r\n[data-autoresize]{\r\n  resize: none;\r\n}\r\n\r\n// Tooltip text\r\n.tooltip-text-start .tooltip-inner{\r\n  text-align: left;\r\n}","// \r\n// avatar.scss\r\n// Theme Component\r\n\r\n// Avatar status\r\n[class*=status-]:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  z-index: 1;\r\n  border-radius: 100%;\r\n  border: 2px solid $white;\r\n  height: 12px;\r\n  width: 12px;\r\n  right: -2px;\r\n  top: -2px;\r\n}\r\n.status-online:before {\r\n  background-color: $success;\r\n}\r\n.status-away:before {\r\n  background-color: $warning;\r\n}\r\n.status-offline:before {\r\n  background-color: $danger;\r\n}\r\n.avatar.avatar-lg[class*=status-]:before { \r\n  right: 2px;\r\n  top: 2px;\r\n}\r\n.avatar.avatar-xl[class*=status-]:before { \r\n  right: 4px;\r\n  top: 4px;\r\n}\r\n.avatar.avatar-xxl[class*=status-]:before { \r\n  right: 12px;\r\n  top: 12px;\r\n}\r\n.avatar.avatar-xxxl[class*=status-]:before { \r\n  right: 18px;\r\n  top: 18px;\r\n}\r\n\r\n// Avatar\r\n.avatar {\r\n  height: $avatar-size-base;\r\n  width: $avatar-size-base;\r\n  position: relative;\r\n  display: inline-block;\r\n  flex-shrink: 0 !important;\r\n}\r\n.avatar-img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n// Avatar group\r\n.avatar-group{\r\n  padding: 0;\r\n  display: flex;\r\n  > li{\r\n    position: relative;\r\n    &:not(:last-child){\r\n      margin-right: -0.8rem;\r\n    }\r\n  }\r\n  .avatar-img{\r\n    border: 2px solid $white;\r\n  }\r\n}\r\n\r\n// Avatar 2 person\r\n.avatar-group-two {\r\n display: inline-flex; \r\n padding: 0;\r\n  > li{\r\n    margin-top: 0.8rem;\r\n    position: relative;\r\n    &:not(:last-child){\r\n      margin-right: -1.2rem;\r\n      margin-top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// Avatar 3 person\r\n.avatar-group-three {\r\n  display: inline-flex; \r\n  padding: 0;\r\n  padding-right: 1.2rem;\r\n  position: relative;\r\n   > li{\r\n     position: relative;\r\n     &:not(:last-child){\r\n       margin-right: -1.2rem;\r\n     }\r\n\r\n     &:last-child {\r\n      position: absolute;\r\n      bottom: -30px;\r\n      left: 50%;\r\n      top: 0;\r\n      transform: translate(-50%, 50%);\r\n     }\r\n\r\n   }\r\n }\r\n\r\n// Avatar 4 person\r\n.avatar-group-four {\r\n  display: inline-grid; \r\n  grid-template-columns: 1fr 1fr; \r\n  grid-template-rows: 1fr 1fr; \r\n  grid-template-columns: auto auto;\r\n  gap: 0px 0px; \r\n    li  {\r\n      margin:0;\r\n      &:not(:last-child){\r\n        margin: 0;\r\n      }\r\n    }\r\n}\r\n\r\n// avatar Sizing\r\n.avatar-xxs {\r\n  height: $avatar-size-xxs;\r\n  width: $avatar-size-xxs;\r\n}\r\n.avatar-xs {\r\n  height: $avatar-size-xs;\r\n  width: $avatar-size-xs;\r\n}\r\n.avatar-sm {\r\n  height: $avatar-size-sm;\r\n  width: $avatar-size-sm;\r\n}\r\n.avatar-lg {\r\n  height: $avatar-size-lg;\r\n  width: $avatar-size-lg;\r\n}\r\n.avatar-xl {\r\n  height: $avatar-size-xl;\r\n  width: $avatar-size-xl;\r\n}\r\n.avatar-xxl {\r\n  height: $avatar-size-xl;\r\n  width: $avatar-size-xl;\r\n  @include media-breakpoint-up(md) {\r\n    width: $avatar-size-xxl;\r\n    height: $avatar-size-xxl;\r\n  }\r\n}\r\n.avatar-xxxl {\r\n  height: $avatar-size-xxl;\r\n  width: $avatar-size-xxl;\r\n  @include media-breakpoint-up(md) {\r\n    width: $avatar-size-xxxl;\r\n    height: $avatar-size-xxxl;\r\n  }\r\n}\r\n\r\n// avatar story\r\n.avatar-story {\r\n  position: relative;\r\n  padding: 4px;\r\n  z-index: 1;\r\n  &:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    border-radius: 50%;\r\n    border: 2px solid var(--#{$prefix}primary);\r\n    z-index: -1;\r\n  }\r\n}\r\n\r\n// avatar profile uploader\r\n.avatar-uploader {\r\n\tposition: relative;\r\n\t.avatar-edit {\r\n\t\tposition: absolute;\r\n\t\tright: 0;\r\n\t\tz-index: 1;\r\n\t\ttop: 0;\r\n\t\tinput {\r\n\t\t\tdisplay: none;\r\n\t\t\t& + label {\r\n\t\t\t\tdisplay: inline-block;\r\n\t\t\t\twidth: 34px;\r\n\t\t\t\theight: 34px;\r\n\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\tborder-radius: 100%;\r\n\t\t\t\tbackground: $body-bg;\r\n\t\t\t\tborder: 1px solid transparent;\r\n\t\t\t\tbox-shadow: $box-shadow;\r\n\t\t\t\tcursor: pointer;\r\n\t\t\t\tfont-weight: normal;\r\n\t\t\t\ttransition: $transition-base;\r\n\t\t\t\t&:after {\r\n\t\t\t\t\tcontent: '\\f303';\r\n\t\t\t\t\tfont-family: $fa-font-family;\r\n\t\t\t\t\tcolor: $secondary;\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\ttop: 50%;\r\n\t\t\t\t\tleft: 0;\r\n\t\t\t\t\tright: 0;\r\n\t\t\t\t\ttext-align: center;\r\n\t\t\t\t\tfont-weight: 900;\r\n\t\t\t\t\ttransform: translate(0,-56%);\r\n\t\t\t\t\tmargin: 0 auto;\r\n\t\t\t\t\ttransition: $transition-base;\r\n\t\t\t\t}\r\n\t\t\t\t&:hover {\r\n\t\t\t\t\tbackground: var(--#{$prefix}primary);\r\n\t\t\t\t\tborder-color: var(--#{$prefix}primary);\r\n\t\t\t\t\t&:after {\r\n\t\t\t\t\t\tcolor: $white;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\timg#avatar-preview {\r\n\t\tobject-fit: cover;\r\n\t}\r\n}","// \r\n// tiny-slider.scss\r\n// Theme Component\r\n\r\n.tns-outer{\r\n  position: relative;\r\n}\r\n.tns-item{\r\n  touch-action: pan-y;\r\n  user-select: none;\r\n}\r\n.tiny-slider{\r\n  .item{\r\n    position: relative;\r\n  }\r\n}\r\n\r\n//\r\n// Slider arrow\r\n//\r\n.tns-controls{\r\n  [data-controls]{\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    width: 30px;\r\n    height: 30px;\r\n    line-height: 30px;\r\n    border-radius: $border-radius;\r\n    display: block;\r\n    z-index: 9;\r\n    text-align: center;\r\n    transition: $transition-base;\r\n    background: rgba(var(--#{$prefix}primary-rgb), 0.3);\r\n    color: $white;\r\n    border: none;\r\n    padding: 0;\r\n    margin: 0 5px;\r\n    &:hover{\r\n      background-color: var(--bs-primary);\r\n      color: $white;\r\n    }\r\n    i{\r\n      line-height: inherit;\r\n    }\r\n  }\r\n}\r\n\r\n.tns-controls [data-controls='prev'] {\r\n  left: 0;\r\n}\r\n.tns-controls [data-controls='next'] {\r\n  right: 0;\r\n}\r\n\r\n/* rtl:raw:\r\n.tiny-slider .tns-controls [data-controls]{\r\n  transform: scaleX(-1) translateY(-50%);\r\n}\r\n.tns-visually-hidden {\r\n  right: -10000em !important;\r\n  left: 0 !important;\r\n}\r\n*/\r\n\r\n// arrow dark\r\n.arrow-dark{\r\n  [data-controls] {\r\n    background: $dark;\r\n    color: $white;\r\n  }\r\n}\r\n.arrow-white{\r\n  [data-controls] {\r\n    background-color: $body-bg;\r\n    color: $body-color;\r\n  }\r\n}\r\n\r\n// arrow round\r\n.arrow-round{\r\n  [data-controls] {\r\n    border-radius: 50%;\r\n  }\r\n}\r\n\r\n// arrow hover\r\n.arrow-hover{\r\n  overflow: hidden;\r\n  [data-controls='prev']{\r\n    left: -60px;\r\n  }\r\n  [data-controls='next']{\r\n    right: -60px;\r\n  }\r\n  &:hover{\r\n    [data-controls='prev']{\r\n    left: 0px;\r\n    }\r\n    [data-controls='next']{\r\n      right: 0px;\r\n    }\r\n  }\r\n}\r\n\r\n// \r\n// Slider dots\r\n// \r\n.tns-nav{\r\n  position: absolute;\r\n  top: 100%;\r\n  bottom: 0;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 10;\r\n  width: auto;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  [data-nav] {\r\n    position: relative;\r\n    display: inline-block;\r\n    margin: 0 4px;\r\n    padding: 0;\r\n    width: 14px;\r\n    height: 14px;\r\n    border-radius: 50%;\r\n    overflow: hidden;\r\n    background-color: transparent;\r\n    box-shadow: inset 0 0 0 2px var(--#{$prefix}gray-500);\r\n    transition: $transition-base;\r\n    border: 0;\r\n  }\r\n  .tns-nav-active{\r\n    background-color: $white;\r\n  }\r\n}\r\n\r\n// Dots inside\r\n.dots-inside .tns-nav{\r\n  top: auto;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n// Dots white\r\n.dots-white .tns-nav{\r\n  [data-nav] {\r\n    box-shadow: inset 0 0 0 2px $white;\r\n    transition: $transition-base;\r\n    &:after{\r\n      background-color: $white;\r\n      box-shadow: 0 0 1px $white;\r\n    }\r\n  }\r\n}\r\n\r\n// Dots dark\r\n.dots-dark .tns-nav{\r\n  [data-nav] {\r\n    box-shadow: inset 0 0 0 2px var(--#{$prefix}gray-800);\r\n    transition: $transition-base;\r\n    &:after{\r\n      background-color: var(--#{$prefix}gray-800);\r\n      box-shadow: 0 0 1px var(--#{$prefix}gray-800);\r\n    }\r\n  }\r\n}","// \r\n// glightbox.scss\r\n// Theme component for utility classes (helper classes)\r\n\r\n// gslide\r\n.gslide-description.description-left, \r\n.gslide-description.description-right{\r\n  max-width: 360px;\r\n}\r\n.gdesc-inner{\r\n  width: 100%;\r\n}\r\n.glightbox-container .gslide{\r\n  user-select: inherit;\r\n}\r\n.glightbox-clean .gslide-desc{\r\n  font-family: $font-family-base;\r\n}\r\n\r\n// glightbox mobile\r\n.glightbox-mobile {\r\n\t.glightbox-container {\r\n\t\t.gslide-desc {\r\n\t\t\t.bg-light {\r\n\t\t\t\tbackground: $dark !important;\r\n\t\t\t}\r\n\t\t\t.form-control {\r\n\t\t\t\tborder-color: $border-color;\r\n\t\t\t}\r\n\t\t\t.text-secondary {\r\n\t\t\t\tcolor: $white !important;\r\n\t\t\t}\r\n\t\t\t.dropdown-menu {\r\n\t\t\t\tbackground: $dark !important;\r\n\t\t\t}\r\n\t\t\ta {\r\n\t\t\t\tfont-weight: normal;\r\n\t\t\t}\r\n\t\t\t.nav {\r\n\t\t\t\t&.nav-divider {\r\n\t\t\t\t\t.nav-item {\r\n\t\t\t\t\t\tcolor: $white !important;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}","// \r\n// Data table.scss\r\n// Vendor css override and new css added\r\n\r\n// choices\r\n.choices{\r\n\r\n  .choices__inner{\r\n    background-color: $input-bg;\r\n    color: $input-color;\r\n    border: $input-border-width solid $input-border-color;\r\n    line-height: $input-line-height;  \r\n    border-radius: $border-radius;\r\n    min-height: auto;\r\n    padding: $input-padding-y $input-padding-x !important;\r\n    @include font-size($input-font-size);\r\n  }\r\n  .choices__list--multiple .choices__item{\r\n    background-color: var(--#{$prefix}light);\r\n    border: 1px solid var(--#{$prefix}light);\r\n    border-radius: $border-radius;\r\n    color: $input-color;\r\n  }\r\n  .choices__list--dropdown{\r\n    background: $input-bg;\r\n    border: $input-border-width solid $input-border-color;\r\n    visibility: visible !important;\r\n    .choices__item--selectable.is-highlighted{\r\n      background-color: var(--#{$prefix}light);\r\n    }\r\n  }\r\n  .choices__list--dropdown .choices__item{\r\n    color: var(--#{$prefix}gray-600);\r\n  }\r\n  .choices__input{\r\n    background: transparent;\r\n    padding: 0; \r\n    color: $input-color;\r\n  }\r\n  .choices__list--dropdown,\r\n  .choices__list[aria-expanded]{\r\n    margin-top: 0px;\r\n  }\r\n  &.is-open .choices__list--dropdown, \r\n  &.is-open .choices__list[aria-expanded]{\r\n    margin-top: -1px;\r\n  }\r\n}\r\n.choices[data-type*=select-one] .choices__input{\r\n  background: var(--bs-white);\r\n  color:  var(--#{$prefix}body-color);\r\n  border-color: $input-border-color !important;\r\n}\r\n.choices__list--single {\r\n  padding: 0;\r\n}\r\n.choices[data-type*=select-multiple] .choices__button, .choices[data-type*=text] .choices__button {\r\n\tborder-left: 1px solid $secondary;\r\n\tbackground-image: escape-svg($btn-close-bg);\r\n}\r\n.choices[data-type*=select-one]:after {\r\n  content: \"\";\r\n  height: 10px;\r\n  width: 10px;\r\n  border: none;\r\n  border-width: 5px;\r\n  position: absolute;\r\n  right: 11.5px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  margin-top: 0;\r\n  background-image: escape-svg($form-select-indicator);\r\n  background-repeat: no-repeat;\r\n  background-position: center center;\r\n  background-size: 16px 12px;\r\n}\r\n.choices[data-type*=select-one].is-open {\r\n\t&:after {\r\n\t\tmargin-top: 0;\r\n\t}\r\n}\r\n.choices[data-type*=select-one] {\r\n\t.choices__input {\r\n\t\tbackground: $input-bg;\r\n\t\tborder-color: $input-bg;\r\n\t}\r\n}\r\n.choices {\r\n\t&.is-focused {\r\n\t\t.choices__inner {\r\n\t\t\tborder-color: var(--#{$prefix}primary);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n// To remove itemSelectText on hover\r\n.choices[data-type*=select-one] .choices__list > .choices__list > .choices__item--selectable, .choices[data-type*=select-multiple] .choices__list > .choices__list > .choices__item--selectable{\r\n\tpadding-right: 0px;\r\n}\r\n.choices[data-type*=select-one] .choices__list > .choices__list > .choices__item--selectable::after, .choices[data-type*=select-multiple] .choices__list > .choices__list > .choices__item--selectable::after{\r\n\tdisplay: none;\r\n}\r\n","// \r\n// dropzone.scss\r\n// Vendor css override and new css added\r\n\r\n// dropzone \r\n.dropzone {\r\n\tmin-height: auto;\r\n\tborder-radius: $border-radius;\r\n\tposition: relative;\r\n\tz-index: 0;\r\n\tborder: 2px dashed $gray-300;\r\n\t.dz-preview {\r\n\t\t&.dz-image-preview {\r\n\t\t\tbackground: transparent;\r\n\t\t}\r\n\t}\r\n}\r\n// Dropzone custom\r\n.dropzone-custom {\r\n\tposition: relative;\r\n\t.dz-cover-preview {\r\n\t\tposition: absolute;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\tright: 0;\r\n\t\tbottom: 0;\r\n\t\tmargin: 0;\r\n\t\t.dz-cover-preview-wrap {\r\n\t\t\tposition: absolute;\r\n\t\t\theight: 100%;\r\n\t\t\twidth: 100%;\r\n\t\t\tborder: 0!important;\r\n\t\t\toverflow: hidden;\r\n\t\t}\r\n\t}\r\n\t.dz-preview {\r\n\t\tmin-height: auto;\r\n\t\tmargin: 0;\r\n\t\twidth: 100%;\r\n\t\t&.dz-cover-preview {\r\n\t\t\t.dz-cover-preview-img {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tobject-fit: cover;\r\n\t\t\t\tborder-radius: 0.375rem;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t&.dropzone-cover {\r\n\t\t.dz-message {\r\n\t\t\tpadding: 6rem 2rem;\r\n\t\t}\r\n\t\t&.dz-file-processing {\r\n\t\t\t.dz-message {\r\n\t\t\t\tdisplay: none;\r\n\t\t\t}\r\n\t\t\t&.dz-file-complete {\r\n\t\t\t\t.dz-message {\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t\t&.dz-max-files-reached {\r\n\t\t\t.dz-message {\r\n\t\t\t\tbackground-color: rgba($black, 0.5);\r\n\t\t\t\tcolor: $white;\r\n\t\t\t\topacity: 0;\r\n\t\t\t\ttransition: all .2s ease-in-out;\r\n\t\t\t\tborder-color: transparent;\r\n\t\t\t}\r\n\t\t}\r\n\t\t.dz-preview {\r\n\t\t\t&.dz-cover-preview {\r\n\t\t\t\t.dz-cover-preview-img {\r\n\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\theight: 100%;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t.dz-message {\r\n\t\tposition: relative;\r\n\t\tpadding: 2rem;\r\n\t\tmargin: 0;\r\n\t}\r\n\t&.dropzone {\r\n\t\t.dz-preview {\r\n\t\t\tdisplay: inline-flex;\r\n\t\t}\r\n\t}\r\n}\r\n.dropzone-custom.dz-clickable .dz-message, .dropzone.dz-clickable .dz-message * {\r\n\tcursor: pointer;\r\n}\r\n.dropzone-custom.dropzone-cover.dz-max-files-reached:focus .dz-message, .dropzone.dropzone-cover.dz-max-files-reached:hover .dz-message {\r\n\topacity: 1;\r\n}","// \r\n// Data overlayscrollbars\r\n// Vendor css override and new css added\r\n\r\n\r\n// Scrollbar color\r\n.os-theme-dark>.os-scrollbar>.os-scrollbar-track>.os-scrollbar-handle, \r\n.os-theme-dark>.os-scrollbar:hover>.os-scrollbar-track>.os-scrollbar-handle{\r\n  background: rgba(var(--#{$prefix}secondary-rgb), 0.15);\r\n}","// \r\n// mockup.scss\r\n// Theme Component\r\n\r\n// iphone-x\r\n.iphone-x{\r\n  position: relative;\r\n  margin: 40px auto;\r\n  width: 360px;\r\n  height: 780px;\r\n  background-color: $dark;\r\n  border-radius: 40px;\r\n  box-shadow: 0px 0px 0px 11px $secondary, 0px 0px 0px 13px $secondary, 0px 0px 0px 20px shade-color($secondary, 20%);\r\n  \r\n  &:before,\r\n  &:after{\r\n    content: '';\r\n    position: absolute;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n  }\r\n  \r\n  // home button indicator\r\n  &:after{\r\n    bottom: 7px;\r\n    width: 140px;\r\n    height: 4px;\r\n    background-color: $light;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  // frontal camera/speaker frame\r\n  &:before{\r\n    top: 0px;\r\n    width: 56%;\r\n    height: 30px;\r\n    background-color: $secondary;\r\n    border-radius: 0px 0px 40px 40px;\r\n  }\r\n  \r\n  i,\r\n  b,\r\n  s,\r\n  span{\r\n    position: absolute;\r\n    display: block;\r\n    color: transparent;\r\n  }\r\n  \r\n  // speaker\r\n  i{\r\n    top: 0px;\r\n    left: 50%;\r\n    transform: translate(-50%, 6px);\r\n    height: 8px;\r\n    width: 15%;\r\n    background-color: $black;\r\n    border-radius: 8px;\r\n    box-shadow: inset 0px -3px 3px 0px rgba(256, 256, 256, 0.2);\r\n  }\r\n  \r\n  // camera\r\n  b{\r\n    left: 10%;\r\n    top: 0px;\r\n    transform: translate(180px, 4px);\r\n    width: 12px;\r\n    height: 12px;\r\n    background-color: $black;\r\n    border-radius: 12px;\r\n    box-shadow: inset 0px -3px 2px 0px rgba(256, 256, 256, 0.2);\r\n    \r\n    &:after {\r\n      content: '';\r\n      position: absolute;\r\n      background-color: rgba($primary, 0.5);\r\n      width: 6px;\r\n      height: 6px;\r\n      top: 2px;\r\n      left: 2px;\r\n      top: 3px;\r\n      left: 3px;\r\n      display: block;\r\n      border-radius: 4px;\r\n      box-shadow: inset 0px -2px 2px rgba($black, 0.5);\r\n    }\r\n  }\r\n  \r\n  // time\r\n  s{\r\n    top: 50px;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    width: 100%;\r\n    font-size: 70px;\r\n    font-weight: 100;\r\n    padding-top: 60px;\r\n  }\r\n  \r\n  // action buttons\r\n  span{\r\n    bottom: 50px;\r\n    width: 40px;\r\n    height: 40px;\r\n    background-color: rgba($black, 0.3);\r\n    border-radius: 50%;\r\n    left: 30px;\r\n    \r\n    & + span {\r\n      left: auto;\r\n      right: 30px;\r\n    }\r\n  }\r\n}\r\n\r\n// iphone x small\r\n.iphone-x.iphone-x-small{\r\n  margin: 40px auto;\r\n  width: 300px;\r\n  height: 600px;\r\n}\r\n\r\n// iphone x half\r\n.iphone-x.iphone-x-half{\r\n  height: 300px;\r\n  background-image: url(../images/mockup/app-placeholder3.jpg);\r\n}\r\n\r\n// iphone x breakpoint\r\n@include media-breakpoint-down(sm){\r\n\r\n  .iphone-x, .iphone-x.iphone-x-small{\r\n    width: 260px;\r\n    height: 540px;\r\n    background-size: 100%;\r\n  }\r\n  .iphone-x{\r\n    &.iphone-x-half{\r\n      width: 240px;\r\n      height: 280px;\r\n      background-size: 100%;\r\n    }\r\n    b{\r\n      left: -6%;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n// MACBOOK\r\n.mac_container{\r\n\twidth: 100%;\r\n\tmargin: 10px auto;\r\n}\r\n.mac_scaler{\r\n\tmargin: auto;\r\n\twidth: 100%;\r\n\tpadding-top: 57.875%;\r\n\theight: 0px;\r\n\tposition: relative;\r\n}\r\n.mac_holder{\r\n\tposition: absolute;\r\n\tleft: 0px;\r\n\ttop: 0px;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n}\r\n// mac screen\r\n.mac_screen{\r\n\tmargin: auto;\r\n\tbackground: $secondary;\r\n\twidth: 86%;\r\n\theight: 100%;\r\n\tborder-top-left-radius: 2% 3%;\r\n\tborder-top-right-radius: 2% 3%;\r\n\tborder-bottom-left-radius: 5% 3%;\r\n\tborder-bottom-right-radius: 5% 3%;\r\n\tbox-sizing: border-box;\r\n\tpadding: 3%;\r\n\tposition: relative;\r\n\toverflow: hidden;\r\n\tborder: 1px solid $light;\r\n\t&:before {\r\n\t\tcontent: '';\r\n\t\tposition: absolute;\r\n\t\tright: 0.3%;\r\n\t\ttop: 0.5%;\r\n\t\twidth: 36.5%;\r\n\t\theight: 35%;\r\n\t\tborder: 1px solid $secondary;\r\n\t\tborder-bottom: none;\r\n\t\tborder-left: none;\r\n\t\tborder-top-right-radius: 4.5% 7%;\r\n\t}\r\n\t&:after {\r\n\t\tcontent: '';\r\n\t\tposition: absolute;\r\n\t\tright: -25%;\r\n\t\ttop: -25%;\r\n\t\twidth: 40%;\r\n\t\theight: 150%;\r\n\t\tbackground: rgba($light,0.2);\r\n\t\tbackground: linear-gradient(rgba(255,255,255,0.2), rgba($light,0) 40%);\r\n\t\ttransform: rotate(-30deg);\r\n\t}\r\n}\r\n\r\n// mac camera\r\n.mac_camera{\r\n\tbackground: #333;\r\n\tborder-radius: 50%;\r\n\twidth: 1%;\r\n\theight: 1.5%;\r\n\tposition: absolute;\r\n\tleft: 49.5%;\r\n\ttop: 2%;\r\n\t&:after{\r\n\t\tcontent: '';\r\n\t\tposition: absolute;\r\n\t\tleft: 35%;\r\n\t\ttop: 40%;\r\n\t\twidth: 30%;\r\n\t\theight: 30%;\r\n\t\tborder-radius: 50%;\r\n\t\tbackground: #777;\r\n\t}\r\n}\r\n// mac bottom\r\n.mac_bottom{\r\n\tbackground: #e9e9e9;\r\n\tbackground: linear-gradient(#ccc 50%, #444);\r\n\twidth: 100%;\r\n\theight: 3%;\r\n\tposition: relative;\r\n\ttop: -1.7%;\r\n\tborder-bottom-left-radius: 6% 50%;\r\n\tborder-bottom-right-radius: 6% 50%;\r\n}\r\n.mac_bottom_top_half{\r\n\twidth: 100%;\r\n\theight: 50%;\r\n\tbackground: #e9e9e9;\r\n\tbackground: linear-gradient(90deg, #aaa, #f3f3f3 0.5%, #aaa 2.5%, #f3f3f3 5.5%, #f3f3f3 94.5%, #aaa 97.5%, #f3f3f3 99.5%, #aaa);\r\n}\r\n.mac_bottom:after{\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\tright: 1%;\r\n\tbottom: 11%;\r\n\twidth: 98%;\r\n\theight: 0%;\r\n\tbox-shadow: 1px 0px 8px 1px #333;\r\n}\r\n// mac thumb\r\n.mac_thumb_space{\r\n\tbackground: #bbb;\r\n\tbackground: radial-gradient(90% 150% at 50% 1%, #eee 49%, #888);\r\n\tmargin: auto;\r\n\twidth: 15%;\r\n\theight: 60%;\r\n\tborder-bottom-left-radius: 8% 100%;\r\n\tborder-bottom-right-radius: 8% 100%;\r\n}\r\n.mac_screen_content{\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\ttext-align: center;\r\n}","// \r\n// flatpickr.scss\r\n// Vendor css override and new css added\r\n\r\n// flatpickr calendar\r\n\r\n.flatpickr-calendar{\r\n  background: $white;\r\n  border-color: $white;\r\n  box-shadow: $box-shadow;\r\n}\r\n.flatpickr-current-month .flatpickr-monthDropdown-months, .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {\r\n  background: $white;\r\n  border-color: $border-color;\r\n}\r\n.flatpickr-calendar.arrowBottom:before, .flatpickr-calendar.arrowBottom:after {\r\n  border-top-color: $white;\r\n}\r\n.flatpickr-calendar.arrowTop:before, .flatpickr-calendar.arrowTop:after, .flatpickr-current-month .numInputWrapper span.arrowUp:after {\r\n  border-bottom-color: $white;\r\n}\r\n.flatpickr-current-month .numInputWrapper span.arrowDown:after {\r\n  border-top-color: var(--#{$prefix}gray-500);\r\n}\r\n.flatpickr-current-month .numInputWrapper span.arrowUp:after {\r\n  border-bottom-color: var(--#{$prefix}gray-500);\r\n}\r\n\r\n// Flatpickr months\r\n.flatpickr-months{\r\n  position: relative;\r\n}\r\n.flatpickr-months .flatpickr-prev-month, .flatpickr-months .flatpickr-next-month{\r\n  border-radius: $border-radius;\r\n  margin: 3px;\r\n  width: 30px;\r\n  height: 30px;\r\n  line-height: 30px;\r\n  text-align: center;\r\n  padding: 0;\r\n  transition: $transition-base;\r\n  svg{\r\n    height: 12px;\r\n    width: 12px;\r\n  }\r\n  &:hover{\r\n    background: rgba(var(--#{$prefix}primary-rgb), 0.1);\r\n    svg{\r\n      fill: var(--#{$prefix}primary);\r\n    }\r\n  }\r\n}\r\n\r\n// flatpickr day\r\n.flatpickr-day, span.flatpickr-weekday, .flatpickr-months .flatpickr-month {\r\n  color: var(--#{$prefix}gray-500);\r\n}\r\n.flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover, .flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay, .flatpickr-day.notAllowed, .flatpickr-day.notAllowed.prevMonthDay, .flatpickr-day.notAllowed.nextMonthDay {\r\n  color: var(--#{$prefix}gray-400);\r\n}\r\n.flatpickr-months .flatpickr-prev-month, .flatpickr-months .flatpickr-next-month {\r\n  fill: var(--#{$prefix}gray-500);\r\n}\r\n.flatpickr-day.today, .flatpickr-day.today:hover, .flatpickr-day.today:focus{\r\n  background: rgba(var(--#{$prefix}primary-rgb), 0.1);\r\n  color: var(--#{$prefix}primary);\r\n  border-color: rgba(var(--#{$prefix}primary-rgb), 0.1);\r\n}\r\n.flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay{\r\n  background: var(--#{$prefix}primary);\r\n  color: $white;\r\n  border-color: var(--#{$prefix}primary);\r\n}\r\n.flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange, .flatpickr-day:hover, .flatpickr-day.prevMonthDay:hover, .flatpickr-day.nextMonthDay:hover, .flatpickr-day:focus, .flatpickr-day.prevMonthDay:focus, .flatpickr-day.nextMonthDay:focus{\r\n  background: var(--#{$prefix}light);\r\n  border-color: var(--#{$prefix}light);\r\n  color: var(--#{$prefix}gray-500);\r\n}\r\n.flatpickr-day.today.inRange, .flatpickr-day.prevMonthDay.today.inRange, .flatpickr-day.nextMonthDay.today.inRange{\r\n  background: rgba(var(--#{$prefix}primary-rgb), 0.1);\r\n  color: var(--#{$prefix}primary);\r\n  border-color: rgba(var(--#{$prefix}primary-rgb), 0.1);\r\n}\r\n.flatpickr-day.inRange {\r\n  box-shadow: -5px 0 0 var(--#{$prefix}light), 5px 0 0 var(--#{$prefix}light);\r\n}\r\n.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)){\r\n  box-shadow: -10px 0 0 var(--#{$prefix}primary);\r\n}\r\n.flatpickr-input{\r\n  &:disabled,\r\n  &[readonly]{\r\n    background-color: $input-bg;\r\n  }\r\n}\r\n\r\n// Flatpickr Time\r\n.flatpickr-time input:hover, .flatpickr-time .flatpickr-am-pm:hover, .flatpickr-time input:focus, .flatpickr-time .flatpickr-am-pm:focus {\r\n  background: var(--#{$prefix}light);\r\n}\r\n.flatpickr-calendar.hasTime .flatpickr-time {\r\n  border-top-color: $border-color;\r\n}\r\n.flatpickr-current-month {\r\n  font-size: 120%;\r\n  padding: 9.48px 0 0 0;\r\n  border-radius: $border-radius;\r\n}\r\n.flatpickr-time {\r\n  input {\r\n  color: var(--#{$prefix}gray-500);\r\n  }\r\n  .flatpickr-am-pm{\r\n    color: var(--#{$prefix}gray-500);\r\n  }\r\n}\r\n\r\n// Responsive\r\n\r\n// Media sm down\r\n@include media-breakpoint-down(sm){\r\n  .flatpickr-calendar, .flatpickr-days, .dayContainer {\r\n    width: 100%;\r\n    min-width: 100%;\r\n    max-width: 100%;\r\n  }\r\n}","// \r\n// zuck.scss\r\n// Vendor css override and new css added\r\n\r\n// stories style\r\n.stories .story > .item-link {\r\n  text-decoration: none;\r\n  color: $headings-color;\r\n}\r\n.stories .story > .item-link > .item-preview {\r\n  border-radius: 50%;\r\n  padding: 2px;\r\n  background: var(--bs-primary);\r\n  height: 5.125rem !important;\r\n  width: 5.125rem !important;\r\n}\r\n\r\n.stories.carousel .story{\r\n  height: auto !important;\r\n  width: 5.125rem !important;\r\n}\r\n\r\n.stories .story > .item-link > .item-preview img {\r\n  border-radius: 50%;\r\n  border: 2px solid $white;\r\n}\r\n.stories .story.seen {\r\n  opacity: 0.5;\r\n}\r\n.stories .story.seen > a > .item-preview {\r\n  background: $gray-500;\r\n}\r\n.stories .story.seen > a {\r\n  color: $body-color !important;\r\n}\r\n\r\n.stories.carousel .story>.item-link>.info .name{\r\n  font-weight: $font-weight-normal;\r\n  font-size: $font-size-sm;\r\n}\r\n\r\n// Close button\r\n#zuck-modal-content .story-viewer .head .right {\r\n  padding: 0px 30px;\r\n  .close{\r\n    color: $white;\r\n  }\r\n}\r\n#zuck-modal.with-effects {\r\n  height: 100vh !important;\r\n}\r\n\r\n// Stories square\r\n.stories-square.stories .story > .item-link > .item-preview {\r\n  border-radius: 5px;\r\n  height: 150px !important;\r\n  object-fit: cover;\r\n  width: auto !important;\r\n  max-height: inherit !important;\r\n  padding: 0 !important;\r\n}\r\n.stories-square.stories.carousel .story {\r\n  border-radius: 0;\r\n  height: 150px !important;\r\n  position: relative;\r\n  width: 120px !important;\r\n  max-width: inherit !important;\r\n  margin-bottom: 4px;\r\n}\r\n.stories-square.stories.carousel .story>.item-link>.info{\r\n  position: absolute;\r\n  left: 10px;\r\n  bottom: 6px;\r\n  color: $white;\r\n  text-align: left;\r\n  z-index: 1;\r\n}\r\n.stories-square.stories.carousel .story>.item-link>.item-preview img {\r\n  border-radius: 5px;\r\n  border: none;\r\n}\r\n.stories-square.stories .story.seen > a > .item-preview {\r\n  background: transparent ;\r\n}\r\n.stories-square.stories .item-preview {\r\n  position: relative;\r\n}\r\n.stories-square.stories .item-preview:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  height: 50%;\r\n  width: 100%;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background-image: -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba($black, 1)));\r\n  background-image: linear-gradient(180deg, transparent, rgba($black, 1));\r\n  z-index: 1;\r\n}\r\n\r\n@media (max-width: 1024px){\r\n  #zuck-modal-content .story-viewer.with-back-button .head .left>.back {\r\n    color: $white;\r\n  }\r\n}\r\n\r\n// Bottom scroll enable\r\n.scroll-enable{\r\n  &.stories.carousel::-webkit-scrollbar-track\r\n  {\r\n    border-radius: 5px;\r\n    background-color: $white;\r\n  }\r\n  &.stories.carousel::-webkit-scrollbar\r\n  {\r\n    width: 5px;\r\n    height: 8px;\r\n    border-radius: 5px;\r\n    background-color: $white;\r\n  }\r\n  &.stories.carousel::-webkit-scrollbar-thumb\r\n  {\r\n    border-radius: 5px;\r\n    -webkit-box-shadow: inset 0 0 4px rgba(0,0,0,.2);\r\n    background-color: $gray-400;\r\n  }\r\n}","// \r\n// dark-mode.scss\r\n// Theme Component\r\n// Dark mode related CSS\r\n\r\n[data-bs-theme=\"dark\"] {\r\n\r\n    //Dark mode styles\r\n    --bs-gray-100: #313235;\r\n    --bs-gray-200: #464950;\r\n    --bs-gray-300: #5f5f68;\r\n    --bs-gray-400: #a1a1a8;\r\n    --bs-gray-500: #bfc0c9;\r\n    --bs-gray-600: #c5c6cc;\r\n    --bs-gray-700: #ffffffb3;\r\n    --bs-gray-800: #fffffff9;\r\n    --bs-gray-900: #fff;\r\n    --bs-light: #202227;\r\n    --bs-secondary-rgb: 197, 198, 204;\r\n    --bs-body-bg: #191a1f;\r\n    --bs-body-color: #a1a1a8;\r\n    --bs-body-color-rgb: 161, 161, 168;\r\n    --bs-mode:#0f0f10;\r\n    --bs-mode-rgb:15, 15, 16;\r\n    --bs-border-color: rgba(255, 255, 255, 0.07);\r\n    --bs-card-bg-dark: #141519;\r\n    --bs-heading-color: var(--bs-gray-900);\r\n\r\n    // Navbar\r\n    .navbar {\r\n    --bs-navbar-color: var(--#{$prefix}gray-600);\r\n    --bs-navbar-disabled-color: var(--#{$prefix}gray-400);\r\n    }\r\n    .navbar-dark {\r\n      --bs-navbar-color: var(--#{$prefix}gray-900);\r\n    }\r\n\r\n    // Dropdown menu\r\n    .dropdown-menu {\r\n      --bs-dropdown-bg: var(--#{$prefix}mode);\r\n      --bs-dropdown-link-disabled-color: var(--#{$prefix}gray-200);\r\n      box-shadow:none;\r\n      --bs-dropdown-divider-bg: var(--#{$prefix}border-color);\r\n      border: 1px solid var(--#{$prefix}border-color);\r\n    }\r\n\r\n    .alert-light{\r\n      --bs-alert-bg: var(--#{$prefix}gray-600);\r\n      --bs-alert-border-color: var(--#{$prefix}gray-600);\r\n    }\r\n\r\n    // Buttons\r\n    .bg-light{\r\n      background-color: var(--#{$prefix}light) !important;\r\n    }\r\n    .btn-dark{\r\n      --bs-btn-bg: var(--#{$prefix}mode);\r\n    }\r\n    .btn-close {\r\n      filter: invert(1) grayscale(100%) brightness(300%);\r\n    }\r\n    .btn-secondary-soft{\r\n      background-color: rgba(var(--#{$prefix}secondary-rgb), 0.1);\r\n      color: var(--#{$prefix}gray-600);\r\n      &:hover{\r\n        background-color: rgba(var(--#{$prefix}secondary-rgb)) !important;\r\n        color: var(--#{$prefix}body-bg) !important;\r\n      }\r\n    }\r\n    .btn-secondary-soft-hover:hover{\r\n      background-color: rgba(var(--#{$prefix}secondary-rgb), 0.1);\r\n      color: var(--#{$prefix}gray-600) !important;\r\n    }\r\n    .btn-light{\r\n      --bs-btn-bg: var(--#{$prefix}light);\r\n      --bs-btn-color: var(--#{$prefix}gray-800);\r\n      --bs-btn-border-color: var(--#{$prefix}light);\r\n      --bs-btn-active-bg: var(--#{$prefix}gray-200);\r\n      --bs-btn-active-color: var(--#{$prefix}gray-800);\r\n    }\r\n\r\n    // Modal\r\n    .modal {\r\n      --bs-modal-bg: var(--#{$prefix}body-bg);\r\n      --bs-modal-footer-border-color: var(--#{$prefix}border-color);\r\n    } \r\n    \r\n    // Card\r\n    .card {\r\n      --bs-card-cap-bg: var(--bs-card-bg-dark) !important;\r\n      --bs-card-bg: var(--bs-card-bg-dark) !important;\r\n      --bs-card-border-color: var(--#{$prefix}light);\r\n    }\r\n\r\n    // Offacanvas\r\n    .offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\r\n      --bs-offcanvas-bg: var(--#{$prefix}body-bg);\r\n    }\r\n\r\n    .popover{\r\n      --bs-popover-bg:var(--#{$prefix}body-bg);\r\n    }\r\n\r\n    // Accordion\r\n    .accordion{\r\n      --bs-accordion-bg: var(--#{$prefix}body-bg);\r\n      --bs-accordion-active-bg: var(--#{$prefix}body-bg);\r\n    }\r\n    .accordion-item{\r\n      background-color: var(--#{$prefix}body-bg);\r\n      color: var(--#{$prefix}gray-400);\r\n      .accordion-button{\r\n        color: var(--#{$prefix}gray-400);\r\n      }\r\n    }\r\n\r\n    // Background mode\r\n    .bg-mode{\r\n      background: var(--#{$prefix}mode);\r\n    }\r\n\r\n    hr{\r\n      color: var(--#{$prefix}gray-300);\r\n    }\r\n\r\n    // Fill secondary\r\n    .fill-secondary{\r\n      fill: rgba(var(--#{$prefix}secondary-rgb)) !important;\r\n    }\r\n\r\n    // Shadow\r\n    .shadow, .shadow-lg, .shadow-sm{\r\n      box-shadow: none !important;\r\n    }\r\n    .navbar-nav .dropdown .dropdown-submenu:hover>.dropdown-menu {\r\n      box-shadow: none;\r\n    }\r\n\r\n    // Mobile mockup and mac mockup\r\n    .iphone-x{\r\n      box-shadow: 0px 0px 0px 11px var(--#{$prefix}gray-600), 0px 0px 0px 13px var(--#{$prefix}gray-600), 0px 0px 0px 20px var(--#{$prefix}gray-400);\r\n      &:after{\r\n        background-color: var(--#{$prefix}light);\r\n      }\r\n      &:before{\r\n        background-color: var(--#{$prefix}gray-600);\r\n      }\r\n    }\r\n    .mac_screen{\r\n      background: var(--#{$prefix}gray-700);\r\n      &:before {\r\n        border: none;\r\n      }\r\n    }\r\n\r\n    // Form control background\r\n    .form-control{\r\n      background-color: var(--#{$prefix}body-bg);\r\n      border-color: var(--bs-gray-100);\r\n      &:focus{\r\n        border-color: var(--bs-primary);\r\n      }\r\n    }\r\n\r\n    // Choices\r\n    .choices .choices__inner{\r\n      background-color: var(--#{$prefix}body-bg);\r\n      border: 1px solid var(--bs-gray-100);\r\n    }\r\n    .choices .choices__list--dropdown{\r\n      background-color: var(--#{$prefix}body-bg);\r\n      border: 1px solid var(--bs-gray-100);\r\n    }\r\n    .choices[data-type*=select-one] .choices__input{\r\n      background: var(--bs-body-bg);\r\n    }\r\n\r\n    // Flatpickr\r\n    .flatpickr-calendar{\r\n      background: var(--#{$prefix}mode);\r\n      border-color: var(--#{$prefix}mode);\r\n    }\r\n    .flatpickr-current-month .flatpickr-monthDropdown-months, .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {\r\n      background: var(--#{$prefix}mode);\r\n    }\r\n    .flatpickr-calendar.arrowBottom:before, .flatpickr-calendar.arrowBottom:after {\r\n      border-top-color: var(--#{$prefix}mode);\r\n    }\r\n    .flatpickr-calendar.arrowTop:before, .flatpickr-calendar.arrowTop:after, .flatpickr-current-month .numInputWrapper span.arrowUp:after {\r\n      border-bottom-color: var(--#{$prefix}mode);\r\n    }\r\n\r\n    // Tabs white\r\n    .nav-tabs-white{\r\n      .nav-item{\r\n        .nav-link.active, .nav-link:hover{\r\n          background: var(--#{$prefix}mode);\r\n        }\r\n      }\r\n    }\r\n\r\n    .navbar.navbar-icon {\r\n      .navbar-nav {\r\n        .nav-item {\r\n          .nav-link {\r\n            &.active {\r\n              &:before {\r\n                border-color: var(--bs-mode) transparent transparent transparent;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    // Responsive navbar\r\n    .navbar-expand {\r\n      @each $breakpoint in map-keys($grid-breakpoints) {\r\n        $next: breakpoint-next($breakpoint, $grid-breakpoints);\r\n        $infix: breakpoint-infix($next, $grid-breakpoints);\r\n        &#{$infix} {\r\n          @include media-breakpoint-down($next) {\r\n            .navbar-collapse{\r\n              background: var(--#{$prefix}mode) !important;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    // Glightbox\r\n    .glightbox-clean .gslide-description {\r\n      background: var(--#{$prefix}mode);\r\n    }\r\n\r\n    // Preloader\r\n    .preloader {\r\n      background-color: var(--#{$prefix}mode);\r\n    }\r\n\r\n    // Ticket border\r\n    .ticket-border {\r\n      &:before {\r\n        background: var(--#{$prefix}mode);\r\n      }\r\n      &:after {\r\n        background: var(--#{$prefix}mode);\r\n      }\r\n    }\r\n\r\n    // story border\r\n    .stories .story > .item-link > .item-preview img {\r\n      border: 2px solid var(--#{$prefix}mode);\r\n    }\r\n    // Story scroll\r\n    .scroll-enable{\r\n      &.stories.carousel::-webkit-scrollbar-track\r\n      {\r\n        background-color: var(--#{$prefix}gray-200);\r\n      }\r\n      &.stories.carousel::-webkit-scrollbar\r\n      {\r\n        background-color: var(--#{$prefix}gray-200);\r\n      }\r\n      &.stories.carousel::-webkit-scrollbar-thumb\r\n      {\r\n        background-color: var(--#{$prefix}gray-400);\r\n      }\r\n    }\r\n  }\r\n  \r\n  // Dark mode switch\r\n  .modeswitch-item {\r\n    .btn-modeswitch {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      transform: translateX(-14%);\r\n      height: 40px;\r\n      width: 40px;\r\n      background: var(--#{$prefix}light);\r\n      border-radius: $border-radius;\r\n      transition: all 1s;\r\n      svg{\r\n      fill: var(--#{$prefix}gray-900);\r\n      }\r\n      &.active{\r\n        background: var(--#{$prefix}primary);\r\n        svg{\r\n          fill: var(--#{$prefix}white);\r\n          }\r\n      }\r\n    }\r\n  }\r\n\r\n// Dark mode item hide and show\r\n.dark-mode-item{\r\n  display: none !important;\r\n}\r\n\r\n[data-bs-theme=\"dark\"]{\r\n  .dark-mode-item{\r\n    display: inline-block !important;\r\n  }\r\n  .light-mode-item{\r\n    display: none !important;\r\n  }\r\n}","// Should you need to overwrite any of our SCSS code or need to add any custom code, We highly recommend that you add your code into this file, so whenever theme update is available and you update the theme, You will not lose your hard work :)\r\n\r\n// Note for dark mode:\r\n// If you want to set different primary(i.e. light color of your primary) color in dark mode only, uncomment below code and change primary color code to set different color in dark mode. If you want your light mode and dark mode both primary color same, you can remove below code.\r\n\r\n/*User CSS*/\r\n\r\n// [data-bs-theme=\"dark\"] {\r\n//   --bs-primary: #19f032 !important;\r\n//   --bs-primary-rgb: 25, 240, 50 !important; \r\n//   --bs-link-color:#19f032 !important;\r\n//   --bs-link-hover-color:#0c911c !important;\r\n//   --bs-link-color-rgb:25, 240, 50 !important;\r\n//   --bs-link-hover-color-rgb:12, 145, 28;\r\n//   --bs-nav-pills-link-active-bg: #19f032 !important;\r\n\r\n//   .navbar {\r\n//     --bs-navbar-hover-color: var(--#{$prefix}primary) !important;\r\n//     --bs-navbar-active-color: var(--#{$prefix}primary) !important;\r\n//     }\r\n    \r\n//     .navbar-dark {\r\n//       --bs-navbar-hover-color: var(--#{$prefix}primary) !important;\r\n//       --bs-navbar-active-color: var(--#{$prefix}primary) !important;\r\n//     }\r\n//     .nav{\r\n//       --bs-nav-link-hover-color: var(--#{$prefix}link-hover-color);\r\n//     }\r\n//     .dropdown-menu {\r\n//       --bs-dropdown-link-hover-color: var(--#{$prefix}primary) !important;\r\n//       --bs-dropdown-link-active-color: var(--#{$prefix}primary) !important;\r\n//     }\r\n  \r\n//   .btn-primary {\r\n//     --bs-btn-bg: var(--#{$prefix}primary);\r\n//     --bs-btn-border-color: var(--#{$prefix}primary);\r\n//     --bs-btn-hover-bg: var(--#{$prefix}link-hover-color);\r\n//     --bs-btn-hover-border-color: var(--#{$prefix}link-hover-color);\r\n//     --bs-btn-active-bg: var(--#{$prefix}link-hover-color);\r\n//     --bs-btn-active-border-color: var(--#{$prefix}link-hover-color);\r\n//     --bs-btn-disabled-bg: var(--#{$prefix}primary);\r\n//     --bs-btn-disabled-border-color: var(--#{$prefix}primary);\r\n//   }\r\n//   .btn-link {\r\n//     --bs-btn-color: var(--#{$prefix}primary);\r\n//     --bs-link-color: var(--#{$prefix}primary);\r\n//     --bs-btn-hover-color: var(--#{$prefix}link-hover-color);\r\n//     --bs-btn-active-color: var(--#{$prefix}link-hover-color);\r\n//   }\r\n//   .btn-outline-primary {\r\n//     --bs-btn-color: var(--#{$prefix}primary);\r\n//     --bs-btn-border-color: var(--#{$prefix}primary);\r\n//     --bs-btn-hover-bg: var(--#{$prefix}primary);\r\n//     --bs-btn-hover-border-color: var(--#{$prefix}primary);\r\n//     --bs-btn-active-bg: var(--#{$prefix}primary);\r\n//     --bs-btn-active-border-color: var(--#{$prefix}primary);\r\n//     --bs-btn-disabled-color: var(--#{$prefix}primary);\r\n//     --bs-btn-disabled-border-color: var(--#{$prefix}primary);\r\n//   }\r\n//   .btn-primary-soft{\r\n//     color: var(--#{$prefix}primary);\r\n//     background-color: rgba(var(--#{$prefix}primary-rgb), 0.1);\r\n//     &:hover, &:focus{\r\n//       color: $white;\r\n//       background-color: var(--#{$prefix}primary) !important;\r\n//       border-color: var(--#{$prefix}primary) !important;\r\n//     }\r\n//   }\r\n\r\n//  .fill-primary{\r\n//    fill: var(--#{$prefix}primary) !important;\r\n//   }\r\n//   .nav-pills {\r\n//     --bs-nav-pills-link-active-bg: var(--#{$prefix}primary);\r\n//   }\r\n//   .form-control:focus{\r\n//     border-color: var(--#{$prefix}primary);\r\n//   }\r\n//   .text-bg-primary{\r\n//     background-color: rgba(var(--#{$prefix}primary-rgb), 1) !important;\r\n//   }\r\n//   .form-check-input:checked {\r\n//     background-color: var(--#{$prefix}primary);\r\n//     border-color: var(--#{$prefix}primary);\r\n//   }\r\n//   .form-select:focus{\r\n//     border-color: var(--#{$prefix}primary);\r\n//   }\r\n//   .form-check-input:focus{\r\n//     border-color: var(--#{$prefix}primary);\r\n//   }\r\n//   .pagination{\r\n//     --bs-pagination-hover-bg: var(--#{$prefix}primary);\r\n//     --bs-pagination-hover-border-color: var(--#{$prefix}primary);\r\n//     --bs-pagination-active-bg: var(--#{$prefix}primary);\r\n//     --bs-pagination-active-border-color: var(--#{$prefix}primary);\r\n//   }\r\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
